const unCodes = [
	{
	  "BAKANLIK_KOD": "000400",
	  "UN_NO": "0004",
	  "ORİJİNAL İSİM": "AMONYUM PİKRAT kütlece %10'dan az su ile ıslatılmış veya kuru",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "000400",
	  "UN_NO__1": "0004"
	},
	{
	  "BAKANLIK_KOD": "000500",
	  "UN_NO": "0005",
	  "ORİJİNAL İSİM": "KARTUŞLAR, SİLAHLAR İÇİN paralama hakkı olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "000500",
	  "UN_NO__1": "0005"
	},
	{
	  "BAKANLIK_KOD": "000600",
	  "UN_NO": "0006",
	  "ORİJİNAL İSİM": "KARTUŞLAR, SİLAHLAR İÇİN paralama hakkı olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1E",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "000600",
	  "UN_NO__1": "0006"
	},
	{
	  "BAKANLIK_KOD": "000700",
	  "UN_NO": "0007",
	  "ORİJİNAL İSİM": "KARTUŞLAR, SİLAHLAR İÇİN paralama hakkı olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "000700",
	  "UN_NO__1": "0007"
	},
	{
	  "BAKANLIK_KOD": "000900",
	  "UN_NO": "0009",
	  "ORİJİNAL İSİM": "MÜHİMMAT, YANGIN ÇIKARTICI paralama hakkı, fırlatma yükü veya sevk maddesi olan veya olmayan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "000900",
	  "UN_NO__1": "0009"
	},
	{
	  "BAKANLIK_KOD": "001000",
	  "UN_NO": "0010",
	  "ORİJİNAL İSİM": "MÜHİMMAT, YANGIN ÇIKARTICI paralama hakkı, fırlatma yükü veya sevk maddesi olan veya olmayan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "001000",
	  "UN_NO__1": "0010"
	},
	{
	  "BAKANLIK_KOD": "001200",
	  "UN_NO": "0012",
	  "ORİJİNAL İSİM": "KARTUŞLAR, SİLAHLAR İÇİN,TESİRSİZ MERMİLİ veya KARTUŞLAR, HAFİF SİLAHLAR İÇİN",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4S",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "001200",
	  "UN_NO__1": "0012"
	},
	{
	  "BAKANLIK_KOD": "001400",
	  "UN_NO": "0014",
	  "ORİJİNAL İSİM": "KARTUŞLAR, SİLAHLAR İÇİN, KURUSIKI veya KARTUŞLAR, HAFİF SİLAHLAR İÇİN, KURUSIKI veya KARTUŞLAR, ALETLER İÇİN, KURUSIKI",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4S",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "001400",
	  "UN_NO__1": "0014"
	},
	{
	  "BAKANLIK_KOD": "001501",
	  "UN_NO": "0015",
	  "ORİJİNAL İSİM": "MÜHİMMAT, DUMANLI paralama hakkı, fırlatma yükü veya sevk maddesi olan veya olmayan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "001501",
	  "UN_NO__1": "0015"
	},
	{
	  "BAKANLIK_KOD": "001502",
	  "UN_NO": "0015",
	  "ORİJİNAL İSİM": "MÜHİMMAT, DUMANLI paralama hakkı, fırlatma yükü veya sevk maddesi olan veya olmayan, aşındırıcı maddeler içeren",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "001502",
	  "UN_NO__1": "0015"
	},
	{
	  "BAKANLIK_KOD": "001503",
	  "UN_NO": "0015",
	  "ORİJİNAL İSİM": "MÜHİMMAT, DUMANLI paralama hakkı, fırlatma yükü veya sevk maddesi olan veya olmayan, soluma yoluyla zehirli maddeler içeren",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "001503",
	  "UN_NO__1": "0015"
	},
	{
	  "BAKANLIK_KOD": "001601",
	  "UN_NO": "0016",
	  "ORİJİNAL İSİM": "MÜHİMMAT, DUMANLI paralama hakkı, fırlatma yükü veya sevk maddesi olan veya olmayan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "001601",
	  "UN_NO__1": "0016"
	},
	{
	  "BAKANLIK_KOD": "001602",
	  "UN_NO": "0016",
	  "ORİJİNAL İSİM": "MÜHİMMAT, DUMANLI paralama hakkı, fırlatma yükü veya sevk maddesi olan veya olmayan, aşındırıcı maddeler içeren",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "001602",
	  "UN_NO__1": "0016"
	},
	{
	  "BAKANLIK_KOD": "001603",
	  "UN_NO": "0016",
	  "ORİJİNAL İSİM": "MÜHİMMAT, DUMANLI paralama hakkı, fırlatma yükü veya sevk maddesi olan veya olmayan, soluma yoluyla zehirli maddeler içeren",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "001603",
	  "UN_NO__1": "0016"
	},
	{
	  "BAKANLIK_KOD": "001800",
	  "UN_NO": "0018",
	  "ORİJİNAL İSİM": "MÜHİMMAT, GÖZ YAŞARTICI paralama hakkı, fırlatma yükü veya sevk maddesi olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "001800",
	  "UN_NO__1": "0018"
	},
	{
	  "BAKANLIK_KOD": "001900",
	  "UN_NO": "0019",
	  "ORİJİNAL İSİM": "MÜHİMMAT, GÖZ YAŞARTICI paralama hakkı, fırlatma yükü veya sevk maddesi olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "001900",
	  "UN_NO__1": "0019"
	},
	{
	  "BAKANLIK_KOD": "002700",
	  "UN_NO": "0027",
	  "ORİJİNAL İSİM": "KARA BARUT (BARUT), granül veya toz halinde",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "002700",
	  "UN_NO__1": "0027"
	},
	{
	  "BAKANLIK_KOD": "002800",
	  "UN_NO": "0028",
	  "ORİJİNAL İSİM": "KARA BARUT (BARUT), SIKIŞTIRILMIŞ veya KARA BARUT (BARUT), SAÇMA HALİNDE",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "002800",
	  "UN_NO__1": "0028"
	},
	{
	  "BAKANLIK_KOD": "002900",
	  "UN_NO": "0029",
	  "ORİJİNAL İSİM": "KAPSÜLLER, ELEKTRİKLİ OLMAYAN, patlatma için",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1B",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "002900",
	  "UN_NO__1": "0029"
	},
	{
	  "BAKANLIK_KOD": "003000",
	  "UN_NO": "0030",
	  "ORİJİNAL İSİM": "KAPSÜLLER, ELEKTRİKLİ, patlatma için",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1B",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "003000",
	  "UN_NO__1": "0030"
	},
	{
	  "BAKANLIK_KOD": "003300",
	  "UN_NO": "0033",
	  "ORİJİNAL İSİM": "BOMBALAR paralama hakkı olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "003300",
	  "UN_NO__1": "0033"
	},
	{
	  "BAKANLIK_KOD": "003400",
	  "UN_NO": "0034",
	  "ORİJİNAL İSİM": "BOMBALAR paralama hakkı olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "003400",
	  "UN_NO__1": "0034"
	},
	{
	  "BAKANLIK_KOD": "003500",
	  "UN_NO": "0035",
	  "ORİJİNAL İSİM": "BOMBALAR paralama hakkı olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "003500",
	  "UN_NO__1": "0035"
	},
	{
	  "BAKANLIK_KOD": "003700",
	  "UN_NO": "0037",
	  "ORİJİNAL İSİM": "BOMBALAR, FOTO-FLAŞ",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "003700",
	  "UN_NO__1": "0037"
	},
	{
	  "BAKANLIK_KOD": "003800",
	  "UN_NO": "0038",
	  "ORİJİNAL İSİM": "BOMBALAR, FOTO-FLAŞ",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "003800",
	  "UN_NO__1": "0038"
	},
	{
	  "BAKANLIK_KOD": "003900",
	  "UN_NO": "0039",
	  "ORİJİNAL İSİM": "BOMBALAR, FOTO-FLAŞ",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "003900",
	  "UN_NO__1": "0039"
	},
	{
	  "BAKANLIK_KOD": "004200",
	  "UN_NO": "0042",
	  "ORİJİNAL İSİM": "TUTUŞTURUCULAR kapsülsüz",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "004200",
	  "UN_NO__1": "0042"
	},
	{
	  "BAKANLIK_KOD": "004300",
	  "UN_NO": "0043",
	  "ORİJİNAL İSİM": "PARALAMA HAKLARI, patlayıcı",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "004300",
	  "UN_NO__1": "0043"
	},
	{
	  "BAKANLIK_KOD": "004400",
	  "UN_NO": "0044",
	  "ORİJİNAL İSİM": "KAPSÜLLER, BAŞLIK TİPİ",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4S",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "004400",
	  "UN_NO__1": "0044"
	},
	{
	  "BAKANLIK_KOD": "004800",
	  "UN_NO": "0048",
	  "ORİJİNAL İSİM": "İMLA HAKLARI, TAHRİPLİ",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "004800",
	  "UN_NO__1": "0048"
	},
	{
	  "BAKANLIK_KOD": "004900",
	  "UN_NO": "0049",
	  "ORİJİNAL İSİM": "KARTUŞLARI, FLAŞ",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "004900",
	  "UN_NO__1": "0049"
	},
	{
	  "BAKANLIK_KOD": "005000",
	  "UN_NO": "0050",
	  "ORİJİNAL İSİM": "KARTUŞLARI, FLAŞ",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "005000",
	  "UN_NO__1": "0050"
	},
	{
	  "BAKANLIK_KOD": "005400",
	  "UN_NO": "0054",
	  "ORİJİNAL İSİM": "FİŞEKLERİ, İŞARET",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "005400",
	  "UN_NO__1": "0054"
	},
	{
	  "BAKANLIK_KOD": "005500",
	  "UN_NO": "0055",
	  "ORİJİNAL İSİM": "KOVANLAR, KARTUŞ, BOŞ,\n KAPSÜLLÜ",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4S",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "005500",
	  "UN_NO__1": "0055"
	},
	{
	  "BAKANLIK_KOD": "005600",
	  "UN_NO": "0056",
	  "ORİJİNAL İSİM": "BOMBALARI, DERİNLİK",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "005600",
	  "UN_NO__1": "0056"
	},
	{
	  "BAKANLIK_KOD": "005900",
	  "UN_NO": "0059",
	  "ORİJİNAL İSİM": "İMLA HAKLARI, BOŞLUKLU, kapsülsüz",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "005900",
	  "UN_NO__1": "0059"
	},
	{
	  "BAKANLIK_KOD": "006000",
	  "UN_NO": "0060",
	  "ORİJİNAL İSİM": "İMLA HAKLARI, İLAVE, İNFİLAK",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "006000",
	  "UN_NO__1": "0060"
	},
	{
	  "BAKANLIK_KOD": "006500",
	  "UN_NO": "0065",
	  "ORİJİNAL İSİM": "FİTİL, İNFİLAKLI, esnek",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "006500",
	  "UN_NO__1": "0065"
	},
	{
	  "BAKANLIK_KOD": "006600",
	  "UN_NO": "0066",
	  "ORİJİNAL İSİM": "FİTİLİ, ATEŞLEME",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "006600",
	  "UN_NO__1": "0066"
	},
	{
	  "BAKANLIK_KOD": "007000",
	  "UN_NO": "0070",
	  "ORİJİNAL İSİM": "KESİCİLER, KABLO, İNFİLAK",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4S",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "007000",
	  "UN_NO__1": "0070"
	},
	{
	  "BAKANLIK_KOD": "007200",
	  "UN_NO": "0072",
	  "ORİJİNAL İSİM": "SİKLOTRİMETİLEN-TRİNİTRAMİN (SİKLONİT; HEKSOJEN; RDX), ISLATILMIŞ kütlece %15'ten daha az olmayan su ile",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "007200",
	  "UN_NO__1": "0072"
	},
	{
	  "BAKANLIK_KOD": "007300",
	  "UN_NO": "0073",
	  "ORİJİNAL İSİM": "KAPSÜLLER, MÜHİMMAT İÇİN",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1B",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "007300",
	  "UN_NO__1": "0073"
	},
	{
	  "BAKANLIK_KOD": "007400",
	  "UN_NO": "0074",
	  "ORİJİNAL İSİM": "DİAZODİNİTROFENOL, ISLATILMIŞ kütlece %40'tan daha az olmayan su veya su alkol karışımı ile",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "007400",
	  "UN_NO__1": "0074"
	},
	{
	  "BAKANLIK_KOD": "007500",
	  "UN_NO": "0075",
	  "ORİJİNAL İSİM": "DİETİLENGLİKOL DİNİTRAT, DUYARLILIĞI AZALTILMIŞ kütlece %25'ten az olmamak üzere uçucu olmayan ve suda çözünmeyen flegmatizör",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "007500",
	  "UN_NO__1": "0075"
	},
	{
	  "BAKANLIK_KOD": "007600",
	  "UN_NO": "0076",
	  "ORİJİNAL İSİM": "DİNİTROFENOL, kütlece %15'ten az su ile ıslatılmış veya kuru",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "007600",
	  "UN_NO__1": "0076"
	},
	{
	  "BAKANLIK_KOD": "007700",
	  "UN_NO": "0077",
	  "ORİJİNAL İSİM": "DİNİTROFENOLATLAR, alkali metaller, kütlece %15'ten az su ile ıslatılmış veya kuru",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "007700",
	  "UN_NO__1": "0077"
	},
	{
	  "BAKANLIK_KOD": "007800",
	  "UN_NO": "0078",
	  "ORİJİNAL İSİM": "DİNİTRORESORSİNOL, kütlece %15'ten az su ile ıslatılmış veya kuru",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "007800",
	  "UN_NO__1": "0078"
	},
	{
	  "BAKANLIK_KOD": "007900",
	  "UN_NO": "0079",
	  "ORİJİNAL İSİM": "HEKZANİTRODİFENİL-AMİN (DİPİKRİLAMİN; HEKZİL)",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "007900",
	  "UN_NO__1": "0079"
	},
	{
	  "BAKANLIK_KOD": "008100",
	  "UN_NO": "0081",
	  "ORİJİNAL İSİM": "PATLAYICI, TAHRİPLİ, TİP A",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "008100",
	  "UN_NO__1": "0081"
	},
	{
	  "BAKANLIK_KOD": "008200",
	  "UN_NO": "0082",
	  "ORİJİNAL İSİM": "PATLAYICI, TAHRİPLİ, TİP B",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "008200",
	  "UN_NO__1": "0082"
	},
	{
	  "BAKANLIK_KOD": "008300",
	  "UN_NO": "0083",
	  "ORİJİNAL İSİM": "PATLAYICI, TAHRİPLİ, TİP C",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "008300",
	  "UN_NO__1": "0083"
	},
	{
	  "BAKANLIK_KOD": "008400",
	  "UN_NO": "0084",
	  "ORİJİNAL İSİM": "PATLAYICI, TAHRİPLİ, TİP D",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "008400",
	  "UN_NO__1": "0084"
	},
	{
	  "BAKANLIK_KOD": "009200",
	  "UN_NO": "0092",
	  "ORİJİNAL İSİM": "İŞARET FİŞEKLERİ, YÜZEY",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "009200",
	  "UN_NO__1": "0092"
	},
	{
	  "BAKANLIK_KOD": "009300",
	  "UN_NO": "0093",
	  "ORİJİNAL İSİM": "İŞARET FİŞEKLERİ, HAVAİ",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "009300",
	  "UN_NO__1": "0093"
	},
	{
	  "BAKANLIK_KOD": "009400",
	  "UN_NO": "0094",
	  "ORİJİNAL İSİM": "PARLAMA TOZU",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "009400",
	  "UN_NO__1": "0094"
	},
	{
	  "BAKANLIK_KOD": "009900",
	  "UN_NO": "0099",
	  "ORİJİNAL İSİM": "KIRICI ALETLER, PATLAYICI kapsülsüz, petrol kuyuları için",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "009900",
	  "UN_NO__1": "0099"
	},
	{
	  "BAKANLIK_KOD": "010100",
	  "UN_NO": "0101",
	  "ORİJİNAL İSİM": "TAPA, İNFİLAKSIZ",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "010100",
	  "UN_NO__1": "0101"
	},
	{
	  "BAKANLIK_KOD": "010200",
	  "UN_NO": "0102",
	  "ORİJİNAL İSİM": "FİTİL (TAPA), İNFİLAKLI, metal zırhlı",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "010200",
	  "UN_NO__1": "0102"
	},
	{
	  "BAKANLIK_KOD": "010300",
	  "UN_NO": "0103",
	  "ORİJİNAL İSİM": "TAPA, ATEŞLEMELİ, boru tipi, metal zırhlı",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "010300",
	  "UN_NO__1": "0103"
	},
	{
	  "BAKANLIK_KOD": "010400",
	  "UN_NO": "0104",
	  "ORİJİNAL İSİM": "FİTİL (TAPA), İNFİLAKLI, HAFİF ETKİLİ, metal zırhlı",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "010400",
	  "UN_NO__1": "0104"
	},
	{
	  "BAKANLIK_KOD": "010500",
	  "UN_NO": "0105",
	  "ORİJİNAL İSİM": "TAPASI, EMNİYET",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4S",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "010500",
	  "UN_NO__1": "0105"
	},
	{
	  "BAKANLIK_KOD": "010600",
	  "UN_NO": "0106",
	  "ORİJİNAL İSİM": "FÜNYELER, İNFİLAKLI",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1B",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "010600",
	  "UN_NO__1": "0106"
	},
	{
	  "BAKANLIK_KOD": "010700",
	  "UN_NO": "0107",
	  "ORİJİNAL İSİM": "FÜNYELER, İNFİLAKLI",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2B",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "010700",
	  "UN_NO__1": "0107"
	},
	{
	  "BAKANLIK_KOD": "011000",
	  "UN_NO": "0110",
	  "ORİJİNAL İSİM": "EL BOMBALARI, EĞİTİM, el veya tüfek ile",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4S",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "011000",
	  "UN_NO__1": "0110"
	},
	{
	  "BAKANLIK_KOD": "011300",
	  "UN_NO": "0113",
	  "ORİJİNAL İSİM": "GUANİLNİTROSAMİNO-GUALİDİN HİDRAZİN, ISLATILMIŞ kütlece %30'dan daha az olmayan su ile",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "011300",
	  "UN_NO__1": "0113"
	},
	{
	  "BAKANLIK_KOD": "011400",
	  "UN_NO": "0114",
	  "ORİJİNAL İSİM": "GUANİLNİTROSAMİNO- GUANİLTETRAZEN (TETRAZEN), ISLATILMIŞ kütlece %30'dan az olmayan su veya alkol su karışımı ile",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "011400",
	  "UN_NO__1": "0114"
	},
	{
	  "BAKANLIK_KOD": "011800",
	  "UN_NO": "0118",
	  "ORİJİNAL İSİM": "HEKZOLİT (HEKZOTOL) kütlece %15'ten az su ile ıslatılmış veya kuru",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "011800",
	  "UN_NO__1": "0118"
	},
	{
	  "BAKANLIK_KOD": "012100",
	  "UN_NO": "0121",
	  "ORİJİNAL İSİM": "ATEŞLEYİCİLER",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "012100",
	  "UN_NO__1": "0121"
	},
	{
	  "BAKANLIK_KOD": "012400",
	  "UN_NO": "0124",
	  "ORİJİNAL İSİM": "JET DELİCİ SİLAHLAR, YÜKLÜ, petrol kuyusu, kapsülsüz",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "012400",
	  "UN_NO__1": "0124"
	},
	{
	  "BAKANLIK_KOD": "012900",
	  "UN_NO": "0129",
	  "ORİJİNAL İSİM": "KURŞUN AZİT, ISLATILMIŞ kütlece %20'den az olmayan su veya alkol su karışımı ile",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "012900",
	  "UN_NO__1": "0129"
	},
	{
	  "BAKANLIK_KOD": "013000",
	  "UN_NO": "0130",
	  "ORİJİNAL İSİM": "KURŞUN STİFNAT (KURŞUN TRİNİTRORESORSİNAT), ISLATILMIŞ kütlece %20'den daha az olmayan su veya alkol karışımı ile",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "013000",
	  "UN_NO__1": "0130"
	},
	{
	  "BAKANLIK_KOD": "013100",
	  "UN_NO": "0131",
	  "ORİJİNAL İSİM": "ÇAKMAKLAR, TAPA",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4S",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "013100",
	  "UN_NO__1": "0131"
	},
	{
	  "BAKANLIK_KOD": "013200",
	  "UN_NO": "0132",
	  "ORİJİNAL İSİM": "AROMATİK NİTRO TÜREVLERİN YANICI METAL TUZLARI, B.B.B.",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "013200",
	  "UN_NO__1": "0132"
	},
	{
	  "BAKANLIK_KOD": "013300",
	  "UN_NO": "0133",
	  "ORİJİNAL İSİM": "MANNİTOL HEKZANİTRAT (NİTROMANNİT), ISLATILMIŞ kütlece %40'tan daha az olmayan su veya su alkol karışımı ile",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "013300",
	  "UN_NO__1": "0133"
	},
	{
	  "BAKANLIK_KOD": "013500",
	  "UN_NO": "0135",
	  "ORİJİNAL İSİM": "CIVA (II) FULMİNAT, ISLATILMIŞ kütlece %20'den daha az olmayan su veya alkol su karışımı ile",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "013500",
	  "UN_NO__1": "0135"
	},
	{
	  "BAKANLIK_KOD": "013600",
	  "UN_NO": "0136",
	  "ORİJİNAL İSİM": "MAYINLAR paralama hakkı olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "013600",
	  "UN_NO__1": "0136"
	},
	{
	  "BAKANLIK_KOD": "013700",
	  "UN_NO": "0137",
	  "ORİJİNAL İSİM": "MAYINLAR paralama hakkı olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "013700",
	  "UN_NO__1": "0137"
	},
	{
	  "BAKANLIK_KOD": "013800",
	  "UN_NO": "0138",
	  "ORİJİNAL İSİM": "MAYINLAR paralama hakkı olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "013800",
	  "UN_NO__1": "0138"
	},
	{
	  "BAKANLIK_KOD": "014300",
	  "UN_NO": "0143",
	  "ORİJİNAL İSİM": "NİTROGLİSERİN, DUYARLILIĞI AZALTILMIŞ kütlece %40'tan az olmamak üzere uçucu olmayan ve suda çözünmeyen flegmatizör ile",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "014300",
	  "UN_NO__1": "0143"
	},
	{
	  "BAKANLIK_KOD": "014400",
	  "UN_NO": "0144",
	  "ORİJİNAL İSİM": "NİTROGLİSERİN ÇÖZELTİSİ ALKOLDE %1'den fazla ama %10'dan daha az nitrogliserin içeren",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "014400",
	  "UN_NO__1": "0144"
	},
	{
	  "BAKANLIK_KOD": "014600",
	  "UN_NO": "0146",
	  "ORİJİNAL İSİM": "NİTRO-NİŞASTA, kütlece %20'den az su ile ıslatılmış veya kuru",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "014600",
	  "UN_NO__1": "0146"
	},
	{
	  "BAKANLIK_KOD": "014700",
	  "UN_NO": "0147",
	  "ORİJİNAL İSİM": "NİTRO ÜRE",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "014700",
	  "UN_NO__1": "0147"
	},
	{
	  "BAKANLIK_KOD": "015000",
	  "UN_NO": "0150",
	  "ORİJİNAL İSİM": "PENTAERİTRİT TETRANİTRAT (PENTAERİTRİTOL TETRANİTRAT; PETN), kütlece %25'ten az olmamak üzere su ile ISLATILMIŞ veya kütlece %15'ten az olmamak üzere flegmatizör ile DUYARLILIĞI AZALTILMIŞ",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "015000",
	  "UN_NO__1": "0150"
	},
	{
	  "BAKANLIK_KOD": "015100",
	  "UN_NO": "0151",
	  "ORİJİNAL İSİM": "PENTOLİT, kütlece %15'ten az su ile ıslatılmış veya kuru",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "015100",
	  "UN_NO__1": "0151"
	},
	{
	  "BAKANLIK_KOD": "015300",
	  "UN_NO": "0153",
	  "ORİJİNAL İSİM": "TRİNİTROANİLİN (PİKRAMİD)",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "015300",
	  "UN_NO__1": "0153"
	},
	{
	  "BAKANLIK_KOD": "015400",
	  "UN_NO": "0154",
	  "ORİJİNAL İSİM": "TRİNİTROFENOL (PİKRİK ASİT), kütlece %30'dan az su ile ıslatılmış veya kuru",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "015400",
	  "UN_NO__1": "0154"
	},
	{
	  "BAKANLIK_KOD": "015500",
	  "UN_NO": "0155",
	  "ORİJİNAL İSİM": "TRİNİTROKLOROBENZEN (PİKRİL KLORÜR)",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "015500",
	  "UN_NO__1": "0155"
	},
	{
	  "BAKANLIK_KOD": "015900",
	  "UN_NO": "0159",
	  "ORİJİNAL İSİM": "BARUT KALIBI (BARUT MACUNU), ISLATILMIŞ kütlece %25'ten daha az olmayan su ile",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "015900",
	  "UN_NO__1": "0159"
	},
	{
	  "BAKANLIK_KOD": "016000",
	  "UN_NO": "0160",
	  "ORİJİNAL İSİM": "BARUT, DUMANSIZ",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "016000",
	  "UN_NO__1": "0160"
	},
	{
	  "BAKANLIK_KOD": "016100",
	  "UN_NO": "0161",
	  "ORİJİNAL İSİM": "BARUT, DUMANSIZ",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "016100",
	  "UN_NO__1": "0161"
	},
	{
	  "BAKANLIK_KOD": "016700",
	  "UN_NO": "0167",
	  "ORİJİNAL İSİM": "MERMİLER paralama hakkı olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "016700",
	  "UN_NO__1": "0167"
	},
	{
	  "BAKANLIK_KOD": "016800",
	  "UN_NO": "0168",
	  "ORİJİNAL İSİM": "MERMİLER paralama hakkı olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "016800",
	  "UN_NO__1": "0168"
	},
	{
	  "BAKANLIK_KOD": "016900",
	  "UN_NO": "0169",
	  "ORİJİNAL İSİM": "MERMİLER paralama hakkı olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "016900",
	  "UN_NO__1": "0169"
	},
	{
	  "BAKANLIK_KOD": "017100",
	  "UN_NO": "0171",
	  "ORİJİNAL İSİM": "MÜHİMMAT, AYDINLATICI paralama hakkı, fırlatma yükü veya sevk maddesi olan veya olmayan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "017100",
	  "UN_NO__1": "0171"
	},
	{
	  "BAKANLIK_KOD": "017300",
	  "UN_NO": "0173",
	  "ORİJİNAL İSİM": "BOŞALTMA ALETLERİ, PATLAYICI",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4S",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "017300",
	  "UN_NO__1": "0173"
	},
	{
	  "BAKANLIK_KOD": "017400",
	  "UN_NO": "0174",
	  "ORİJİNAL İSİM": "PERÇİNLER, PATLAYICI",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4S",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "017400",
	  "UN_NO__1": "0174"
	},
	{
	  "BAKANLIK_KOD": "018000",
	  "UN_NO": "0180",
	  "ORİJİNAL İSİM": "ROKETLER paralama hakkı olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "018000",
	  "UN_NO__1": "0180"
	},
	{
	  "BAKANLIK_KOD": "018100",
	  "UN_NO": "0181",
	  "ORİJİNAL İSİM": "ROKETLER paralama hakkı olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1E",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "018100",
	  "UN_NO__1": "0181"
	},
	{
	  "BAKANLIK_KOD": "018200",
	  "UN_NO": "0182",
	  "ORİJİNAL İSİM": "ROKETLER paralama hakkı olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2E",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "018200",
	  "UN_NO__1": "0182"
	},
	{
	  "BAKANLIK_KOD": "018300",
	  "UN_NO": "0183",
	  "ORİJİNAL İSİM": "ROKETLER tesirsiz başlığı olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "018300",
	  "UN_NO__1": "0183"
	},
	{
	  "BAKANLIK_KOD": "018600",
	  "UN_NO": "0186",
	  "ORİJİNAL İSİM": "ROKET MOTORLARI",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "018600",
	  "UN_NO__1": "0186"
	},
	{
	  "BAKANLIK_KOD": "019000",
	  "UN_NO": "0190",
	  "ORİJİNAL İSİM": "NUMUNELERİ, PATLAYICI tepkime başlatıcı patlayıcı hariç",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "019000",
	  "UN_NO__1": "0190"
	},
	{
	  "BAKANLIK_KOD": "019100",
	  "UN_NO": "0191",
	  "ORİJİNAL İSİM": "İŞARET ALETLERİ, EL",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "019100",
	  "UN_NO__1": "0191"
	},
	{
	  "BAKANLIK_KOD": "019200",
	  "UN_NO": "0192",
	  "ORİJİNAL İSİM": "İŞARETLERİ, DEMİRYOLU, PATLAYICI",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "019200",
	  "UN_NO__1": "0192"
	},
	{
	  "BAKANLIK_KOD": "019300",
	  "UN_NO": "0193",
	  "ORİJİNAL İSİM": "İŞARETLERİ, DEMİRYOLU, PATLAYICI",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4S",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "019300",
	  "UN_NO__1": "0193"
	},
	{
	  "BAKANLIK_KOD": "019400",
	  "UN_NO": "0194",
	  "ORİJİNAL İSİM": "İŞARETLERİ, İMDAT, gemi",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "019400",
	  "UN_NO__1": "0194"
	},
	{
	  "BAKANLIK_KOD": "019500",
	  "UN_NO": "0195",
	  "ORİJİNAL İSİM": "İŞARETLERİ, İMDAT, gemi",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "019500",
	  "UN_NO__1": "0195"
	},
	{
	  "BAKANLIK_KOD": "019600",
	  "UN_NO": "0196",
	  "ORİJİNAL İSİM": "İŞARETLERİ, DUMAN",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "019600",
	  "UN_NO__1": "0196"
	},
	{
	  "BAKANLIK_KOD": "019700",
	  "UN_NO": "0197",
	  "ORİJİNAL İSİM": "İŞARETLERİ, DUMAN",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "019700",
	  "UN_NO__1": "0197"
	},
	{
	  "BAKANLIK_KOD": "020400",
	  "UN_NO": "0204",
	  "ORİJİNAL İSİM": "SONDAJ CİHAZLARI, PATLAYICI",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "020400",
	  "UN_NO__1": "0204"
	},
	{
	  "BAKANLIK_KOD": "020700",
	  "UN_NO": "0207",
	  "ORİJİNAL İSİM": "TETRANİTROANİLİN",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "020700",
	  "UN_NO__1": "0207"
	},
	{
	  "BAKANLIK_KOD": "020800",
	  "UN_NO": "0208",
	  "ORİJİNAL İSİM": "TRİNİTROFENİLMETİL-NİTRAMİN (TETRİL)",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "020800",
	  "UN_NO__1": "0208"
	},
	{
	  "BAKANLIK_KOD": "020900",
	  "UN_NO": "0209",
	  "ORİJİNAL İSİM": "TRİNİTROTOLUEN (TNT) kütlece %30'dan daha az su ile ıslatılmış veya kuru",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "020900",
	  "UN_NO__1": "0209"
	},
	{
	  "BAKANLIK_KOD": "021200",
	  "UN_NO": "0212",
	  "ORİJİNAL İSİM": "MÜHİMMAT İÇİN İZLİ MERMİLER",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "021200",
	  "UN_NO__1": "0212"
	},
	{
	  "BAKANLIK_KOD": "021300",
	  "UN_NO": "0213",
	  "ORİJİNAL İSİM": "TRİNİTROANİZOL",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "021300",
	  "UN_NO__1": "0213"
	},
	{
	  "BAKANLIK_KOD": "021400",
	  "UN_NO": "0214",
	  "ORİJİNAL İSİM": "TRİNİTROBENZEN, kütlece %30'dan az su ile ıslatılmış veya kuru",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "021400",
	  "UN_NO__1": "0214"
	},
	{
	  "BAKANLIK_KOD": "021500",
	  "UN_NO": "0215",
	  "ORİJİNAL İSİM": "TRİNİTROBENZOİK ASİT, kuru veya kütlece %30'dan az su ile ıslatılmış",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "021500",
	  "UN_NO__1": "0215"
	},
	{
	  "BAKANLIK_KOD": "021600",
	  "UN_NO": "0216",
	  "ORİJİNAL İSİM": "TRİNİTRO-m-KRİZOL",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "021600",
	  "UN_NO__1": "0216"
	},
	{
	  "BAKANLIK_KOD": "021700",
	  "UN_NO": "0217",
	  "ORİJİNAL İSİM": "TRİNİTRONAFTALİN",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "021700",
	  "UN_NO__1": "0217"
	},
	{
	  "BAKANLIK_KOD": "021800",
	  "UN_NO": "0218",
	  "ORİJİNAL İSİM": "TRİNİTROFENETOL",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "021800",
	  "UN_NO__1": "0218"
	},
	{
	  "BAKANLIK_KOD": "021900",
	  "UN_NO": "0219",
	  "ORİJİNAL İSİM": "TRİNİTRORESORSİNOL (STİFNİK ASİT) kütlece %20'den az su veya su alkol karışımı ile ıslatılmış veya kuru",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "021900",
	  "UN_NO__1": "0219"
	},
	{
	  "BAKANLIK_KOD": "022000",
	  "UN_NO": "0220",
	  "ORİJİNAL İSİM": "ÜRE NİTRAT, kuru veya kütlece %20'den az su ile ıslatılmış",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "022000",
	  "UN_NO__1": "0220"
	},
	{
	  "BAKANLIK_KOD": "022100",
	  "UN_NO": "0221",
	  "ORİJİNAL İSİM": "SAVAŞ BAŞLIKLARI, TORPİDO paralama hakkı olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "022100",
	  "UN_NO__1": "0221"
	},
	{
	  "BAKANLIK_KOD": "022200",
	  "UN_NO": "0222",
	  "ORİJİNAL İSİM": "AMONYUM NİTRAT",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "022200",
	  "UN_NO__1": "0222"
	},
	{
	  "BAKANLIK_KOD": "022400",
	  "UN_NO": "0224",
	  "ORİJİNAL İSİM": "BARYUM AZİT, kuru veya kütlece %50'den az su ile ıslatılmış",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "022400",
	  "UN_NO__1": "0224"
	},
	{
	  "BAKANLIK_KOD": "022500",
	  "UN_NO": "0225",
	  "ORİJİNAL İSİM": "TUTUŞTURUCULAR, KAPSÜLLÜ",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1B",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "022500",
	  "UN_NO__1": "0225"
	},
	{
	  "BAKANLIK_KOD": "022600",
	  "UN_NO": "0226",
	  "ORİJİNAL İSİM": "SİKLOTETRAMETİLEN-TETRANİTRAMİN (HMX; OKTOJEN), ISLATILMIŞ kütlece %15'ten daha az olmayan su içeren",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "022600",
	  "UN_NO__1": "0226"
	},
	{
	  "BAKANLIK_KOD": "023400",
	  "UN_NO": "0234",
	  "ORİJİNAL İSİM": "SODYUM DİNİTRO-o-KRESOLAT, kütlece %15'ten az su ile ıslatılmış veya kuru",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "023400",
	  "UN_NO__1": "0234"
	},
	{
	  "BAKANLIK_KOD": "023500",
	  "UN_NO": "0235",
	  "ORİJİNAL İSİM": "SODYUM PİKRAMAT, kütlece %20'den az su ile ıslatılmış veya kuru",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "023500",
	  "UN_NO__1": "0235"
	},
	{
	  "BAKANLIK_KOD": "023600",
	  "UN_NO": "0236",
	  "ORİJİNAL İSİM": "ZİRKONYUM PİKRAMAT, kütlece %20'den az su ile ıslatılmış veya kuru",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "023600",
	  "UN_NO__1": "0236"
	},
	{
	  "BAKANLIK_KOD": "023700",
	  "UN_NO": "0237",
	  "ORİJİNAL İSİM": "İMLA HAKLARI, BOŞLUKLU, ESNEK, DOĞRUSAL",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "023700",
	  "UN_NO__1": "0237"
	},
	{
	  "BAKANLIK_KOD": "023800",
	  "UN_NO": "0238",
	  "ORİJİNAL İSİM": "ROKETLER, HALAT FIRLATICI",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "023800",
	  "UN_NO__1": "0238"
	},
	{
	  "BAKANLIK_KOD": "024000",
	  "UN_NO": "0240",
	  "ORİJİNAL İSİM": "ROKETLER, HALAT FIRLATICI",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "024000",
	  "UN_NO__1": "0240"
	},
	{
	  "BAKANLIK_KOD": "024100",
	  "UN_NO": "0241",
	  "ORİJİNAL İSİM": "PATLAYICI, TAHRİPLİ, TİP E",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "024100",
	  "UN_NO__1": "0241"
	},
	{
	  "BAKANLIK_KOD": "024200",
	  "UN_NO": "0242",
	  "ORİJİNAL İSİM": "MADDELERİ, SEVK, TOP İÇİN",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "024200",
	  "UN_NO__1": "0242"
	},
	{
	  "BAKANLIK_KOD": "024300",
	  "UN_NO": "0243",
	  "ORİJİNAL İSİM": "MÜHİMMAT, YANGIN ÇIKARTICI, BEYAZ FOSFORLU paralama hakkı, fırlatma yükü veya sevk maddesi olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2H",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "024300",
	  "UN_NO__1": "0243"
	},
	{
	  "BAKANLIK_KOD": "024400",
	  "UN_NO": "0244",
	  "ORİJİNAL İSİM": "MÜHİMMAT, YANGIN ÇIKARTICI, BEYAZ FOSFORLU paralama hakkı, fırlatma yükü veya sevk maddesi olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3H",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "024400",
	  "UN_NO__1": "0244"
	},
	{
	  "BAKANLIK_KOD": "024500",
	  "UN_NO": "0245",
	  "ORİJİNAL İSİM": "MÜHİMMAT, DUMANLI, BEYAZ FOSFORLU paralama hakkı, fırlatma yükü veya sevk maddesi olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2H",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "024500",
	  "UN_NO__1": "0245"
	},
	{
	  "BAKANLIK_KOD": "024600",
	  "UN_NO": "0246",
	  "ORİJİNAL İSİM": "MÜHİMMAT, DUMANLI, BEYAZ FOSFORLU paralama hakkı, fırlatma yükü veya sevk maddesi olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3H",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "024600",
	  "UN_NO__1": "0246"
	},
	{
	  "BAKANLIK_KOD": "024700",
	  "UN_NO": "0247",
	  "ORİJİNAL İSİM": "MÜHİMMAT, YANGIN ÇIKARTICI, sıvı veya jel, paralama hakkı, fırlatma yükü veya sevk maddesi olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3J",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "024700",
	  "UN_NO__1": "0247"
	},
	{
	  "BAKANLIK_KOD": "024800",
	  "UN_NO": "0248",
	  "ORİJİNAL İSİM": "TERTİBATLAR, SU İLE ETKİNLEŞEN paralama hakkı, fırlatma yükü veya sevk maddesi olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2L",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "024800",
	  "UN_NO__1": "0248"
	},
	{
	  "BAKANLIK_KOD": "024900",
	  "UN_NO": "0249",
	  "ORİJİNAL İSİM": "TERTİBATLAR, SU İLE ETKİNLEŞEN paralama\n hakkı, fırlatma yükü veya sevk maddesi olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3L",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "024900",
	  "UN_NO__1": "0249"
	},
	{
	  "BAKANLIK_KOD": "025000",
	  "UN_NO": "0250",
	  "ORİJİNAL İSİM": "ROKET MOTORLARI, HİPERGOLİK SIVI İÇEREN\n fırlatma yükü olan veya olmayan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3L",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "025000",
	  "UN_NO__1": "0250"
	},
	{
	  "BAKANLIK_KOD": "025400",
	  "UN_NO": "0254",
	  "ORİJİNAL İSİM": "MÜHİMMAT, AYDINLATICI paralama hakkı, fırlatma yükü veya sevk maddesi olan veya olmayan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "025400",
	  "UN_NO__1": "0254"
	},
	{
	  "BAKANLIK_KOD": "025500",
	  "UN_NO": "0255",
	  "ORİJİNAL İSİM": "KAPSÜLLER, ELEKTRİKLİ, patlatma için",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4B",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "025500",
	  "UN_NO__1": "0255"
	},
	{
	  "BAKANLIK_KOD": "025700",
	  "UN_NO": "0257",
	  "ORİJİNAL İSİM": "FÜNYELER, İNFİLAKLI",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4B",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "025700",
	  "UN_NO__1": "0257"
	},
	{
	  "BAKANLIK_KOD": "026600",
	  "UN_NO": "0266",
	  "ORİJİNAL İSİM": "OKTOLİT (OKTOL), kuru veya kütlece %15'ten az su ile ıslatılmış",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "026600",
	  "UN_NO__1": "0266"
	},
	{
	  "BAKANLIK_KOD": "026700",
	  "UN_NO": "0267",
	  "ORİJİNAL İSİM": "KAPSÜLLER, ELEKTRİKLİ OLMAYAN, patlatma için",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4B",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "026700",
	  "UN_NO__1": "0267"
	},
	{
	  "BAKANLIK_KOD": "026800",
	  "UN_NO": "0268",
	  "ORİJİNAL İSİM": "TUTUŞTURUCULAR, KAPSÜLLÜ",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2B",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "026800",
	  "UN_NO__1": "0268"
	},
	{
	  "BAKANLIK_KOD": "027100",
	  "UN_NO": "0271",
	  "ORİJİNAL İSİM": "MADDELERİ, SEVK",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "027100",
	  "UN_NO__1": "0271"
	},
	{
	  "BAKANLIK_KOD": "027200",
	  "UN_NO": "0272",
	  "ORİJİNAL İSİM": "MADDELERİ, SEVK",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "027200",
	  "UN_NO__1": "0272"
	},
	{
	  "BAKANLIK_KOD": "027500",
	  "UN_NO": "0275",
	  "ORİJİNAL İSİM": "KARTUŞLARI, GÜÇ ALETİ",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "027500",
	  "UN_NO__1": "0275"
	},
	{
	  "BAKANLIK_KOD": "027600",
	  "UN_NO": "0276",
	  "ORİJİNAL İSİM": "KARTUŞLARI, GÜÇ ALETİ",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "027600",
	  "UN_NO__1": "0276"
	},
	{
	  "BAKANLIK_KOD": "027700",
	  "UN_NO": "0277",
	  "ORİJİNAL İSİM": "KARTUŞLARI, PETROL KUYUSU",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "027700",
	  "UN_NO__1": "0277"
	},
	{
	  "BAKANLIK_KOD": "027800",
	  "UN_NO": "0278",
	  "ORİJİNAL İSİM": "KARTUŞLARI, PETROL KUYUSU",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "027800",
	  "UN_NO__1": "0278"
	},
	{
	  "BAKANLIK_KOD": "027900",
	  "UN_NO": "0279",
	  "ORİJİNAL İSİM": "MADDELERİ, SEVK, TOP İÇİN",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "027900",
	  "UN_NO__1": "0279"
	},
	{
	  "BAKANLIK_KOD": "028000",
	  "UN_NO": "0280",
	  "ORİJİNAL İSİM": "ROKET MOTORLARI",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "028000",
	  "UN_NO__1": "0280"
	},
	{
	  "BAKANLIK_KOD": "028100",
	  "UN_NO": "0281",
	  "ORİJİNAL İSİM": "ROKET MOTORLARI",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "028100",
	  "UN_NO__1": "0281"
	},
	{
	  "BAKANLIK_KOD": "028200",
	  "UN_NO": "0282",
	  "ORİJİNAL İSİM": "NİTROGUANİDİN (PİKRİT), ISLATILMIŞ kütlece %20'den daha az su ile veya kuru",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "028200",
	  "UN_NO__1": "0282"
	},
	{
	  "BAKANLIK_KOD": "028300",
	  "UN_NO": "0283",
	  "ORİJİNAL İSİM": "TUTUŞTURUCULAR kapsülsüz",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "028300",
	  "UN_NO__1": "0283"
	},
	{
	  "BAKANLIK_KOD": "028400",
	  "UN_NO": "0284",
	  "ORİJİNAL İSİM": "EL BOMBALARI, el veya tüfek, paralama hakkı olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "028400",
	  "UN_NO__1": "0284"
	},
	{
	  "BAKANLIK_KOD": "028500",
	  "UN_NO": "0285",
	  "ORİJİNAL İSİM": "EL BOMBALARI, el veya tüfek, paralama hakkı olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "028500",
	  "UN_NO__1": "0285"
	},
	{
	  "BAKANLIK_KOD": "028600",
	  "UN_NO": "0286",
	  "ORİJİNAL İSİM": "SAVAŞ BAŞLIKLARI, ROKET, paralama hakkı olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "028600",
	  "UN_NO__1": "0286"
	},
	{
	  "BAKANLIK_KOD": "028700",
	  "UN_NO": "0287",
	  "ORİJİNAL İSİM": "SAVAŞ BAŞLIKLARI, ROKET, paralama hakkı olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "028700",
	  "UN_NO__1": "0287"
	},
	{
	  "BAKANLIK_KOD": "028800",
	  "UN_NO": "0288",
	  "ORİJİNAL İSİM": "İMLA HAKLARI, BOŞLUKLU, ESNEK,\n DOĞRUSAL",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "028800",
	  "UN_NO__1": "0288"
	},
	{
	  "BAKANLIK_KOD": "028900",
	  "UN_NO": "0289",
	  "ORİJİNAL İSİM": "FİTİL, İNFİLAKLI, esnek",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "028900",
	  "UN_NO__1": "0289"
	},
	{
	  "BAKANLIK_KOD": "029000",
	  "UN_NO": "0290",
	  "ORİJİNAL İSİM": "FİTİL (TAPA), İNFİLAKLI, metal zırhlı",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "029000",
	  "UN_NO__1": "0290"
	},
	{
	  "BAKANLIK_KOD": "029100",
	  "UN_NO": "0291",
	  "ORİJİNAL İSİM": "BOMBALAR paralama hakkı olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "029100",
	  "UN_NO__1": "0291"
	},
	{
	  "BAKANLIK_KOD": "029200",
	  "UN_NO": "0292",
	  "ORİJİNAL İSİM": "EL BOMBALARI, el veya tüfek, paralama hakkı olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "029200",
	  "UN_NO__1": "0292"
	},
	{
	  "BAKANLIK_KOD": "029300",
	  "UN_NO": "0293",
	  "ORİJİNAL İSİM": "EL BOMBALARI, el veya tüfek, paralama hakkı olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "029300",
	  "UN_NO__1": "0293"
	},
	{
	  "BAKANLIK_KOD": "029400",
	  "UN_NO": "0294",
	  "ORİJİNAL İSİM": "MAYINLAR paralama hakkı olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "029400",
	  "UN_NO__1": "0294"
	},
	{
	  "BAKANLIK_KOD": "029500",
	  "UN_NO": "0295",
	  "ORİJİNAL İSİM": "ROKETLER paralama hakkı olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "029500",
	  "UN_NO__1": "0295"
	},
	{
	  "BAKANLIK_KOD": "029600",
	  "UN_NO": "0296",
	  "ORİJİNAL İSİM": "SONDAJ CİHAZLARI, PATLAYICI",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "029600",
	  "UN_NO__1": "0296"
	},
	{
	  "BAKANLIK_KOD": "029700",
	  "UN_NO": "0297",
	  "ORİJİNAL İSİM": "MÜHİMMAT, AYDINLATICI paralama hakkı, fırlatma yükü veya sevk maddesi olan veya olmayan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "029700",
	  "UN_NO__1": "0297"
	},
	{
	  "BAKANLIK_KOD": "029900",
	  "UN_NO": "0299",
	  "ORİJİNAL İSİM": "BOMBALAR, FOTO-FLAŞ",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "029900",
	  "UN_NO__1": "0299"
	},
	{
	  "BAKANLIK_KOD": "030000",
	  "UN_NO": "0300",
	  "ORİJİNAL İSİM": "MÜHİMMAT, YANGIN ÇIKARTICI paralama hakkı, fırlatma yükü veya sevk maddesi olan veya olmayan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "030000",
	  "UN_NO__1": "0300"
	},
	{
	  "BAKANLIK_KOD": "030100",
	  "UN_NO": "0301",
	  "ORİJİNAL İSİM": "MÜHİMMAT, GÖZ YAŞARTICI paralama hakkı, fırlatma yükü veya sevk maddesi olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "030100",
	  "UN_NO__1": "0301"
	},
	{
	  "BAKANLIK_KOD": "030301",
	  "UN_NO": "0303",
	  "ORİJİNAL İSİM": "MÜHİMMAT, DUMANLI paralama hakkı, fırlatma yükü veya sevk maddesi olan veya olmayan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "030301",
	  "UN_NO__1": "0303"
	},
	{
	  "BAKANLIK_KOD": "030302",
	  "UN_NO": "0303",
	  "ORİJİNAL İSİM": "MÜHİMMAT, DUMANLI paralama hakkı, fırlatma yükü veya sevk maddesi olan veya olmayan, aşındırıcı maddeler içeren",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "030302",
	  "UN_NO__1": "0303"
	},
	{
	  "BAKANLIK_KOD": "030303",
	  "UN_NO": "0303",
	  "ORİJİNAL İSİM": "MÜHİMMAT, DUMANLI paralama hakkı, fırlatma yükü veya sevk maddesi olan veya olmayan, soluma yoluyla zehirli maddeler içeren",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "030303",
	  "UN_NO__1": "0303"
	},
	{
	  "BAKANLIK_KOD": "030500",
	  "UN_NO": "0305",
	  "ORİJİNAL İSİM": "PARLAMA TOZU",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "030500",
	  "UN_NO__1": "0305"
	},
	{
	  "BAKANLIK_KOD": "030600",
	  "UN_NO": "0306",
	  "ORİJİNAL İSİM": "MÜHİMMAT İÇİN İZLİ MERMİLER",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "030600",
	  "UN_NO__1": "0306"
	},
	{
	  "BAKANLIK_KOD": "031200",
	  "UN_NO": "0312",
	  "ORİJİNAL İSİM": "FİŞEKLERİ, İŞARET",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "031200",
	  "UN_NO__1": "0312"
	},
	{
	  "BAKANLIK_KOD": "031300",
	  "UN_NO": "0313",
	  "ORİJİNAL İSİM": "İŞARETLERİ, DUMAN",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "031300",
	  "UN_NO__1": "0313"
	},
	{
	  "BAKANLIK_KOD": "031400",
	  "UN_NO": "0314",
	  "ORİJİNAL İSİM": "ATEŞLEYİCİLER",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "031400",
	  "UN_NO__1": "0314"
	},
	{
	  "BAKANLIK_KOD": "031500",
	  "UN_NO": "0315",
	  "ORİJİNAL İSİM": "ATEŞLEYİCİLER",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "031500",
	  "UN_NO__1": "0315"
	},
	{
	  "BAKANLIK_KOD": "031600",
	  "UN_NO": "0316",
	  "ORİJİNAL İSİM": "FÜNYELER, ATEŞLEMELİ",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "031600",
	  "UN_NO__1": "0316"
	},
	{
	  "BAKANLIK_KOD": "031700",
	  "UN_NO": "0317",
	  "ORİJİNAL İSİM": "FÜNYELER, ATEŞLEMELİ",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "031700",
	  "UN_NO__1": "0317"
	},
	{
	  "BAKANLIK_KOD": "031800",
	  "UN_NO": "0318",
	  "ORİJİNAL İSİM": "EL BOMBALARI, EĞİTİM, el veya tüfek ile",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "031800",
	  "UN_NO__1": "0318"
	},
	{
	  "BAKANLIK_KOD": "031900",
	  "UN_NO": "0319",
	  "ORİJİNAL İSİM": "KAPSÜLLER, BORU TİPİ",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "031900",
	  "UN_NO__1": "0319"
	},
	{
	  "BAKANLIK_KOD": "032000",
	  "UN_NO": "0320",
	  "ORİJİNAL İSİM": "KAPSÜLLER, BORU TİPİ",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "032000",
	  "UN_NO__1": "0320"
	},
	{
	  "BAKANLIK_KOD": "032100",
	  "UN_NO": "0321",
	  "ORİJİNAL İSİM": "KARTUŞLAR, SİLAHLAR İÇİN paralama hakkı olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2E",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "032100",
	  "UN_NO__1": "0321"
	},
	{
	  "BAKANLIK_KOD": "032200",
	  "UN_NO": "0322",
	  "ORİJİNAL İSİM": "ROKET MOTORLARI, HİPERGOLİK SIVI İÇEREN fırlatma yükü olan veya olmayan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2L",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "032200",
	  "UN_NO__1": "0322"
	},
	{
	  "BAKANLIK_KOD": "032300",
	  "UN_NO": "0323",
	  "ORİJİNAL İSİM": "KARTUŞLARI, GÜÇ ALETİ",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4S",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "032300",
	  "UN_NO__1": "0323"
	},
	{
	  "BAKANLIK_KOD": "032400",
	  "UN_NO": "0324",
	  "ORİJİNAL İSİM": "MERMİLER paralama hakkı olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "032400",
	  "UN_NO__1": "0324"
	},
	{
	  "BAKANLIK_KOD": "032500",
	  "UN_NO": "0325",
	  "ORİJİNAL İSİM": "ATEŞLEYİCİLER",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "032500",
	  "UN_NO__1": "0325"
	},
	{
	  "BAKANLIK_KOD": "032600",
	  "UN_NO": "0326",
	  "ORİJİNAL İSİM": "KARTUŞLAR, SİLAHLAR İÇİN, KURUSIKI",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "032600",
	  "UN_NO__1": "0326"
	},
	{
	  "BAKANLIK_KOD": "032700",
	  "UN_NO": "0327",
	  "ORİJİNAL İSİM": "KARTUŞLAR, SİLAHLAR İÇİN, KURUSIKI veya KARTUŞLAR, HAFİF SİLAHLAR İÇİN, KURUSIKI",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "032700",
	  "UN_NO__1": "0327"
	},
	{
	  "BAKANLIK_KOD": "032800",
	  "UN_NO": "0328",
	  "ORİJİNAL İSİM": "KARTUŞLAR, SİLAHLAR İÇİN, TESİRSİZ MERMİLİ",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "032800",
	  "UN_NO__1": "0328"
	},
	{
	  "BAKANLIK_KOD": "032900",
	  "UN_NO": "0329",
	  "ORİJİNAL İSİM": "TORPİDOLAR paralama hakkı olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1E",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "032900",
	  "UN_NO__1": "0329"
	},
	{
	  "BAKANLIK_KOD": "033000",
	  "UN_NO": "0330",
	  "ORİJİNAL İSİM": "TORPİDOLAR paralama hakkı olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "033000",
	  "UN_NO__1": "0330"
	},
	{
	  "BAKANLIK_KOD": "033100",
	  "UN_NO": "0331",
	  "ORİJİNAL İSİM": "PATLAYICI, TAHRİPLİ, TİP B (AJAN, TAHRİPLİ, TİP B)",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.5D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "033100",
	  "UN_NO__1": "0331"
	},
	{
	  "BAKANLIK_KOD": "033200",
	  "UN_NO": "0332",
	  "ORİJİNAL İSİM": "PATLAYICI, TAHRİPLİ, TİP E (AJAN, TAHRİPLİ, TİP E)",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.5D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "033200",
	  "UN_NO__1": "0332"
	},
	{
	  "BAKANLIK_KOD": "033300",
	  "UN_NO": "0333",
	  "ORİJİNAL İSİM": "HAVAİ FİŞEKLER",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "033300",
	  "UN_NO__1": "0333"
	},
	{
	  "BAKANLIK_KOD": "033400",
	  "UN_NO": "0334",
	  "ORİJİNAL İSİM": "HAVAİ FİŞEKLER",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "033400",
	  "UN_NO__1": "0334"
	},
	{
	  "BAKANLIK_KOD": "033500",
	  "UN_NO": "0335",
	  "ORİJİNAL İSİM": "HAVAİ FİŞEKLER",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "033500",
	  "UN_NO__1": "0335"
	},
	{
	  "BAKANLIK_KOD": "033600",
	  "UN_NO": "0336",
	  "ORİJİNAL İSİM": "HAVAİ FİŞEKLER",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "033600",
	  "UN_NO__1": "0336"
	},
	{
	  "BAKANLIK_KOD": "033700",
	  "UN_NO": "0337",
	  "ORİJİNAL İSİM": "HAVAİ FİŞEKLER",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4S",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "033700",
	  "UN_NO__1": "0337"
	},
	{
	  "BAKANLIK_KOD": "033800",
	  "UN_NO": "0338",
	  "ORİJİNAL İSİM": "KARTUŞLAR, SİLAHLAR İÇİN, KURUSIKI veya KARTUŞLAR, HAFİF SİLAHLAR İÇİN, KURUSIKI",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "033800",
	  "UN_NO__1": "0338"
	},
	{
	  "BAKANLIK_KOD": "033900",
	  "UN_NO": "0339",
	  "ORİJİNAL İSİM": "KARTUŞLAR, SİLAHLAR İÇİN, TESİRSİZ MERMİLİ veya KARTUŞLAR, HAFİF SİLAHLAR İÇİN",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "033900",
	  "UN_NO__1": "0339"
	},
	{
	  "BAKANLIK_KOD": "034000",
	  "UN_NO": "0340",
	  "ORİJİNAL İSİM": "NİTROSELÜLOZ, kütlece %25'ten az su (veya alkol) ile ıslatılmış veya kuru",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "034000",
	  "UN_NO__1": "0340"
	},
	{
	  "BAKANLIK_KOD": "034100",
	  "UN_NO": "0341",
	  "ORİJİNAL İSİM": "NİTROSELÜLOZ, değiştirilmemiş veya kütlece %18'den az olmak üzere plastikleştirici madde ile plastikleştirilmiş",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "034100",
	  "UN_NO__1": "0341"
	},
	{
	  "BAKANLIK_KOD": "034200",
	  "UN_NO": "0342",
	  "ORİJİNAL İSİM": "NİTROSELÜLOZ, ISLATILMIŞ kütlece %25'ten az olmayan alkol ile",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "034200",
	  "UN_NO__1": "0342"
	},
	{
	  "BAKANLIK_KOD": "034300",
	  "UN_NO": "0343",
	  "ORİJİNAL İSİM": "NİTROSELÜLOZ, PLASTİKLEŞTİRİLMİŞ kütlece %18'den az olmak üzere plastikleştirici madde ile",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "034300",
	  "UN_NO__1": "0343"
	},
	{
	  "BAKANLIK_KOD": "034400",
	  "UN_NO": "0344",
	  "ORİJİNAL İSİM": "MERMİLER paralama hakkı olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "034400",
	  "UN_NO__1": "0344"
	},
	{
	  "BAKANLIK_KOD": "034500",
	  "UN_NO": "0345",
	  "ORİJİNAL İSİM": "MERMİLER, tesirsiz, izli",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4S",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "034500",
	  "UN_NO__1": "0345"
	},
	{
	  "BAKANLIK_KOD": "034600",
	  "UN_NO": "0346",
	  "ORİJİNAL İSİM": "MERMİLER paralama hakkı veya fırlatma yükü olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "034600",
	  "UN_NO__1": "0346"
	},
	{
	  "BAKANLIK_KOD": "034700",
	  "UN_NO": "0347",
	  "ORİJİNAL İSİM": "MERMİLER paralama hakkı veya fırlatma yükü olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "034700",
	  "UN_NO__1": "0347"
	},
	{
	  "BAKANLIK_KOD": "034800",
	  "UN_NO": "0348",
	  "ORİJİNAL İSİM": "KARTUŞLAR, SİLAHLAR İÇİN paralama hakkı olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "034800",
	  "UN_NO__1": "0348"
	},
	{
	  "BAKANLIK_KOD": "034900",
	  "UN_NO": "0349",
	  "ORİJİNAL İSİM": "NESNELER, PATLAYICI, B.B.B.",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4S",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "034900",
	  "UN_NO__1": "0349"
	},
	{
	  "BAKANLIK_KOD": "035000",
	  "UN_NO": "0350",
	  "ORİJİNAL İSİM": "NESNELER, PATLAYICI, B.B.B.",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4B",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "035000",
	  "UN_NO__1": "0350"
	},
	{
	  "BAKANLIK_KOD": "035100",
	  "UN_NO": "0351",
	  "ORİJİNAL İSİM": "NESNELER, PATLAYICI, B.B.B.",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "035100",
	  "UN_NO__1": "0351"
	},
	{
	  "BAKANLIK_KOD": "035200",
	  "UN_NO": "0352",
	  "ORİJİNAL İSİM": "NESNELER, PATLAYICI, B.B.B.",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "035200",
	  "UN_NO__1": "0352"
	},
	{
	  "BAKANLIK_KOD": "035300",
	  "UN_NO": "0353",
	  "ORİJİNAL İSİM": "NESNELER, PATLAYICI, B.B.B.",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "035300",
	  "UN_NO__1": "0353"
	},
	{
	  "BAKANLIK_KOD": "035400",
	  "UN_NO": "0354",
	  "ORİJİNAL İSİM": "NESNELER, PATLAYICI, B.B.B.",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1L",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "035400",
	  "UN_NO__1": "0354"
	},
	{
	  "BAKANLIK_KOD": "035500",
	  "UN_NO": "0355",
	  "ORİJİNAL İSİM": "NESNELER, PATLAYICI, B.B.B.",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2L",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "035500",
	  "UN_NO__1": "0355"
	},
	{
	  "BAKANLIK_KOD": "035600",
	  "UN_NO": "0356",
	  "ORİJİNAL İSİM": "NESNELER, PATLAYICI, B.B.B.",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3L",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "035600",
	  "UN_NO__1": "0356"
	},
	{
	  "BAKANLIK_KOD": "035700",
	  "UN_NO": "0357",
	  "ORİJİNAL İSİM": "MADDELER, PATLAYICI, B.B.B.",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1L",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "035700",
	  "UN_NO__1": "0357"
	},
	{
	  "BAKANLIK_KOD": "035800",
	  "UN_NO": "0358",
	  "ORİJİNAL İSİM": "MADDELER, PATLAYICI, B.B.B.",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2L",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "035800",
	  "UN_NO__1": "0358"
	},
	{
	  "BAKANLIK_KOD": "035900",
	  "UN_NO": "0359",
	  "ORİJİNAL İSİM": "MADDELER, PATLAYICI, B.B.B.",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3L",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "035900",
	  "UN_NO__1": "0359"
	},
	{
	  "BAKANLIK_KOD": "036000",
	  "UN_NO": "0360",
	  "ORİJİNAL İSİM": "KAPSÜL DÜZENEKLERİ, ELEKTRİKLİ OLMAYAN, patlatma için",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1B",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "036000",
	  "UN_NO__1": "0360"
	},
	{
	  "BAKANLIK_KOD": "036100",
	  "UN_NO": "0361",
	  "ORİJİNAL İSİM": "KAPSÜL DÜZENEKLERİ, ELEKTRİKLİ OLMAYAN, patlatma için",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4B",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "036100",
	  "UN_NO__1": "0361"
	},
	{
	  "BAKANLIK_KOD": "036200",
	  "UN_NO": "0362",
	  "ORİJİNAL İSİM": "MÜHİMMATI, EĞİTİM",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "036200",
	  "UN_NO__1": "0362"
	},
	{
	  "BAKANLIK_KOD": "036300",
	  "UN_NO": "0363",
	  "ORİJİNAL İSİM": "MÜHİMMATI, DENEME ATIŞI",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "036300",
	  "UN_NO__1": "0363"
	},
	{
	  "BAKANLIK_KOD": "036400",
	  "UN_NO": "0364",
	  "ORİJİNAL İSİM": "KAPSÜLLER, MÜHİMMAT İÇİN",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2B",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "036400",
	  "UN_NO__1": "0364"
	},
	{
	  "BAKANLIK_KOD": "036500",
	  "UN_NO": "0365",
	  "ORİJİNAL İSİM": "KAPSÜLLER, MÜHİMMAT İÇİN",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4B",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "036500",
	  "UN_NO__1": "0365"
	},
	{
	  "BAKANLIK_KOD": "036600",
	  "UN_NO": "0366",
	  "ORİJİNAL İSİM": "KAPSÜLLER, MÜHİMMAT İÇİN",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4S",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "036600",
	  "UN_NO__1": "0366"
	},
	{
	  "BAKANLIK_KOD": "036700",
	  "UN_NO": "0367",
	  "ORİJİNAL İSİM": "FÜNYELER, İNFİLAKLI",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4S",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "036700",
	  "UN_NO__1": "0367"
	},
	{
	  "BAKANLIK_KOD": "036800",
	  "UN_NO": "0368",
	  "ORİJİNAL İSİM": "FÜNYELER, ATEŞLEMELİ",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4S",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "036800",
	  "UN_NO__1": "0368"
	},
	{
	  "BAKANLIK_KOD": "036900",
	  "UN_NO": "0369",
	  "ORİJİNAL İSİM": "SAVAŞ BAŞLIKLARI, ROKET, paralama hakkı olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "036900",
	  "UN_NO__1": "0369"
	},
	{
	  "BAKANLIK_KOD": "037000",
	  "UN_NO": "0370",
	  "ORİJİNAL İSİM": "SAVAŞ BAŞLIKLARI, ROKET, paralama hakkı veya fırlatma yükü olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "037000",
	  "UN_NO__1": "0370"
	},
	{
	  "BAKANLIK_KOD": "037100",
	  "UN_NO": "0371",
	  "ORİJİNAL İSİM": "SAVAŞ BAŞLIKLARI, ROKET, paralama hakkı veya fırlatma yükü olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "037100",
	  "UN_NO__1": "0371"
	},
	{
	  "BAKANLIK_KOD": "037200",
	  "UN_NO": "0372",
	  "ORİJİNAL İSİM": "EL BOMBALARI, EĞİTİM, el veya tüfek ile",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "037200",
	  "UN_NO__1": "0372"
	},
	{
	  "BAKANLIK_KOD": "037300",
	  "UN_NO": "0373",
	  "ORİJİNAL İSİM": "İŞARET ALETLERİ, EL",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4S",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "037300",
	  "UN_NO__1": "0373"
	},
	{
	  "BAKANLIK_KOD": "037400",
	  "UN_NO": "0374",
	  "ORİJİNAL İSİM": "SONDAJ CİHAZLARI, PATLAYICI",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "037400",
	  "UN_NO__1": "0374"
	},
	{
	  "BAKANLIK_KOD": "037500",
	  "UN_NO": "0375",
	  "ORİJİNAL İSİM": "SONDAJ CİHAZLARI, PATLAYICI",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "037500",
	  "UN_NO__1": "0375"
	},
	{
	  "BAKANLIK_KOD": "037600",
	  "UN_NO": "0376",
	  "ORİJİNAL İSİM": "KAPSÜLLER, BORU TİPİ",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4S",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "037600",
	  "UN_NO__1": "0376"
	},
	{
	  "BAKANLIK_KOD": "037700",
	  "UN_NO": "0377",
	  "ORİJİNAL İSİM": "KAPSÜLLER, BAŞLIK TİPİ",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1B",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "037700",
	  "UN_NO__1": "0377"
	},
	{
	  "BAKANLIK_KOD": "037800",
	  "UN_NO": "0378",
	  "ORİJİNAL İSİM": "KAPSÜLLER, BAŞLIK TİPİ",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4B",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "037800",
	  "UN_NO__1": "0378"
	},
	{
	  "BAKANLIK_KOD": "037900",
	  "UN_NO": "0379",
	  "ORİJİNAL İSİM": "KOVANLAR, KARTUŞ, BOŞ, KAPSÜLLÜ",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "037900",
	  "UN_NO__1": "0379"
	},
	{
	  "BAKANLIK_KOD": "038000",
	  "UN_NO": "0380",
	  "ORİJİNAL İSİM": "NESNELER, PİROFORİK",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2L",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "038000",
	  "UN_NO__1": "0380"
	},
	{
	  "BAKANLIK_KOD": "038100",
	  "UN_NO": "0381",
	  "ORİJİNAL İSİM": "KARTUŞLARI, GÜÇ ALETİ",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "038100",
	  "UN_NO__1": "0381"
	},
	{
	  "BAKANLIK_KOD": "038200",
	  "UN_NO": "0382",
	  "ORİJİNAL İSİM": "BİLEŞENLERİ, PATLAYICI ZİNCİRİ, B.B.B.",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2B",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "038200",
	  "UN_NO__1": "0382"
	},
	{
	  "BAKANLIK_KOD": "038300",
	  "UN_NO": "0383",
	  "ORİJİNAL İSİM": "BİLEŞENLERİ, PATLAYICI ZİNCİRİ, B.B.B.",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4B",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "038300",
	  "UN_NO__1": "0383"
	},
	{
	  "BAKANLIK_KOD": "038400",
	  "UN_NO": "0384",
	  "ORİJİNAL İSİM": "BİLEŞENLERİ, PATLAYICI ZİNCİRİ, B.B.B.",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4S",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "038400",
	  "UN_NO__1": "0384"
	},
	{
	  "BAKANLIK_KOD": "038500",
	  "UN_NO": "0385",
	  "ORİJİNAL İSİM": "5-NİTROBENZOTRİAZOL",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "038500",
	  "UN_NO__1": "0385"
	},
	{
	  "BAKANLIK_KOD": "038600",
	  "UN_NO": "0386",
	  "ORİJİNAL İSİM": "TRİNİTROBENZEN-SÜLFONİK ASİT",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "038600",
	  "UN_NO__1": "0386"
	},
	{
	  "BAKANLIK_KOD": "038700",
	  "UN_NO": "0387",
	  "ORİJİNAL İSİM": "TRİNİTROFLORENON",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "038700",
	  "UN_NO__1": "0387"
	},
	{
	  "BAKANLIK_KOD": "038800",
	  "UN_NO": "0388",
	  "ORİJİNAL İSİM": "TRİNİTROTOLUEN (TNT) VE TRİNİTROBENZEN KARIŞIMI veya TRİNİTROTOLUEN (TNT) VE HEKZANİTROSTİLBEN KARIŞIMI",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "038800",
	  "UN_NO__1": "0388"
	},
	{
	  "BAKANLIK_KOD": "038900",
	  "UN_NO": "0389",
	  "ORİJİNAL İSİM": "TRİNİTROTOLUEN (TNT) KARIŞIMI TRİNİTROBENZEN VE HEKZANİTROSTİLBEN İÇEREN",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "038900",
	  "UN_NO__1": "0389"
	},
	{
	  "BAKANLIK_KOD": "039000",
	  "UN_NO": "0390",
	  "ORİJİNAL İSİM": "TRİTONAL",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "039000",
	  "UN_NO__1": "0390"
	},
	{
	  "BAKANLIK_KOD": "039100",
	  "UN_NO": "0391",
	  "ORİJİNAL İSİM": "SİKLOTRİMETİLEN-TRİNİTRAMİN (SİKLONİT; HEKSOJEN; RDX) VE SİKLOTETRAMETİLEN- TETRANİTRAMİN (HMX; OKTOJEN) KARIŞIM, kütlece %15'ten az olmayan su ile ISLATILMIŞ veya %10'dan az olmayan flegmatizör ile DUYARLILIĞI AZALTILMIŞ",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "039100",
	  "UN_NO__1": "0391"
	},
	{
	  "BAKANLIK_KOD": "039200",
	  "UN_NO": "0392",
	  "ORİJİNAL İSİM": "HEKZANİTROSTİLBEN",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "039200",
	  "UN_NO__1": "0392"
	},
	{
	  "BAKANLIK_KOD": "039300",
	  "UN_NO": "0393",
	  "ORİJİNAL İSİM": "HEKZOTONAL",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "039300",
	  "UN_NO__1": "0393"
	},
	{
	  "BAKANLIK_KOD": "039400",
	  "UN_NO": "0394",
	  "ORİJİNAL İSİM": "TRİNİTRORESORSİNOL (STİFNİK ASİT) ISLATILMIŞ kütlece %20'den az olmayan su veya su alkol karışımı ile",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "039400",
	  "UN_NO__1": "0394"
	},
	{
	  "BAKANLIK_KOD": "039500",
	  "UN_NO": "0395",
	  "ORİJİNAL İSİM": "ROKET MOTORLARI, SIVI YAKITLI",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2J",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "039500",
	  "UN_NO__1": "0395"
	},
	{
	  "BAKANLIK_KOD": "039600",
	  "UN_NO": "0396",
	  "ORİJİNAL İSİM": "ROKET MOTORLARI, SIVI YAKITLI",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3J",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "039600",
	  "UN_NO__1": "0396"
	},
	{
	  "BAKANLIK_KOD": "039700",
	  "UN_NO": "0397",
	  "ORİJİNAL İSİM": "ROKETLER, SIVI YAKITLI paralama hakkı olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1J",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "039700",
	  "UN_NO__1": "0397"
	},
	{
	  "BAKANLIK_KOD": "039800",
	  "UN_NO": "0398",
	  "ORİJİNAL İSİM": "ROKETLER, SIVI YAKITLI paralama hakkı olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2J",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "039800",
	  "UN_NO__1": "0398"
	},
	{
	  "BAKANLIK_KOD": "039900",
	  "UN_NO": "0399",
	  "ORİJİNAL İSİM": "BOMBALAR, ALEVLENEBİLİR SIVISI OLAN paralama hakkı olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1J",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "039900",
	  "UN_NO__1": "0399"
	},
	{
	  "BAKANLIK_KOD": "040000",
	  "UN_NO": "0400",
	  "ORİJİNAL İSİM": "BOMBALAR, ALEVLENEBİLİR SIVISI OLAN paralama hakkı olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2J",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "040000",
	  "UN_NO__1": "0400"
	},
	{
	  "BAKANLIK_KOD": "040100",
	  "UN_NO": "0401",
	  "ORİJİNAL İSİM": "DİPİKRİL SÜLFİT, kütlece %10'dan az su ile ıslatılmış veya kuru",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "040100",
	  "UN_NO__1": "0401"
	},
	{
	  "BAKANLIK_KOD": "040200",
	  "UN_NO": "0402",
	  "ORİJİNAL İSİM": "AMONYUM PERKLORAT",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "040200",
	  "UN_NO__1": "0402"
	},
	{
	  "BAKANLIK_KOD": "040300",
	  "UN_NO": "0403",
	  "ORİJİNAL İSİM": "İŞARET FİŞEKLERİ, HAVAİ",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "040300",
	  "UN_NO__1": "0403"
	},
	{
	  "BAKANLIK_KOD": "040400",
	  "UN_NO": "0404",
	  "ORİJİNAL İSİM": "İŞARET FİŞEKLERİ, HAVAİ",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4S",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "040400",
	  "UN_NO__1": "0404"
	},
	{
	  "BAKANLIK_KOD": "040500",
	  "UN_NO": "0405",
	  "ORİJİNAL İSİM": "FİŞEKLERİ, İŞARET",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4S",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "040500",
	  "UN_NO__1": "0405"
	},
	{
	  "BAKANLIK_KOD": "040600",
	  "UN_NO": "0406",
	  "ORİJİNAL İSİM": "DİNİTROSOBENZEN",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "040600",
	  "UN_NO__1": "0406"
	},
	{
	  "BAKANLIK_KOD": "040700",
	  "UN_NO": "0407",
	  "ORİJİNAL İSİM": "TETRAZOL-1-ASETİK ASİT",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "040700",
	  "UN_NO__1": "0407"
	},
	{
	  "BAKANLIK_KOD": "040800",
	  "UN_NO": "0408",
	  "ORİJİNAL İSİM": "FÜNYELER, İNFİLAKLI, koruyucu özellikli",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "040800",
	  "UN_NO__1": "0408"
	},
	{
	  "BAKANLIK_KOD": "040900",
	  "UN_NO": "0409",
	  "ORİJİNAL İSİM": "FÜNYELER, İNFİLAKLI, koruyucu özellikli",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "040900",
	  "UN_NO__1": "0409"
	},
	{
	  "BAKANLIK_KOD": "041000",
	  "UN_NO": "0410",
	  "ORİJİNAL İSİM": "FÜNYELER, İNFİLAKLI, koruyucu özellikli",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "041000",
	  "UN_NO__1": "0410"
	},
	{
	  "BAKANLIK_KOD": "041100",
	  "UN_NO": "0411",
	  "ORİJİNAL İSİM": "PENTAERİTRİT TETRANİTRAT (PENTAERİTRİTOL TETRANİTRAT; PETN) kütlece %7'den az olmayan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "041100",
	  "UN_NO__1": "0411"
	},
	{
	  "BAKANLIK_KOD": "041200",
	  "UN_NO": "0412",
	  "ORİJİNAL İSİM": "KARTUŞLAR, SİLAHLAR İÇİN paralama hakkı olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4E",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "041200",
	  "UN_NO__1": "0412"
	},
	{
	  "BAKANLIK_KOD": "041300",
	  "UN_NO": "0413",
	  "ORİJİNAL İSİM": "KARTUŞLAR, SİLAHLAR İÇİN, KURUSIKI",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "041300",
	  "UN_NO__1": "0413"
	},
	{
	  "BAKANLIK_KOD": "041400",
	  "UN_NO": "0414",
	  "ORİJİNAL İSİM": "MADDELERİ, SEVK, TOP İÇİN",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "041400",
	  "UN_NO__1": "0414"
	},
	{
	  "BAKANLIK_KOD": "041500",
	  "UN_NO": "0415",
	  "ORİJİNAL İSİM": "MADDELERİ, SEVK",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "041500",
	  "UN_NO__1": "0415"
	},
	{
	  "BAKANLIK_KOD": "041700",
	  "UN_NO": "0417",
	  "ORİJİNAL İSİM": "KARTUŞLAR, SİLAHLAR İÇİN, TESİRSİZ MERMİLİ veya KARTUŞLAR, HAFİF SİLAHLAR İÇİN",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "041700",
	  "UN_NO__1": "0417"
	},
	{
	  "BAKANLIK_KOD": "041800",
	  "UN_NO": "0418",
	  "ORİJİNAL İSİM": "İŞARET FİŞEKLERİ, YÜZEY",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "041800",
	  "UN_NO__1": "0418"
	},
	{
	  "BAKANLIK_KOD": "041900",
	  "UN_NO": "0419",
	  "ORİJİNAL İSİM": "İŞARET FİŞEKLERİ, YÜZEY",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "041900",
	  "UN_NO__1": "0419"
	},
	{
	  "BAKANLIK_KOD": "042000",
	  "UN_NO": "0420",
	  "ORİJİNAL İSİM": "İŞARET FİŞEKLERİ, HAVAİ",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "042000",
	  "UN_NO__1": "0420"
	},
	{
	  "BAKANLIK_KOD": "042100",
	  "UN_NO": "0421",
	  "ORİJİNAL İSİM": "İŞARET FİŞEKLERİ, HAVAİ",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "042100",
	  "UN_NO__1": "0421"
	},
	{
	  "BAKANLIK_KOD": "042400",
	  "UN_NO": "0424",
	  "ORİJİNAL İSİM": "MERMİLER, tesirsiz, izli",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "042400",
	  "UN_NO__1": "0424"
	},
	{
	  "BAKANLIK_KOD": "042500",
	  "UN_NO": "0425",
	  "ORİJİNAL İSİM": "MERMİLER, tesirsiz, izli",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "042500",
	  "UN_NO__1": "0425"
	},
	{
	  "BAKANLIK_KOD": "042600",
	  "UN_NO": "0426",
	  "ORİJİNAL İSİM": "MERMİLER paralama hakkı veya fırlatma yükü olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "042600",
	  "UN_NO__1": "0426"
	},
	{
	  "BAKANLIK_KOD": "042700",
	  "UN_NO": "0427",
	  "ORİJİNAL İSİM": "MERMİLER paralama hakkı veya fırlatma yükü olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "042700",
	  "UN_NO__1": "0427"
	},
	{
	  "BAKANLIK_KOD": "042800",
	  "UN_NO": "0428",
	  "ORİJİNAL İSİM": "NESNELER, PİROTEKNİK teknik amaçlar için",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "042800",
	  "UN_NO__1": "0428"
	},
	{
	  "BAKANLIK_KOD": "042900",
	  "UN_NO": "0429",
	  "ORİJİNAL İSİM": "NESNELER, PİROTEKNİK teknik amaçlar için",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "042900",
	  "UN_NO__1": "0429"
	},
	{
	  "BAKANLIK_KOD": "043000",
	  "UN_NO": "0430",
	  "ORİJİNAL İSİM": "NESNELER, PİROTEKNİK teknik amaçlar için",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "043000",
	  "UN_NO__1": "0430"
	},
	{
	  "BAKANLIK_KOD": "043100",
	  "UN_NO": "0431",
	  "ORİJİNAL İSİM": "NESNELER, PİROTEKNİK teknik amaçlar için",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "043100",
	  "UN_NO__1": "0431"
	},
	{
	  "BAKANLIK_KOD": "043200",
	  "UN_NO": "0432",
	  "ORİJİNAL İSİM": "NESNELER, PİROTEKNİK teknik amaçlar için",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4S",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "043200",
	  "UN_NO__1": "0432"
	},
	{
	  "BAKANLIK_KOD": "043300",
	  "UN_NO": "0433",
	  "ORİJİNAL İSİM": "BARUT KALIBI (BARUT MACUNU), ISLATILMIŞ, kütlece %17'den daha az olmayan alkol ile",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "043300",
	  "UN_NO__1": "0433"
	},
	{
	  "BAKANLIK_KOD": "043400",
	  "UN_NO": "0434",
	  "ORİJİNAL İSİM": "MERMİLER paralama hakkı veya fırlatma yükü olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "043400",
	  "UN_NO__1": "0434"
	},
	{
	  "BAKANLIK_KOD": "043500",
	  "UN_NO": "0435",
	  "ORİJİNAL İSİM": "MERMİLER paralama hakkı veya fırlatma yükü olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "043500",
	  "UN_NO__1": "0435"
	},
	{
	  "BAKANLIK_KOD": "043600",
	  "UN_NO": "0436",
	  "ORİJİNAL İSİM": "ROKETLER fırlatma yükü olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "043600",
	  "UN_NO__1": "0436"
	},
	{
	  "BAKANLIK_KOD": "043700",
	  "UN_NO": "0437",
	  "ORİJİNAL İSİM": "ROKETLER fırlatma yükü olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "043700",
	  "UN_NO__1": "0437"
	},
	{
	  "BAKANLIK_KOD": "043800",
	  "UN_NO": "0438",
	  "ORİJİNAL İSİM": "ROKETLER fırlatma yükü olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "043800",
	  "UN_NO__1": "0438"
	},
	{
	  "BAKANLIK_KOD": "043900",
	  "UN_NO": "0439",
	  "ORİJİNAL İSİM": "İMLA HAKLARI, BOŞLUKLU, kapsülsüz",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "043900",
	  "UN_NO__1": "0439"
	},
	{
	  "BAKANLIK_KOD": "044000",
	  "UN_NO": "0440",
	  "ORİJİNAL İSİM": "İMLA HAKLARI, BOŞLUKLU, kapsülsüz",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "044000",
	  "UN_NO__1": "0440"
	},
	{
	  "BAKANLIK_KOD": "044100",
	  "UN_NO": "0441",
	  "ORİJİNAL İSİM": "İMLA HAKLARI, BOŞLUKLU, kapsülsüz",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4S",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "044100",
	  "UN_NO__1": "0441"
	},
	{
	  "BAKANLIK_KOD": "044200",
	  "UN_NO": "0442",
	  "ORİJİNAL İSİM": "İMLA HAKLARI, İNFİLAK, TİCARİ kapsülsüz",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "044200",
	  "UN_NO__1": "0442"
	},
	{
	  "BAKANLIK_KOD": "044300",
	  "UN_NO": "0443",
	  "ORİJİNAL İSİM": "İMLA HAKLARI, İNFİLAK, TİCARİ kapsülsüz",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "044300",
	  "UN_NO__1": "0443"
	},
	{
	  "BAKANLIK_KOD": "044400",
	  "UN_NO": "0444",
	  "ORİJİNAL İSİM": "İMLA HAKLARI, İNFİLAK, TİCARİ kapsülsüz",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "044400",
	  "UN_NO__1": "0444"
	},
	{
	  "BAKANLIK_KOD": "044500",
	  "UN_NO": "0445",
	  "ORİJİNAL İSİM": "İMLA HAKLARI, İNFİLAK, TİCARİ kapsülsüz",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4S",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "044500",
	  "UN_NO__1": "0445"
	},
	{
	  "BAKANLIK_KOD": "044600",
	  "UN_NO": "0446",
	  "ORİJİNAL İSİM": "KOVANLAR, YANICI, BOŞ, KAPSÜLSÜZ",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "044600",
	  "UN_NO__1": "0446"
	},
	{
	  "BAKANLIK_KOD": "044700",
	  "UN_NO": "0447",
	  "ORİJİNAL İSİM": "KOVANLAR, YANICI, BOŞ, KAPSÜLSÜZ",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "044700",
	  "UN_NO__1": "0447"
	},
	{
	  "BAKANLIK_KOD": "044800",
	  "UN_NO": "0448",
	  "ORİJİNAL İSİM": "5-MERKAPTOTETRAZOL-1-ASETİK ASİT",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "044800",
	  "UN_NO__1": "0448"
	},
	{
	  "BAKANLIK_KOD": "044900",
	  "UN_NO": "0449",
	  "ORİJİNAL İSİM": "TORPİDOLAR, SIVI YAKITLI, paralama hakkı olan veya olmayan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1J",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "044900",
	  "UN_NO__1": "0449"
	},
	{
	  "BAKANLIK_KOD": "045000",
	  "UN_NO": "0450",
	  "ORİJİNAL İSİM": "TORPİDOLAR, SIVI YAKITLI, tesirsiz başlığı olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3J",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "045000",
	  "UN_NO__1": "0450"
	},
	{
	  "BAKANLIK_KOD": "045100",
	  "UN_NO": "0451",
	  "ORİJİNAL İSİM": "TORPİDOLAR paralama hakkı olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "045100",
	  "UN_NO__1": "0451"
	},
	{
	  "BAKANLIK_KOD": "045200",
	  "UN_NO": "0452",
	  "ORİJİNAL İSİM": "EL BOMBALARI, EĞİTİM, el veya tüfek ile",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "045200",
	  "UN_NO__1": "0452"
	},
	{
	  "BAKANLIK_KOD": "045300",
	  "UN_NO": "0453",
	  "ORİJİNAL İSİM": "ROKETLER, HALAT FIRLATICI",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "045300",
	  "UN_NO__1": "0453"
	},
	{
	  "BAKANLIK_KOD": "045400",
	  "UN_NO": "0454",
	  "ORİJİNAL İSİM": "ATEŞLEYİCİLER",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4S",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "045400",
	  "UN_NO__1": "0454"
	},
	{
	  "BAKANLIK_KOD": "045500",
	  "UN_NO": "0455",
	  "ORİJİNAL İSİM": "KAPSÜLLER, ELEKTRİKLİ OLMAYAN, patlatma için",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4S",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "045500",
	  "UN_NO__1": "0455"
	},
	{
	  "BAKANLIK_KOD": "045600",
	  "UN_NO": "0456",
	  "ORİJİNAL İSİM": "KAPSÜLLER, ELEKTRİKLİ, patlatma için",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4S",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "045600",
	  "UN_NO__1": "0456"
	},
	{
	  "BAKANLIK_KOD": "045700",
	  "UN_NO": "0457",
	  "ORİJİNAL İSİM": "HAKLARI, PARALAMA, PLASTİK BAĞLI",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "045700",
	  "UN_NO__1": "0457"
	},
	{
	  "BAKANLIK_KOD": "045800",
	  "UN_NO": "0458",
	  "ORİJİNAL İSİM": "HAKLARI, PARALAMA, PLASTİK BAĞLI",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "045800",
	  "UN_NO__1": "0458"
	},
	{
	  "BAKANLIK_KOD": "045900",
	  "UN_NO": "0459",
	  "ORİJİNAL İSİM": "HAKLARI, PARALAMA, PLASTİK BAĞLI",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "045900",
	  "UN_NO__1": "0459"
	},
	{
	  "BAKANLIK_KOD": "046000",
	  "UN_NO": "0460",
	  "ORİJİNAL İSİM": "HAKLARI, PARALAMA, PLASTİK BAĞLI",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4S",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "046000",
	  "UN_NO__1": "0460"
	},
	{
	  "BAKANLIK_KOD": "046100",
	  "UN_NO": "0461",
	  "ORİJİNAL İSİM": "BİLEŞENLERİ, PATLAYICI ZİNCİRİ, B.B.B.",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1B",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "046100",
	  "UN_NO__1": "0461"
	},
	{
	  "BAKANLIK_KOD": "046200",
	  "UN_NO": "0462",
	  "ORİJİNAL İSİM": "NESNELER, PATLAYICI, B.B.B.",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "046200",
	  "UN_NO__1": "0462"
	},
	{
	  "BAKANLIK_KOD": "046300",
	  "UN_NO": "0463",
	  "ORİJİNAL İSİM": "NESNELER, PATLAYICI, B.B.B.",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "046300",
	  "UN_NO__1": "0463"
	},
	{
	  "BAKANLIK_KOD": "046400",
	  "UN_NO": "0464",
	  "ORİJİNAL İSİM": "NESNELER, PATLAYICI, B.B.B.",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1E",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "046400",
	  "UN_NO__1": "0464"
	},
	{
	  "BAKANLIK_KOD": "046500",
	  "UN_NO": "0465",
	  "ORİJİNAL İSİM": "NESNELER, PATLAYICI, B.B.B.",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "046500",
	  "UN_NO__1": "0465"
	},
	{
	  "BAKANLIK_KOD": "046600",
	  "UN_NO": "0466",
	  "ORİJİNAL İSİM": "NESNELER, PATLAYICI, B.B.B.",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "046600",
	  "UN_NO__1": "0466"
	},
	{
	  "BAKANLIK_KOD": "046700",
	  "UN_NO": "0467",
	  "ORİJİNAL İSİM": "NESNELER, PATLAYICI, B.B.B.",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "046700",
	  "UN_NO__1": "0467"
	},
	{
	  "BAKANLIK_KOD": "046800",
	  "UN_NO": "0468",
	  "ORİJİNAL İSİM": "NESNELER, PATLAYICI, B.B.B.",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2E",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "046800",
	  "UN_NO__1": "0468"
	},
	{
	  "BAKANLIK_KOD": "046900",
	  "UN_NO": "0469",
	  "ORİJİNAL İSİM": "NESNELER, PATLAYICI, B.B.B.",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "046900",
	  "UN_NO__1": "0469"
	},
	{
	  "BAKANLIK_KOD": "047000",
	  "UN_NO": "0470",
	  "ORİJİNAL İSİM": "NESNELER, PATLAYICI, B.B.B.",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "047000",
	  "UN_NO__1": "0470"
	},
	{
	  "BAKANLIK_KOD": "047100",
	  "UN_NO": "0471",
	  "ORİJİNAL İSİM": "NESNELER, PATLAYICI, B.B.B.",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4E",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "047100",
	  "UN_NO__1": "0471"
	},
	{
	  "BAKANLIK_KOD": "047200",
	  "UN_NO": "0472",
	  "ORİJİNAL İSİM": "NESNELER, PATLAYICI, B.B.B.",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "047200",
	  "UN_NO__1": "0472"
	},
	{
	  "BAKANLIK_KOD": "047300",
	  "UN_NO": "0473",
	  "ORİJİNAL İSİM": "MADDELER, PATLAYICI, B.B.B.",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "047300",
	  "UN_NO__1": "0473"
	},
	{
	  "BAKANLIK_KOD": "047400",
	  "UN_NO": "0474",
	  "ORİJİNAL İSİM": "MADDELER, PATLAYICI, B.B.B.",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "047400",
	  "UN_NO__1": "0474"
	},
	{
	  "BAKANLIK_KOD": "047500",
	  "UN_NO": "0475",
	  "ORİJİNAL İSİM": "MADDELER, PATLAYICI, B.B.B.",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "047500",
	  "UN_NO__1": "0475"
	},
	{
	  "BAKANLIK_KOD": "047600",
	  "UN_NO": "0476",
	  "ORİJİNAL İSİM": "MADDELER, PATLAYICI, B.B.B.",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "047600",
	  "UN_NO__1": "0476"
	},
	{
	  "BAKANLIK_KOD": "047700",
	  "UN_NO": "0477",
	  "ORİJİNAL İSİM": "MADDELER, PATLAYICI, B.B.B.",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "047700",
	  "UN_NO__1": "0477"
	},
	{
	  "BAKANLIK_KOD": "047800",
	  "UN_NO": "0478",
	  "ORİJİNAL İSİM": "MADDELER, PATLAYICI, B.B.B.",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "047800",
	  "UN_NO__1": "0478"
	},
	{
	  "BAKANLIK_KOD": "047900",
	  "UN_NO": "0479",
	  "ORİJİNAL İSİM": "MADDELER, PATLAYICI, B.B.B.",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "047900",
	  "UN_NO__1": "0479"
	},
	{
	  "BAKANLIK_KOD": "048000",
	  "UN_NO": "0480",
	  "ORİJİNAL İSİM": "MADDELER, PATLAYICI, B.B.B.",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "048000",
	  "UN_NO__1": "0480"
	},
	{
	  "BAKANLIK_KOD": "048100",
	  "UN_NO": "0481",
	  "ORİJİNAL İSİM": "MADDELER, PATLAYICI, B.B.B.",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4S",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "048100",
	  "UN_NO__1": "0481"
	},
	{
	  "BAKANLIK_KOD": "048200",
	  "UN_NO": "0482",
	  "ORİJİNAL İSİM": "MADDELER, PATLAYICI, ÇOK DUYARSIZ (MADDELER, EVI), B.B.B.",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.5D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "048200",
	  "UN_NO__1": "0482"
	},
	{
	  "BAKANLIK_KOD": "048300",
	  "UN_NO": "0483",
	  "ORİJİNAL İSİM": "SİKLOTRİMETİLEN-TRİNİTRAMİN (SİKLONİT; HEKSOJEN; RDX), DUYARLILIĞI AZALTILMIŞ",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "048300",
	  "UN_NO__1": "0483"
	},
	{
	  "BAKANLIK_KOD": "048400",
	  "UN_NO": "0484",
	  "ORİJİNAL İSİM": "SİKLOTETRAMETİLEN-TETRA-\n NİTRAMİN (HMX; OKTOJEN), DUYARLILIĞI AZALTILMIŞ",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "048400",
	  "UN_NO__1": "0484"
	},
	{
	  "BAKANLIK_KOD": "048500",
	  "UN_NO": "0485",
	  "ORİJİNAL İSİM": "MADDELER, PATLAYICI, B.B.B.",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "048500",
	  "UN_NO__1": "0485"
	},
	{
	  "BAKANLIK_KOD": "048600",
	  "UN_NO": "0486",
	  "ORİJİNAL İSİM": "NESNELER, PATLAYICI, AŞIRI\n DUYARSIZ (NESNELER, EEI)",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.6N",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "048600",
	  "UN_NO__1": "0486"
	},
	{
	  "BAKANLIK_KOD": "048700",
	  "UN_NO": "0487",
	  "ORİJİNAL İSİM": "İŞARETLERİ, DUMAN",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "048700",
	  "UN_NO__1": "0487"
	},
	{
	  "BAKANLIK_KOD": "048800",
	  "UN_NO": "0488",
	  "ORİJİNAL İSİM": "MÜHİMMATI, EĞİTİM",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "048800",
	  "UN_NO__1": "0488"
	},
	{
	  "BAKANLIK_KOD": "048900",
	  "UN_NO": "0489",
	  "ORİJİNAL İSİM": "DİNİTROGLİKOLURİL (DINGU)",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "048900",
	  "UN_NO__1": "0489"
	},
	{
	  "BAKANLIK_KOD": "049000",
	  "UN_NO": "0490",
	  "ORİJİNAL İSİM": "NİTROTRİAZOLON (NTO)",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "049000",
	  "UN_NO__1": "0490"
	},
	{
	  "BAKANLIK_KOD": "049100",
	  "UN_NO": "0491",
	  "ORİJİNAL İSİM": "MADDELERİ, SEVK",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "049100",
	  "UN_NO__1": "0491"
	},
	{
	  "BAKANLIK_KOD": "049200",
	  "UN_NO": "0492",
	  "ORİJİNAL İSİM": "İŞARETLERİ, DEMİRYOLU, PATLAYICI",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "049200",
	  "UN_NO__1": "0492"
	},
	{
	  "BAKANLIK_KOD": "049300",
	  "UN_NO": "0493",
	  "ORİJİNAL İSİM": "İŞARETLERİ, DEMİRYOLU, PATLAYICI",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "049300",
	  "UN_NO__1": "0493"
	},
	{
	  "BAKANLIK_KOD": "049400",
	  "UN_NO": "0494",
	  "ORİJİNAL İSİM": "JET DELİCİ SİLAHLAR, YÜKLÜ, petrol kuyusu, kapsülsüz",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "049400",
	  "UN_NO__1": "0494"
	},
	{
	  "BAKANLIK_KOD": "049500",
	  "UN_NO": "0495",
	  "ORİJİNAL İSİM": "SEVK YAKITI, SIVI",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "049500",
	  "UN_NO__1": "0495"
	},
	{
	  "BAKANLIK_KOD": "049600",
	  "UN_NO": "0496",
	  "ORİJİNAL İSİM": "OKTONAL",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "049600",
	  "UN_NO__1": "0496"
	},
	{
	  "BAKANLIK_KOD": "049700",
	  "UN_NO": "0497",
	  "ORİJİNAL İSİM": "SEVK YAKITI, SIVI",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "049700",
	  "UN_NO__1": "0497"
	},
	{
	  "BAKANLIK_KOD": "049800",
	  "UN_NO": "0498",
	  "ORİJİNAL İSİM": "SEVK YAKITI, KATI",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "049800",
	  "UN_NO__1": "0498"
	},
	{
	  "BAKANLIK_KOD": "049900",
	  "UN_NO": "0499",
	  "ORİJİNAL İSİM": "SEVK YAKITI, KATI",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "049900",
	  "UN_NO__1": "0499"
	},
	{
	  "BAKANLIK_KOD": "050000",
	  "UN_NO": "0500",
	  "ORİJİNAL İSİM": "KAPSÜL DÜZENEKLERİ, ELEKTRİKLİ OLMAYAN, patlatma için",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4S",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "050000",
	  "UN_NO__1": "0500"
	},
	{
	  "BAKANLIK_KOD": "050100",
	  "UN_NO": "0501",
	  "ORİJİNAL İSİM": "SEVK YAKITI, KATI",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "050100",
	  "UN_NO__1": "0501"
	},
	{
	  "BAKANLIK_KOD": "050200",
	  "UN_NO": "0502",
	  "ORİJİNAL İSİM": "ROKETLER tesirsiz başlığı olan",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.2C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "050200",
	  "UN_NO__1": "0502"
	},
	{
	  "BAKANLIK_KOD": "050300",
	  "UN_NO": "0503",
	  "ORİJİNAL İSİM": "GÜVENLİK CİHAZLARI, PİROTEKNİK",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "050300",
	  "UN_NO__1": "0503"
	},
	{
	  "BAKANLIK_KOD": "050400",
	  "UN_NO": "0504",
	  "ORİJİNAL İSİM": "1H-TETRAZOL",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "050400",
	  "UN_NO__1": "0504"
	},
	{
	  "BAKANLIK_KOD": "050500",
	  "UN_NO": "0505",
	  "ORİJİNAL İSİM": "İŞARETLERİ, İMDAT, gemi",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4G",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "050500",
	  "UN_NO__1": "0505"
	},
	{
	  "BAKANLIK_KOD": "050600",
	  "UN_NO": "0506",
	  "ORİJİNAL İSİM": "İŞARETLERİ, İMDAT, gemi",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4S",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "050600",
	  "UN_NO__1": "0506"
	},
	{
	  "BAKANLIK_KOD": "050700",
	  "UN_NO": "0507",
	  "ORİJİNAL İSİM": "İŞARETLERİ, DUMAN",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4S",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "050700",
	  "UN_NO__1": "0507"
	},
	{
	  "BAKANLIK_KOD": "050800",
	  "UN_NO": "0508",
	  "ORİJİNAL İSİM": "1-HİDROKSİ-BENZOTRİAZOL, SUSUZ, kütlece %20'den az su ile ıslatılmış veya kuru",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.3C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "050800",
	  "UN_NO__1": "0508"
	},
	{
	  "BAKANLIK_KOD": "050900",
	  "UN_NO": "0509",
	  "ORİJİNAL İSİM": "BARUT, DUMANSIZ",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "050900",
	  "UN_NO__1": "0509"
	},
	{
	  "BAKANLIK_KOD": "051000",
	  "UN_NO": "0510",
	  "ORİJİNAL İSİM": "ROKET MOTORLARI",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "051000",
	  "UN_NO__1": "0510"
	},
	{
	  "BAKANLIK_KOD": "051100",
	  "UN_NO": "0511",
	  "ORİJİNAL İSİM": "DETONATÖRLER, ELEKTRONİK Patlama için programlanabilir",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.1B",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "051100",
	  "UN_NO__1": "0511"
	},
	{
	  "BAKANLIK_KOD": "051200",
	  "UN_NO": "0512",
	  "ORİJİNAL İSİM": "DETONATÖRLER, ELEKTRONİK Patlama için programlanabilir",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4B",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "051200",
	  "UN_NO__1": "0512"
	},
	{
	  "BAKANLIK_KOD": "051300",
	  "UN_NO": "0513",
	  "ORİJİNAL İSİM": "DETONATÖRLER, ELEKTRONİK Patlama için programlanabilir",
	  "SINIF": 1,
	  "SINIFLANDIRMA_KODU": "1.4S",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": "051300",
	  "UN_NO__1": "0513"
	},
	{
	  "BAKANLIK_KOD": 100100,
	  "UN_NO": 1001,
	  "ORİJİNAL İSİM": "ASETİLEN, ÇÖZÜNMÜŞ",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "4F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 100100,
	  "UN_NO__1": 1001
	},
	{
	  "BAKANLIK_KOD": 100200,
	  "UN_NO": 1002,
	  "ORİJİNAL İSİM": "HAVA, SIKIŞTIRILMIŞ",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "1A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 100200,
	  "UN_NO__1": 1002
	},
	{
	  "BAKANLIK_KOD": 100300,
	  "UN_NO": 1003,
	  "ORİJİNAL İSİM": "HAVA, SOĞUTULMUŞ SIVI",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "3O",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 100300,
	  "UN_NO__1": 1003
	},
	{
	  "BAKANLIK_KOD": 100500,
	  "UN_NO": 1005,
	  "ORİJİNAL İSİM": "AMONYAK, SUSUZ",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 100500,
	  "UN_NO__1": 1005
	},
	{
	  "BAKANLIK_KOD": 100600,
	  "UN_NO": 1006,
	  "ORİJİNAL İSİM": "ARGON, SIKIŞTIRILMIŞ",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "1A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 100600,
	  "UN_NO__1": 1006
	},
	{
	  "BAKANLIK_KOD": 100800,
	  "UN_NO": 1008,
	  "ORİJİNAL İSİM": "BOR TRİFLORÜR",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 100800,
	  "UN_NO__1": 1008
	},
	{
	  "BAKANLIK_KOD": 100900,
	  "UN_NO": 1009,
	  "ORİJİNAL İSİM": "BROMOTİFLORO-METAN (SOĞUTUCU GAZ R 13B1)",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 100900,
	  "UN_NO__1": 1009
	},
	{
	  "BAKANLIK_KOD": 101000,
	  "UN_NO": 1010,
	  "ORİJİNAL İSİM": "BÜTADİENLER, STABİLİZE veya BÜTADİENLER VE HİDROKARBON KARIŞIMI, STABİLİZE, ,% 40'tan fazla butadien içeren",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 101000,
	  "UN_NO__1": 1010
	},
	{
	  "BAKANLIK_KOD": 101100,
	  "UN_NO": 1011,
	  "ORİJİNAL İSİM": "BÜTAN",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 101100,
	  "UN_NO__1": 1011
	},
	{
	  "BAKANLIK_KOD": 101200,
	  "UN_NO": 1012,
	  "ORİJİNAL İSİM": "BÜTİLENLER KARIŞIMI veya 1-BÜTİLEN veya cis-2-BÜTİLEN veya trans- 2-BÜTİLEN",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 101200,
	  "UN_NO__1": 1012
	},
	{
	  "BAKANLIK_KOD": 101300,
	  "UN_NO": 1013,
	  "ORİJİNAL İSİM": "KARBON DİOKSİT",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 101300,
	  "UN_NO__1": 1013
	},
	{
	  "BAKANLIK_KOD": 101600,
	  "UN_NO": 1016,
	  "ORİJİNAL İSİM": "KARBON MONOKSİT, SIKIŞTIRILMIŞ",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "1TF",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 101600,
	  "UN_NO__1": 1016
	},
	{
	  "BAKANLIK_KOD": 101700,
	  "UN_NO": 1017,
	  "ORİJİNAL İSİM": "KLOR",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TOC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 101700,
	  "UN_NO__1": 1017
	},
	{
	  "BAKANLIK_KOD": 101800,
	  "UN_NO": 1018,
	  "ORİJİNAL İSİM": "KLORODİFLORO-METAN (SOĞUTUCU GAZ R 22)",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 101800,
	  "UN_NO__1": 1018
	},
	{
	  "BAKANLIK_KOD": 102000,
	  "UN_NO": 1020,
	  "ORİJİNAL İSİM": "KLOROPENTAFLORO-ETAN (SOĞUTUCU GAZ R 115)",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 102000,
	  "UN_NO__1": 1020
	},
	{
	  "BAKANLIK_KOD": 102100,
	  "UN_NO": 1021,
	  "ORİJİNAL İSİM": "1-KLORO-1,2,2,2-TETRAFLOROETAN\n (SOĞUTUCU GAZ R 124)",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 102100,
	  "UN_NO__1": 1021
	},
	{
	  "BAKANLIK_KOD": 102200,
	  "UN_NO": 1022,
	  "ORİJİNAL İSİM": "KLOROTRİFLORO-METAN (SOĞUTUCU GAZ R 13)",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 102200,
	  "UN_NO__1": 1022
	},
	{
	  "BAKANLIK_KOD": 102300,
	  "UN_NO": 1023,
	  "ORİJİNAL İSİM": "KÖMÜR GAZI, SIKIŞTIRILMIŞ",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "1TF",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 102300,
	  "UN_NO__1": 1023
	},
	{
	  "BAKANLIK_KOD": 102600,
	  "UN_NO": 1026,
	  "ORİJİNAL İSİM": "SİYANOJEN",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TF",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 102600,
	  "UN_NO__1": 1026
	},
	{
	  "BAKANLIK_KOD": 102700,
	  "UN_NO": 1027,
	  "ORİJİNAL İSİM": "SİKLOPROPAN",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 102700,
	  "UN_NO__1": 1027
	},
	{
	  "BAKANLIK_KOD": 102800,
	  "UN_NO": 1028,
	  "ORİJİNAL İSİM": "DİKLORODİFLORO-METAN (SOĞUTUCU GAZ R 12)",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 102800,
	  "UN_NO__1": 1028
	},
	{
	  "BAKANLIK_KOD": 102900,
	  "UN_NO": 1029,
	  "ORİJİNAL İSİM": "DİKLORODİFLORO-METAN (SOĞUTUCU GAZ R 21)",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 102900,
	  "UN_NO__1": 1029
	},
	{
	  "BAKANLIK_KOD": 103000,
	  "UN_NO": 1030,
	  "ORİJİNAL İSİM": "1,1-DİFLOROETAN (SOĞUTUCU GAZ R 152a)",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 103000,
	  "UN_NO__1": 1030
	},
	{
	  "BAKANLIK_KOD": 103200,
	  "UN_NO": 1032,
	  "ORİJİNAL İSİM": "DİMETİLAMİN, SUSUZ",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 103200,
	  "UN_NO__1": 1032
	},
	{
	  "BAKANLIK_KOD": 103300,
	  "UN_NO": 1033,
	  "ORİJİNAL İSİM": "DİMETİL ETER",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 103300,
	  "UN_NO__1": 1033
	},
	{
	  "BAKANLIK_KOD": 103500,
	  "UN_NO": 1035,
	  "ORİJİNAL İSİM": "ETAN",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 103500,
	  "UN_NO__1": 1035
	},
	{
	  "BAKANLIK_KOD": 103600,
	  "UN_NO": 1036,
	  "ORİJİNAL İSİM": "ETİLAMİN",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 103600,
	  "UN_NO__1": 1036
	},
	{
	  "BAKANLIK_KOD": 103700,
	  "UN_NO": 1037,
	  "ORİJİNAL İSİM": "ETİL KLORÜR",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 103700,
	  "UN_NO__1": 1037
	},
	{
	  "BAKANLIK_KOD": 103800,
	  "UN_NO": 1038,
	  "ORİJİNAL İSİM": "ETİLEN, SOĞUTULMUŞ SIVI",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "3F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 103800,
	  "UN_NO__1": 1038
	},
	{
	  "BAKANLIK_KOD": 103900,
	  "UN_NO": 1039,
	  "ORİJİNAL İSİM": "ETİL METİL ETER",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 103900,
	  "UN_NO__1": 1039
	},
	{
	  "BAKANLIK_KOD": 104001,
	  "UN_NO": 1040,
	  "ORİJİNAL İSİM": "ETİLEN OKSİT",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TF",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 104001,
	  "UN_NO__1": 1040
	},
	{
	  "BAKANLIK_KOD": 104002,
	  "UN_NO": 1040,
	  "ORİJİNAL İSİM": "ETİLEN OKSİT, AZOTLU 50 °C'de 1 MPa'ya (10 bar) kadar toplam basınç",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TF",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 104002,
	  "UN_NO__1": 1040
	},
	{
	  "BAKANLIK_KOD": 104100,
	  "UN_NO": 1041,
	  "ORİJİNAL İSİM": "ETİLEN OKSİT VE KARBON DİOKSİT KARIŞIM %9'dan fazla ama %87'den az etilen oksit ile",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 104100,
	  "UN_NO__1": 1041
	},
	{
	  "BAKANLIK_KOD": 104300,
	  "UN_NO": 1043,
	  "ORİJİNAL İSİM": "GÜBRELER AMONYAK ÇÖZELTİ serbest amonyaklı",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "4A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 104300,
	  "UN_NO__1": 1043
	},
	{
	  "BAKANLIK_KOD": 104400,
	  "UN_NO": 1044,
	  "ORİJİNAL İSİM": "YANGIN SÖNDÜRÜCÜLER sıkıştırılmış veya sıvılaştırılmış gazlı",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "6A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 104400,
	  "UN_NO__1": 1044
	},
	{
	  "BAKANLIK_KOD": 104500,
	  "UN_NO": 1045,
	  "ORİJİNAL İSİM": "FLOR, SIKIŞTIRILMIŞ",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "1TOC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 104500,
	  "UN_NO__1": 1045
	},
	{
	  "BAKANLIK_KOD": 104600,
	  "UN_NO": 1046,
	  "ORİJİNAL İSİM": "HELYUM, SIKIŞTIRILMIŞ",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "1A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 104600,
	  "UN_NO__1": 1046
	},
	{
	  "BAKANLIK_KOD": 104800,
	  "UN_NO": 1048,
	  "ORİJİNAL İSİM": "HİDROJEN BROMÜR, SUSUZ",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 104800,
	  "UN_NO__1": 1048
	},
	{
	  "BAKANLIK_KOD": 104900,
	  "UN_NO": 1049,
	  "ORİJİNAL İSİM": "HİDROJEN, SIKIŞTIRILMIŞ",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "1F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 104900,
	  "UN_NO__1": 1049
	},
	{
	  "BAKANLIK_KOD": 105000,
	  "UN_NO": 1050,
	  "ORİJİNAL İSİM": "HİDROJEN KLORÜR, SUSUZ",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 105000,
	  "UN_NO__1": 1050
	},
	{
	  "BAKANLIK_KOD": 105100,
	  "UN_NO": 1051,
	  "ORİJİNAL İSİM": "HİDROJEN SİYANÜR, STABİLİZE %3'ten az su içeren",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 105100,
	  "UN_NO__1": 1051
	},
	{
	  "BAKANLIK_KOD": 105200,
	  "UN_NO": 1052,
	  "ORİJİNAL İSİM": "HİDROJEN FLORÜR, SUSUZ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CT1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 105200,
	  "UN_NO__1": 1052
	},
	{
	  "BAKANLIK_KOD": 105300,
	  "UN_NO": 1053,
	  "ORİJİNAL İSİM": "HİDROJEN SÜLFÜR",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TF",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 105300,
	  "UN_NO__1": 1053
	},
	{
	  "BAKANLIK_KOD": 105500,
	  "UN_NO": 1055,
	  "ORİJİNAL İSİM": "İZOBÜTİLEN",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 105500,
	  "UN_NO__1": 1055
	},
	{
	  "BAKANLIK_KOD": 105600,
	  "UN_NO": 1056,
	  "ORİJİNAL İSİM": "KRİPTON, SIKIŞTIRILMIŞ",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "1A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 105600,
	  "UN_NO__1": 1056
	},
	{
	  "BAKANLIK_KOD": 105700,
	  "UN_NO": 1057,
	  "ORİJİNAL İSİM": "ÇAKMAKLAR veya ÇAKMAK GAZI KARTUŞLARI alevlenebilir gaz içeren",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "6F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 105700,
	  "UN_NO__1": 1057
	},
	{
	  "BAKANLIK_KOD": 105800,
	  "UN_NO": 1058,
	  "ORİJİNAL İSİM": "SIVILAŞTIRILMIŞ GAZLAR, alevlenebilir olmayan, karbondioksit, hava ve azot yüklü",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 105800,
	  "UN_NO__1": 1058
	},
	{
	  "BAKANLIK_KOD": 106000,
	  "UN_NO": 1060,
	  "ORİJİNAL İSİM": "METİL ASETİLEN VE PROPADİEN KARIŞIMI, STABİLİZE karışım P1 veya karışım P2",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 106000,
	  "UN_NO__1": 1060
	},
	{
	  "BAKANLIK_KOD": 106100,
	  "UN_NO": 1061,
	  "ORİJİNAL İSİM": "METİLAMİN, SUSUZ",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 106100,
	  "UN_NO__1": 1061
	},
	{
	  "BAKANLIK_KOD": 106200,
	  "UN_NO": 1062,
	  "ORİJİNAL İSİM": "METİL BROMÜR %2'den daha az kloropikrin ile",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2T",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 106200,
	  "UN_NO__1": 1062
	},
	{
	  "BAKANLIK_KOD": 106300,
	  "UN_NO": 1063,
	  "ORİJİNAL İSİM": "METİL KLORÜR (SOĞUTUCU GAZ R 40)",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 106300,
	  "UN_NO__1": 1063
	},
	{
	  "BAKANLIK_KOD": 106400,
	  "UN_NO": 1064,
	  "ORİJİNAL İSİM": "METİL MERKAPTAN",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TF",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 106400,
	  "UN_NO__1": 1064
	},
	{
	  "BAKANLIK_KOD": 106500,
	  "UN_NO": 1065,
	  "ORİJİNAL İSİM": "NEON, SIKIŞTIRILMIŞ",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "1A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 106500,
	  "UN_NO__1": 1065
	},
	{
	  "BAKANLIK_KOD": 106600,
	  "UN_NO": 1066,
	  "ORİJİNAL İSİM": "NİTROJEN, SIKIŞTIRILMIŞ",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "1A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 106600,
	  "UN_NO__1": 1066
	},
	{
	  "BAKANLIK_KOD": 106700,
	  "UN_NO": 1067,
	  "ORİJİNAL İSİM": "DİAZOT TETROKSİT (AZOT DİOKSİT)",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TOC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 106700,
	  "UN_NO__1": 1067
	},
	{
	  "BAKANLIK_KOD": 106900,
	  "UN_NO": 1069,
	  "ORİJİNAL İSİM": "NİTROZİL KLORÜR",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 106900,
	  "UN_NO__1": 1069
	},
	{
	  "BAKANLIK_KOD": 107000,
	  "UN_NO": 1070,
	  "ORİJİNAL İSİM": "AZOTLU OKSİT",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2O",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 107000,
	  "UN_NO__1": 1070
	},
	{
	  "BAKANLIK_KOD": 107100,
	  "UN_NO": 1071,
	  "ORİJİNAL İSİM": "PETROL GAZI, SIKIŞTIRILMIŞ",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "1TF",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 107100,
	  "UN_NO__1": 1071
	},
	{
	  "BAKANLIK_KOD": 107200,
	  "UN_NO": 1072,
	  "ORİJİNAL İSİM": "OKSİJEN, SIKIŞTIRILMIŞ",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "1O",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 107200,
	  "UN_NO__1": 1072
	},
	{
	  "BAKANLIK_KOD": 107300,
	  "UN_NO": 1073,
	  "ORİJİNAL İSİM": "OKSİJEN, SOĞUTULMUŞ SIVI",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "3O",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 107300,
	  "UN_NO__1": 1073
	},
	{
	  "BAKANLIK_KOD": 107500,
	  "UN_NO": 1075,
	  "ORİJİNAL İSİM": "PETROL GAZLARI, SIVILAŞTIRILMIŞ",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 107500,
	  "UN_NO__1": 1075
	},
	{
	  "BAKANLIK_KOD": 107600,
	  "UN_NO": 1076,
	  "ORİJİNAL İSİM": "FOSJEN",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 107600,
	  "UN_NO__1": 1076
	},
	{
	  "BAKANLIK_KOD": 107700,
	  "UN_NO": 1077,
	  "ORİJİNAL İSİM": "PROPİLEN",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 107700,
	  "UN_NO__1": 1077
	},
	{
	  "BAKANLIK_KOD": 107800,
	  "UN_NO": 1078,
	  "ORİJİNAL İSİM": "SOĞUTUCU GAZ, B.B.B., karışım F1, karışım F2 veya karışım F3 gibi",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 107800,
	  "UN_NO__1": 1078
	},
	{
	  "BAKANLIK_KOD": 107900,
	  "UN_NO": 1079,
	  "ORİJİNAL İSİM": "SÜLFÜR DİOKSİT",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 107900,
	  "UN_NO__1": 1079
	},
	{
	  "BAKANLIK_KOD": 108000,
	  "UN_NO": 1080,
	  "ORİJİNAL İSİM": "SÜLFÜR HEKZAFLORÜR",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 108000,
	  "UN_NO__1": 1080
	},
	{
	  "BAKANLIK_KOD": 108100,
	  "UN_NO": 1081,
	  "ORİJİNAL İSİM": "TETRAFLOROETİLEN, STABİLİZE",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 108100,
	  "UN_NO__1": 1081
	},
	{
	  "BAKANLIK_KOD": 108200,
	  "UN_NO": 1082,
	  "ORİJİNAL İSİM": "TRİFLOROKLORO-ETİLEN, STABİLİZE SOĞUTUCU GAZ R 1113",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TF",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 108200,
	  "UN_NO__1": 1082
	},
	{
	  "BAKANLIK_KOD": 108300,
	  "UN_NO": 1083,
	  "ORİJİNAL İSİM": "TRİMETİLAMİN, SUSUZ",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 108300,
	  "UN_NO__1": 1083
	},
	{
	  "BAKANLIK_KOD": 108500,
	  "UN_NO": 1085,
	  "ORİJİNAL İSİM": "VİNİL BROMÜR, STABİLİZE",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 108500,
	  "UN_NO__1": 1085
	},
	{
	  "BAKANLIK_KOD": 108600,
	  "UN_NO": 1086,
	  "ORİJİNAL İSİM": "VİNİL KLORÜR, STABİLİZE",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 108600,
	  "UN_NO__1": 1086
	},
	{
	  "BAKANLIK_KOD": 108700,
	  "UN_NO": 1087,
	  "ORİJİNAL İSİM": "VİNİL METİL ETER, STABİLİZE",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 108700,
	  "UN_NO__1": 1087
	},
	{
	  "BAKANLIK_KOD": 108800,
	  "UN_NO": 1088,
	  "ORİJİNAL İSİM": "ASETAL",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 108800,
	  "UN_NO__1": 1088
	},
	{
	  "BAKANLIK_KOD": 108900,
	  "UN_NO": 1089,
	  "ORİJİNAL İSİM": "ASETALDEHİT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 108900,
	  "UN_NO__1": 1089
	},
	{
	  "BAKANLIK_KOD": 109000,
	  "UN_NO": 1090,
	  "ORİJİNAL İSİM": "ASETON",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 109000,
	  "UN_NO__1": 1090
	},
	{
	  "BAKANLIK_KOD": 109100,
	  "UN_NO": 1091,
	  "ORİJİNAL İSİM": "ASETON YAĞLARI",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 109100,
	  "UN_NO__1": 1091
	},
	{
	  "BAKANLIK_KOD": 109200,
	  "UN_NO": 1092,
	  "ORİJİNAL İSİM": "AKROLEİN, STABİLİZE",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 109200,
	  "UN_NO__1": 1092
	},
	{
	  "BAKANLIK_KOD": 109300,
	  "UN_NO": 1093,
	  "ORİJİNAL İSİM": "AKRİLONİTRİL, STABİLİZE",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 109300,
	  "UN_NO__1": 1093
	},
	{
	  "BAKANLIK_KOD": 109800,
	  "UN_NO": 1098,
	  "ORİJİNAL İSİM": "ALİL ALKOL",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 109800,
	  "UN_NO__1": 1098
	},
	{
	  "BAKANLIK_KOD": 109900,
	  "UN_NO": 1099,
	  "ORİJİNAL İSİM": "ALİL BROMÜR",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 109900,
	  "UN_NO__1": 1099
	},
	{
	  "BAKANLIK_KOD": 110000,
	  "UN_NO": 1100,
	  "ORİJİNAL İSİM": "ALİL KLORÜR",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 110000,
	  "UN_NO__1": 1100
	},
	{
	  "BAKANLIK_KOD": 110400,
	  "UN_NO": 1104,
	  "ORİJİNAL İSİM": "AMİL ASETATLAR",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 110400,
	  "UN_NO__1": 1104
	},
	{
	  "BAKANLIK_KOD": 110501,
	  "UN_NO": 1105,
	  "ORİJİNAL İSİM": "PENTANOLLER",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 110501,
	  "UN_NO__1": 1105
	},
	{
	  "BAKANLIK_KOD": 110502,
	  "UN_NO": 1105,
	  "ORİJİNAL İSİM": "PENTANOLLER",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 110502,
	  "UN_NO__1": 1105
	},
	{
	  "BAKANLIK_KOD": 110601,
	  "UN_NO": 1106,
	  "ORİJİNAL İSİM": "AMİLAMİN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 110601,
	  "UN_NO__1": 1106
	},
	{
	  "BAKANLIK_KOD": 110602,
	  "UN_NO": 1106,
	  "ORİJİNAL İSİM": "AMİLAMİN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 110602,
	  "UN_NO__1": 1106
	},
	{
	  "BAKANLIK_KOD": 110700,
	  "UN_NO": 1107,
	  "ORİJİNAL İSİM": "AMİL KLORÜR",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 110700,
	  "UN_NO__1": 1107
	},
	{
	  "BAKANLIK_KOD": 110800,
	  "UN_NO": 1108,
	  "ORİJİNAL İSİM": "1-PENTEN (n-AMİLEN)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 110800,
	  "UN_NO__1": 1108
	},
	{
	  "BAKANLIK_KOD": 110900,
	  "UN_NO": 1109,
	  "ORİJİNAL İSİM": "AMİL FORMATLAR",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 110900,
	  "UN_NO__1": 1109
	},
	{
	  "BAKANLIK_KOD": 111000,
	  "UN_NO": 1110,
	  "ORİJİNAL İSİM": "n-AMİL METİL KETON",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 111000,
	  "UN_NO__1": 1110
	},
	{
	  "BAKANLIK_KOD": 111100,
	  "UN_NO": 1111,
	  "ORİJİNAL İSİM": "AMİL MERKAPTAN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 111100,
	  "UN_NO__1": 1111
	},
	{
	  "BAKANLIK_KOD": 111200,
	  "UN_NO": 1112,
	  "ORİJİNAL İSİM": "AMİL NİTRAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 111200,
	  "UN_NO__1": 1112
	},
	{
	  "BAKANLIK_KOD": 111300,
	  "UN_NO": 1113,
	  "ORİJİNAL İSİM": "AMİL NİTRİT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 111300,
	  "UN_NO__1": 1113
	},
	{
	  "BAKANLIK_KOD": 111400,
	  "UN_NO": 1114,
	  "ORİJİNAL İSİM": "BENZEN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 111400,
	  "UN_NO__1": 1114
	},
	{
	  "BAKANLIK_KOD": 112001,
	  "UN_NO": 1120,
	  "ORİJİNAL İSİM": "BÜTANOLLER",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 112001,
	  "UN_NO__1": 1120
	},
	{
	  "BAKANLIK_KOD": 112002,
	  "UN_NO": 1120,
	  "ORİJİNAL İSİM": "BÜTANOLLER",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 112002,
	  "UN_NO__1": 1120
	},
	{
	  "BAKANLIK_KOD": 112301,
	  "UN_NO": 1123,
	  "ORİJİNAL İSİM": "BÜTİL ASETATLAR",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 112301,
	  "UN_NO__1": 1123
	},
	{
	  "BAKANLIK_KOD": 112302,
	  "UN_NO": 1123,
	  "ORİJİNAL İSİM": "BÜTİL ASETATLAR",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 112302,
	  "UN_NO__1": 1123
	},
	{
	  "BAKANLIK_KOD": 112500,
	  "UN_NO": 1125,
	  "ORİJİNAL İSİM": "n-BÜTİLAMİN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 112500,
	  "UN_NO__1": 1125
	},
	{
	  "BAKANLIK_KOD": 112600,
	  "UN_NO": 1126,
	  "ORİJİNAL İSİM": "1-BROMOBÜTAN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 112600,
	  "UN_NO__1": 1126
	},
	{
	  "BAKANLIK_KOD": 112700,
	  "UN_NO": 1127,
	  "ORİJİNAL İSİM": "KLOROBÜTANLAR",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 112700,
	  "UN_NO__1": 1127
	},
	{
	  "BAKANLIK_KOD": 112800,
	  "UN_NO": 1128,
	  "ORİJİNAL İSİM": "n-BÜTİL FORMAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 112800,
	  "UN_NO__1": 1128
	},
	{
	  "BAKANLIK_KOD": 112900,
	  "UN_NO": 1129,
	  "ORİJİNAL İSİM": "BÜTİRALDEHİT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 112900,
	  "UN_NO__1": 1129
	},
	{
	  "BAKANLIK_KOD": 113000,
	  "UN_NO": 1130,
	  "ORİJİNAL İSİM": "KAFUR YAĞI",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 113000,
	  "UN_NO__1": 1130
	},
	{
	  "BAKANLIK_KOD": 113100,
	  "UN_NO": 1131,
	  "ORİJİNAL İSİM": "KARBON DİSÜLFÜR",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 113100,
	  "UN_NO__1": 1131
	},
	{
	  "BAKANLIK_KOD": 113301,
	  "UN_NO": 1133,
	  "ORİJİNAL İSİM": "YAPIŞTIRICILAR alevlenebilir sıvı içeren",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 113301,
	  "UN_NO__1": 1133
	},
	{
	  "BAKANLIK_KOD": 113302,
	  "UN_NO": 1133,
	  "ORİJİNAL İSİM": "YAPIŞTIRICILAR alevlenebilir sıvı içeren (50 °C'de buhar basıncı 110 kPa'dan daha yüksek olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 113302,
	  "UN_NO__1": 1133
	},
	{
	  "BAKANLIK_KOD": 113303,
	  "UN_NO": 1133,
	  "ORİJİNAL İSİM": "YAPIŞTIRICILAR alevlenebilir sıvı içeren (50 °C'de buhar basıncı 110 kPa'aeşit veya daha düşük olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 113303,
	  "UN_NO__1": 1133
	},
	{
	  "BAKANLIK_KOD": 113304,
	  "UN_NO": 1133,
	  "ORİJİNAL İSİM": "YAPIŞTIRICILAR alevlenebilir sıvı içeren",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 113304,
	  "UN_NO__1": 1133
	},
	{
	  "BAKANLIK_KOD": 113305,
	  "UN_NO": 1133,
	  "ORİJİNAL İSİM": "YAPIŞTIRICILAR alevlenebilir sıvı içeren (2.2.3.1.4 uyarınca viskoz ve parlama noktası 23 °C'nin altında) (50 °C'de buhar basıncı 110 kPa'dan daha yüksek olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 113305,
	  "UN_NO__1": 1133
	},
	{
	  "BAKANLIK_KOD": 113306,
	  "UN_NO": 1133,
	  "ORİJİNAL İSİM": "YAPIŞTIRICILAR alevlenebilir sıvı içeren (2.2.3.1.4 uyarınca viskoz ve parlama noktası 23 °C'nin altında) (50 °C'de buhar basıncı 110 kPa?a eşit veya daha düşük olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 113306,
	  "UN_NO__1": 1133
	},
	{
	  "BAKANLIK_KOD": 113400,
	  "UN_NO": 1134,
	  "ORİJİNAL İSİM": "KLOROBENZEN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 113400,
	  "UN_NO__1": 1134
	},
	{
	  "BAKANLIK_KOD": 113500,
	  "UN_NO": 1135,
	  "ORİJİNAL İSİM": "ETİLEN KLOROHİDRİN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 113500,
	  "UN_NO__1": 1135
	},
	{
	  "BAKANLIK_KOD": 113601,
	  "UN_NO": 1136,
	  "ORİJİNAL İSİM": "KÖMÜR KATRANI DİSTİLATLARI, ALEVLENEBİLİR",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 113601,
	  "UN_NO__1": 1136
	},
	{
	  "BAKANLIK_KOD": 113602,
	  "UN_NO": 1136,
	  "ORİJİNAL İSİM": "KÖMÜR KATRANI DİSTİLATLARI, ALEVLENEBİLİR",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 113602,
	  "UN_NO__1": 1136
	},
	{
	  "BAKANLIK_KOD": 113901,
	  "UN_NO": 1139,
	  "ORİJİNAL İSİM": "KAPLAMA ÇÖZELTİSİ (yüzey uygulamaları veya endüstriyel veya araç alt kaplaması, varil veya fıçı iç kaplaması gibi diğer kaplamaları kapsar)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 113901,
	  "UN_NO__1": 1139
	},
	{
	  "BAKANLIK_KOD": 113902,
	  "UN_NO": 1139,
	  "ORİJİNAL İSİM": "KAPLAMA ÇÖZELTİSİ (yüzey uygulamaları veya endüstriyel veya araç alt kaplaması, varil veya fıçı iç kaplaması gibi diğer kaplamaları kapsar) (50 °C'de buhar basıncı 110 kPa'dan daha yüksek olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 113902,
	  "UN_NO__1": 1139
	},
	{
	  "BAKANLIK_KOD": 113903,
	  "UN_NO": 1139,
	  "ORİJİNAL İSİM": "KAPLAMA ÇÖZELTİSİ (yüzey uygulamaları veya endüstriyel veya araç alt kaplaması, varil veya fıçı iç kaplaması gibi diğer kaplamaları kapsar) (50 °C'de buhar basıncı 110 kPa'a eşit veya daha düşük olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 113903,
	  "UN_NO__1": 1139
	},
	{
	  "BAKANLIK_KOD": 113904,
	  "UN_NO": 1139,
	  "ORİJİNAL İSİM": "KAPLAMA ÇÖZELTİSİ (yüzey uygulamaları veya endüstriyel veya araç alt kaplaması, varil veya fıçı iç kaplaması gibi diğer kaplamaları kapsar)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 113904,
	  "UN_NO__1": 1139
	},
	{
	  "BAKANLIK_KOD": 113905,
	  "UN_NO": 1139,
	  "ORİJİNAL İSİM": "KAPLAMA ÇÖZELTİSİ (yüzey uygulamaları veya endüstriyel veya araç alt kaplaması, varil veya fıçı iç kaplaması gibi diğer kaplamaları kapsar) (2.2.3.1.4 uyarınca iskoz ve parlama noktası 23 °C'nin altında) (50 °C'de buhar basıncı 110 kPa'dan daha yüksek olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 113905,
	  "UN_NO__1": 1139
	},
	{
	  "BAKANLIK_KOD": 113906,
	  "UN_NO": 1139,
	  "ORİJİNAL İSİM": "KAPLAMA ÇÖZELTİSİ (yüzey uygulamaları veya endüstriyel veya araç alt kaplaması, varil veya fıçı iç kaplaması gibi diğer kaplamaları kapsar) (2.2.3.1.4'e göre viskoz ve parlama noktası 23 °C'nin altında olan) (50 °C'de buhar basıncı 110 kPa'a eşit veya daha düşük olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 113906,
	  "UN_NO__1": 1139
	},
	{
	  "BAKANLIK_KOD": 114300,
	  "UN_NO": 1143,
	  "ORİJİNAL İSİM": "KROTONALDEHİT veya KROTONALDEHİT, STABİLİZE",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 114300,
	  "UN_NO__1": 1143
	},
	{
	  "BAKANLIK_KOD": 114400,
	  "UN_NO": 1144,
	  "ORİJİNAL İSİM": "KROTONİLEN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 114400,
	  "UN_NO__1": 1144
	},
	{
	  "BAKANLIK_KOD": 114500,
	  "UN_NO": 1145,
	  "ORİJİNAL İSİM": "SİKLOHEKZAN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 114500,
	  "UN_NO__1": 1145
	},
	{
	  "BAKANLIK_KOD": 114600,
	  "UN_NO": 1146,
	  "ORİJİNAL İSİM": "SİKLOPENTAN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 114600,
	  "UN_NO__1": 1146
	},
	{
	  "BAKANLIK_KOD": 114700,
	  "UN_NO": 1147,
	  "ORİJİNAL İSİM": "DEKAHİDRO-NAFTALİN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 114700,
	  "UN_NO__1": 1147
	},
	{
	  "BAKANLIK_KOD": 114801,
	  "UN_NO": 1148,
	  "ORİJİNAL İSİM": "DİASETON ALKOL",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 114801,
	  "UN_NO__1": 1148
	},
	{
	  "BAKANLIK_KOD": 114802,
	  "UN_NO": 1148,
	  "ORİJİNAL İSİM": "DİASETON ALKOL",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 114802,
	  "UN_NO__1": 1148
	},
	{
	  "BAKANLIK_KOD": 114900,
	  "UN_NO": 1149,
	  "ORİJİNAL İSİM": "DİBÜTİL ETERLER",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 114900,
	  "UN_NO__1": 1149
	},
	{
	  "BAKANLIK_KOD": 115000,
	  "UN_NO": 1150,
	  "ORİJİNAL İSİM": "1,2-DİKLOROETİLEN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 115000,
	  "UN_NO__1": 1150
	},
	{
	  "BAKANLIK_KOD": 115200,
	  "UN_NO": 1152,
	  "ORİJİNAL İSİM": "DİKLOROPENTANLAR",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 115200,
	  "UN_NO__1": 1152
	},
	{
	  "BAKANLIK_KOD": 115301,
	  "UN_NO": 1153,
	  "ORİJİNAL İSİM": "ETİLEN GLİKOL DİETİL ETER",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 115301,
	  "UN_NO__1": 1153
	},
	{
	  "BAKANLIK_KOD": 115302,
	  "UN_NO": 1153,
	  "ORİJİNAL İSİM": "ETİLEN GLİKOL DİETİL ETER",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 115302,
	  "UN_NO__1": 1153
	},
	{
	  "BAKANLIK_KOD": 115400,
	  "UN_NO": 1154,
	  "ORİJİNAL İSİM": "DİETİLAMİN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 115400,
	  "UN_NO__1": 1154
	},
	{
	  "BAKANLIK_KOD": 115500,
	  "UN_NO": 1155,
	  "ORİJİNAL İSİM": "DİETİL ETER (ETİL ETER)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 115500,
	  "UN_NO__1": 1155
	},
	{
	  "BAKANLIK_KOD": 115600,
	  "UN_NO": 1156,
	  "ORİJİNAL İSİM": "DİETİL KETON",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 115600,
	  "UN_NO__1": 1156
	},
	{
	  "BAKANLIK_KOD": 115700,
	  "UN_NO": 1157,
	  "ORİJİNAL İSİM": "DİİZOBÜTİL KETON",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 115700,
	  "UN_NO__1": 1157
	},
	{
	  "BAKANLIK_KOD": 115800,
	  "UN_NO": 1158,
	  "ORİJİNAL İSİM": "DİİZOPROPİLAMİN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 115800,
	  "UN_NO__1": 1158
	},
	{
	  "BAKANLIK_KOD": 115900,
	  "UN_NO": 1159,
	  "ORİJİNAL İSİM": "DİİZOPROPİL ETER",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 115900,
	  "UN_NO__1": 1159
	},
	{
	  "BAKANLIK_KOD": 116000,
	  "UN_NO": 1160,
	  "ORİJİNAL İSİM": "DİMETİLAMİN SULU ÇÖZELTİ",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 116000,
	  "UN_NO__1": 1160
	},
	{
	  "BAKANLIK_KOD": 116100,
	  "UN_NO": 1161,
	  "ORİJİNAL İSİM": "DİMETİL KARBONAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 116100,
	  "UN_NO__1": 1161
	},
	{
	  "BAKANLIK_KOD": 116200,
	  "UN_NO": 1162,
	  "ORİJİNAL İSİM": "DİMETİLDİKLORO-SİLAN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 116200,
	  "UN_NO__1": 1162
	},
	{
	  "BAKANLIK_KOD": 116300,
	  "UN_NO": 1163,
	  "ORİJİNAL İSİM": "DİMETİLHİDRAZİN, ASİMETRİK",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TFC",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 116300,
	  "UN_NO__1": 1163
	},
	{
	  "BAKANLIK_KOD": 116400,
	  "UN_NO": 1164,
	  "ORİJİNAL İSİM": "DİMETİL SÜLFİT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 116400,
	  "UN_NO__1": 1164
	},
	{
	  "BAKANLIK_KOD": 116500,
	  "UN_NO": 1165,
	  "ORİJİNAL İSİM": "DİOKSAN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 116500,
	  "UN_NO__1": 1165
	},
	{
	  "BAKANLIK_KOD": 116600,
	  "UN_NO": 1166,
	  "ORİJİNAL İSİM": "DİOKSOLAN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 116600,
	  "UN_NO__1": 1166
	},
	{
	  "BAKANLIK_KOD": 116700,
	  "UN_NO": 1167,
	  "ORİJİNAL İSİM": "DİVİNİL ETER, STABİLİZE",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 116700,
	  "UN_NO__1": 1167
	},
	{
	  "BAKANLIK_KOD": 116901,
	  "UN_NO": 1169,
	  "ORİJİNAL İSİM": "ÖZÜTLER, AROMATİK, SIVI (50 °C'de buhar basıncı 110 kPa'dan daha yüksek olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 116901,
	  "UN_NO__1": 1169
	},
	{
	  "BAKANLIK_KOD": 116902,
	  "UN_NO": 1169,
	  "ORİJİNAL İSİM": "ÖZÜTLER, AROMATİK, SIVI (50 °C'de buhar basıncı 110 kPa?a eşit veya daha düşük olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 116902,
	  "UN_NO__1": 1169
	},
	{
	  "BAKANLIK_KOD": 116903,
	  "UN_NO": 1169,
	  "ORİJİNAL İSİM": "ÖZÜTLER, AROMATİK, SIVI",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 116903,
	  "UN_NO__1": 1169
	},
	{
	  "BAKANLIK_KOD": 116904,
	  "UN_NO": 1169,
	  "ORİJİNAL İSİM": "ÖZÜTLER, AROMATİK, SIVI (2.2.3.1.4 uyarınca viskoz ve parlama noktası 23 °C'nin altında) (50 °C'de buhar basıncı 110 kPa'dan daha yüksek olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 116904,
	  "UN_NO__1": 1169
	},
	{
	  "BAKANLIK_KOD": 116905,
	  "UN_NO": 1169,
	  "ORİJİNAL İSİM": "ÖZÜTLER, AROMATİK, SIVI (2.2.3.1.4 uyarınca viskoz ve parlama noktası 23 °C'nin altında) (50 °C'de buhar basıncı 110 kPa?a eşit veya daha düşük olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 116905,
	  "UN_NO__1": 1169
	},
	{
	  "BAKANLIK_KOD": 117001,
	  "UN_NO": 1170,
	  "ORİJİNAL İSİM": "ETANOL (ETİL ALKOL) veya ETANOL ÇÖZELTİSİ (ETİL ALKOL ÇÖZELTİSİ)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 117001,
	  "UN_NO__1": 1170
	},
	{
	  "BAKANLIK_KOD": 117002,
	  "UN_NO": 1170,
	  "ORİJİNAL İSİM": "ETANOL ÇÖZELTİSİ (ETİL ALKOL ÇÖZELTİSİ)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 117002,
	  "UN_NO__1": 1170
	},
	{
	  "BAKANLIK_KOD": 117100,
	  "UN_NO": 1171,
	  "ORİJİNAL İSİM": "ETİLEN GLİKOL MONOETİL ETER",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 117100,
	  "UN_NO__1": 1171
	},
	{
	  "BAKANLIK_KOD": 117200,
	  "UN_NO": 1172,
	  "ORİJİNAL İSİM": "ETİLEN GLİKOL MONOETİL ETER ASETAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 117200,
	  "UN_NO__1": 1172
	},
	{
	  "BAKANLIK_KOD": 117300,
	  "UN_NO": 1173,
	  "ORİJİNAL İSİM": "ETİL ASETAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 117300,
	  "UN_NO__1": 1173
	},
	{
	  "BAKANLIK_KOD": 117500,
	  "UN_NO": 1175,
	  "ORİJİNAL İSİM": "ETİLBENZEN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 117500,
	  "UN_NO__1": 1175
	},
	{
	  "BAKANLIK_KOD": 117600,
	  "UN_NO": 1176,
	  "ORİJİNAL İSİM": "ETİL BORAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 117600,
	  "UN_NO__1": 1176
	},
	{
	  "BAKANLIK_KOD": 117700,
	  "UN_NO": 1177,
	  "ORİJİNAL İSİM": "2-ETİLBÜTİL ASETAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 117700,
	  "UN_NO__1": 1177
	},
	{
	  "BAKANLIK_KOD": 117800,
	  "UN_NO": 1178,
	  "ORİJİNAL İSİM": "2-ETİLBÜTİRALDEHİT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 117800,
	  "UN_NO__1": 1178
	},
	{
	  "BAKANLIK_KOD": 117900,
	  "UN_NO": 1179,
	  "ORİJİNAL İSİM": "ETİL BÜTİL ETER",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 117900,
	  "UN_NO__1": 1179
	},
	{
	  "BAKANLIK_KOD": 118000,
	  "UN_NO": 1180,
	  "ORİJİNAL İSİM": "ETİL BÜTİRAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 118000,
	  "UN_NO__1": 1180
	},
	{
	  "BAKANLIK_KOD": 118100,
	  "UN_NO": 1181,
	  "ORİJİNAL İSİM": "ETİL KLOROASETAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 118100,
	  "UN_NO__1": 1181
	},
	{
	  "BAKANLIK_KOD": 118200,
	  "UN_NO": 1182,
	  "ORİJİNAL İSİM": "ETİL KLOROFORMAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TFC",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 118200,
	  "UN_NO__1": 1182
	},
	{
	  "BAKANLIK_KOD": 118300,
	  "UN_NO": 1183,
	  "ORİJİNAL İSİM": "ETİLDİKLOROSİLAN",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WFC",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 118300,
	  "UN_NO__1": 1183
	},
	{
	  "BAKANLIK_KOD": 118400,
	  "UN_NO": 1184,
	  "ORİJİNAL İSİM": "ETİLEN DİKLORÜR",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 118400,
	  "UN_NO__1": 1184
	},
	{
	  "BAKANLIK_KOD": 118500,
	  "UN_NO": 1185,
	  "ORİJİNAL İSİM": "ETİLENİMİN, STABİLİZE",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 118500,
	  "UN_NO__1": 1185
	},
	{
	  "BAKANLIK_KOD": 118800,
	  "UN_NO": 1188,
	  "ORİJİNAL İSİM": "ETİLEN GLİKOL MONOMETİL ETER",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 118800,
	  "UN_NO__1": 1188
	},
	{
	  "BAKANLIK_KOD": 118900,
	  "UN_NO": 1189,
	  "ORİJİNAL İSİM": "ETİLEN GLİKOL MONOMETİL ETER ASETAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 118900,
	  "UN_NO__1": 1189
	},
	{
	  "BAKANLIK_KOD": 119000,
	  "UN_NO": 1190,
	  "ORİJİNAL İSİM": "ETİL FORMAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 119000,
	  "UN_NO__1": 1190
	},
	{
	  "BAKANLIK_KOD": 119100,
	  "UN_NO": 1191,
	  "ORİJİNAL İSİM": "OKTİL ALDEHİTLER",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 119100,
	  "UN_NO__1": 1191
	},
	{
	  "BAKANLIK_KOD": 119200,
	  "UN_NO": 1192,
	  "ORİJİNAL İSİM": "ETİL LAKTAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 119200,
	  "UN_NO__1": 1192
	},
	{
	  "BAKANLIK_KOD": 119300,
	  "UN_NO": 1193,
	  "ORİJİNAL İSİM": "ETİL METİL KETON (METİL\n ETİL KETON)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 119300,
	  "UN_NO__1": 1193
	},
	{
	  "BAKANLIK_KOD": 119400,
	  "UN_NO": 1194,
	  "ORİJİNAL İSİM": "ETİL NİTRİT ÇÖZELTİSİ",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 119400,
	  "UN_NO__1": 1194
	},
	{
	  "BAKANLIK_KOD": 119500,
	  "UN_NO": 1195,
	  "ORİJİNAL İSİM": "ETİL PROPİONAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 119500,
	  "UN_NO__1": 1195
	},
	{
	  "BAKANLIK_KOD": 119600,
	  "UN_NO": 1196,
	  "ORİJİNAL İSİM": "ETİLTRİKLOROSİLAN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 119600,
	  "UN_NO__1": 1196
	},
	{
	  "BAKANLIK_KOD": 119701,
	  "UN_NO": 1197,
	  "ORİJİNAL İSİM": "ÖZÜTLER, TATLANDIRICI, SIVI (50 °C'de buhar basıncı 110 kPa'dan daha yüksek olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 119701,
	  "UN_NO__1": 1197
	},
	{
	  "BAKANLIK_KOD": 119702,
	  "UN_NO": 1197,
	  "ORİJİNAL İSİM": "ÖZÜTLER, TATLANDIRICI, SIVI (50 °C'de buhar basıncı 110 kPa?a eşit veya daha düşük olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 119702,
	  "UN_NO__1": 1197
	},
	{
	  "BAKANLIK_KOD": 119703,
	  "UN_NO": 1197,
	  "ORİJİNAL İSİM": "ÖZÜTLER, TATLANDIRICI, SIVI",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 119703,
	  "UN_NO__1": 1197
	},
	{
	  "BAKANLIK_KOD": 119704,
	  "UN_NO": 1197,
	  "ORİJİNAL İSİM": "ÖZÜTLER, TATLANDIRICI, SIVI (2.2.3.1.4 uyarınca viskoz ve parlama noktası 23 °C'nin altında) (50 °C'de buhar basıncı 110 kPa'dan daha yüksek olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 119704,
	  "UN_NO__1": 1197
	},
	{
	  "BAKANLIK_KOD": 119705,
	  "UN_NO": 1197,
	  "ORİJİNAL İSİM": "ÖZÜTLER, TATLANDIRICI, SIVI (2.2.3.1.4 uyarınca viskoz ve parlama noktası 23 °C'nin altında) (50 °C'de buhar basıncı 110 kPa?a eşit veya daha düşük olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 119705,
	  "UN_NO__1": 1197
	},
	{
	  "BAKANLIK_KOD": 119800,
	  "UN_NO": 1198,
	  "ORİJİNAL İSİM": "FORMALDEHİT ÇÖZELTİSİ, ALEVLENEBİLİR",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 119800,
	  "UN_NO__1": 1198
	},
	{
	  "BAKANLIK_KOD": 119900,
	  "UN_NO": 1199,
	  "ORİJİNAL İSİM": "FURALDEHİTLER",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 119900,
	  "UN_NO__1": 1199
	},
	{
	  "BAKANLIK_KOD": 120101,
	  "UN_NO": 1201,
	  "ORİJİNAL İSİM": "FUZEL YAĞI",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 120101,
	  "UN_NO__1": 1201
	},
	{
	  "BAKANLIK_KOD": 120102,
	  "UN_NO": 1201,
	  "ORİJİNAL İSİM": "FUZEL YAĞI",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 120102,
	  "UN_NO__1": 1201
	},
	{
	  "BAKANLIK_KOD": 120201,
	  "UN_NO": 1202,
	  "ORİJİNAL İSİM": "GAZ YAĞI veya DİZEL YAKIT veya ISITMA YAĞI, HAFİF (parlama noktası 60 °C'den fazla olmayan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 120201,
	  "UN_NO__1": 1202
	},
	{
	  "BAKANLIK_KOD": 120202,
	  "UN_NO": 1202,
	  "ORİJİNAL İSİM": "DİZEL YAKIT, EN 590:2013+AC:2017 standardına uygun veya GAZ YAĞI veya ISITMA YAĞI, HAFİF, EN 590:2013 +AC:2017'te belirtilen parlama noktasına sahip",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 120202,
	  "UN_NO__1": 1202
	},
	{
	  "BAKANLIK_KOD": 120203,
	  "UN_NO": 1202,
	  "ORİJİNAL İSİM": "GAZ YAĞI veya DİZEL YAKIT veya ISITMA YAĞI, HAFİF (parlama noktası 60 °C'den yüksek ve 100 °C'den düşük olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 120203,
	  "UN_NO__1": 1202
	},
	{
	  "BAKANLIK_KOD": 120300,
	  "UN_NO": 1203,
	  "ORİJİNAL İSİM": "BENZİN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 120300,
	  "UN_NO__1": 1203
	},
	{
	  "BAKANLIK_KOD": 120400,
	  "UN_NO": 1204,
	  "ORİJİNAL İSİM": "NİTROGLİSERİN ÇÖZELTİSİ, ALKOLDE %1'den az nitrogliserin ile",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "D",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 120400,
	  "UN_NO__1": 1204
	},
	{
	  "BAKANLIK_KOD": 120600,
	  "UN_NO": 1206,
	  "ORİJİNAL İSİM": "HEPTANLAR",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 120600,
	  "UN_NO__1": 1206
	},
	{
	  "BAKANLIK_KOD": 120700,
	  "UN_NO": 1207,
	  "ORİJİNAL İSİM": "HEKZALDEHİT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 120700,
	  "UN_NO__1": 1207
	},
	{
	  "BAKANLIK_KOD": 120800,
	  "UN_NO": 1208,
	  "ORİJİNAL İSİM": "HEKZANLAR",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 120800,
	  "UN_NO__1": 1208
	},
	{
	  "BAKANLIK_KOD": 121001,
	  "UN_NO": 1210,
	  "ORİJİNAL İSİM": "MATBAA MÜREKKEBİ, alevlenebilir veya MATBAA MÜREKKEBİ İLE İLGİLİ MALZEME (matbaa mürekkebi inceltici veya azaltıcı bileşiği dahil), alevlenebilir",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 121001,
	  "UN_NO__1": 1210
	},
	{
	  "BAKANLIK_KOD": 121002,
	  "UN_NO": 1210,
	  "ORİJİNAL İSİM": "MATBAA MÜREKKEBİ, alevlenebilir veya MATBAA MÜREKKEBİ İLE İLGİLİ MALZEME (matbaa mürekkebi inceltici veya azaltıcı bileşeni dahil), alevlenebilir (50 °C'de buhar basıncı 110 kPa'dan daha yüksek olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 121002,
	  "UN_NO__1": 1210
	},
	{
	  "BAKANLIK_KOD": 121003,
	  "UN_NO": 1210,
	  "ORİJİNAL İSİM": "MATBAA MÜREKKEBİ, alevlenebilir veya MATBAA MÜREKKEBİ İLE İLGİLİ MALZEME (matbaa mürekkebi inceltici veya azaltıcı bileşiği dahil), alevlenebilir (50 °C'de buhar basıncı 110 kPa?a eşit veya daha düşük olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 121003,
	  "UN_NO__1": 1210
	},
	{
	  "BAKANLIK_KOD": 121004,
	  "UN_NO": 1210,
	  "ORİJİNAL İSİM": "MATBAA MÜREKKEBİ, alevlenebilir veya MATBAA MÜREKKEBİ İLE İLGİLİ MALZEME (matbaa mürekkebi inceltici veya azaltıcı bileşiği dahil), alevlenebilir",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 121004,
	  "UN_NO__1": 1210
	},
	{
	  "BAKANLIK_KOD": 121005,
	  "UN_NO": 1210,
	  "ORİJİNAL İSİM": "MATBAA MÜREKKEBİ, alevlenebilir veya MATBAA MÜREKKEBİ İLE İLGİLİ MALZEME (matbaa mürekkebi inceltici veya azaltıcı bileşiği dahil), alevlenebilir (2.2.3.1.4'e göre viskoz ve parlama noktası 23\n °C'nin altında) (50 °C'de buhar basıncı 110 kPa'dan daha yüksek olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 121005,
	  "UN_NO__1": 1210
	},
	{
	  "BAKANLIK_KOD": 121006,
	  "UN_NO": 1210,
	  "ORİJİNAL İSİM": "MATBAA MÜREKKEBİ, alevlenebilir veya MATBAA MÜREKKEBİ İLE İLGİLİ MALZEME (matbaa mürekkebi inceltici veya azaltıcı bileşiği dahil), alevlenebilir 2.2.3.1.4'e göre viskoz ve parlama noktası 23 °C'nin altında) (50 °C'de buhar basıncı 110 kPa?a eşit veya daha düşük olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 121006,
	  "UN_NO__1": 1210
	},
	{
	  "BAKANLIK_KOD": 121200,
	  "UN_NO": 1212,
	  "ORİJİNAL İSİM": "İZOBÜTANOL (İZOBÜTİL ALKOL)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 121200,
	  "UN_NO__1": 1212
	},
	{
	  "BAKANLIK_KOD": 121300,
	  "UN_NO": 1213,
	  "ORİJİNAL İSİM": "İZOBÜTİL ASETAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 121300,
	  "UN_NO__1": 1213
	},
	{
	  "BAKANLIK_KOD": 121400,
	  "UN_NO": 1214,
	  "ORİJİNAL İSİM": "İZOBÜTİLAMİN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 121400,
	  "UN_NO__1": 1214
	},
	{
	  "BAKANLIK_KOD": 121600,
	  "UN_NO": 1216,
	  "ORİJİNAL İSİM": "İZOOKTANLAR",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 121600,
	  "UN_NO__1": 1216
	},
	{
	  "BAKANLIK_KOD": 121800,
	  "UN_NO": 1218,
	  "ORİJİNAL İSİM": "İZOPREN, STABİLİZE",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 121800,
	  "UN_NO__1": 1218
	},
	{
	  "BAKANLIK_KOD": 121900,
	  "UN_NO": 1219,
	  "ORİJİNAL İSİM": "İZOPROPANOL (İZOPROPİL ALKOL)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 121900,
	  "UN_NO__1": 1219
	},
	{
	  "BAKANLIK_KOD": 122000,
	  "UN_NO": 1220,
	  "ORİJİNAL İSİM": "İZOPROPİL ASETAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 122000,
	  "UN_NO__1": 1220
	},
	{
	  "BAKANLIK_KOD": 122100,
	  "UN_NO": 1221,
	  "ORİJİNAL İSİM": "İZOPROPİLAMİN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 122100,
	  "UN_NO__1": 1221
	},
	{
	  "BAKANLIK_KOD": 122200,
	  "UN_NO": 1222,
	  "ORİJİNAL İSİM": "İZOPROPİL NİTRAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 122200,
	  "UN_NO__1": 1222
	},
	{
	  "BAKANLIK_KOD": 122300,
	  "UN_NO": 1223,
	  "ORİJİNAL İSİM": "KEROSEN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 122300,
	  "UN_NO__1": 1223
	},
	{
	  "BAKANLIK_KOD": 122401,
	  "UN_NO": 1224,
	  "ORİJİNAL İSİM": "KETONLAR, SIVI, B.B.B (50 °C'de buhar basıncı 110 kPa'dan daha yüksek olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 122401,
	  "UN_NO__1": 1224
	},
	{
	  "BAKANLIK_KOD": 122402,
	  "UN_NO": 1224,
	  "ORİJİNAL İSİM": "KETONLAR, SIVI, B.B.B (50 °C'de buhar basıncı 110 kPa?a eşit veya daha düşük olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 122402,
	  "UN_NO__1": 1224
	},
	{
	  "BAKANLIK_KOD": 122403,
	  "UN_NO": 1224,
	  "ORİJİNAL İSİM": "KETONLAR, SIVI, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 122403,
	  "UN_NO__1": 1224
	},
	{
	  "BAKANLIK_KOD": 122801,
	  "UN_NO": 1228,
	  "ORİJİNAL İSİM": "MERKAPTANLAR, SIVI, ALEVLENEBİLİR, ZEHİRLİ, B.B.B. veya MERKAPTAN KARIŞIMI, SIVI, ALEVLENEBİLİR, ZEHİRLİ, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 122801,
	  "UN_NO__1": 1228
	},
	{
	  "BAKANLIK_KOD": 122802,
	  "UN_NO": 1228,
	  "ORİJİNAL İSİM": "MERKAPTANLAR, SIVI, ALEVLENEBİLİR, ZEHİRLİ, B.B.B. veya MERKAPTAN KARIŞIMI, SIVI, ALEVLENEBİLİR, ZEHİRLİ, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 122802,
	  "UN_NO__1": 1228
	},
	{
	  "BAKANLIK_KOD": 122900,
	  "UN_NO": 1229,
	  "ORİJİNAL İSİM": "MESİTİL OKSİT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 122900,
	  "UN_NO__1": 1229
	},
	{
	  "BAKANLIK_KOD": 123000,
	  "UN_NO": 1230,
	  "ORİJİNAL İSİM": "METANOL",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 123000,
	  "UN_NO__1": 1230
	},
	{
	  "BAKANLIK_KOD": 123100,
	  "UN_NO": 1231,
	  "ORİJİNAL İSİM": "METİL ASETAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 123100,
	  "UN_NO__1": 1231
	},
	{
	  "BAKANLIK_KOD": 123300,
	  "UN_NO": 1233,
	  "ORİJİNAL İSİM": "METİLAMİL ASETAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 123300,
	  "UN_NO__1": 1233
	},
	{
	  "BAKANLIK_KOD": 123400,
	  "UN_NO": 1234,
	  "ORİJİNAL İSİM": "METİLAL",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 123400,
	  "UN_NO__1": 1234
	},
	{
	  "BAKANLIK_KOD": 123500,
	  "UN_NO": 1235,
	  "ORİJİNAL İSİM": "METİLAMİN, SULU ÇÖZELTİ",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 123500,
	  "UN_NO__1": 1235
	},
	{
	  "BAKANLIK_KOD": 123700,
	  "UN_NO": 1237,
	  "ORİJİNAL İSİM": "METİL BÜTİRAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 123700,
	  "UN_NO__1": 1237
	},
	{
	  "BAKANLIK_KOD": 123800,
	  "UN_NO": 1238,
	  "ORİJİNAL İSİM": "METİL KLOROFORMAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TFC",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 123800,
	  "UN_NO__1": 1238
	},
	{
	  "BAKANLIK_KOD": 123900,
	  "UN_NO": 1239,
	  "ORİJİNAL İSİM": "METİL KLORO-METİL ETER",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 123900,
	  "UN_NO__1": 1239
	},
	{
	  "BAKANLIK_KOD": 124200,
	  "UN_NO": 1242,
	  "ORİJİNAL İSİM": "METİLDİKLOROSİLAN",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WFC",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 124200,
	  "UN_NO__1": 1242
	},
	{
	  "BAKANLIK_KOD": 124300,
	  "UN_NO": 1243,
	  "ORİJİNAL İSİM": "METİL FORMAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 124300,
	  "UN_NO__1": 1243
	},
	{
	  "BAKANLIK_KOD": 124400,
	  "UN_NO": 1244,
	  "ORİJİNAL İSİM": "METİLHİDRAZİN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TFC",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 124400,
	  "UN_NO__1": 1244
	},
	{
	  "BAKANLIK_KOD": 124500,
	  "UN_NO": 1245,
	  "ORİJİNAL İSİM": "METİL İZOBÜTİL KETON",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 124500,
	  "UN_NO__1": 1245
	},
	{
	  "BAKANLIK_KOD": 124600,
	  "UN_NO": 1246,
	  "ORİJİNAL İSİM": "METİL İZOPROPENİL KETON, STABİLİZE",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 124600,
	  "UN_NO__1": 1246
	},
	{
	  "BAKANLIK_KOD": 124700,
	  "UN_NO": 1247,
	  "ORİJİNAL İSİM": "METİL METAKRİLAT MONOMER, STABİLİZE",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 124700,
	  "UN_NO__1": 1247
	},
	{
	  "BAKANLIK_KOD": 124800,
	  "UN_NO": 1248,
	  "ORİJİNAL İSİM": "METİL PROPİONAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 124800,
	  "UN_NO__1": 1248
	},
	{
	  "BAKANLIK_KOD": 124900,
	  "UN_NO": 1249,
	  "ORİJİNAL İSİM": "METİL PROPİL KETON",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 124900,
	  "UN_NO__1": 1249
	},
	{
	  "BAKANLIK_KOD": 125000,
	  "UN_NO": 1250,
	  "ORİJİNAL İSİM": "METİLTRİKLORO-SİLAN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 125000,
	  "UN_NO__1": 1250
	},
	{
	  "BAKANLIK_KOD": 125100,
	  "UN_NO": 1251,
	  "ORİJİNAL İSİM": "METİL VİNİL KETON, STABİLİZE",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TFC",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 125100,
	  "UN_NO__1": 1251
	},
	{
	  "BAKANLIK_KOD": 125900,
	  "UN_NO": 1259,
	  "ORİJİNAL İSİM": "NİKEL KARBONİL",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 125900,
	  "UN_NO__1": 1259
	},
	{
	  "BAKANLIK_KOD": 126100,
	  "UN_NO": 1261,
	  "ORİJİNAL İSİM": "NİTROMETAN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 126100,
	  "UN_NO__1": 1261
	},
	{
	  "BAKANLIK_KOD": 126200,
	  "UN_NO": 1262,
	  "ORİJİNAL İSİM": "OKTANLAR",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 126200,
	  "UN_NO__1": 1262
	},
	{
	  "BAKANLIK_KOD": 126301,
	  "UN_NO": 1263,
	  "ORİJİNAL İSİM": "BOYA (boya, vernik, emaye, renklendirici, lake, cila, parlatıcı sıvı dolgu ve sıvı vernik bazı dahil) veya BOYA İLE İLGİLİ MALZEME (boya inceltici veya azaltıcı bileşiği dahil)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 126301,
	  "UN_NO__1": 1263
	},
	{
	  "BAKANLIK_KOD": 126302,
	  "UN_NO": 1263,
	  "ORİJİNAL İSİM": "BOYA (boya, vernik, emaye, renklendirici, lake, cila, parlatıcı, sıvı dolgu ve sıvı vernik bazı dahil) veya BOYA İLE İLGİLİ MALZEME (boya inceltici veya azaltıcı bileşiği dahil) (50 °C'de buhar basıncı 110 kPa?dan daha yüksek olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 126302,
	  "UN_NO__1": 1263
	},
	{
	  "BAKANLIK_KOD": 126303,
	  "UN_NO": 1263,
	  "ORİJİNAL İSİM": "BOYA (boya, vernik, emaye, renklendirici, lake, cila, parlatıcı, sıvı dolgu ve sıvı vernik bazı dahil) veya BOYA İLE İLGİLİ MALZEME (boya inceltici veya azaltıcı bileşiği ahil) (50 °C'de buhar basıncı 110 kPa?a eşit veya daha düşük olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 126303,
	  "UN_NO__1": 1263
	},
	{
	  "BAKANLIK_KOD": 126304,
	  "UN_NO": 1263,
	  "ORİJİNAL İSİM": "BOYA (boya, vernik, emaye, renklendirici, lake, cila, parlatıcı sıvı dolgu ve sıvı vernik bazı dahil) veya BOYA İLE İLGİLİ MALZEME (boya inceltici veya azaltıcı bileşiği dahil)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 126304,
	  "UN_NO__1": 1263
	},
	{
	  "BAKANLIK_KOD": 126305,
	  "UN_NO": 1263,
	  "ORİJİNAL İSİM": "BOYA (boya, vernik, emaye, renklendirici, lake, cila, parlatıcı, sıvı dolgu ve sıvı vernik bazı dahil) veya BOYA İLE İLGİLİ MALZEME (boya inceltici veya azaltıcı bileşiği dahil) (parlama noktası 23 °C'nin altında) (50 °C'de buhar basıncı 110 kPa?dan daha yüksek olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 126305,
	  "UN_NO__1": 1263
	},
	{
	  "BAKANLIK_KOD": 126306,
	  "UN_NO": 1263,
	  "ORİJİNAL İSİM": "BOYA (boya, vernik, emaye, renklendirici, lake, cila, parlatıcı, sıvı dolgu ve sıvı vernik bazı dahil) veya BOYA İLE İLGİLİ MALZEME (boya inceltici veya azaltıcı bileşeni dahil) (parlama noktası 23 °C'nin altında) (50 °C'de buhar basıncı 110 kPa?a eşit veya daha düşük olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 126306,
	  "UN_NO__1": 1263
	},
	{
	  "BAKANLIK_KOD": 126400,
	  "UN_NO": 1264,
	  "ORİJİNAL İSİM": "PARALDEHİT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 126400,
	  "UN_NO__1": 1264
	},
	{
	  "BAKANLIK_KOD": 126501,
	  "UN_NO": 1265,
	  "ORİJİNAL İSİM": "PENTANLAR, sıvı",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 126501,
	  "UN_NO__1": 1265
	},
	{
	  "BAKANLIK_KOD": 126502,
	  "UN_NO": 1265,
	  "ORİJİNAL İSİM": "PENTANLAR, sıvı",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 126502,
	  "UN_NO__1": 1265
	},
	{
	  "BAKANLIK_KOD": 126601,
	  "UN_NO": 1266,
	  "ORİJİNAL İSİM": "PARFÜMERİ ÜRÜNLERİ alevlenebilir çözücüler içeren (50 °C'de buhar basıncı110 kPa?dan daha yüksek olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 126601,
	  "UN_NO__1": 1266
	},
	{
	  "BAKANLIK_KOD": 126602,
	  "UN_NO": 1266,
	  "ORİJİNAL İSİM": "PARFÜMERİ ÜRÜNLERİ alevlenebilir çözücüler içeren (50 °C'de buhar basıncı110 kPa?a eşit veya daha düşük olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 126602,
	  "UN_NO__1": 1266
	},
	{
	  "BAKANLIK_KOD": 126603,
	  "UN_NO": 1266,
	  "ORİJİNAL İSİM": "PARFÜMERİ ÜRÜNLERİ alevlenebilir çözücüler içeren",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 126603,
	  "UN_NO__1": 1266
	},
	{
	  "BAKANLIK_KOD": 126604,
	  "UN_NO": 1266,
	  "ORİJİNAL İSİM": "PARFÜMERİ ÜRÜNLERİ alevlenebilir çözücüler içeren (2.2.3.1.4 uyarınca viskoz ve parlama noktası 23 °C'nin altında) (50 °C'de buhar basıncı 110 kPa?dan daha yüksek olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 126604,
	  "UN_NO__1": 1266
	},
	{
	  "BAKANLIK_KOD": 126605,
	  "UN_NO": 1266,
	  "ORİJİNAL İSİM": "PARFÜMERİ ÜRÜNLERİ alevlenebilir çözücüler içeren (2.2.3.1.4 uyarınca viskoz ve parlama noktası 23 °C'nin altında) (50 °C'de buhar basıncı 110 kPa?a eşit veya daha düşük olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 126605,
	  "UN_NO__1": 1266
	},
	{
	  "BAKANLIK_KOD": 126701,
	  "UN_NO": 1267,
	  "ORİJİNAL İSİM": "HAM PETROL",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 126701,
	  "UN_NO__1": 1267
	},
	{
	  "BAKANLIK_KOD": 126702,
	  "UN_NO": 1267,
	  "ORİJİNAL İSİM": "HAM PETROL (50 °C'de buhar basıncı 110 kPa?dan daha yüksek olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 126702,
	  "UN_NO__1": 1267
	},
	{
	  "BAKANLIK_KOD": 126703,
	  "UN_NO": 1267,
	  "ORİJİNAL İSİM": "HAM PETROL (50 °C'de buhar basıncı 110 kPa?a eşit veya daha düşük olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 126703,
	  "UN_NO__1": 1267
	},
	{
	  "BAKANLIK_KOD": 126704,
	  "UN_NO": 1267,
	  "ORİJİNAL İSİM": "HAM PETROL",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 126704,
	  "UN_NO__1": 1267
	},
	{
	  "BAKANLIK_KOD": 126801,
	  "UN_NO": 1268,
	  "ORİJİNAL İSİM": "PETROL DİSTİLATLARI, B.B.B. veya PETROL ÜRÜNLERİ, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 126801,
	  "UN_NO__1": 1268
	},
	{
	  "BAKANLIK_KOD": 126802,
	  "UN_NO": 1268,
	  "ORİJİNAL İSİM": "PETROL DİSTİLATLARI, B.B.B. veya PETROL ÜRÜNLERİ, B.B.B. (50 °C'de buhar basıncı 110 kPa?dan daha yüksek olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 126802,
	  "UN_NO__1": 1268
	},
	{
	  "BAKANLIK_KOD": 126803,
	  "UN_NO": 1268,
	  "ORİJİNAL İSİM": "PETROL DİSTİLATLARI, B.B.B. veya PETROL ÜRÜNLERİ, B.B.B. (50 °C'de buhar basıncı 110 kPa?a eşit veya daha düşük olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 126803,
	  "UN_NO__1": 1268
	},
	{
	  "BAKANLIK_KOD": 126804,
	  "UN_NO": 1268,
	  "ORİJİNAL İSİM": "PETROL DİSTİLATLARI, B.B.B. veya PETROL ÜRÜNLERİ, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 126804,
	  "UN_NO__1": 1268
	},
	{
	  "BAKANLIK_KOD": 127200,
	  "UN_NO": 1272,
	  "ORİJİNAL İSİM": "ÇAM YAĞI",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 127200,
	  "UN_NO__1": 1272
	},
	{
	  "BAKANLIK_KOD": 127401,
	  "UN_NO": 1274,
	  "ORİJİNAL İSİM": "n-PROPANOL (PROPİL ALKOL, NORMAL)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 127401,
	  "UN_NO__1": 1274
	},
	{
	  "BAKANLIK_KOD": 127402,
	  "UN_NO": 1274,
	  "ORİJİNAL İSİM": "n-PROPANOL (PROPİL ALKOL, NORMAL)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 127402,
	  "UN_NO__1": 1274
	},
	{
	  "BAKANLIK_KOD": 127500,
	  "UN_NO": 1275,
	  "ORİJİNAL İSİM": "PROPİONALDEHİT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 127500,
	  "UN_NO__1": 1275
	},
	{
	  "BAKANLIK_KOD": 127600,
	  "UN_NO": 1276,
	  "ORİJİNAL İSİM": "n-PROPİL ASETAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 127600,
	  "UN_NO__1": 1276
	},
	{
	  "BAKANLIK_KOD": 127700,
	  "UN_NO": 1277,
	  "ORİJİNAL İSİM": "PROPİLAMİN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 127700,
	  "UN_NO__1": 1277
	},
	{
	  "BAKANLIK_KOD": 127800,
	  "UN_NO": 1278,
	  "ORİJİNAL İSİM": "1-KLOROPROPAN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 127800,
	  "UN_NO__1": 1278
	},
	{
	  "BAKANLIK_KOD": 127900,
	  "UN_NO": 1279,
	  "ORİJİNAL İSİM": "1,2-DİKLOROPROPAN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 127900,
	  "UN_NO__1": 1279
	},
	{
	  "BAKANLIK_KOD": 128000,
	  "UN_NO": 1280,
	  "ORİJİNAL İSİM": "PROPİLEN OKSİT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 128000,
	  "UN_NO__1": 1280
	},
	{
	  "BAKANLIK_KOD": 128100,
	  "UN_NO": 1281,
	  "ORİJİNAL İSİM": "PROPİL FORMATLAR",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 128100,
	  "UN_NO__1": 1281
	},
	{
	  "BAKANLIK_KOD": 128200,
	  "UN_NO": 1282,
	  "ORİJİNAL İSİM": "PRİDİN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 128200,
	  "UN_NO__1": 1282
	},
	{
	  "BAKANLIK_KOD": 128601,
	  "UN_NO": 1286,
	  "ORİJİNAL İSİM": "ÇAM SAKIZI YAĞI (50 °C'de buhar basıncı 110 kPa?dan daha yüksek olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 128601,
	  "UN_NO__1": 1286
	},
	{
	  "BAKANLIK_KOD": 128602,
	  "UN_NO": 1286,
	  "ORİJİNAL İSİM": "ÇAM SAKIZI YAĞI (50 °C'de buhar basıncı 110 kPa?a eşit veya daha düşük olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 128602,
	  "UN_NO__1": 1286
	},
	{
	  "BAKANLIK_KOD": 128603,
	  "UN_NO": 1286,
	  "ORİJİNAL İSİM": "ÇAM SAKIZI YAĞI",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 128603,
	  "UN_NO__1": 1286
	},
	{
	  "BAKANLIK_KOD": 128604,
	  "UN_NO": 1286,
	  "ORİJİNAL İSİM": "ÇAM SAKIZI YAĞI (2.2.3.1.4 uyarınca viskoz ve parlama noktası 23 °C'nin altında) (50 °C'de buhar basıncı 110 kPa?dan daha yüksek olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 128604,
	  "UN_NO__1": 1286
	},
	{
	  "BAKANLIK_KOD": 128605,
	  "UN_NO": 1286,
	  "ORİJİNAL İSİM": "ÇAM SAKIZI YAĞI (2.2.3.1.4 uyarınca viskoz ve parlama noktası 23 °C'nin altında) (50 °C'de buhar basıncı 110 kPa?a eşit veya daha düşük olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 128605,
	  "UN_NO__1": 1286
	},
	{
	  "BAKANLIK_KOD": 128701,
	  "UN_NO": 1287,
	  "ORİJİNAL İSİM": "KAUÇUK ÇÖZELTİSİ (50 °C'de buhar basıncı 110 kPa?dan daha yüksek olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 128701,
	  "UN_NO__1": 1287
	},
	{
	  "BAKANLIK_KOD": 128702,
	  "UN_NO": 1287,
	  "ORİJİNAL İSİM": "KAUÇUK ÇÖZELTİSİ (50 °C'de buhar basıncı 110 kPa?a eşit veya daha düşük olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 128702,
	  "UN_NO__1": 1287
	},
	{
	  "BAKANLIK_KOD": 128703,
	  "UN_NO": 1287,
	  "ORİJİNAL İSİM": "KAUÇUK ÇÖZELTİSİ",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 128703,
	  "UN_NO__1": 1287
	},
	{
	  "BAKANLIK_KOD": 128704,
	  "UN_NO": 1287,
	  "ORİJİNAL İSİM": "KAUÇUK ÇÖZELTİSİ (2.2.3.1.4 uyarınca viskoz ve parlama noktası 23 °C'nin altında) (50 °C'de buhar basıncı 110 kPa?dan daha yüksek olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 128704,
	  "UN_NO__1": 1287
	},
	{
	  "BAKANLIK_KOD": 128705,
	  "UN_NO": 1287,
	  "ORİJİNAL İSİM": "KAUÇUK ÇÖZELTİSİ (2.2.3.1.4 uyarınca viskoz ve parlama noktası 23 °C'nin altında) (50 °C'de buhar basıncı 110 kPa?a eşit veya daha düşük olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 128705,
	  "UN_NO__1": 1287
	},
	{
	  "BAKANLIK_KOD": 128801,
	  "UN_NO": 1288,
	  "ORİJİNAL İSİM": "ŞİST YAĞI",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 128801,
	  "UN_NO__1": 1288
	},
	{
	  "BAKANLIK_KOD": 128802,
	  "UN_NO": 1288,
	  "ORİJİNAL İSİM": "ŞİST YAĞI",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 128802,
	  "UN_NO__1": 1288
	},
	{
	  "BAKANLIK_KOD": 128901,
	  "UN_NO": 1289,
	  "ORİJİNAL İSİM": "SODYUM METİLAT ÇÖZELTİSİ alkolde",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 128901,
	  "UN_NO__1": 1289
	},
	{
	  "BAKANLIK_KOD": 128902,
	  "UN_NO": 1289,
	  "ORİJİNAL İSİM": "SODYUM METİLAT ÇÖZELTİSİ alkolde",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 128902,
	  "UN_NO__1": 1289
	},
	{
	  "BAKANLIK_KOD": 129200,
	  "UN_NO": 1292,
	  "ORİJİNAL İSİM": "TETRAETİL SİLİKAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 129200,
	  "UN_NO__1": 1292
	},
	{
	  "BAKANLIK_KOD": 129301,
	  "UN_NO": 1293,
	  "ORİJİNAL İSİM": "TENTÜRLER, TIBBİ",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 129301,
	  "UN_NO__1": 1293
	},
	{
	  "BAKANLIK_KOD": 129302,
	  "UN_NO": 1293,
	  "ORİJİNAL İSİM": "TENTÜRLER, TIBBİ",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 129302,
	  "UN_NO__1": 1293
	},
	{
	  "BAKANLIK_KOD": 129400,
	  "UN_NO": 1294,
	  "ORİJİNAL İSİM": "TOLÜEN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 129400,
	  "UN_NO__1": 1294
	},
	{
	  "BAKANLIK_KOD": 129500,
	  "UN_NO": 1295,
	  "ORİJİNAL İSİM": "TRİKLOROSİLAN",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WFC",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 129500,
	  "UN_NO__1": 1295
	},
	{
	  "BAKANLIK_KOD": 129600,
	  "UN_NO": 1296,
	  "ORİJİNAL İSİM": "TRİETİLAMİN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 129600,
	  "UN_NO__1": 1296
	},
	{
	  "BAKANLIK_KOD": 129701,
	  "UN_NO": 1297,
	  "ORİJİNAL İSİM": "TRİMETİLAMİN, SULU ÇÖZELTİ, kütlece %50'den az trimetilamin",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 129701,
	  "UN_NO__1": 1297
	},
	{
	  "BAKANLIK_KOD": 129702,
	  "UN_NO": 1297,
	  "ORİJİNAL İSİM": "TRİMETİLAMİN, SULU ÇÖZELTİ, kütlece %50'den az trimetilamin",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 129702,
	  "UN_NO__1": 1297
	},
	{
	  "BAKANLIK_KOD": 129703,
	  "UN_NO": 1297,
	  "ORİJİNAL İSİM": "TRİMETİLAMİN, SULU ÇÖZELTİ, kütlece %50'den az trimetilamin",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 129703,
	  "UN_NO__1": 1297
	},
	{
	  "BAKANLIK_KOD": 129800,
	  "UN_NO": 1298,
	  "ORİJİNAL İSİM": "TRİMETİLKLORO-SİLAN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 129800,
	  "UN_NO__1": 1298
	},
	{
	  "BAKANLIK_KOD": 129900,
	  "UN_NO": 1299,
	  "ORİJİNAL İSİM": "TEREBENTİN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 129900,
	  "UN_NO__1": 1299
	},
	{
	  "BAKANLIK_KOD": 130001,
	  "UN_NO": 1300,
	  "ORİJİNAL İSİM": "TEREBENTİN İKAMESİ",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 130001,
	  "UN_NO__1": 1300
	},
	{
	  "BAKANLIK_KOD": 130002,
	  "UN_NO": 1300,
	  "ORİJİNAL İSİM": "TEREBENTİN İKAMESİ",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 130002,
	  "UN_NO__1": 1300
	},
	{
	  "BAKANLIK_KOD": 130100,
	  "UN_NO": 1301,
	  "ORİJİNAL İSİM": "VİNİL ASETAT, STABİLİZE",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 130100,
	  "UN_NO__1": 1301
	},
	{
	  "BAKANLIK_KOD": 130200,
	  "UN_NO": 1302,
	  "ORİJİNAL İSİM": "VİNİL ETİL ETER, STABİLİZE",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 130200,
	  "UN_NO__1": 1302
	},
	{
	  "BAKANLIK_KOD": 130300,
	  "UN_NO": 1303,
	  "ORİJİNAL İSİM": "VİNİLİDEN KLORÜR, STABİLİZE",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 130300,
	  "UN_NO__1": 1303
	},
	{
	  "BAKANLIK_KOD": 130400,
	  "UN_NO": 1304,
	  "ORİJİNAL İSİM": "VİNİL İZOBÜTİL ETER, STABİLİZE",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 130400,
	  "UN_NO__1": 1304
	},
	{
	  "BAKANLIK_KOD": 130500,
	  "UN_NO": 1305,
	  "ORİJİNAL İSİM": "VİNİLTRİKLOROSİLAN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 130500,
	  "UN_NO__1": 1305
	},
	{
	  "BAKANLIK_KOD": 130601,
	  "UN_NO": 1306,
	  "ORİJİNAL İSİM": "AHŞAP KORUYUCULAR, SIVI (50 °C'de buhar basıncı 110 kPa?dan daha yüksek olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 130601,
	  "UN_NO__1": 1306
	},
	{
	  "BAKANLIK_KOD": 130602,
	  "UN_NO": 1306,
	  "ORİJİNAL İSİM": "AHŞAP KORUYUCULAR, SIVI (50 °C'de buhar basıncı 110 kPa?a eşit veya daha düşük olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 130602,
	  "UN_NO__1": 1306
	},
	{
	  "BAKANLIK_KOD": 130603,
	  "UN_NO": 1306,
	  "ORİJİNAL İSİM": "AHŞAP KORUYUCULAR, SIVI",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 130603,
	  "UN_NO__1": 1306
	},
	{
	  "BAKANLIK_KOD": 130604,
	  "UN_NO": 1306,
	  "ORİJİNAL İSİM": "AHŞAP KORUYUCULAR, SIVI (2.2.3.1.4 uyarınca viskoz ve parlama noktası 23 °C'nin altında) (50 °C'de buhar basıncı 110 kPa?dan daha yüksek olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 130604,
	  "UN_NO__1": 1306
	},
	{
	  "BAKANLIK_KOD": 130605,
	  "UN_NO": 1306,
	  "ORİJİNAL İSİM": "AHŞAP KORUYUCULAR, SIVI (2.2.3.1.4 uyarınca viskoz ve parlama noktası 23 °C'nin altında) (50 °C'de buhar basıncı 110 kPa?a eşit veya daha düşük olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 130605,
	  "UN_NO__1": 1306
	},
	{
	  "BAKANLIK_KOD": 130701,
	  "UN_NO": 1307,
	  "ORİJİNAL İSİM": "KSİLENLER",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 130701,
	  "UN_NO__1": 1307
	},
	{
	  "BAKANLIK_KOD": 130702,
	  "UN_NO": 1307,
	  "ORİJİNAL İSİM": "KSİLENLER",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 130702,
	  "UN_NO__1": 1307
	},
	{
	  "BAKANLIK_KOD": 130801,
	  "UN_NO": 1308,
	  "ORİJİNAL İSİM": "ZİRKONYUM, ALEVLENEBİLİR SIVI İÇİNDE ASKIDA",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 130801,
	  "UN_NO__1": 1308
	},
	{
	  "BAKANLIK_KOD": 130802,
	  "UN_NO": 1308,
	  "ORİJİNAL İSİM": "ZİRKONYUM, ALEVLENEBİLİR SIVI İÇİNDE ASKIDA (50 °C'de buhar basıncı 110 kPa?dan daha yüksek olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 130802,
	  "UN_NO__1": 1308
	},
	{
	  "BAKANLIK_KOD": 130803,
	  "UN_NO": 1308,
	  "ORİJİNAL İSİM": "ZİRKONYUM, ALEVLENEBİLİR SIVI İÇİNDE ASKIDA (50 °C'de buhar basıncı 110 kPa?a eşit veya daha düşük olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 130803,
	  "UN_NO__1": 1308
	},
	{
	  "BAKANLIK_KOD": 130804,
	  "UN_NO": 1308,
	  "ORİJİNAL İSİM": "ZİRKONYUM, ALEVLENEBİLİR SIVI İÇİNDE ASKIDA",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 130804,
	  "UN_NO__1": 1308
	},
	{
	  "BAKANLIK_KOD": 130901,
	  "UN_NO": 1309,
	  "ORİJİNAL İSİM": "ALÜMİNYUM TOZU, KAPLANMIŞ",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 130901,
	  "UN_NO__1": 1309
	},
	{
	  "BAKANLIK_KOD": 130902,
	  "UN_NO": 1309,
	  "ORİJİNAL İSİM": "ALÜMİNYUM TOZU, KAPLANMIŞ",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 130902,
	  "UN_NO__1": 1309
	},
	{
	  "BAKANLIK_KOD": 131000,
	  "UN_NO": 1310,
	  "ORİJİNAL İSİM": "AMONYUM PİKRAT, ISLATILMIŞ kütlece %10'dan az olmayan su ile",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "D",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 131000,
	  "UN_NO__1": 1310
	},
	{
	  "BAKANLIK_KOD": 131200,
	  "UN_NO": 1312,
	  "ORİJİNAL İSİM": "BORNEOL",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 131200,
	  "UN_NO__1": 1312
	},
	{
	  "BAKANLIK_KOD": 131300,
	  "UN_NO": 1313,
	  "ORİJİNAL İSİM": "KALSİYUM REZİNAT",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 131300,
	  "UN_NO__1": 1313
	},
	{
	  "BAKANLIK_KOD": 131400,
	  "UN_NO": 1314,
	  "ORİJİNAL İSİM": "KALSİYUM REZİNAT, ERGİTİLMİŞ",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 131400,
	  "UN_NO__1": 1314
	},
	{
	  "BAKANLIK_KOD": 131800,
	  "UN_NO": 1318,
	  "ORİJİNAL İSİM": "KOBALT REZİNAT, ÇÖKELMİŞ",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 131800,
	  "UN_NO__1": 1318
	},
	{
	  "BAKANLIK_KOD": 132000,
	  "UN_NO": 1320,
	  "ORİJİNAL İSİM": "DİNİTROFENOL, ISLATILMIŞ kütlece %15'ten az olmayan su ile",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "DT",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 132000,
	  "UN_NO__1": 1320
	},
	{
	  "BAKANLIK_KOD": 132100,
	  "UN_NO": 1321,
	  "ORİJİNAL İSİM": "DİNİTROFENOLATLAR, ISLATILMIŞ kütlece %15'ten az olmayan su ile",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "DT",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 132100,
	  "UN_NO__1": 1321
	},
	{
	  "BAKANLIK_KOD": 132200,
	  "UN_NO": 1322,
	  "ORİJİNAL İSİM": "DİNİTRORESORSİNOL, ISLATILMIŞ kütlece %15'ten az olmayan su ile",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "D",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 132200,
	  "UN_NO__1": 1322
	},
	{
	  "BAKANLIK_KOD": 132300,
	  "UN_NO": 1323,
	  "ORİJİNAL İSİM": "FERROSERYUM",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 132300,
	  "UN_NO__1": 1323
	},
	{
	  "BAKANLIK_KOD": 132400,
	  "UN_NO": 1324,
	  "ORİJİNAL İSİM": "FİLMLER, NİTROSELÜLOZ ESASLI, jelatin kaplı, artık olanlar hariç",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 132400,
	  "UN_NO__1": 1324
	},
	{
	  "BAKANLIK_KOD": 132501,
	  "UN_NO": 1325,
	  "ORİJİNAL İSİM": "ALEVLENEBİLİR KATI, ORGANİK, B.B.B.",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 132501,
	  "UN_NO__1": 1325
	},
	{
	  "BAKANLIK_KOD": 132502,
	  "UN_NO": 1325,
	  "ORİJİNAL İSİM": "ALEVLENEBİLİR KATI, ORGANİK, B.B.B.",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 132502,
	  "UN_NO__1": 1325
	},
	{
	  "BAKANLIK_KOD": 132600,
	  "UN_NO": 1326,
	  "ORİJİNAL İSİM": "HAFNİYUM TOZU, ISLATILMIŞ %25'ten az olmayan su ile",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 132600,
	  "UN_NO__1": 1326
	},
	{
	  "BAKANLIK_KOD": 132800,
	  "UN_NO": 1328,
	  "ORİJİNAL İSİM": "HEKZAMETİLENTETRAMİN",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 132800,
	  "UN_NO__1": 1328
	},
	{
	  "BAKANLIK_KOD": 133000,
	  "UN_NO": 1330,
	  "ORİJİNAL İSİM": "MANGANEZ REZİNAT",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 133000,
	  "UN_NO__1": 1330
	},
	{
	  "BAKANLIK_KOD": 133100,
	  "UN_NO": 1331,
	  "ORİJİNAL İSİM": "KİBRİTLER, 'HERHANGİ BİR YERDE ÇAKILABİLİR'",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 133100,
	  "UN_NO__1": 1331
	},
	{
	  "BAKANLIK_KOD": 133200,
	  "UN_NO": 1332,
	  "ORİJİNAL İSİM": "METALDEHİT",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 133200,
	  "UN_NO__1": 1332
	},
	{
	  "BAKANLIK_KOD": 133300,
	  "UN_NO": 1333,
	  "ORİJİNAL İSİM": "SERYUM, plakalar, külçeler veya çubuklar",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 133300,
	  "UN_NO__1": 1333
	},
	{
	  "BAKANLIK_KOD": 133400,
	  "UN_NO": 1334,
	  "ORİJİNAL İSİM": "NAFTALİN, HAM veya NAFTALİN, RAFİNE",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 133400,
	  "UN_NO__1": 1334
	},
	{
	  "BAKANLIK_KOD": 133600,
	  "UN_NO": 1336,
	  "ORİJİNAL İSİM": "NİTROGUANİDİN (PİKRİT), ISLATILMIŞ kütlece %20'den az olmayan su ile",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "D",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 133600,
	  "UN_NO__1": 1336
	},
	{
	  "BAKANLIK_KOD": 133700,
	  "UN_NO": 1337,
	  "ORİJİNAL İSİM": "NİTRO-NİŞASTA, ISLATILMIŞ kütlece %20'den az olmayan su ile",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "D",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 133700,
	  "UN_NO__1": 1337
	},
	{
	  "BAKANLIK_KOD": 133800,
	  "UN_NO": 1338,
	  "ORİJİNAL İSİM": "FOSFOR, AMORF",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 133800,
	  "UN_NO__1": 1338
	},
	{
	  "BAKANLIK_KOD": 133900,
	  "UN_NO": 1339,
	  "ORİJİNAL İSİM": "FOSFOR HEPTASÜLFİT, sarı ve beyaz fosfor içermeyen",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 133900,
	  "UN_NO__1": 1339
	},
	{
	  "BAKANLIK_KOD": 134000,
	  "UN_NO": 1340,
	  "ORİJİNAL İSİM": "FOSFOR PENTASÜLFİT, sarı ve beyaz fosfor içermeyen",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WF2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 134000,
	  "UN_NO__1": 1340
	},
	{
	  "BAKANLIK_KOD": 134100,
	  "UN_NO": 1341,
	  "ORİJİNAL İSİM": "FOSFOR SESKUİSÜLFİT, sarı ve beyaz fosfor içermeyen",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 134100,
	  "UN_NO__1": 1341
	},
	{
	  "BAKANLIK_KOD": 134300,
	  "UN_NO": 1343,
	  "ORİJİNAL İSİM": "FOSFOR TRİSÜLFİT, sarı ve beyaz fosfor içermeyen",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 134300,
	  "UN_NO__1": 1343
	},
	{
	  "BAKANLIK_KOD": 134400,
	  "UN_NO": 1344,
	  "ORİJİNAL İSİM": "TRİNİTROFENOL (PİKRİK ASİT) ISLATILMIŞ kütlece %30'dan az olmayan su ile",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "D",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 134400,
	  "UN_NO__1": 1344
	},
	{
	  "BAKANLIK_KOD": 134500,
	  "UN_NO": 1345,
	  "ORİJİNAL İSİM": "KAUÇUK HURDA veya KAUÇUK DÖKÜNTÜ, toz veya granül halde",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 134500,
	  "UN_NO__1": 1345
	},
	{
	  "BAKANLIK_KOD": 134600,
	  "UN_NO": 1346,
	  "ORİJİNAL İSİM": "SİLİSYUM TOZU, AMORF",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 134600,
	  "UN_NO__1": 1346
	},
	{
	  "BAKANLIK_KOD": 134700,
	  "UN_NO": 1347,
	  "ORİJİNAL İSİM": "GÜMÜŞ PİKRAT, ISLATILMIŞ kütlece %30'dan az olmayan su ile",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "D",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 134700,
	  "UN_NO__1": 1347
	},
	{
	  "BAKANLIK_KOD": 134800,
	  "UN_NO": 1348,
	  "ORİJİNAL İSİM": "SODYUM DİNİTRO-o-KRESOLAT, ISLATILMIŞ kütlece %15'ten az olmayan su ile",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "DT",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 134800,
	  "UN_NO__1": 1348
	},
	{
	  "BAKANLIK_KOD": 134900,
	  "UN_NO": 1349,
	  "ORİJİNAL İSİM": "SODYUM PİKRAMAT, ISLATILMIŞ kütlece %20'den az olmayan su ile",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "D",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 134900,
	  "UN_NO__1": 1349
	},
	{
	  "BAKANLIK_KOD": 135000,
	  "UN_NO": 1350,
	  "ORİJİNAL İSİM": "SÜLFÜR",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 135000,
	  "UN_NO__1": 1350
	},
	{
	  "BAKANLIK_KOD": 135200,
	  "UN_NO": 1352,
	  "ORİJİNAL İSİM": "TİTANYUM TOZU, ISLATILMIŞ %25'ten az olmayan su ile",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 135200,
	  "UN_NO__1": 1352
	},
	{
	  "BAKANLIK_KOD": 135300,
	  "UN_NO": 1353,
	  "ORİJİNAL İSİM": "LİFLER veya KUMAŞLAR, HAFİFÇE NİTRATLANMIŞ NİTROSELÜLOZA EMDİRİLMİŞ, B.B.B.",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 135300,
	  "UN_NO__1": 1353
	},
	{
	  "BAKANLIK_KOD": 135400,
	  "UN_NO": 1354,
	  "ORİJİNAL İSİM": "TRİNİTROBENZEN, ISLATILMIŞ kütlece %30'dan az olmayan su ile",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "D",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 135400,
	  "UN_NO__1": 1354
	},
	{
	  "BAKANLIK_KOD": 135500,
	  "UN_NO": 1355,
	  "ORİJİNAL İSİM": "TRİNİTROBENZOİK ASİT, ISLATILMIŞ kütlece %30'dan az olmayan su ile",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "D",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 135500,
	  "UN_NO__1": 1355
	},
	{
	  "BAKANLIK_KOD": 135600,
	  "UN_NO": 1356,
	  "ORİJİNAL İSİM": "TRİNİTROTOLUEN (TNT), ISLATILMIŞ kütlece %30'dan az olmayan su ile",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "D",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 135600,
	  "UN_NO__1": 1356
	},
	{
	  "BAKANLIK_KOD": 135700,
	  "UN_NO": 1357,
	  "ORİJİNAL İSİM": "ÜRE NİTRAT, ISLATILMIŞ kütlece %20'den az olmayan su ile",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "D",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 135700,
	  "UN_NO__1": 1357
	},
	{
	  "BAKANLIK_KOD": 135800,
	  "UN_NO": 1358,
	  "ORİJİNAL İSİM": "ZİRKONYUM TOZU, ISLATILMIŞ %25'ten az olmayan su ile",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 135800,
	  "UN_NO__1": 1358
	},
	{
	  "BAKANLIK_KOD": 136000,
	  "UN_NO": 1360,
	  "ORİJİNAL İSİM": "KALSİYUM FOSFÜR",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WT2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 136000,
	  "UN_NO__1": 1360
	},
	{
	  "BAKANLIK_KOD": 136101,
	  "UN_NO": 1361,
	  "ORİJİNAL İSİM": "KARBON, hayvansal veya bitkisel kaynaklı",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 136101,
	  "UN_NO__1": 1361
	},
	{
	  "BAKANLIK_KOD": 136102,
	  "UN_NO": 1361,
	  "ORİJİNAL İSİM": "KARBON, hayvansal veya bitkisel kaynaklı",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 136102,
	  "UN_NO__1": 1361
	},
	{
	  "BAKANLIK_KOD": 136200,
	  "UN_NO": 1362,
	  "ORİJİNAL İSİM": "KARBON, AKTİF",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 136200,
	  "UN_NO__1": 1362
	},
	{
	  "BAKANLIK_KOD": 136300,
	  "UN_NO": 1363,
	  "ORİJİNAL İSİM": "KOPRA",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 136300,
	  "UN_NO__1": 1363
	},
	{
	  "BAKANLIK_KOD": 136400,
	  "UN_NO": 1364,
	  "ORİJİNAL İSİM": "PAMUK ARTIĞI, YAĞLI",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 136400,
	  "UN_NO__1": 1364
	},
	{
	  "BAKANLIK_KOD": 136500,
	  "UN_NO": 1365,
	  "ORİJİNAL İSİM": "PAMUK, NEMLİ",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 136500,
	  "UN_NO__1": 1365
	},
	{
	  "BAKANLIK_KOD": 136900,
	  "UN_NO": 1369,
	  "ORİJİNAL İSİM": "p-NİTROSODİMETİL- ANİLİN",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 136900,
	  "UN_NO__1": 1369
	},
	{
	  "BAKANLIK_KOD": 137300,
	  "UN_NO": 1373,
	  "ORİJİNAL İSİM": "LİFLER veya KUMAŞLAR, HAYVANSAL veya BİTKİSEL veya SENTETİK, B.B.B. yağlı",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 137300,
	  "UN_NO__1": 1373
	},
	{
	  "BAKANLIK_KOD": 137400,
	  "UN_NO": 1374,
	  "ORİJİNAL İSİM": "BALIK YEMİ (BALIK ATIKLARI), STABİLİZE OLMAYAN",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 137400,
	  "UN_NO__1": 1374
	},
	{
	  "BAKANLIK_KOD": 137600,
	  "UN_NO": 1376,
	  "ORİJİNAL İSİM": "DEMİR OKSİT, KULLANILMIŞ veya DEMİR SÜNGERİ, KULLANILMIŞ, kömür gaz saflaştırma ile elde edilen",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S4",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 137600,
	  "UN_NO__1": 1376
	},
	{
	  "BAKANLIK_KOD": 137800,
	  "UN_NO": 1378,
	  "ORİJİNAL İSİM": "METAL KATALİZÖR, ISLATILMIŞ, görünür derecede fazla sıvı ile",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S4",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 137800,
	  "UN_NO__1": 1378
	},
	{
	  "BAKANLIK_KOD": 137900,
	  "UN_NO": 1379,
	  "ORİJİNAL İSİM": "KAĞIT, DOYMAMIŞ YAĞ İLE İŞLEM GÖRMÜŞ, tümüyle kurutulmamış (karbon kağıt dahil)",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 137900,
	  "UN_NO__1": 1379
	},
	{
	  "BAKANLIK_KOD": 138000,
	  "UN_NO": 1380,
	  "ORİJİNAL İSİM": "PENTABORAN",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "ST3",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 138000,
	  "UN_NO__1": 1380
	},
	{
	  "BAKANLIK_KOD": 138101,
	  "UN_NO": 1381,
	  "ORİJİNAL İSİM": "FOSFOR, BEYAZ veya SARI, SU ALTINDA veya ÇÖZELTİ İÇİNDE",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "ST3",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 138101,
	  "UN_NO__1": 1381
	},
	{
	  "BAKANLIK_KOD": 138102,
	  "UN_NO": 1381,
	  "ORİJİNAL İSİM": "FOSFOR, BEYAZ veya SARI, KURU",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "ST4",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 138102,
	  "UN_NO__1": 1381
	},
	{
	  "BAKANLIK_KOD": 138200,
	  "UN_NO": 1382,
	  "ORİJİNAL İSİM": "POTASYUM SÜLFÜR, SUSUZ veya POTASYUM SÜLFÜR %30'dan az kristalizasyon suyu ile",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S4",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 138200,
	  "UN_NO__1": 1382
	},
	{
	  "BAKANLIK_KOD": 138300,
	  "UN_NO": 1383,
	  "ORİJİNAL İSİM": "PİROFORİK METAL, B.B.B. veya PİROFORİK ALAŞIM, B.B.B.",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S4",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 138300,
	  "UN_NO__1": 1383
	},
	{
	  "BAKANLIK_KOD": 138400,
	  "UN_NO": 1384,
	  "ORİJİNAL İSİM": "SODYUM DİTİYONİT (SODYUM HİDROSÜLFİT)",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S4",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 138400,
	  "UN_NO__1": 1384
	},
	{
	  "BAKANLIK_KOD": 138500,
	  "UN_NO": 1385,
	  "ORİJİNAL İSİM": "SODYUM SÜLFİT, SUSUZ veya SODYUM SÜLFİT %30'dan az kristalizasyon suyu ile",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S4",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 138500,
	  "UN_NO__1": 1385
	},
	{
	  "BAKANLIK_KOD": 138600,
	  "UN_NO": 1386,
	  "ORİJİNAL İSİM": "TOHUM KÜSPESİ kütlece %1,5'ten fazla yağ ve kütlece %11'den az nem ile",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 138600,
	  "UN_NO__1": 1386
	},
	{
	  "BAKANLIK_KOD": 138900,
	  "UN_NO": 1389,
	  "ORİJİNAL İSİM": "ALKALİ METAL AMALGAM, SIVI",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 138900,
	  "UN_NO__1": 1389
	},
	{
	  "BAKANLIK_KOD": 139000,
	  "UN_NO": 1390,
	  "ORİJİNAL İSİM": "ALKALİ METAL AMİTLER",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 139000,
	  "UN_NO__1": 1390
	},
	{
	  "BAKANLIK_KOD": 139100,
	  "UN_NO": 1391,
	  "ORİJİNAL İSİM": "ALKALİ METAL DAĞILIMI veya ALKALİ TOPRAK METAL DAĞILIMI",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 139100,
	  "UN_NO__1": 1391
	},
	{
	  "BAKANLIK_KOD": 139200,
	  "UN_NO": 1392,
	  "ORİJİNAL İSİM": "ALKALİ TOPRAK METAL AMALGAM, SIVI",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 139200,
	  "UN_NO__1": 1392
	},
	{
	  "BAKANLIK_KOD": 139300,
	  "UN_NO": 1393,
	  "ORİJİNAL İSİM": "ALKALİ TOPRAK METAL ALAŞIM, B.B.B.",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 139300,
	  "UN_NO__1": 1393
	},
	{
	  "BAKANLIK_KOD": 139400,
	  "UN_NO": 1394,
	  "ORİJİNAL İSİM": "ALÜMİNYUM KARBÜR",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 139400,
	  "UN_NO__1": 1394
	},
	{
	  "BAKANLIK_KOD": 139500,
	  "UN_NO": 1395,
	  "ORİJİNAL İSİM": "ALÜMİNYUM FERROSİLİSYUM TOZU",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WT2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 139500,
	  "UN_NO__1": 1395
	},
	{
	  "BAKANLIK_KOD": 139601,
	  "UN_NO": 1396,
	  "ORİJİNAL İSİM": "ALÜMİNYUM TOZU, KAPLANMAMIŞ",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 139601,
	  "UN_NO__1": 1396
	},
	{
	  "BAKANLIK_KOD": 139602,
	  "UN_NO": 1396,
	  "ORİJİNAL İSİM": "ALÜMİNYUM TOZU, KAPLANMAMIŞ",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 139602,
	  "UN_NO__1": 1396
	},
	{
	  "BAKANLIK_KOD": 139700,
	  "UN_NO": 1397,
	  "ORİJİNAL İSİM": "ALÜMİNYUM FOSFÜR",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WT2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 139700,
	  "UN_NO__1": 1397
	},
	{
	  "BAKANLIK_KOD": 139800,
	  "UN_NO": 1398,
	  "ORİJİNAL İSİM": "ALÜMİNYUM SİLİSYUM TOZU, KAPLANMAMIŞ",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 139800,
	  "UN_NO__1": 1398
	},
	{
	  "BAKANLIK_KOD": 140000,
	  "UN_NO": 1400,
	  "ORİJİNAL İSİM": "BARYUM",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 140000,
	  "UN_NO__1": 1400
	},
	{
	  "BAKANLIK_KOD": 140100,
	  "UN_NO": 1401,
	  "ORİJİNAL İSİM": "KALSİYUM",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 140100,
	  "UN_NO__1": 1401
	},
	{
	  "BAKANLIK_KOD": 140201,
	  "UN_NO": 1402,
	  "ORİJİNAL İSİM": "KALSİYUM KARBÜR",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 140201,
	  "UN_NO__1": 1402
	},
	{
	  "BAKANLIK_KOD": 140202,
	  "UN_NO": 1402,
	  "ORİJİNAL İSİM": "KALSİYUM KARBÜR",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 140202,
	  "UN_NO__1": 1402
	},
	{
	  "BAKANLIK_KOD": 140300,
	  "UN_NO": 1403,
	  "ORİJİNAL İSİM": "KALSİYUM SİYANAMİD %0,1'den fazla kalsiyum karbür ile",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 140300,
	  "UN_NO__1": 1403
	},
	{
	  "BAKANLIK_KOD": 140400,
	  "UN_NO": 1404,
	  "ORİJİNAL İSİM": "KALSİYUM HİDRÜR",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 140400,
	  "UN_NO__1": 1404
	},
	{
	  "BAKANLIK_KOD": 140501,
	  "UN_NO": 1405,
	  "ORİJİNAL İSİM": "KALSİYUM SİLİSİD",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 140501,
	  "UN_NO__1": 1405
	},
	{
	  "BAKANLIK_KOD": 140502,
	  "UN_NO": 1405,
	  "ORİJİNAL İSİM": "KALSİYUM SİLİSİD",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 140502,
	  "UN_NO__1": 1405
	},
	{
	  "BAKANLIK_KOD": 140700,
	  "UN_NO": 1407,
	  "ORİJİNAL İSİM": "SEZYUM",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 140700,
	  "UN_NO__1": 1407
	},
	{
	  "BAKANLIK_KOD": 140800,
	  "UN_NO": 1408,
	  "ORİJİNAL İSİM": "FERROSİLİSYUM %30 veya daha fazla ancak %90'dan az silisyum ile",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WT2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 140800,
	  "UN_NO__1": 1408
	},
	{
	  "BAKANLIK_KOD": 140901,
	  "UN_NO": 1409,
	  "ORİJİNAL İSİM": "METAL HİDRİTLER, SU İLE TEPKİMEYE GİREN, B.B.B",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 140901,
	  "UN_NO__1": 1409
	},
	{
	  "BAKANLIK_KOD": 140902,
	  "UN_NO": 1409,
	  "ORİJİNAL İSİM": "METAL HİDRİTLER, SU İLE TEPKİMEYE GİREN, B.B.B",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 140902,
	  "UN_NO__1": 1409
	},
	{
	  "BAKANLIK_KOD": 141000,
	  "UN_NO": 1410,
	  "ORİJİNAL İSİM": "LİTYUM ALÜMİNYUM HİDRÜR",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 141000,
	  "UN_NO__1": 1410
	},
	{
	  "BAKANLIK_KOD": 141100,
	  "UN_NO": 1411,
	  "ORİJİNAL İSİM": "LİTYUM ALÜMİNYUM HİDRÜR, ETERSİ",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 141100,
	  "UN_NO__1": 1411
	},
	{
	  "BAKANLIK_KOD": 141300,
	  "UN_NO": 1413,
	  "ORİJİNAL İSİM": "LİTYUM BOROHİDRÜR",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 141300,
	  "UN_NO__1": 1413
	},
	{
	  "BAKANLIK_KOD": 141400,
	  "UN_NO": 1414,
	  "ORİJİNAL İSİM": "LİTYUM HİDRÜR",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 141400,
	  "UN_NO__1": 1414
	},
	{
	  "BAKANLIK_KOD": 141500,
	  "UN_NO": 1415,
	  "ORİJİNAL İSİM": "LİTYUM",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 141500,
	  "UN_NO__1": 1415
	},
	{
	  "BAKANLIK_KOD": 141700,
	  "UN_NO": 1417,
	  "ORİJİNAL İSİM": "LİTYUM SİLİS",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 141700,
	  "UN_NO__1": 1417
	},
	{
	  "BAKANLIK_KOD": 141801,
	  "UN_NO": 1418,
	  "ORİJİNAL İSİM": "MAGNEZYUM TOZU veya MAGNEZYUM ALAŞIMLARI TOZU",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WS",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 141801,
	  "UN_NO__1": 1418
	},
	{
	  "BAKANLIK_KOD": 141802,
	  "UN_NO": 1418,
	  "ORİJİNAL İSİM": "MAGNEZYUM TOZU veya MAGNEZYUM ALAŞIMLARI TOZU",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WS",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 141802,
	  "UN_NO__1": 1418
	},
	{
	  "BAKANLIK_KOD": 141803,
	  "UN_NO": 1418,
	  "ORİJİNAL İSİM": "MAGNEZYUM TOZU veya MAGNEZYUM ALAŞIMLARI TOZU",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WS",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 141803,
	  "UN_NO__1": 1418
	},
	{
	  "BAKANLIK_KOD": 141900,
	  "UN_NO": 1419,
	  "ORİJİNAL İSİM": "MAGNEZYUM ALÜMİNYUM FOSFÜR",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WT2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 141900,
	  "UN_NO__1": 1419
	},
	{
	  "BAKANLIK_KOD": 142000,
	  "UN_NO": 1420,
	  "ORİJİNAL İSİM": "POTASYUM METAL ALAŞIMLARI, SIVI",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 142000,
	  "UN_NO__1": 1420
	},
	{
	  "BAKANLIK_KOD": 142100,
	  "UN_NO": 1421,
	  "ORİJİNAL İSİM": "ALKALİ METAL ALAŞIM, SIVI, B.B.B.",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 142100,
	  "UN_NO__1": 1421
	},
	{
	  "BAKANLIK_KOD": 142200,
	  "UN_NO": 1422,
	  "ORİJİNAL İSİM": "POTASYUM SODYUM ALAŞIMLARI, SIVI",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 142200,
	  "UN_NO__1": 1422
	},
	{
	  "BAKANLIK_KOD": 142300,
	  "UN_NO": 1423,
	  "ORİJİNAL İSİM": "RUBİDYUM",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 142300,
	  "UN_NO__1": 1423
	},
	{
	  "BAKANLIK_KOD": 142600,
	  "UN_NO": 1426,
	  "ORİJİNAL İSİM": "SODYUM BOROHİDRÜR",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 142600,
	  "UN_NO__1": 1426
	},
	{
	  "BAKANLIK_KOD": 142700,
	  "UN_NO": 1427,
	  "ORİJİNAL İSİM": "SODYUM HİDRÜR",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 142700,
	  "UN_NO__1": 1427
	},
	{
	  "BAKANLIK_KOD": 142800,
	  "UN_NO": 1428,
	  "ORİJİNAL İSİM": "SODYUM",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 142800,
	  "UN_NO__1": 1428
	},
	{
	  "BAKANLIK_KOD": 143100,
	  "UN_NO": 1431,
	  "ORİJİNAL İSİM": "SODYUM METİLAT",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "SC4",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 143100,
	  "UN_NO__1": 1431
	},
	{
	  "BAKANLIK_KOD": 143200,
	  "UN_NO": 1432,
	  "ORİJİNAL İSİM": "SODYUM FOSFÜR",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WT2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 143200,
	  "UN_NO__1": 1432
	},
	{
	  "BAKANLIK_KOD": 143300,
	  "UN_NO": 1433,
	  "ORİJİNAL İSİM": "KALAY FOSFÜRLER",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WT2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 143300,
	  "UN_NO__1": 1433
	},
	{
	  "BAKANLIK_KOD": 143500,
	  "UN_NO": 1435,
	  "ORİJİNAL İSİM": "ÇİNKO KÜLLERİ",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 143500,
	  "UN_NO__1": 1435
	},
	{
	  "BAKANLIK_KOD": 143601,
	  "UN_NO": 1436,
	  "ORİJİNAL İSİM": "ÇİNKO TOZU veya ÇİNKO TOZ",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WS",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 143601,
	  "UN_NO__1": 1436
	},
	{
	  "BAKANLIK_KOD": 143602,
	  "UN_NO": 1436,
	  "ORİJİNAL İSİM": "ÇİNKO TOZU veya ÇİNKO TOZ",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WS",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 143602,
	  "UN_NO__1": 1436
	},
	{
	  "BAKANLIK_KOD": 143603,
	  "UN_NO": 1436,
	  "ORİJİNAL İSİM": "ÇİNKO TOZU veya ÇİNKO TOZ",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WS",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 143603,
	  "UN_NO__1": 1436
	},
	{
	  "BAKANLIK_KOD": 143700,
	  "UN_NO": 1437,
	  "ORİJİNAL İSİM": "ZİRKONYUM HİDRÜR",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 143700,
	  "UN_NO__1": 1437
	},
	{
	  "BAKANLIK_KOD": 143800,
	  "UN_NO": 1438,
	  "ORİJİNAL İSİM": "ALÜMİNYUM NİTRAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 143800,
	  "UN_NO__1": 1438
	},
	{
	  "BAKANLIK_KOD": 143900,
	  "UN_NO": 1439,
	  "ORİJİNAL İSİM": "AMONYUM DİKROMAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 143900,
	  "UN_NO__1": 1439
	},
	{
	  "BAKANLIK_KOD": 144200,
	  "UN_NO": 1442,
	  "ORİJİNAL İSİM": "AMONYUM PERKLORAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 144200,
	  "UN_NO__1": 1442
	},
	{
	  "BAKANLIK_KOD": 144400,
	  "UN_NO": 1444,
	  "ORİJİNAL İSİM": "AMONYUM PERSÜLFAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 144400,
	  "UN_NO__1": 1444
	},
	{
	  "BAKANLIK_KOD": 144500,
	  "UN_NO": 1445,
	  "ORİJİNAL İSİM": "BARYUM KLORAT, KATI",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OT2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 144500,
	  "UN_NO__1": 1445
	},
	{
	  "BAKANLIK_KOD": 144600,
	  "UN_NO": 1446,
	  "ORİJİNAL İSİM": "BARYUM NİTRAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OT2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 144600,
	  "UN_NO__1": 1446
	},
	{
	  "BAKANLIK_KOD": 144700,
	  "UN_NO": 1447,
	  "ORİJİNAL İSİM": "BARYUM PERKLORAT, KATI",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OT2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 144700,
	  "UN_NO__1": 1447
	},
	{
	  "BAKANLIK_KOD": 144800,
	  "UN_NO": 1448,
	  "ORİJİNAL İSİM": "BARYUM PERMANGANAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OT2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 144800,
	  "UN_NO__1": 1448
	},
	{
	  "BAKANLIK_KOD": 144900,
	  "UN_NO": 1449,
	  "ORİJİNAL İSİM": "BARYUM PEROKSİT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OT2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 144900,
	  "UN_NO__1": 1449
	},
	{
	  "BAKANLIK_KOD": 145000,
	  "UN_NO": 1450,
	  "ORİJİNAL İSİM": "BROMATLAR, İNORGANİK, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 145000,
	  "UN_NO__1": 1450
	},
	{
	  "BAKANLIK_KOD": 145100,
	  "UN_NO": 1451,
	  "ORİJİNAL İSİM": "SEZYUM NİTRAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 145100,
	  "UN_NO__1": 1451
	},
	{
	  "BAKANLIK_KOD": 145200,
	  "UN_NO": 1452,
	  "ORİJİNAL İSİM": "KALSİYUM KLORAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 145200,
	  "UN_NO__1": 1452
	},
	{
	  "BAKANLIK_KOD": 145300,
	  "UN_NO": 1453,
	  "ORİJİNAL İSİM": "KALSİYUM KLORÜR",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 145300,
	  "UN_NO__1": 1453
	},
	{
	  "BAKANLIK_KOD": 145400,
	  "UN_NO": 1454,
	  "ORİJİNAL İSİM": "KALSİYUM NİTRAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 145400,
	  "UN_NO__1": 1454
	},
	{
	  "BAKANLIK_KOD": 145500,
	  "UN_NO": 1455,
	  "ORİJİNAL İSİM": "KALSİYUM PERKLORAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 145500,
	  "UN_NO__1": 1455
	},
	{
	  "BAKANLIK_KOD": 145600,
	  "UN_NO": 1456,
	  "ORİJİNAL İSİM": "KALSİYUM PERMANGANAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 145600,
	  "UN_NO__1": 1456
	},
	{
	  "BAKANLIK_KOD": 145700,
	  "UN_NO": 1457,
	  "ORİJİNAL İSİM": "KALSİYUM PEROKSİT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 145700,
	  "UN_NO__1": 1457
	},
	{
	  "BAKANLIK_KOD": 145801,
	  "UN_NO": 1458,
	  "ORİJİNAL İSİM": "KLORAT VE BORAT KARIŞIMI",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 145801,
	  "UN_NO__1": 1458
	},
	{
	  "BAKANLIK_KOD": 145802,
	  "UN_NO": 1458,
	  "ORİJİNAL İSİM": "KLORAT VE BORAT KARIŞIMI",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 145802,
	  "UN_NO__1": 1458
	},
	{
	  "BAKANLIK_KOD": 145901,
	  "UN_NO": 1459,
	  "ORİJİNAL İSİM": "KLORAT VE MAGNEZYUM KLORÜR KARIŞIMI, KATI",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 145901,
	  "UN_NO__1": 1459
	},
	{
	  "BAKANLIK_KOD": 145902,
	  "UN_NO": 1459,
	  "ORİJİNAL İSİM": "KLORAT VE MAGNEZYUM KLORÜR KARIŞIMI, KATI",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 145902,
	  "UN_NO__1": 1459
	},
	{
	  "BAKANLIK_KOD": 146100,
	  "UN_NO": 1461,
	  "ORİJİNAL İSİM": "KLORATLAR, İNORGANİK, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 146100,
	  "UN_NO__1": 1461
	},
	{
	  "BAKANLIK_KOD": 146200,
	  "UN_NO": 1462,
	  "ORİJİNAL İSİM": "KLORÜRLER, İNORGANİK, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 146200,
	  "UN_NO__1": 1462
	},
	{
	  "BAKANLIK_KOD": 146300,
	  "UN_NO": 1463,
	  "ORİJİNAL İSİM": "KROM TRİOKSİT, SUSUZ",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OTC",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 146300,
	  "UN_NO__1": 1463
	},
	{
	  "BAKANLIK_KOD": 146500,
	  "UN_NO": 1465,
	  "ORİJİNAL İSİM": "DİDİMİYUM NİTRAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 146500,
	  "UN_NO__1": 1465
	},
	{
	  "BAKANLIK_KOD": 146600,
	  "UN_NO": 1466,
	  "ORİJİNAL İSİM": "DEMİR (III) NİTRAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 146600,
	  "UN_NO__1": 1466
	},
	{
	  "BAKANLIK_KOD": 146700,
	  "UN_NO": 1467,
	  "ORİJİNAL İSİM": "GUANİDİN NİTRAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 146700,
	  "UN_NO__1": 1467
	},
	{
	  "BAKANLIK_KOD": 146900,
	  "UN_NO": 1469,
	  "ORİJİNAL İSİM": "KURŞUN (II) NİTRAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OT2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 146900,
	  "UN_NO__1": 1469
	},
	{
	  "BAKANLIK_KOD": 147000,
	  "UN_NO": 1470,
	  "ORİJİNAL İSİM": "KURŞUN (II) PERKLORAT, KATI",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OT2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 147000,
	  "UN_NO__1": 1470
	},
	{
	  "BAKANLIK_KOD": 147101,
	  "UN_NO": 1471,
	  "ORİJİNAL İSİM": "LİTYUM HİPOKLORİT, KURU veya LİTYUM HİPOKLORİT KARIŞIMI",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 147101,
	  "UN_NO__1": 1471
	},
	{
	  "BAKANLIK_KOD": 147102,
	  "UN_NO": 1471,
	  "ORİJİNAL İSİM": "LİTYUM HİPOKLORİT, KURU veya LİTYUM HİPOKLORİT KARIŞIMI",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 147102,
	  "UN_NO__1": 1471
	},
	{
	  "BAKANLIK_KOD": 147200,
	  "UN_NO": 1472,
	  "ORİJİNAL İSİM": "LİTYUM PEROKSİT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 147200,
	  "UN_NO__1": 1472
	},
	{
	  "BAKANLIK_KOD": 147300,
	  "UN_NO": 1473,
	  "ORİJİNAL İSİM": "MAGNEZYUM BROMAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 147300,
	  "UN_NO__1": 1473
	},
	{
	  "BAKANLIK_KOD": 147400,
	  "UN_NO": 1474,
	  "ORİJİNAL İSİM": "MAGNEZYUM NİTRAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 147400,
	  "UN_NO__1": 1474
	},
	{
	  "BAKANLIK_KOD": 147500,
	  "UN_NO": 1475,
	  "ORİJİNAL İSİM": "MAGNEZYUM PERKLORAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 147500,
	  "UN_NO__1": 1475
	},
	{
	  "BAKANLIK_KOD": 147600,
	  "UN_NO": 1476,
	  "ORİJİNAL İSİM": "MAGNEZYUM PEROKSİT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 147600,
	  "UN_NO__1": 1476
	},
	{
	  "BAKANLIK_KOD": 147701,
	  "UN_NO": 1477,
	  "ORİJİNAL İSİM": "NİTRATLAR, İNORGANİK, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 147701,
	  "UN_NO__1": 1477
	},
	{
	  "BAKANLIK_KOD": 147702,
	  "UN_NO": 1477,
	  "ORİJİNAL İSİM": "NİTRATLAR, İNORGANİK, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 147702,
	  "UN_NO__1": 1477
	},
	{
	  "BAKANLIK_KOD": 147901,
	  "UN_NO": 1479,
	  "ORİJİNAL İSİM": "YÜKSELTGEN KATI, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 147901,
	  "UN_NO__1": 1479
	},
	{
	  "BAKANLIK_KOD": 147902,
	  "UN_NO": 1479,
	  "ORİJİNAL İSİM": "YÜKSELTGEN KATI, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 147902,
	  "UN_NO__1": 1479
	},
	{
	  "BAKANLIK_KOD": 147903,
	  "UN_NO": 1479,
	  "ORİJİNAL İSİM": "YÜKSELTGEN KATI, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 147903,
	  "UN_NO__1": 1479
	},
	{
	  "BAKANLIK_KOD": 148101,
	  "UN_NO": 1481,
	  "ORİJİNAL İSİM": "PERKLORATLAR, İNORGANİK, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 148101,
	  "UN_NO__1": 1481
	},
	{
	  "BAKANLIK_KOD": 148102,
	  "UN_NO": 1481,
	  "ORİJİNAL İSİM": "PERKLORATLAR, İNORGANİK, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 148102,
	  "UN_NO__1": 1481
	},
	{
	  "BAKANLIK_KOD": 148201,
	  "UN_NO": 1482,
	  "ORİJİNAL İSİM": "PERMANGANATLAR, İNORGANİK, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 148201,
	  "UN_NO__1": 1482
	},
	{
	  "BAKANLIK_KOD": 148202,
	  "UN_NO": 1482,
	  "ORİJİNAL İSİM": "PERMANGANATLAR, İNORGANİK, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 148202,
	  "UN_NO__1": 1482
	},
	{
	  "BAKANLIK_KOD": 148301,
	  "UN_NO": 1483,
	  "ORİJİNAL İSİM": "PEROKSİTLER, İNORGANİK, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 148301,
	  "UN_NO__1": 1483
	},
	{
	  "BAKANLIK_KOD": 148302,
	  "UN_NO": 1483,
	  "ORİJİNAL İSİM": "PEROKSİTLER, İNORGANİK, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 148302,
	  "UN_NO__1": 1483
	},
	{
	  "BAKANLIK_KOD": 148400,
	  "UN_NO": 1484,
	  "ORİJİNAL İSİM": "POTASYUM BROMAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 148400,
	  "UN_NO__1": 1484
	},
	{
	  "BAKANLIK_KOD": 148500,
	  "UN_NO": 1485,
	  "ORİJİNAL İSİM": "POTASYUM KLORAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 148500,
	  "UN_NO__1": 1485
	},
	{
	  "BAKANLIK_KOD": 148600,
	  "UN_NO": 1486,
	  "ORİJİNAL İSİM": "POTASYUM NİTRAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 148600,
	  "UN_NO__1": 1486
	},
	{
	  "BAKANLIK_KOD": 148700,
	  "UN_NO": 1487,
	  "ORİJİNAL İSİM": "POTASYUM NİTRAT VE SODYUM NİTRİT KARIŞIMI",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 148700,
	  "UN_NO__1": 1487
	},
	{
	  "BAKANLIK_KOD": 148800,
	  "UN_NO": 1488,
	  "ORİJİNAL İSİM": "POTASYUM NİTRİT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 148800,
	  "UN_NO__1": 1488
	},
	{
	  "BAKANLIK_KOD": 148900,
	  "UN_NO": 1489,
	  "ORİJİNAL İSİM": "POTASYUM PERKLORAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 148900,
	  "UN_NO__1": 1489
	},
	{
	  "BAKANLIK_KOD": 149000,
	  "UN_NO": 1490,
	  "ORİJİNAL İSİM": "POTASYUM PERMANGANAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 149000,
	  "UN_NO__1": 1490
	},
	{
	  "BAKANLIK_KOD": 149100,
	  "UN_NO": 1491,
	  "ORİJİNAL İSİM": "POTASYUM PEROKSİT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 149100,
	  "UN_NO__1": 1491
	},
	{
	  "BAKANLIK_KOD": 149200,
	  "UN_NO": 1492,
	  "ORİJİNAL İSİM": "POTASYUM PERSÜLFAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 149200,
	  "UN_NO__1": 1492
	},
	{
	  "BAKANLIK_KOD": 149300,
	  "UN_NO": 1493,
	  "ORİJİNAL İSİM": "GÜMÜŞ NİTRAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 149300,
	  "UN_NO__1": 1493
	},
	{
	  "BAKANLIK_KOD": 149400,
	  "UN_NO": 1494,
	  "ORİJİNAL İSİM": "SODYUM BROMAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 149400,
	  "UN_NO__1": 1494
	},
	{
	  "BAKANLIK_KOD": 149500,
	  "UN_NO": 1495,
	  "ORİJİNAL İSİM": "SODYUM KLORAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 149500,
	  "UN_NO__1": 1495
	},
	{
	  "BAKANLIK_KOD": 149600,
	  "UN_NO": 1496,
	  "ORİJİNAL İSİM": "SODYUM KLORİT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 149600,
	  "UN_NO__1": 1496
	},
	{
	  "BAKANLIK_KOD": 149800,
	  "UN_NO": 1498,
	  "ORİJİNAL İSİM": "SODYUM NİTRAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 149800,
	  "UN_NO__1": 1498
	},
	{
	  "BAKANLIK_KOD": 149900,
	  "UN_NO": 1499,
	  "ORİJİNAL İSİM": "POTASYUM NİTRAT VE SODYUM NİTRAT KARIŞIMI",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 149900,
	  "UN_NO__1": 1499
	},
	{
	  "BAKANLIK_KOD": 150000,
	  "UN_NO": 1500,
	  "ORİJİNAL İSİM": "SODYUM NİTRİT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OT2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 150000,
	  "UN_NO__1": 1500
	},
	{
	  "BAKANLIK_KOD": 150200,
	  "UN_NO": 1502,
	  "ORİJİNAL İSİM": "SODYUM PERKLORAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 150200,
	  "UN_NO__1": 1502
	},
	{
	  "BAKANLIK_KOD": 150300,
	  "UN_NO": 1503,
	  "ORİJİNAL İSİM": "SODYUM PERMANGANAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 150300,
	  "UN_NO__1": 1503
	},
	{
	  "BAKANLIK_KOD": 150400,
	  "UN_NO": 1504,
	  "ORİJİNAL İSİM": "SODYUM PEROKSİT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 150400,
	  "UN_NO__1": 1504
	},
	{
	  "BAKANLIK_KOD": 150500,
	  "UN_NO": 1505,
	  "ORİJİNAL İSİM": "SODYUM PERSÜLFAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 150500,
	  "UN_NO__1": 1505
	},
	{
	  "BAKANLIK_KOD": 150600,
	  "UN_NO": 1506,
	  "ORİJİNAL İSİM": "STRONSİYUM KLORAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 150600,
	  "UN_NO__1": 1506
	},
	{
	  "BAKANLIK_KOD": 150700,
	  "UN_NO": 1507,
	  "ORİJİNAL İSİM": "STRONSİYUM NİTRAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 150700,
	  "UN_NO__1": 1507
	},
	{
	  "BAKANLIK_KOD": 150800,
	  "UN_NO": 1508,
	  "ORİJİNAL İSİM": "STRONSİYUM PERKLORAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 150800,
	  "UN_NO__1": 1508
	},
	{
	  "BAKANLIK_KOD": 150900,
	  "UN_NO": 1509,
	  "ORİJİNAL İSİM": "STRONSİYUM PEROKSİT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 150900,
	  "UN_NO__1": 1509
	},
	{
	  "BAKANLIK_KOD": 151000,
	  "UN_NO": 1510,
	  "ORİJİNAL İSİM": "TETRANİTROMETAN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TO1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 151000,
	  "UN_NO__1": 1510
	},
	{
	  "BAKANLIK_KOD": 151100,
	  "UN_NO": 1511,
	  "ORİJİNAL İSİM": "ÜRE HİDROJEN PEROKSİT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OC2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 151100,
	  "UN_NO__1": 1511
	},
	{
	  "BAKANLIK_KOD": 151200,
	  "UN_NO": 1512,
	  "ORİJİNAL İSİM": "ÇİNKO AMONYUM NİTRİT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 151200,
	  "UN_NO__1": 1512
	},
	{
	  "BAKANLIK_KOD": 151300,
	  "UN_NO": 1513,
	  "ORİJİNAL İSİM": "ÇİNKO KLORAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 151300,
	  "UN_NO__1": 1513
	},
	{
	  "BAKANLIK_KOD": 151400,
	  "UN_NO": 1514,
	  "ORİJİNAL İSİM": "ÇİNKO NİTRAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 151400,
	  "UN_NO__1": 1514
	},
	{
	  "BAKANLIK_KOD": 151500,
	  "UN_NO": 1515,
	  "ORİJİNAL İSİM": "ÇİNKO PERMANGANAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 151500,
	  "UN_NO__1": 1515
	},
	{
	  "BAKANLIK_KOD": 151600,
	  "UN_NO": 1516,
	  "ORİJİNAL İSİM": "ÇİNKO PEROKSİT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 151600,
	  "UN_NO__1": 1516
	},
	{
	  "BAKANLIK_KOD": 151700,
	  "UN_NO": 1517,
	  "ORİJİNAL İSİM": "ZİRKONYUM PİKRAMAT, ISLATILMIŞ kütlece %20'den az olmayan su ile",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "D",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 151700,
	  "UN_NO__1": 1517
	},
	{
	  "BAKANLIK_KOD": 154100,
	  "UN_NO": 1541,
	  "ORİJİNAL İSİM": "ASETON SİYANOHİDRİN, STABİLİZE",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 154100,
	  "UN_NO__1": 1541
	},
	{
	  "BAKANLIK_KOD": 154401,
	  "UN_NO": 1544,
	  "ORİJİNAL İSİM": "ALKALOİTLER, KATI, B.B.B. veya ALKALOİT TUZLARI, KATI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 154401,
	  "UN_NO__1": 1544
	},
	{
	  "BAKANLIK_KOD": 154402,
	  "UN_NO": 1544,
	  "ORİJİNAL İSİM": "ALKALOİTLER, KATI, B.B.B. veya ALKALOİT TUZLARI, KATI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 154402,
	  "UN_NO__1": 1544
	},
	{
	  "BAKANLIK_KOD": 154403,
	  "UN_NO": 1544,
	  "ORİJİNAL İSİM": "ALKALOİTLER, KATI, B.B.B. veya ALKALOİT TUZLARI, KATI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 154403,
	  "UN_NO__1": 1544
	},
	{
	  "BAKANLIK_KOD": 154500,
	  "UN_NO": 1545,
	  "ORİJİNAL İSİM": "ALİL İZOTİYOSİYANAT, STABİLİZE",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 154500,
	  "UN_NO__1": 1545
	},
	{
	  "BAKANLIK_KOD": 154600,
	  "UN_NO": 1546,
	  "ORİJİNAL İSİM": "AMONYUM ARSENAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 154600,
	  "UN_NO__1": 1546
	},
	{
	  "BAKANLIK_KOD": 154700,
	  "UN_NO": 1547,
	  "ORİJİNAL İSİM": "ANİLİN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 154700,
	  "UN_NO__1": 1547
	},
	{
	  "BAKANLIK_KOD": 154800,
	  "UN_NO": 1548,
	  "ORİJİNAL İSİM": "ANİLİN HİDROKLORÜR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 154800,
	  "UN_NO__1": 1548
	},
	{
	  "BAKANLIK_KOD": 154900,
	  "UN_NO": 1549,
	  "ORİJİNAL İSİM": "ANTİMON BİLEŞİĞİ, İNORGANİK, KATI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 154900,
	  "UN_NO__1": 1549
	},
	{
	  "BAKANLIK_KOD": 155000,
	  "UN_NO": 1550,
	  "ORİJİNAL İSİM": "ANTİMON (III) LAKTAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 155000,
	  "UN_NO__1": 1550
	},
	{
	  "BAKANLIK_KOD": 155100,
	  "UN_NO": 1551,
	  "ORİJİNAL İSİM": "ANTİMON POTASYUM TARTARAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 155100,
	  "UN_NO__1": 1551
	},
	{
	  "BAKANLIK_KOD": 155300,
	  "UN_NO": 1553,
	  "ORİJİNAL İSİM": "ARSENİK ASİT, SIVI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T4",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 155300,
	  "UN_NO__1": 1553
	},
	{
	  "BAKANLIK_KOD": 155400,
	  "UN_NO": 1554,
	  "ORİJİNAL İSİM": "ARSENİK ASİT, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 155400,
	  "UN_NO__1": 1554
	},
	{
	  "BAKANLIK_KOD": 155500,
	  "UN_NO": 1555,
	  "ORİJİNAL İSİM": "ARSENİK (III) BROMÜR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 155500,
	  "UN_NO__1": 1555
	},
	{
	  "BAKANLIK_KOD": 155601,
	  "UN_NO": 1556,
	  "ORİJİNAL İSİM": "ARSENİK BİLEŞİĞİ, SIVI, B.B.B., inorganik, içeriği: Arsenatlar, b.b.b., Arsenitler, b.b.b. ve Arsenik sülfürler, b.b.b.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T4",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 155601,
	  "UN_NO__1": 1556
	},
	{
	  "BAKANLIK_KOD": 155602,
	  "UN_NO": 1556,
	  "ORİJİNAL İSİM": "ARSENİK BİLEŞİĞİ, SIVI, B.B.B., inorganik, içeriği: Arsenatlar, b.b.b., Arsenitler, b.b.b. ve Arsenik sülfürler, b.b.b.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T4",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 155602,
	  "UN_NO__1": 1556
	},
	{
	  "BAKANLIK_KOD": 155603,
	  "UN_NO": 1556,
	  "ORİJİNAL İSİM": "ARSENİK BİLEŞİĞİ, SIVI, B.B.B., inorganik, içeriği: Arsenatlar, b.b.b., Arsenitler, b.b.b. ve Arsenik sülfürler, b.b.b.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T4",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 155603,
	  "UN_NO__1": 1556
	},
	{
	  "BAKANLIK_KOD": 155701,
	  "UN_NO": 1557,
	  "ORİJİNAL İSİM": "ARSENİK BİLEŞİĞİ, KATI, B.B.B., inorganik, içeriği: Arsenatlar, b.b.b., Arsenitler, b.b.b. ve Arsenik sülfürler, b.b.b.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 155701,
	  "UN_NO__1": 1557
	},
	{
	  "BAKANLIK_KOD": 155702,
	  "UN_NO": 1557,
	  "ORİJİNAL İSİM": "ARSENİK BİLEŞİĞİ, KATI, B.B.B., inorganik, içeriği: Arsenatlar, b.b.b., Arsenitler, b.b.b. ve Arsenik sülfürler, b.b.b.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 155702,
	  "UN_NO__1": 1557
	},
	{
	  "BAKANLIK_KOD": 155703,
	  "UN_NO": 1557,
	  "ORİJİNAL İSİM": "ARSENİK BİLEŞİĞİ, KATI, B.B.B., inorganik, içeriği: Arsenatlar, b.b.b., Arsenitler, b.b.b. ve Arsenik sülfürler, b.b.b.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 155703,
	  "UN_NO__1": 1557
	},
	{
	  "BAKANLIK_KOD": 155800,
	  "UN_NO": 1558,
	  "ORİJİNAL İSİM": "ARSENİK",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 155800,
	  "UN_NO__1": 1558
	},
	{
	  "BAKANLIK_KOD": 155900,
	  "UN_NO": 1559,
	  "ORİJİNAL İSİM": "ARSENİK PENTOKSİT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 155900,
	  "UN_NO__1": 1559
	},
	{
	  "BAKANLIK_KOD": 156000,
	  "UN_NO": 1560,
	  "ORİJİNAL İSİM": "ARSENİK TRİKLORÜR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T4",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 156000,
	  "UN_NO__1": 1560
	},
	{
	  "BAKANLIK_KOD": 156100,
	  "UN_NO": 1561,
	  "ORİJİNAL İSİM": "ARSENİK TRİOKSİT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 156100,
	  "UN_NO__1": 1561
	},
	{
	  "BAKANLIK_KOD": 156200,
	  "UN_NO": 1562,
	  "ORİJİNAL İSİM": "ARSENİK TOZU",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 156200,
	  "UN_NO__1": 1562
	},
	{
	  "BAKANLIK_KOD": 156401,
	  "UN_NO": 1564,
	  "ORİJİNAL İSİM": "BARYUM BİLEŞİĞİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 156401,
	  "UN_NO__1": 1564
	},
	{
	  "BAKANLIK_KOD": 156402,
	  "UN_NO": 1564,
	  "ORİJİNAL İSİM": "BARYUM BİLEŞİĞİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 156402,
	  "UN_NO__1": 1564
	},
	{
	  "BAKANLIK_KOD": 156500,
	  "UN_NO": 1565,
	  "ORİJİNAL İSİM": "BARYUM SİYANÜR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 156500,
	  "UN_NO__1": 1565
	},
	{
	  "BAKANLIK_KOD": 156601,
	  "UN_NO": 1566,
	  "ORİJİNAL İSİM": "BERİLYUM BİLEŞİĞİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 156601,
	  "UN_NO__1": 1566
	},
	{
	  "BAKANLIK_KOD": 156602,
	  "UN_NO": 1566,
	  "ORİJİNAL İSİM": "BERİLYUM BİLEŞİĞİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 156602,
	  "UN_NO__1": 1566
	},
	{
	  "BAKANLIK_KOD": 156700,
	  "UN_NO": 1567,
	  "ORİJİNAL İSİM": "BERİLYUM TOZU",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 156700,
	  "UN_NO__1": 1567
	},
	{
	  "BAKANLIK_KOD": 156900,
	  "UN_NO": 1569,
	  "ORİJİNAL İSİM": "BROMOASETON",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 156900,
	  "UN_NO__1": 1569
	},
	{
	  "BAKANLIK_KOD": 157000,
	  "UN_NO": 1570,
	  "ORİJİNAL İSİM": "BRÜSİN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 157000,
	  "UN_NO__1": 1570
	},
	{
	  "BAKANLIK_KOD": 157100,
	  "UN_NO": 1571,
	  "ORİJİNAL İSİM": "BARYUM AZİT, ISLATILMIŞ kütlece %50'den az olmayan su ile",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "DT",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 157100,
	  "UN_NO__1": 1571
	},
	{
	  "BAKANLIK_KOD": 157200,
	  "UN_NO": 1572,
	  "ORİJİNAL İSİM": "KAKODİLİK ASİT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 157200,
	  "UN_NO__1": 1572
	},
	{
	  "BAKANLIK_KOD": 157300,
	  "UN_NO": 1573,
	  "ORİJİNAL İSİM": "KALSİYUM ARSENAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 157300,
	  "UN_NO__1": 1573
	},
	{
	  "BAKANLIK_KOD": 157400,
	  "UN_NO": 1574,
	  "ORİJİNAL İSİM": "KALSİYUM ARSENAT VE KALSİYUM ARSENİT KARIŞIMI, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 157400,
	  "UN_NO__1": 1574
	},
	{
	  "BAKANLIK_KOD": 157500,
	  "UN_NO": 1575,
	  "ORİJİNAL İSİM": "KALSİYUM SİYANÜR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 157500,
	  "UN_NO__1": 1575
	},
	{
	  "BAKANLIK_KOD": 157700,
	  "UN_NO": 1577,
	  "ORİJİNAL İSİM": "KLORODİNİTRO- BENZENLER, SIVI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 157700,
	  "UN_NO__1": 1577
	},
	{
	  "BAKANLIK_KOD": 157800,
	  "UN_NO": 1578,
	  "ORİJİNAL İSİM": "KLORONİTROBENZENLER, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 157800,
	  "UN_NO__1": 1578
	},
	{
	  "BAKANLIK_KOD": 157900,
	  "UN_NO": 1579,
	  "ORİJİNAL İSİM": "4-KLORO-o-TOLUİDİN HİDROKLORÜR, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 157900,
	  "UN_NO__1": 1579
	},
	{
	  "BAKANLIK_KOD": 158000,
	  "UN_NO": 1580,
	  "ORİJİNAL İSİM": "KLOROPİKRİN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 158000,
	  "UN_NO__1": 1580
	},
	{
	  "BAKANLIK_KOD": 158100,
	  "UN_NO": 1581,
	  "ORİJİNAL İSİM": "KLOROPİKRİN VE METİL BROMÜR KARIŞIMI %2'den fazla kloropikrin ile",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2T",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 158100,
	  "UN_NO__1": 1581
	},
	{
	  "BAKANLIK_KOD": 158200,
	  "UN_NO": 1582,
	  "ORİJİNAL İSİM": "KLOROPİKRİN VE METİL KLORÜR KARIŞIMI",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2T",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 158200,
	  "UN_NO__1": 1582
	},
	{
	  "BAKANLIK_KOD": 158301,
	  "UN_NO": 1583,
	  "ORİJİNAL İSİM": "KLOROPİKRİN KARIŞIMI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 158301,
	  "UN_NO__1": 1583
	},
	{
	  "BAKANLIK_KOD": 158302,
	  "UN_NO": 1583,
	  "ORİJİNAL İSİM": "KLOROPİKRİN KARIŞIMI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 158302,
	  "UN_NO__1": 1583
	},
	{
	  "BAKANLIK_KOD": 158303,
	  "UN_NO": 1583,
	  "ORİJİNAL İSİM": "KLOROPİKRİN KARIŞIMI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 158303,
	  "UN_NO__1": 1583
	},
	{
	  "BAKANLIK_KOD": 158500,
	  "UN_NO": 1585,
	  "ORİJİNAL İSİM": "BAKIR ASETOARSENİT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 158500,
	  "UN_NO__1": 1585
	},
	{
	  "BAKANLIK_KOD": 158600,
	  "UN_NO": 1586,
	  "ORİJİNAL İSİM": "BAKIR (II) ARSENİT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 158600,
	  "UN_NO__1": 1586
	},
	{
	  "BAKANLIK_KOD": 158700,
	  "UN_NO": 1587,
	  "ORİJİNAL İSİM": "BAKIR SİYANÜR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 158700,
	  "UN_NO__1": 1587
	},
	{
	  "BAKANLIK_KOD": 158801,
	  "UN_NO": 1588,
	  "ORİJİNAL İSİM": "SİYANÜRLER, İNORGANİK, KATI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 158801,
	  "UN_NO__1": 1588
	},
	{
	  "BAKANLIK_KOD": 158802,
	  "UN_NO": 1588,
	  "ORİJİNAL İSİM": "SİYANÜRLER, İNORGANİK, KATI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 158802,
	  "UN_NO__1": 1588
	},
	{
	  "BAKANLIK_KOD": 158803,
	  "UN_NO": 1588,
	  "ORİJİNAL İSİM": "SİYANÜRLER, İNORGANİK, KATI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 158803,
	  "UN_NO__1": 1588
	},
	{
	  "BAKANLIK_KOD": 158900,
	  "UN_NO": 1589,
	  "ORİJİNAL İSİM": "SİYANOJEN KLORÜR, STABİLİZE",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 158900,
	  "UN_NO__1": 1589
	},
	{
	  "BAKANLIK_KOD": 159000,
	  "UN_NO": 1590,
	  "ORİJİNAL İSİM": "DİKLOROANİLİNLER, SIVI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 159000,
	  "UN_NO__1": 1590
	},
	{
	  "BAKANLIK_KOD": 159100,
	  "UN_NO": 1591,
	  "ORİJİNAL İSİM": "o-DİKLOROBENZEN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 159100,
	  "UN_NO__1": 1591
	},
	{
	  "BAKANLIK_KOD": 159300,
	  "UN_NO": 1593,
	  "ORİJİNAL İSİM": "DİKLOROMETAN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 159300,
	  "UN_NO__1": 1593
	},
	{
	  "BAKANLIK_KOD": 159400,
	  "UN_NO": 1594,
	  "ORİJİNAL İSİM": "DİETİL SÜLFAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 159400,
	  "UN_NO__1": 1594
	},
	{
	  "BAKANLIK_KOD": 159500,
	  "UN_NO": 1595,
	  "ORİJİNAL İSİM": "DİMETİL SÜLFAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TC1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 159500,
	  "UN_NO__1": 1595
	},
	{
	  "BAKANLIK_KOD": 159600,
	  "UN_NO": 1596,
	  "ORİJİNAL İSİM": "DİNİTROANİLİNLER",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 159600,
	  "UN_NO__1": 1596
	},
	{
	  "BAKANLIK_KOD": 159701,
	  "UN_NO": 1597,
	  "ORİJİNAL İSİM": "DİNİTROBENZENLER, SIVI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 159701,
	  "UN_NO__1": 1597
	},
	{
	  "BAKANLIK_KOD": 159702,
	  "UN_NO": 1597,
	  "ORİJİNAL İSİM": "DİNİTROBENZENLER, SIVI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 159702,
	  "UN_NO__1": 1597
	},
	{
	  "BAKANLIK_KOD": 159800,
	  "UN_NO": 1598,
	  "ORİJİNAL İSİM": "DİNİTRO-o-KRESOL",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 159800,
	  "UN_NO__1": 1598
	},
	{
	  "BAKANLIK_KOD": 159901,
	  "UN_NO": 1599,
	  "ORİJİNAL İSİM": "DİNİTROFENOL ÇÖZELTİSİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 159901,
	  "UN_NO__1": 1599
	},
	{
	  "BAKANLIK_KOD": 159902,
	  "UN_NO": 1599,
	  "ORİJİNAL İSİM": "DİNİTROFENOL ÇÖZELTİSİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 159902,
	  "UN_NO__1": 1599
	},
	{
	  "BAKANLIK_KOD": 160000,
	  "UN_NO": 1600,
	  "ORİJİNAL İSİM": "DİNİTROTOLUENLER, ERİMİŞ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 160000,
	  "UN_NO__1": 1600
	},
	{
	  "BAKANLIK_KOD": 160101,
	  "UN_NO": 1601,
	  "ORİJİNAL İSİM": "DEZENFEKTAN, KATI, ZEHİRLİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 160101,
	  "UN_NO__1": 1601
	},
	{
	  "BAKANLIK_KOD": 160102,
	  "UN_NO": 1601,
	  "ORİJİNAL İSİM": "DEZENFEKTAN, KATI, ZEHİRLİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 160102,
	  "UN_NO__1": 1601
	},
	{
	  "BAKANLIK_KOD": 160103,
	  "UN_NO": 1601,
	  "ORİJİNAL İSİM": "DEZENFEKTAN, KATI, ZEHİRLİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 160103,
	  "UN_NO__1": 1601
	},
	{
	  "BAKANLIK_KOD": 160201,
	  "UN_NO": 1602,
	  "ORİJİNAL İSİM": "BOYA, SIVI, ZEHİRLİ, B.B.B. veya BOYA ARA ÜRÜN, SIVI, ZEHİRLİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 160201,
	  "UN_NO__1": 1602
	},
	{
	  "BAKANLIK_KOD": 160202,
	  "UN_NO": 1602,
	  "ORİJİNAL İSİM": "BOYA, SIVI, ZEHİRLİ, B.B.B. veya BOYA ARA ÜRÜN, SIVI, ZEHİRLİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 160202,
	  "UN_NO__1": 1602
	},
	{
	  "BAKANLIK_KOD": 160203,
	  "UN_NO": 1602,
	  "ORİJİNAL İSİM": "BOYA, SIVI, ZEHİRLİ, B.B.B. veya BOYA ARA ÜRÜN, SIVI, ZEHİRLİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 160203,
	  "UN_NO__1": 1602
	},
	{
	  "BAKANLIK_KOD": 160300,
	  "UN_NO": 1603,
	  "ORİJİNAL İSİM": "ETİL BROMOASETAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 160300,
	  "UN_NO__1": 1603
	},
	{
	  "BAKANLIK_KOD": 160400,
	  "UN_NO": 1604,
	  "ORİJİNAL İSİM": "ETİLENDİAMİN",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CF1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 160400,
	  "UN_NO__1": 1604
	},
	{
	  "BAKANLIK_KOD": 160500,
	  "UN_NO": 1605,
	  "ORİJİNAL İSİM": "ETİLEN DİBROMÜR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 160500,
	  "UN_NO__1": 1605
	},
	{
	  "BAKANLIK_KOD": 160600,
	  "UN_NO": 1606,
	  "ORİJİNAL İSİM": "DEMİR (III) ARSENAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 160600,
	  "UN_NO__1": 1606
	},
	{
	  "BAKANLIK_KOD": 160700,
	  "UN_NO": 1607,
	  "ORİJİNAL İSİM": "DEMİR (III) ARSENİT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 160700,
	  "UN_NO__1": 1607
	},
	{
	  "BAKANLIK_KOD": 160800,
	  "UN_NO": 1608,
	  "ORİJİNAL İSİM": "FERRÖZ (III) ARSENAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 160800,
	  "UN_NO__1": 1608
	},
	{
	  "BAKANLIK_KOD": 161100,
	  "UN_NO": 1611,
	  "ORİJİNAL İSİM": "HEKZAETİL TETRAFOSFAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 161100,
	  "UN_NO__1": 1611
	},
	{
	  "BAKANLIK_KOD": 161200,
	  "UN_NO": 1612,
	  "ORİJİNAL İSİM": "HEKZAETİL TETRAFOSFAT VE SIKIŞTIRILMIŞ GAZ KARIŞIMI",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "1T",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 161200,
	  "UN_NO__1": 1612
	},
	{
	  "BAKANLIK_KOD": 161300,
	  "UN_NO": 1613,
	  "ORİJİNAL İSİM": "HİDROSİYANİK ASİT, SULU ÇÖZELTİ (HİDROJEN SİYANÜR, SULU ÇÖZELTİ) %20'den fazla olmayan hidrojen siyanür ile",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 161300,
	  "UN_NO__1": 1613
	},
	{
	  "BAKANLIK_KOD": 161400,
	  "UN_NO": 1614,
	  "ORİJİNAL İSİM": "HİDROJEN SİYANÜR, STABİLİZE, %3'ten az su içeren ve gözenekli inert malzemeye emdirilmiş",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 161400,
	  "UN_NO__1": 1614
	},
	{
	  "BAKANLIK_KOD": 161600,
	  "UN_NO": 1616,
	  "ORİJİNAL İSİM": "KURŞUN ASETAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 161600,
	  "UN_NO__1": 1616
	},
	{
	  "BAKANLIK_KOD": 161700,
	  "UN_NO": 1617,
	  "ORİJİNAL İSİM": "KURŞUN ARSENATLAR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 161700,
	  "UN_NO__1": 1617
	},
	{
	  "BAKANLIK_KOD": 161800,
	  "UN_NO": 1618,
	  "ORİJİNAL İSİM": "KURŞUN ARSENİTLER",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 161800,
	  "UN_NO__1": 1618
	},
	{
	  "BAKANLIK_KOD": 162000,
	  "UN_NO": 1620,
	  "ORİJİNAL İSİM": "KURŞUN SİYANÜR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 162000,
	  "UN_NO__1": 1620
	},
	{
	  "BAKANLIK_KOD": 162100,
	  "UN_NO": 1621,
	  "ORİJİNAL İSİM": "LONDON PURPLE (ETKEN MADDESİ KALSİYUM ARSENAT OLAN İNSEKTİSİT)",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 162100,
	  "UN_NO__1": 1621
	},
	{
	  "BAKANLIK_KOD": 162200,
	  "UN_NO": 1622,
	  "ORİJİNAL İSİM": "MAGNEZYUM ARSENAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 162200,
	  "UN_NO__1": 1622
	},
	{
	  "BAKANLIK_KOD": 162300,
	  "UN_NO": 1623,
	  "ORİJİNAL İSİM": "CIVA (II) ARSENAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 162300,
	  "UN_NO__1": 1623
	},
	{
	  "BAKANLIK_KOD": 162400,
	  "UN_NO": 1624,
	  "ORİJİNAL İSİM": "CIVA (II) KLORÜR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 162400,
	  "UN_NO__1": 1624
	},
	{
	  "BAKANLIK_KOD": 162500,
	  "UN_NO": 1625,
	  "ORİJİNAL İSİM": "CIVA (II) NİTRAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 162500,
	  "UN_NO__1": 1625
	},
	{
	  "BAKANLIK_KOD": 162600,
	  "UN_NO": 1626,
	  "ORİJİNAL İSİM": "CIVA (II) POTASYUM SİYANÜR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 162600,
	  "UN_NO__1": 1626
	},
	{
	  "BAKANLIK_KOD": 162700,
	  "UN_NO": 1627,
	  "ORİJİNAL İSİM": "CIVA (I) NİTRAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 162700,
	  "UN_NO__1": 1627
	},
	{
	  "BAKANLIK_KOD": 162900,
	  "UN_NO": 1629,
	  "ORİJİNAL İSİM": "CIVA ASETAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 162900,
	  "UN_NO__1": 1629
	},
	{
	  "BAKANLIK_KOD": 163000,
	  "UN_NO": 1630,
	  "ORİJİNAL İSİM": "CIVA AMONYUM KLORÜR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 163000,
	  "UN_NO__1": 1630
	},
	{
	  "BAKANLIK_KOD": 163100,
	  "UN_NO": 1631,
	  "ORİJİNAL İSİM": "CIVA BENZOAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 163100,
	  "UN_NO__1": 1631
	},
	{
	  "BAKANLIK_KOD": 163400,
	  "UN_NO": 1634,
	  "ORİJİNAL İSİM": "CIVA BROMÜRLER",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 163400,
	  "UN_NO__1": 1634
	},
	{
	  "BAKANLIK_KOD": 163600,
	  "UN_NO": 1636,
	  "ORİJİNAL İSİM": "CIVA SİYANÜR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 163600,
	  "UN_NO__1": 1636
	},
	{
	  "BAKANLIK_KOD": 163700,
	  "UN_NO": 1637,
	  "ORİJİNAL İSİM": "CIVA GLUKONAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 163700,
	  "UN_NO__1": 1637
	},
	{
	  "BAKANLIK_KOD": 163800,
	  "UN_NO": 1638,
	  "ORİJİNAL İSİM": "CIVA İYODÜR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 163800,
	  "UN_NO__1": 1638
	},
	{
	  "BAKANLIK_KOD": 163900,
	  "UN_NO": 1639,
	  "ORİJİNAL İSİM": "CIVA NÜKLEAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 163900,
	  "UN_NO__1": 1639
	},
	{
	  "BAKANLIK_KOD": 164000,
	  "UN_NO": 1640,
	  "ORİJİNAL İSİM": "CIVA OLEAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 164000,
	  "UN_NO__1": 1640
	},
	{
	  "BAKANLIK_KOD": 164100,
	  "UN_NO": 1641,
	  "ORİJİNAL İSİM": "CIVA OKSİT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 164100,
	  "UN_NO__1": 1641
	},
	{
	  "BAKANLIK_KOD": 164200,
	  "UN_NO": 1642,
	  "ORİJİNAL İSİM": "CIVA OKSİSİYANÜR, DUYARLILIĞI AZALTILMIŞ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 164200,
	  "UN_NO__1": 1642
	},
	{
	  "BAKANLIK_KOD": 164300,
	  "UN_NO": 1643,
	  "ORİJİNAL İSİM": "CIVA POTASYUM İYODÜR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 164300,
	  "UN_NO__1": 1643
	},
	{
	  "BAKANLIK_KOD": 164400,
	  "UN_NO": 1644,
	  "ORİJİNAL İSİM": "CIVA SALİSİLAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 164400,
	  "UN_NO__1": 1644
	},
	{
	  "BAKANLIK_KOD": 164500,
	  "UN_NO": 1645,
	  "ORİJİNAL İSİM": "CIVA SÜLFAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 164500,
	  "UN_NO__1": 1645
	},
	{
	  "BAKANLIK_KOD": 164600,
	  "UN_NO": 1646,
	  "ORİJİNAL İSİM": "CIVA TİYOSİYANAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 164600,
	  "UN_NO__1": 1646
	},
	{
	  "BAKANLIK_KOD": 164700,
	  "UN_NO": 1647,
	  "ORİJİNAL İSİM": "METİL BROMÜR VE ETİLEN DİBROMÜR KARIŞIMI, SIVI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 164700,
	  "UN_NO__1": 1647
	},
	{
	  "BAKANLIK_KOD": 164800,
	  "UN_NO": 1648,
	  "ORİJİNAL İSİM": "ASETONİTRİL",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 164800,
	  "UN_NO__1": 1648
	},
	{
	  "BAKANLIK_KOD": 164900,
	  "UN_NO": 1649,
	  "ORİJİNAL İSİM": "MOTOR YAKITI VURUNTU ÖNLEYİCİ KARIŞIM",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T3",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 164900,
	  "UN_NO__1": 1649
	},
	{
	  "BAKANLIK_KOD": 165000,
	  "UN_NO": 1650,
	  "ORİJİNAL İSİM": "beta-NAFTİLAMİN, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 165000,
	  "UN_NO__1": 1650
	},
	{
	  "BAKANLIK_KOD": 165100,
	  "UN_NO": 1651,
	  "ORİJİNAL İSİM": "NAFTİLİTİYOÜRE",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 165100,
	  "UN_NO__1": 1651
	},
	{
	  "BAKANLIK_KOD": 165200,
	  "UN_NO": 1652,
	  "ORİJİNAL İSİM": "NAFTİLÜRE",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 165200,
	  "UN_NO__1": 1652
	},
	{
	  "BAKANLIK_KOD": 165300,
	  "UN_NO": 1653,
	  "ORİJİNAL İSİM": "NİKEL SİYANÜR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 165300,
	  "UN_NO__1": 1653
	},
	{
	  "BAKANLIK_KOD": 165400,
	  "UN_NO": 1654,
	  "ORİJİNAL İSİM": "NİKOTİN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 165400,
	  "UN_NO__1": 1654
	},
	{
	  "BAKANLIK_KOD": 165501,
	  "UN_NO": 1655,
	  "ORİJİNAL İSİM": "NİKOTİN BİLEŞİĞİ, KATI, B.B.B. veya NİKOTİN MÜSTAHZAR, KATI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 165501,
	  "UN_NO__1": 1655
	},
	{
	  "BAKANLIK_KOD": 165502,
	  "UN_NO": 1655,
	  "ORİJİNAL İSİM": "NİKOTİN BİLEŞİĞİ, KATI, B.B.B. veya NİKOTİN MÜSTAHZAR, KATI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 165502,
	  "UN_NO__1": 1655
	},
	{
	  "BAKANLIK_KOD": 165503,
	  "UN_NO": 1655,
	  "ORİJİNAL İSİM": "NİKOTİN BİLEŞİĞİ, KATI, B.B.B. veya NİKOTİN MÜSTAHZAR, KATI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 165503,
	  "UN_NO__1": 1655
	},
	{
	  "BAKANLIK_KOD": 165601,
	  "UN_NO": 1656,
	  "ORİJİNAL İSİM": "NİKOTİN HİDROKLORÜR, SIVI veya ÇÖZELTİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 165601,
	  "UN_NO__1": 1656
	},
	{
	  "BAKANLIK_KOD": 165602,
	  "UN_NO": 1656,
	  "ORİJİNAL İSİM": "NİKOTİN HİDROKLORÜR, SIVI veya ÇÖZELTİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 165602,
	  "UN_NO__1": 1656
	},
	{
	  "BAKANLIK_KOD": 165700,
	  "UN_NO": 1657,
	  "ORİJİNAL İSİM": "NİKOTİN SALİSİLAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 165700,
	  "UN_NO__1": 1657
	},
	{
	  "BAKANLIK_KOD": 165801,
	  "UN_NO": 1658,
	  "ORİJİNAL İSİM": "NİKOTİN SÜLFAT, ÇÖZELTİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 165801,
	  "UN_NO__1": 1658
	},
	{
	  "BAKANLIK_KOD": 165802,
	  "UN_NO": 1658,
	  "ORİJİNAL İSİM": "NİKOTİN SÜLFAT, ÇÖZELTİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 165802,
	  "UN_NO__1": 1658
	},
	{
	  "BAKANLIK_KOD": 165900,
	  "UN_NO": 1659,
	  "ORİJİNAL İSİM": "NİKOTİN TARTARAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 165900,
	  "UN_NO__1": 1659
	},
	{
	  "BAKANLIK_KOD": 166000,
	  "UN_NO": 1660,
	  "ORİJİNAL İSİM": "NİTRİK OKSİT, SIKIŞTIRILMIŞ",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "1TOC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 166000,
	  "UN_NO__1": 1660
	},
	{
	  "BAKANLIK_KOD": 166100,
	  "UN_NO": 1661,
	  "ORİJİNAL İSİM": "NİTROANİLİNLER (o-, m-, p)",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 166100,
	  "UN_NO__1": 1661
	},
	{
	  "BAKANLIK_KOD": 166200,
	  "UN_NO": 1662,
	  "ORİJİNAL İSİM": "NİTROBENZEN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 166200,
	  "UN_NO__1": 1662
	},
	{
	  "BAKANLIK_KOD": 166300,
	  "UN_NO": 1663,
	  "ORİJİNAL İSİM": "NİTROFENOLLER (o-, m-, p-)",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 166300,
	  "UN_NO__1": 1663
	},
	{
	  "BAKANLIK_KOD": 166400,
	  "UN_NO": 1664,
	  "ORİJİNAL İSİM": "NİTROTOLUENLER, SIVI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 166400,
	  "UN_NO__1": 1664
	},
	{
	  "BAKANLIK_KOD": 166500,
	  "UN_NO": 1665,
	  "ORİJİNAL İSİM": "NİTROKSİLENLER, SIVI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 166500,
	  "UN_NO__1": 1665
	},
	{
	  "BAKANLIK_KOD": 166900,
	  "UN_NO": 1669,
	  "ORİJİNAL İSİM": "PENTAKLOROETAN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 166900,
	  "UN_NO__1": 1669
	},
	{
	  "BAKANLIK_KOD": 167000,
	  "UN_NO": 1670,
	  "ORİJİNAL İSİM": "PERKLOROMETİL MERKAPTAN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 167000,
	  "UN_NO__1": 1670
	},
	{
	  "BAKANLIK_KOD": 167100,
	  "UN_NO": 1671,
	  "ORİJİNAL İSİM": "FENOL, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 167100,
	  "UN_NO__1": 1671
	},
	{
	  "BAKANLIK_KOD": 167200,
	  "UN_NO": 1672,
	  "ORİJİNAL İSİM": "FENİLKARBİLAMİN KLORÜR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 167200,
	  "UN_NO__1": 1672
	},
	{
	  "BAKANLIK_KOD": 167300,
	  "UN_NO": 1673,
	  "ORİJİNAL İSİM": "FENİLENDİAMİNLER (o-, m-, p-)",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 167300,
	  "UN_NO__1": 1673
	},
	{
	  "BAKANLIK_KOD": 167400,
	  "UN_NO": 1674,
	  "ORİJİNAL İSİM": "FENİLCIVA (II) ASETAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 167400,
	  "UN_NO__1": 1674
	},
	{
	  "BAKANLIK_KOD": 167700,
	  "UN_NO": 1677,
	  "ORİJİNAL İSİM": "POTASYUM ARSENAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 167700,
	  "UN_NO__1": 1677
	},
	{
	  "BAKANLIK_KOD": 167800,
	  "UN_NO": 1678,
	  "ORİJİNAL İSİM": "POTASYUM ARSENİT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 167800,
	  "UN_NO__1": 1678
	},
	{
	  "BAKANLIK_KOD": 167900,
	  "UN_NO": 1679,
	  "ORİJİNAL İSİM": "POTASYUM KUPROSİYANÜR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 167900,
	  "UN_NO__1": 1679
	},
	{
	  "BAKANLIK_KOD": 168000,
	  "UN_NO": 1680,
	  "ORİJİNAL İSİM": "POTASYUM SİYANÜR, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 168000,
	  "UN_NO__1": 1680
	},
	{
	  "BAKANLIK_KOD": 168300,
	  "UN_NO": 1683,
	  "ORİJİNAL İSİM": "GÜMÜŞ ARSENİT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 168300,
	  "UN_NO__1": 1683
	},
	{
	  "BAKANLIK_KOD": 168400,
	  "UN_NO": 1684,
	  "ORİJİNAL İSİM": "GÜMÜŞ SİYANÜR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 168400,
	  "UN_NO__1": 1684
	},
	{
	  "BAKANLIK_KOD": 168500,
	  "UN_NO": 1685,
	  "ORİJİNAL İSİM": "SODYUM ARSENAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 168500,
	  "UN_NO__1": 1685
	},
	{
	  "BAKANLIK_KOD": 168601,
	  "UN_NO": 1686,
	  "ORİJİNAL İSİM": "SODYUM ARSENİT, SULU ÇÖZELTİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T4",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 168601,
	  "UN_NO__1": 1686
	},
	{
	  "BAKANLIK_KOD": 168602,
	  "UN_NO": 1686,
	  "ORİJİNAL İSİM": "SODYUM ARSENİT, SULU ÇÖZELTİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T4",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 168602,
	  "UN_NO__1": 1686
	},
	{
	  "BAKANLIK_KOD": 168700,
	  "UN_NO": 1687,
	  "ORİJİNAL İSİM": "SODYUM AZİD",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 168700,
	  "UN_NO__1": 1687
	},
	{
	  "BAKANLIK_KOD": 168800,
	  "UN_NO": 1688,
	  "ORİJİNAL İSİM": "SODYUM KAKODİLAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 168800,
	  "UN_NO__1": 1688
	},
	{
	  "BAKANLIK_KOD": 168900,
	  "UN_NO": 1689,
	  "ORİJİNAL İSİM": "SODYUM SİYANÜR, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 168900,
	  "UN_NO__1": 1689
	},
	{
	  "BAKANLIK_KOD": 169000,
	  "UN_NO": 1690,
	  "ORİJİNAL İSİM": "SODYUM FLORÜR, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 169000,
	  "UN_NO__1": 1690
	},
	{
	  "BAKANLIK_KOD": 169100,
	  "UN_NO": 1691,
	  "ORİJİNAL İSİM": "STRONSİYUM ARSENİT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 169100,
	  "UN_NO__1": 1691
	},
	{
	  "BAKANLIK_KOD": 169200,
	  "UN_NO": 1692,
	  "ORİJİNAL İSİM": "STRİKNİN veya STRİKNİN TUZLARI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 169200,
	  "UN_NO__1": 1692
	},
	{
	  "BAKANLIK_KOD": 169301,
	  "UN_NO": 1693,
	  "ORİJİNAL İSİM": "GÖZ YAŞARTICI GAZ MADDESİ, SIVI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 169301,
	  "UN_NO__1": 1693
	},
	{
	  "BAKANLIK_KOD": 169302,
	  "UN_NO": 1693,
	  "ORİJİNAL İSİM": "GÖZ YAŞARTICI GAZ MADDESİ, SIVI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 169302,
	  "UN_NO__1": 1693
	},
	{
	  "BAKANLIK_KOD": 169400,
	  "UN_NO": 1694,
	  "ORİJİNAL İSİM": "BROMOBENZİL SİYANÜRLER, SIVI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 169400,
	  "UN_NO__1": 1694
	},
	{
	  "BAKANLIK_KOD": 169500,
	  "UN_NO": 1695,
	  "ORİJİNAL İSİM": "KLOROASETON, STABİLİZE",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TFC",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 169500,
	  "UN_NO__1": 1695
	},
	{
	  "BAKANLIK_KOD": 169700,
	  "UN_NO": 1697,
	  "ORİJİNAL İSİM": "KLOROASETOFENON, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 169700,
	  "UN_NO__1": 1697
	},
	{
	  "BAKANLIK_KOD": 169800,
	  "UN_NO": 1698,
	  "ORİJİNAL İSİM": "DİFENİLAMİN KLOROARSİN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T3",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 169800,
	  "UN_NO__1": 1698
	},
	{
	  "BAKANLIK_KOD": 169900,
	  "UN_NO": 1699,
	  "ORİJİNAL İSİM": "DİFENİLKLORO-ARSİN, SIVI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T3",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 169900,
	  "UN_NO__1": 1699
	},
	{
	  "BAKANLIK_KOD": 170000,
	  "UN_NO": 1700,
	  "ORİJİNAL İSİM": "GÖZ YAŞARTICI GAZ MUMLARI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF3",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 170000,
	  "UN_NO__1": 1700
	},
	{
	  "BAKANLIK_KOD": 170100,
	  "UN_NO": 1701,
	  "ORİJİNAL İSİM": "KSİLİL BROMÜR, SIVI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 170100,
	  "UN_NO__1": 1701
	},
	{
	  "BAKANLIK_KOD": 170200,
	  "UN_NO": 1702,
	  "ORİJİNAL İSİM": "1,1,2,2-TETRAKLOROETAN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 170200,
	  "UN_NO__1": 1702
	},
	{
	  "BAKANLIK_KOD": 170400,
	  "UN_NO": 1704,
	  "ORİJİNAL İSİM": "TETRAETİL DİTİYOPİROFOSFAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 170400,
	  "UN_NO__1": 1704
	},
	{
	  "BAKANLIK_KOD": 170700,
	  "UN_NO": 1707,
	  "ORİJİNAL İSİM": "TALYUM BİLEŞİĞİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 170700,
	  "UN_NO__1": 1707
	},
	{
	  "BAKANLIK_KOD": 170800,
	  "UN_NO": 1708,
	  "ORİJİNAL İSİM": "TOLUİDİNLER, SIVI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 170800,
	  "UN_NO__1": 1708
	},
	{
	  "BAKANLIK_KOD": 170900,
	  "UN_NO": 1709,
	  "ORİJİNAL İSİM": "2,4-TOLUİLENDİAMİN, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 170900,
	  "UN_NO__1": 1709
	},
	{
	  "BAKANLIK_KOD": 171000,
	  "UN_NO": 1710,
	  "ORİJİNAL İSİM": "TRİKLOROETİLEN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 171000,
	  "UN_NO__1": 1710
	},
	{
	  "BAKANLIK_KOD": 171100,
	  "UN_NO": 1711,
	  "ORİJİNAL İSİM": "KSİLİDİNLER, SIVI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 171100,
	  "UN_NO__1": 1711
	},
	{
	  "BAKANLIK_KOD": 171200,
	  "UN_NO": 1712,
	  "ORİJİNAL İSİM": "ÇİNKO ARSENAT, ÇİNKO ARSENİT veya ÇİNKO ARSENAT VE ÇİNKO ARSENİT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 171200,
	  "UN_NO__1": 1712
	},
	{
	  "BAKANLIK_KOD": 171300,
	  "UN_NO": 1713,
	  "ORİJİNAL İSİM": "ÇİNKO SİYANÜR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 171300,
	  "UN_NO__1": 1713
	},
	{
	  "BAKANLIK_KOD": 171400,
	  "UN_NO": 1714,
	  "ORİJİNAL İSİM": "ÇİNKO FOSFÜR",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WT2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 171400,
	  "UN_NO__1": 1714
	},
	{
	  "BAKANLIK_KOD": 171500,
	  "UN_NO": 1715,
	  "ORİJİNAL İSİM": "ASETİK ANHİDRİT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CF1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 171500,
	  "UN_NO__1": 1715
	},
	{
	  "BAKANLIK_KOD": 171600,
	  "UN_NO": 1716,
	  "ORİJİNAL İSİM": "ASETİL BROMÜR",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 171600,
	  "UN_NO__1": 1716
	},
	{
	  "BAKANLIK_KOD": 171700,
	  "UN_NO": 1717,
	  "ORİJİNAL İSİM": "ASETİL KLORÜR",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 171700,
	  "UN_NO__1": 1717
	},
	{
	  "BAKANLIK_KOD": 171800,
	  "UN_NO": 1718,
	  "ORİJİNAL İSİM": "BÜTİL ASİT FOSFAT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 171800,
	  "UN_NO__1": 1718
	},
	{
	  "BAKANLIK_KOD": 171901,
	  "UN_NO": 1719,
	  "ORİJİNAL İSİM": "KOSTİK ALKALİ SIVI, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 171901,
	  "UN_NO__1": 1719
	},
	{
	  "BAKANLIK_KOD": 171902,
	  "UN_NO": 1719,
	  "ORİJİNAL İSİM": "KOSTİK ALKALİ SIVI, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C5",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 171902,
	  "UN_NO__1": 1719
	},
	{
	  "BAKANLIK_KOD": 172200,
	  "UN_NO": 1722,
	  "ORİJİNAL İSİM": "ALİL KLOROFORMAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TFC",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 172200,
	  "UN_NO__1": 1722
	},
	{
	  "BAKANLIK_KOD": 172300,
	  "UN_NO": 1723,
	  "ORİJİNAL İSİM": "ALİL İYODÜR",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 172300,
	  "UN_NO__1": 1723
	},
	{
	  "BAKANLIK_KOD": 172400,
	  "UN_NO": 1724,
	  "ORİJİNAL İSİM": "ALİLTRİKLOROSİLAN, STABİLİZE",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CF1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 172400,
	  "UN_NO__1": 1724
	},
	{
	  "BAKANLIK_KOD": 172500,
	  "UN_NO": 1725,
	  "ORİJİNAL İSİM": "ALÜMİNYUM BROMÜR, SUSUZ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 172500,
	  "UN_NO__1": 1725
	},
	{
	  "BAKANLIK_KOD": 172600,
	  "UN_NO": 1726,
	  "ORİJİNAL İSİM": "ALÜMİNYUM KLORÜR, SUSUZ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 172600,
	  "UN_NO__1": 1726
	},
	{
	  "BAKANLIK_KOD": 172700,
	  "UN_NO": 1727,
	  "ORİJİNAL İSİM": "AMONYUM HİDROJENDİFLORÜR, KATI",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 172700,
	  "UN_NO__1": 1727
	},
	{
	  "BAKANLIK_KOD": 172800,
	  "UN_NO": 1728,
	  "ORİJİNAL İSİM": "AMİLTRİKLOROSİLAN",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 172800,
	  "UN_NO__1": 1728
	},
	{
	  "BAKANLIK_KOD": 172900,
	  "UN_NO": 1729,
	  "ORİJİNAL İSİM": "ANİZOİL KLORÜR",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C4",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 172900,
	  "UN_NO__1": 1729
	},
	{
	  "BAKANLIK_KOD": 173000,
	  "UN_NO": 1730,
	  "ORİJİNAL İSİM": "ANTİMON PENTAKLORÜR, SIVI",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 173000,
	  "UN_NO__1": 1730
	},
	{
	  "BAKANLIK_KOD": 173101,
	  "UN_NO": 1731,
	  "ORİJİNAL İSİM": "ANTİMON PENTAKLORÜR ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 173101,
	  "UN_NO__1": 1731
	},
	{
	  "BAKANLIK_KOD": 173102,
	  "UN_NO": 1731,
	  "ORİJİNAL İSİM": "ANTİMON PENTAKLORÜR ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 173102,
	  "UN_NO__1": 1731
	},
	{
	  "BAKANLIK_KOD": 173200,
	  "UN_NO": 1732,
	  "ORİJİNAL İSİM": "ANTİMON PENTAFLORÜR",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CT1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 173200,
	  "UN_NO__1": 1732
	},
	{
	  "BAKANLIK_KOD": 173300,
	  "UN_NO": 1733,
	  "ORİJİNAL İSİM": "ANTİMON TRİKLORÜR",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 173300,
	  "UN_NO__1": 1733
	},
	{
	  "BAKANLIK_KOD": 173600,
	  "UN_NO": 1736,
	  "ORİJİNAL İSİM": "BENZOİL KLORÜR",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 173600,
	  "UN_NO__1": 1736
	},
	{
	  "BAKANLIK_KOD": 173700,
	  "UN_NO": 1737,
	  "ORİJİNAL İSİM": "BENZİL BROMÜR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TC1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 173700,
	  "UN_NO__1": 1737
	},
	{
	  "BAKANLIK_KOD": 173800,
	  "UN_NO": 1738,
	  "ORİJİNAL İSİM": "BENZİL KLORÜR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TC1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 173800,
	  "UN_NO__1": 1738
	},
	{
	  "BAKANLIK_KOD": 173900,
	  "UN_NO": 1739,
	  "ORİJİNAL İSİM": "BENZİL KLOROFORMAT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C9",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 173900,
	  "UN_NO__1": 1739
	},
	{
	  "BAKANLIK_KOD": 174001,
	  "UN_NO": 1740,
	  "ORİJİNAL İSİM": "HİDROJENDİFLORÜRLER, KATI, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 174001,
	  "UN_NO__1": 1740
	},
	{
	  "BAKANLIK_KOD": 174002,
	  "UN_NO": 1740,
	  "ORİJİNAL İSİM": "HİDROJENDİFLORÜRLER, KATI, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 174002,
	  "UN_NO__1": 1740
	},
	{
	  "BAKANLIK_KOD": 174100,
	  "UN_NO": 1741,
	  "ORİJİNAL İSİM": "BOR TRİKLORÜR",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 174100,
	  "UN_NO__1": 1741
	},
	{
	  "BAKANLIK_KOD": 174200,
	  "UN_NO": 1742,
	  "ORİJİNAL İSİM": "BOR TRİFLORÜR ASETİK ASİT KOMPLEKSİ, SIVI",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 174200,
	  "UN_NO__1": 1742
	},
	{
	  "BAKANLIK_KOD": 174300,
	  "UN_NO": 1743,
	  "ORİJİNAL İSİM": "BOR TRİFLORÜR PROPİONİK ASİT KOMPLEKSİ, SIVI",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 174300,
	  "UN_NO__1": 1743
	},
	{
	  "BAKANLIK_KOD": 174400,
	  "UN_NO": 1744,
	  "ORİJİNAL İSİM": "BROM veya BROM ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CT1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 174400,
	  "UN_NO__1": 1744
	},
	{
	  "BAKANLIK_KOD": 174500,
	  "UN_NO": 1745,
	  "ORİJİNAL İSİM": "BROM PENTAFLORÜR",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OTC",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 174500,
	  "UN_NO__1": 1745
	},
	{
	  "BAKANLIK_KOD": 174600,
	  "UN_NO": 1746,
	  "ORİJİNAL İSİM": "BROM TRİFLORÜR",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OTC",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 174600,
	  "UN_NO__1": 1746
	},
	{
	  "BAKANLIK_KOD": 174700,
	  "UN_NO": 1747,
	  "ORİJİNAL İSİM": "BÜTİLTRİKLOROSİLAN",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CF1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 174700,
	  "UN_NO__1": 1747
	},
	{
	  "BAKANLIK_KOD": 174801,
	  "UN_NO": 1748,
	  "ORİJİNAL İSİM": "KALSİYUM HİPOKLORİT, KURU veya KALSİYUM HİPOKLORİT KARIŞIMI, KURU %39'dan fazla hazır klorür (%8,8 hazır oksijen) ile",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 174801,
	  "UN_NO__1": 1748
	},
	{
	  "BAKANLIK_KOD": 174802,
	  "UN_NO": 1748,
	  "ORİJİNAL İSİM": "KALSİYUM HİPOKLORİT, KURU veya KALSİYUM HİPOKLORİT KARIŞIMI, KURU %39'dan fazla hazır klorür (%8,8 hazır oksijen) ile",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 174802,
	  "UN_NO__1": 1748
	},
	{
	  "BAKANLIK_KOD": 174900,
	  "UN_NO": 1749,
	  "ORİJİNAL İSİM": "KLOR TRİFLORÜR",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TOC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 174900,
	  "UN_NO__1": 1749
	},
	{
	  "BAKANLIK_KOD": 175000,
	  "UN_NO": 1750,
	  "ORİJİNAL İSİM": "KLOROASETİK ASİT ÇÖZELTİSİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TC1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 175000,
	  "UN_NO__1": 1750
	},
	{
	  "BAKANLIK_KOD": 175100,
	  "UN_NO": 1751,
	  "ORİJİNAL İSİM": "KLOROASETİK ASİT, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TC2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 175100,
	  "UN_NO__1": 1751
	},
	{
	  "BAKANLIK_KOD": 175200,
	  "UN_NO": 1752,
	  "ORİJİNAL İSİM": "KLOROASETİL KLORÜR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TC1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 175200,
	  "UN_NO__1": 1752
	},
	{
	  "BAKANLIK_KOD": 175300,
	  "UN_NO": 1753,
	  "ORİJİNAL İSİM": "KLOROFENİL-TRİKLOROSİLAN",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 175300,
	  "UN_NO__1": 1753
	},
	{
	  "BAKANLIK_KOD": 175400,
	  "UN_NO": 1754,
	  "ORİJİNAL İSİM": "KLOROSÜLFONİK ASİT (kükürt trioksit içeren veya içermeyen)",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 175400,
	  "UN_NO__1": 1754
	},
	{
	  "BAKANLIK_KOD": 175501,
	  "UN_NO": 1755,
	  "ORİJİNAL İSİM": "KROMİK ASİT ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 175501,
	  "UN_NO__1": 1755
	},
	{
	  "BAKANLIK_KOD": 175502,
	  "UN_NO": 1755,
	  "ORİJİNAL İSİM": "KROMİK ASİT ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 175502,
	  "UN_NO__1": 1755
	},
	{
	  "BAKANLIK_KOD": 175600,
	  "UN_NO": 1756,
	  "ORİJİNAL İSİM": "KROMİK FLORÜR, KATI",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 175600,
	  "UN_NO__1": 1756
	},
	{
	  "BAKANLIK_KOD": 175701,
	  "UN_NO": 1757,
	  "ORİJİNAL İSİM": "KROMİK FLORÜR ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 175701,
	  "UN_NO__1": 1757
	},
	{
	  "BAKANLIK_KOD": 175702,
	  "UN_NO": 1757,
	  "ORİJİNAL İSİM": "KROMİK FLORÜR ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 175702,
	  "UN_NO__1": 1757
	},
	{
	  "BAKANLIK_KOD": 175800,
	  "UN_NO": 1758,
	  "ORİJİNAL İSİM": "KROM OKSİKLORÜR",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 175800,
	  "UN_NO__1": 1758
	},
	{
	  "BAKANLIK_KOD": 175901,
	  "UN_NO": 1759,
	  "ORİJİNAL İSİM": "AŞINDIRICI KATI, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C10",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 175901,
	  "UN_NO__1": 1759
	},
	{
	  "BAKANLIK_KOD": 175902,
	  "UN_NO": 1759,
	  "ORİJİNAL İSİM": "AŞINDIRICI KATI, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C10",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 175902,
	  "UN_NO__1": 1759
	},
	{
	  "BAKANLIK_KOD": 175903,
	  "UN_NO": 1759,
	  "ORİJİNAL İSİM": "AŞINDIRICI KATI, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C10",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 175903,
	  "UN_NO__1": 1759
	},
	{
	  "BAKANLIK_KOD": 176001,
	  "UN_NO": 1760,
	  "ORİJİNAL İSİM": "AŞINDIRICI SIVI, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C9",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 176001,
	  "UN_NO__1": 1760
	},
	{
	  "BAKANLIK_KOD": 176002,
	  "UN_NO": 1760,
	  "ORİJİNAL İSİM": "AŞINDIRICI SIVI, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C9",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 176002,
	  "UN_NO__1": 1760
	},
	{
	  "BAKANLIK_KOD": 176003,
	  "UN_NO": 1760,
	  "ORİJİNAL İSİM": "AŞINDIRICI SIVI, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C9",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 176003,
	  "UN_NO__1": 1760
	},
	{
	  "BAKANLIK_KOD": 176101,
	  "UN_NO": 1761,
	  "ORİJİNAL İSİM": "KÜPRİETİLENDİAMİN ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CT1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 176101,
	  "UN_NO__1": 1761
	},
	{
	  "BAKANLIK_KOD": 176102,
	  "UN_NO": 1761,
	  "ORİJİNAL İSİM": "KÜPRİETİLENDİAMİN ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CT1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 176102,
	  "UN_NO__1": 1761
	},
	{
	  "BAKANLIK_KOD": 176200,
	  "UN_NO": 1762,
	  "ORİJİNAL İSİM": "SİKLOHEKSENİLTRİKLORO -SİLAN",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 176200,
	  "UN_NO__1": 1762
	},
	{
	  "BAKANLIK_KOD": 176300,
	  "UN_NO": 1763,
	  "ORİJİNAL İSİM": "SİKLOHEKSENİLTRİKLORO -SİLAN",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 176300,
	  "UN_NO__1": 1763
	},
	{
	  "BAKANLIK_KOD": 176400,
	  "UN_NO": 1764,
	  "ORİJİNAL İSİM": "DİKLOROASETİK ASİT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 176400,
	  "UN_NO__1": 1764
	},
	{
	  "BAKANLIK_KOD": 176500,
	  "UN_NO": 1765,
	  "ORİJİNAL İSİM": "DİKLOROASETİL KLORÜR",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 176500,
	  "UN_NO__1": 1765
	},
	{
	  "BAKANLIK_KOD": 176600,
	  "UN_NO": 1766,
	  "ORİJİNAL İSİM": "DİKLOROFENİL- TRİKLOROSİLAN",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 176600,
	  "UN_NO__1": 1766
	},
	{
	  "BAKANLIK_KOD": 176700,
	  "UN_NO": 1767,
	  "ORİJİNAL İSİM": "DİETİLDİKLORO-SİLAN",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CF1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 176700,
	  "UN_NO__1": 1767
	},
	{
	  "BAKANLIK_KOD": 176800,
	  "UN_NO": 1768,
	  "ORİJİNAL İSİM": "DİFLOROFOSFORİK ASİT, SUSUZ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 176800,
	  "UN_NO__1": 1768
	},
	{
	  "BAKANLIK_KOD": 176900,
	  "UN_NO": 1769,
	  "ORİJİNAL İSİM": "DİFENİLDİKLORO-SİLAN",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 176900,
	  "UN_NO__1": 1769
	},
	{
	  "BAKANLIK_KOD": 177000,
	  "UN_NO": 1770,
	  "ORİJİNAL İSİM": "DİFENİLMETİL BROMÜR",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C10",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 177000,
	  "UN_NO__1": 1770
	},
	{
	  "BAKANLIK_KOD": 177100,
	  "UN_NO": 1771,
	  "ORİJİNAL İSİM": "DODESİLTRİKLORO-SİLAN",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 177100,
	  "UN_NO__1": 1771
	},
	{
	  "BAKANLIK_KOD": 177300,
	  "UN_NO": 1773,
	  "ORİJİNAL İSİM": "DEMİR (III) KLORÜR, SUSUZ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 177300,
	  "UN_NO__1": 1773
	},
	{
	  "BAKANLIK_KOD": 177400,
	  "UN_NO": 1774,
	  "ORİJİNAL İSİM": "YANGIN SÖNDÜRME CİHAZI SEVK MADDELERİ, aşındırıcı sıvı",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C11",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 177400,
	  "UN_NO__1": 1774
	},
	{
	  "BAKANLIK_KOD": 177500,
	  "UN_NO": 1775,
	  "ORİJİNAL İSİM": "FLOROBORİK ASİT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 177500,
	  "UN_NO__1": 1775
	},
	{
	  "BAKANLIK_KOD": 177600,
	  "UN_NO": 1776,
	  "ORİJİNAL İSİM": "FLOROFOSFORİK ASİT, SUSUZ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 177600,
	  "UN_NO__1": 1776
	},
	{
	  "BAKANLIK_KOD": 177700,
	  "UN_NO": 1777,
	  "ORİJİNAL İSİM": "FLOROSÜLFONİK ASİT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 177700,
	  "UN_NO__1": 1777
	},
	{
	  "BAKANLIK_KOD": 177800,
	  "UN_NO": 1778,
	  "ORİJİNAL İSİM": "FLOROSİLİSİK ASİT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 177800,
	  "UN_NO__1": 1778
	},
	{
	  "BAKANLIK_KOD": 177900,
	  "UN_NO": 1779,
	  "ORİJİNAL İSİM": "FORMİK ASİT kütlece %85'ten fazla asit içeren",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CF1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 177900,
	  "UN_NO__1": 1779
	},
	{
	  "BAKANLIK_KOD": 178000,
	  "UN_NO": 1780,
	  "ORİJİNAL İSİM": "FUMARİL KLORÜR",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 178000,
	  "UN_NO__1": 1780
	},
	{
	  "BAKANLIK_KOD": 178100,
	  "UN_NO": 1781,
	  "ORİJİNAL İSİM": "HEKZADESİLTRİKLORO- SİLAN",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 178100,
	  "UN_NO__1": 1781
	},
	{
	  "BAKANLIK_KOD": 178200,
	  "UN_NO": 1782,
	  "ORİJİNAL İSİM": "HEKZAFLORO-FOSFORİK ASİT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 178200,
	  "UN_NO__1": 1782
	},
	{
	  "BAKANLIK_KOD": 178301,
	  "UN_NO": 1783,
	  "ORİJİNAL İSİM": "HEKZAMETİLEN-DİAMİN ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C7",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 178301,
	  "UN_NO__1": 1783
	},
	{
	  "BAKANLIK_KOD": 178302,
	  "UN_NO": 1783,
	  "ORİJİNAL İSİM": "HEKZAMETİLEN-DİAMİN ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C7",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 178302,
	  "UN_NO__1": 1783
	},
	{
	  "BAKANLIK_KOD": 178400,
	  "UN_NO": 1784,
	  "ORİJİNAL İSİM": "HEKZİLTRİKLOROSİLAN",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 178400,
	  "UN_NO__1": 1784
	},
	{
	  "BAKANLIK_KOD": 178600,
	  "UN_NO": 1786,
	  "ORİJİNAL İSİM": "HİDROFLORİK ASİT VE SÜLFÜRİK ASİT KARIŞIMI",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CT1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 178600,
	  "UN_NO__1": 1786
	},
	{
	  "BAKANLIK_KOD": 178701,
	  "UN_NO": 1787,
	  "ORİJİNAL İSİM": "HİDROİYODİK ASİT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 178701,
	  "UN_NO__1": 1787
	},
	{
	  "BAKANLIK_KOD": 178702,
	  "UN_NO": 1787,
	  "ORİJİNAL İSİM": "HİDROİYODİK ASİT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 178702,
	  "UN_NO__1": 1787
	},
	{
	  "BAKANLIK_KOD": 178801,
	  "UN_NO": 1788,
	  "ORİJİNAL İSİM": "HİDROBROMİK ASİT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 178801,
	  "UN_NO__1": 1788
	},
	{
	  "BAKANLIK_KOD": 178802,
	  "UN_NO": 1788,
	  "ORİJİNAL İSİM": "HİDROBROMİK ASİT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 178802,
	  "UN_NO__1": 1788
	},
	{
	  "BAKANLIK_KOD": 178901,
	  "UN_NO": 1789,
	  "ORİJİNAL İSİM": "HİDROKLORİK ASİT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 178901,
	  "UN_NO__1": 1789
	},
	{
	  "BAKANLIK_KOD": 178902,
	  "UN_NO": 1789,
	  "ORİJİNAL İSİM": "HİDROKLORİK ASİT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 178902,
	  "UN_NO__1": 1789
	},
	{
	  "BAKANLIK_KOD": 179001,
	  "UN_NO": 1790,
	  "ORİJİNAL İSİM": "HİDROFLORİK ASİT %85'ten fazla hidrojen florür içeren",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CT1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 179001,
	  "UN_NO__1": 1790
	},
	{
	  "BAKANLIK_KOD": 179002,
	  "UN_NO": 1790,
	  "ORİJİNAL İSİM": "HİDROFLORİK ASİT %60'tan fazla, %85'ten az hidrojen florür içeren",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CT1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 179002,
	  "UN_NO__1": 1790
	},
	{
	  "BAKANLIK_KOD": 179003,
	  "UN_NO": 1790,
	  "ORİJİNAL İSİM": "HİDROFLORİK ASİT %60'tan az hidrojen florür içeren",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CT1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 179003,
	  "UN_NO__1": 1790
	},
	{
	  "BAKANLIK_KOD": 179101,
	  "UN_NO": 1791,
	  "ORİJİNAL İSİM": "HİPOKLORİT ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C9",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 179101,
	  "UN_NO__1": 1791
	},
	{
	  "BAKANLIK_KOD": 179102,
	  "UN_NO": 1791,
	  "ORİJİNAL İSİM": "HİPOKLORİT ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C9",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 179102,
	  "UN_NO__1": 1791
	},
	{
	  "BAKANLIK_KOD": 179200,
	  "UN_NO": 1792,
	  "ORİJİNAL İSİM": "İYOT MONOKLORÜR, KATI",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 179200,
	  "UN_NO__1": 1792
	},
	{
	  "BAKANLIK_KOD": 179300,
	  "UN_NO": 1793,
	  "ORİJİNAL İSİM": "İZOPROPİL ASİT FOSFAT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 179300,
	  "UN_NO__1": 1793
	},
	{
	  "BAKANLIK_KOD": 179400,
	  "UN_NO": 1794,
	  "ORİJİNAL İSİM": "KURŞUN SÜLFAT %3'ten fazla serbest asit içeren",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 179400,
	  "UN_NO__1": 1794
	},
	{
	  "BAKANLIK_KOD": 179601,
	  "UN_NO": 1796,
	  "ORİJİNAL İSİM": "NİTRATLAYICI ASİT KARIŞIMI %50'den fazla nitrik asit içeren",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CO1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 179601,
	  "UN_NO__1": 1796
	},
	{
	  "BAKANLIK_KOD": 179602,
	  "UN_NO": 1796,
	  "ORİJİNAL İSİM": "NİTRATLAYICI ASİT KARIŞIMI %50'den fazla olmayan nitrik asit içeren",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 179602,
	  "UN_NO__1": 1796
	},
	{
	  "BAKANLIK_KOD": 179900,
	  "UN_NO": 1799,
	  "ORİJİNAL İSİM": "NONİLTRİKLOROSİLAN",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 179900,
	  "UN_NO__1": 1799
	},
	{
	  "BAKANLIK_KOD": 180000,
	  "UN_NO": 1800,
	  "ORİJİNAL İSİM": "OKTADESİLTRİKLORO-SİLAN",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 180000,
	  "UN_NO__1": 1800
	},
	{
	  "BAKANLIK_KOD": 180100,
	  "UN_NO": 1801,
	  "ORİJİNAL İSİM": "OKTİLTRİKLOROSİLAN",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 180100,
	  "UN_NO__1": 1801
	},
	{
	  "BAKANLIK_KOD": 180200,
	  "UN_NO": 1802,
	  "ORİJİNAL İSİM": "PERKLORİK ASİT, kütlece %50'den fazla asit içermeyen",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CO1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 180200,
	  "UN_NO__1": 1802
	},
	{
	  "BAKANLIK_KOD": 180300,
	  "UN_NO": 1803,
	  "ORİJİNAL İSİM": "FENOLSÜLFONİK ASİT, SIVI",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 180300,
	  "UN_NO__1": 1803
	},
	{
	  "BAKANLIK_KOD": 180400,
	  "UN_NO": 1804,
	  "ORİJİNAL İSİM": "FENİLTRİKLORO-SİLAN",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 180400,
	  "UN_NO__1": 1804
	},
	{
	  "BAKANLIK_KOD": 180500,
	  "UN_NO": 1805,
	  "ORİJİNAL İSİM": "FOSFORİK ASİT, ÇÖZELTİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 180500,
	  "UN_NO__1": 1805
	},
	{
	  "BAKANLIK_KOD": 180600,
	  "UN_NO": 1806,
	  "ORİJİNAL İSİM": "FOSFOR PENTAKLORÜR",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 180600,
	  "UN_NO__1": 1806
	},
	{
	  "BAKANLIK_KOD": 180700,
	  "UN_NO": 1807,
	  "ORİJİNAL İSİM": "FOSFOR PENTOKSİT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 180700,
	  "UN_NO__1": 1807
	},
	{
	  "BAKANLIK_KOD": 180800,
	  "UN_NO": 1808,
	  "ORİJİNAL İSİM": "FOSFOR TRİBROMÜR",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 180800,
	  "UN_NO__1": 1808
	},
	{
	  "BAKANLIK_KOD": 180900,
	  "UN_NO": 1809,
	  "ORİJİNAL İSİM": "FOSFOR TRİKLORÜR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TC3",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 180900,
	  "UN_NO__1": 1809
	},
	{
	  "BAKANLIK_KOD": 181000,
	  "UN_NO": 1810,
	  "ORİJİNAL İSİM": "FOSFOR OKSİKLORÜR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TC3",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 181000,
	  "UN_NO__1": 1810
	},
	{
	  "BAKANLIK_KOD": 181100,
	  "UN_NO": 1811,
	  "ORİJİNAL İSİM": "POTASYUM HİDROJENDİFLORÜR, KATI",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CT2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 181100,
	  "UN_NO__1": 1811
	},
	{
	  "BAKANLIK_KOD": 181200,
	  "UN_NO": 1812,
	  "ORİJİNAL İSİM": "POTASYUM FLORÜR, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 181200,
	  "UN_NO__1": 1812
	},
	{
	  "BAKANLIK_KOD": 181300,
	  "UN_NO": 1813,
	  "ORİJİNAL İSİM": "POTASYUM HİDROKSİT, KATI",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C6",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 181300,
	  "UN_NO__1": 1813
	},
	{
	  "BAKANLIK_KOD": 181401,
	  "UN_NO": 1814,
	  "ORİJİNAL İSİM": "POTASYUM HİDROKSİT ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 181401,
	  "UN_NO__1": 1814
	},
	{
	  "BAKANLIK_KOD": 181402,
	  "UN_NO": 1814,
	  "ORİJİNAL İSİM": "POTASYUM HİDROKSİT ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C5",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 181402,
	  "UN_NO__1": 1814
	},
	{
	  "BAKANLIK_KOD": 181500,
	  "UN_NO": 1815,
	  "ORİJİNAL İSİM": "PROPİONİL KLORÜR",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 181500,
	  "UN_NO__1": 1815
	},
	{
	  "BAKANLIK_KOD": 181600,
	  "UN_NO": 1816,
	  "ORİJİNAL İSİM": "PİROPİLTRİKLORO-SİLAN",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CF1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 181600,
	  "UN_NO__1": 1816
	},
	{
	  "BAKANLIK_KOD": 181700,
	  "UN_NO": 1817,
	  "ORİJİNAL İSİM": "PİROSÜLFİRİL KLORÜR",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 181700,
	  "UN_NO__1": 1817
	},
	{
	  "BAKANLIK_KOD": 181800,
	  "UN_NO": 1818,
	  "ORİJİNAL İSİM": "SİLİSYUM TETRAKLORÜR",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 181800,
	  "UN_NO__1": 1818
	},
	{
	  "BAKANLIK_KOD": 181901,
	  "UN_NO": 1819,
	  "ORİJİNAL İSİM": "SODYUM ALÜMİNAT ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 181901,
	  "UN_NO__1": 1819
	},
	{
	  "BAKANLIK_KOD": 181902,
	  "UN_NO": 1819,
	  "ORİJİNAL İSİM": "SODYUM ALÜMİNAT ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C5",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 181902,
	  "UN_NO__1": 1819
	},
	{
	  "BAKANLIK_KOD": 182300,
	  "UN_NO": 1823,
	  "ORİJİNAL İSİM": "SODYUM HİDROKSİT, KATI",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C6",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 182300,
	  "UN_NO__1": 1823
	},
	{
	  "BAKANLIK_KOD": 182401,
	  "UN_NO": 1824,
	  "ORİJİNAL İSİM": "SODYUM HİDROKSİT ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 182401,
	  "UN_NO__1": 1824
	},
	{
	  "BAKANLIK_KOD": 182402,
	  "UN_NO": 1824,
	  "ORİJİNAL İSİM": "SODYUM HİDROKSİT ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C5",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 182402,
	  "UN_NO__1": 1824
	},
	{
	  "BAKANLIK_KOD": 182500,
	  "UN_NO": 1825,
	  "ORİJİNAL İSİM": "SODYUM MONOKSİT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C6",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 182500,
	  "UN_NO__1": 1825
	},
	{
	  "BAKANLIK_KOD": 182601,
	  "UN_NO": 1826,
	  "ORİJİNAL İSİM": "NİTRATLAYICI ASİT KARIŞIMI, KULLANILMIŞ %50'den fazla nitrik asit içeren",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CO1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 182601,
	  "UN_NO__1": 1826
	},
	{
	  "BAKANLIK_KOD": 182602,
	  "UN_NO": 1826,
	  "ORİJİNAL İSİM": "NİTRATLAYICI ASİT KARIŞIMI, KULLANILMIŞ %50'den az nitrik asit içeren",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 182602,
	  "UN_NO__1": 1826
	},
	{
	  "BAKANLIK_KOD": 182700,
	  "UN_NO": 1827,
	  "ORİJİNAL İSİM": "KALAY KLORÜR SUSUZ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 182700,
	  "UN_NO__1": 1827
	},
	{
	  "BAKANLIK_KOD": 182800,
	  "UN_NO": 1828,
	  "ORİJİNAL İSİM": "SÜLFÜR KLORÜRLER",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 182800,
	  "UN_NO__1": 1828
	},
	{
	  "BAKANLIK_KOD": 182900,
	  "UN_NO": 1829,
	  "ORİJİNAL İSİM": "SÜLFÜR TRİOKSİT, STABİLİZE",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 182900,
	  "UN_NO__1": 1829
	},
	{
	  "BAKANLIK_KOD": 183000,
	  "UN_NO": 1830,
	  "ORİJİNAL İSİM": "SÜLFÜRİK ASİT %51'den fazla asit içeren",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 183000,
	  "UN_NO__1": 1830
	},
	{
	  "BAKANLIK_KOD": 183100,
	  "UN_NO": 1831,
	  "ORİJİNAL İSİM": "SÜLFÜRİK ASİT, DUMANLI",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CT1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 183100,
	  "UN_NO__1": 1831
	},
	{
	  "BAKANLIK_KOD": 183200,
	  "UN_NO": 1832,
	  "ORİJİNAL İSİM": "SÜLFÜRİK ASİT, KULLANILMIŞ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 183200,
	  "UN_NO__1": 1832
	},
	{
	  "BAKANLIK_KOD": 183300,
	  "UN_NO": 1833,
	  "ORİJİNAL İSİM": "SÜLFÜRÖZ ASİT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 183300,
	  "UN_NO__1": 1833
	},
	{
	  "BAKANLIK_KOD": 183400,
	  "UN_NO": 1834,
	  "ORİJİNAL İSİM": "SÜLFÜRİL KLORÜR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TC3",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 183400,
	  "UN_NO__1": 1834
	},
	{
	  "BAKANLIK_KOD": 183501,
	  "UN_NO": 1835,
	  "ORİJİNAL İSİM": "TETRAMETİL-AMONYUM HİDROKSİT ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C7",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 183501,
	  "UN_NO__1": 1835
	},
	{
	  "BAKANLIK_KOD": 183502,
	  "UN_NO": 1835,
	  "ORİJİNAL İSİM": "TETRAMETİL-AMONYUM HİDROKSİT ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C7",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 183502,
	  "UN_NO__1": 1835
	},
	{
	  "BAKANLIK_KOD": 183600,
	  "UN_NO": 1836,
	  "ORİJİNAL İSİM": "TİYONİL KLORÜR",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 183600,
	  "UN_NO__1": 1836
	},
	{
	  "BAKANLIK_KOD": 183700,
	  "UN_NO": 1837,
	  "ORİJİNAL İSİM": "TİYOFOSFORİL KLORÜR",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 183700,
	  "UN_NO__1": 1837
	},
	{
	  "BAKANLIK_KOD": 183800,
	  "UN_NO": 1838,
	  "ORİJİNAL İSİM": "TİTANYUM TETRAKLORÜR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TC3",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 183800,
	  "UN_NO__1": 1838
	},
	{
	  "BAKANLIK_KOD": 183900,
	  "UN_NO": 1839,
	  "ORİJİNAL İSİM": "TRİKLOROASETİK ASİT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C4",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 183900,
	  "UN_NO__1": 1839
	},
	{
	  "BAKANLIK_KOD": 184000,
	  "UN_NO": 1840,
	  "ORİJİNAL İSİM": "ÇİNKO KLORÜR ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 184000,
	  "UN_NO__1": 1840
	},
	{
	  "BAKANLIK_KOD": 184100,
	  "UN_NO": 1841,
	  "ORİJİNAL İSİM": "ASETALDEHİT AMONYAK",
	  "SINIF": 9,
	  "SINIFLANDIRMA_KODU": "M11",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 184100,
	  "UN_NO__1": 1841
	},
	{
	  "BAKANLIK_KOD": 184300,
	  "UN_NO": 1843,
	  "ORİJİNAL İSİM": "AMONYUM DİNİTRO-o- KRESOLAT, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 184300,
	  "UN_NO__1": 1843
	},
	{
	  "BAKANLIK_KOD": 184600,
	  "UN_NO": 1846,
	  "ORİJİNAL İSİM": "KARBON TETRAKLORÜR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 184600,
	  "UN_NO__1": 1846
	},
	{
	  "BAKANLIK_KOD": 184700,
	  "UN_NO": 1847,
	  "ORİJİNAL İSİM": "POTASYUM SÜLFÜR, HİDRATLANMIŞ, %30'dan az olmayan kristalizasyon suyu ile",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C6",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 184700,
	  "UN_NO__1": 1847
	},
	{
	  "BAKANLIK_KOD": 184800,
	  "UN_NO": 1848,
	  "ORİJİNAL İSİM": "PROPİYONİK ASİT, kütlece %10'dan fazla ancak %90'dan az asit içeren",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 184800,
	  "UN_NO__1": 1848
	},
	{
	  "BAKANLIK_KOD": 184900,
	  "UN_NO": 1849,
	  "ORİJİNAL İSİM": "SODYUM SÜLFÜR, HİDRATLANMIŞ %30'dan az olmayan su ile",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C6",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 184900,
	  "UN_NO__1": 1849
	},
	{
	  "BAKANLIK_KOD": 185101,
	  "UN_NO": 1851,
	  "ORİJİNAL İSİM": "İLAÇ, SIVI, ZEHİRLİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 185101,
	  "UN_NO__1": 1851
	},
	{
	  "BAKANLIK_KOD": 185102,
	  "UN_NO": 1851,
	  "ORİJİNAL İSİM": "İLAÇ, SIVI, ZEHİRLİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 185102,
	  "UN_NO__1": 1851
	},
	{
	  "BAKANLIK_KOD": 185400,
	  "UN_NO": 1854,
	  "ORİJİNAL İSİM": "BARYUM ALAŞIMLARI, PİROFORİK",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S4",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 185400,
	  "UN_NO__1": 1854
	},
	{
	  "BAKANLIK_KOD": 185500,
	  "UN_NO": 1855,
	  "ORİJİNAL İSİM": "KALSİYUM, PİROFORİK veya KALSİYUM ALAŞIMLARI, PİROFORİK",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S4",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 185500,
	  "UN_NO__1": 1855
	},
	{
	  "BAKANLIK_KOD": 185800,
	  "UN_NO": 1858,
	  "ORİJİNAL İSİM": "HEKZAFLOROPROPİLEN (SOĞUTUCU GAZ R 1216)",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 185800,
	  "UN_NO__1": 1858
	},
	{
	  "BAKANLIK_KOD": 185900,
	  "UN_NO": 1859,
	  "ORİJİNAL İSİM": "SİLİSYUM TETRAFLORÜR",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 185900,
	  "UN_NO__1": 1859
	},
	{
	  "BAKANLIK_KOD": 186000,
	  "UN_NO": 1860,
	  "ORİJİNAL İSİM": "VİNİL FLORÜR, STABİLİZE",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 186000,
	  "UN_NO__1": 1860
	},
	{
	  "BAKANLIK_KOD": 186200,
	  "UN_NO": 1862,
	  "ORİJİNAL İSİM": "ETİL KROTONAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 186200,
	  "UN_NO__1": 1862
	},
	{
	  "BAKANLIK_KOD": 186301,
	  "UN_NO": 1863,
	  "ORİJİNAL İSİM": "YAKITI, HAVACILIK, TÜRBİN MOTORU",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 186301,
	  "UN_NO__1": 1863
	},
	{
	  "BAKANLIK_KOD": 186302,
	  "UN_NO": 1863,
	  "ORİJİNAL İSİM": "YAKITI, HAVACILIK, TÜRBİN MOTORU (50 °C'de buhar basıncı 110 kPa?dan daha yüksek olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 186302,
	  "UN_NO__1": 1863
	},
	{
	  "BAKANLIK_KOD": 186303,
	  "UN_NO": 1863,
	  "ORİJİNAL İSİM": "YAKITI, HAVACILIK, TÜRBİN MOTORU (50 °C'de buhar basıncı 110 kPa?a eşit veya daha düşük olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 186303,
	  "UN_NO__1": 1863
	},
	{
	  "BAKANLIK_KOD": 186304,
	  "UN_NO": 1863,
	  "ORİJİNAL İSİM": "YAKITI, HAVACILIK, TÜRBİN MOTORU",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 186304,
	  "UN_NO__1": 1863
	},
	{
	  "BAKANLIK_KOD": 186500,
	  "UN_NO": 1865,
	  "ORİJİNAL İSİM": "n-PROPİL NİTRAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 186500,
	  "UN_NO__1": 1865
	},
	{
	  "BAKANLIK_KOD": 186601,
	  "UN_NO": 1866,
	  "ORİJİNAL İSİM": "REÇİNE ÇÖZELTİSİ, alevlenebilir",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 186601,
	  "UN_NO__1": 1866
	},
	{
	  "BAKANLIK_KOD": 186602,
	  "UN_NO": 1866,
	  "ORİJİNAL İSİM": "REÇİNE ÇÖZELTİSİ, alevlenebilir (50 °C'de buhar basıncı110 kPa?dan daha yüksek olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 186602,
	  "UN_NO__1": 1866
	},
	{
	  "BAKANLIK_KOD": 186603,
	  "UN_NO": 1866,
	  "ORİJİNAL İSİM": "REÇİNE ÇÖZELTİSİ, alevlenebilir (50 °C'de buhar basıncı110 kPa?a eşit veya daha düşük olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 186603,
	  "UN_NO__1": 1866
	},
	{
	  "BAKANLIK_KOD": 186604,
	  "UN_NO": 1866,
	  "ORİJİNAL İSİM": "REÇİNE ÇÖZELTİSİ, alevlenebilir",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 186604,
	  "UN_NO__1": 1866
	},
	{
	  "BAKANLIK_KOD": 186605,
	  "UN_NO": 1866,
	  "ORİJİNAL İSİM": "REÇİNE ÇÖZELTİSİ, alevlenebilir (2.2.3.1.4 uyarınca viskoz ve parlama noktası 23 °C'nin altında) (50 °C'de buhar basıncı 110 kPa?dan daha yüksek olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 186605,
	  "UN_NO__1": 1866
	},
	{
	  "BAKANLIK_KOD": 186606,
	  "UN_NO": 1866,
	  "ORİJİNAL İSİM": "REÇİNE ÇÖZELTİSİ, alevlenebilir (2.2.3.1.4 uyarınca viskoz ve parlama noktası 23 °C'nin altında) (50 °C'de buhar basıncı 110 kPa?a eşit veya daha düşük olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 186606,
	  "UN_NO__1": 1866
	},
	{
	  "BAKANLIK_KOD": 186800,
	  "UN_NO": 1868,
	  "ORİJİNAL İSİM": "DEKABORAN",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "FT2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 186800,
	  "UN_NO__1": 1868
	},
	{
	  "BAKANLIK_KOD": 186900,
	  "UN_NO": 1869,
	  "ORİJİNAL İSİM": "MAGNEZYUM veya MAGNEZYUM ALAŞIMLARI topak, talaş veya bantlar halinde %50'den fazla magnezyum içeren",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 186900,
	  "UN_NO__1": 1869
	},
	{
	  "BAKANLIK_KOD": 187000,
	  "UN_NO": 1870,
	  "ORİJİNAL İSİM": "POTASYUM BOROHİDRİT",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 187000,
	  "UN_NO__1": 1870
	},
	{
	  "BAKANLIK_KOD": 187100,
	  "UN_NO": 1871,
	  "ORİJİNAL İSİM": "TİTANYUM HİDRİT",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 187100,
	  "UN_NO__1": 1871
	},
	{
	  "BAKANLIK_KOD": 187200,
	  "UN_NO": 1872,
	  "ORİJİNAL İSİM": "KURŞUN DİOKSİT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OT2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 187200,
	  "UN_NO__1": 1872
	},
	{
	  "BAKANLIK_KOD": 187300,
	  "UN_NO": 1873,
	  "ORİJİNAL İSİM": "PERKLORİK ASİT %50'den fazla, %72'den az asit içeren",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OC1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 187300,
	  "UN_NO__1": 1873
	},
	{
	  "BAKANLIK_KOD": 188400,
	  "UN_NO": 1884,
	  "ORİJİNAL İSİM": "BARYUM OKSİT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 188400,
	  "UN_NO__1": 1884
	},
	{
	  "BAKANLIK_KOD": 188500,
	  "UN_NO": 1885,
	  "ORİJİNAL İSİM": "BENZİDİN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 188500,
	  "UN_NO__1": 1885
	},
	{
	  "BAKANLIK_KOD": 188600,
	  "UN_NO": 1886,
	  "ORİJİNAL İSİM": "BENZİLİDEN KLORÜR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 188600,
	  "UN_NO__1": 1886
	},
	{
	  "BAKANLIK_KOD": 188700,
	  "UN_NO": 1887,
	  "ORİJİNAL İSİM": "BROMOKLOROMETAN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 188700,
	  "UN_NO__1": 1887
	},
	{
	  "BAKANLIK_KOD": 188800,
	  "UN_NO": 1888,
	  "ORİJİNAL İSİM": "KLOROFORM",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 188800,
	  "UN_NO__1": 1888
	},
	{
	  "BAKANLIK_KOD": 188900,
	  "UN_NO": 1889,
	  "ORİJİNAL İSİM": "SİYANOJEN BROMÜR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TC2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 188900,
	  "UN_NO__1": 1889
	},
	{
	  "BAKANLIK_KOD": 189100,
	  "UN_NO": 1891,
	  "ORİJİNAL İSİM": "ETİL BROMÜR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 189100,
	  "UN_NO__1": 1891
	},
	{
	  "BAKANLIK_KOD": 189200,
	  "UN_NO": 1892,
	  "ORİJİNAL İSİM": "ETİLDİKLOROARSİN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T3",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 189200,
	  "UN_NO__1": 1892
	},
	{
	  "BAKANLIK_KOD": 189400,
	  "UN_NO": 1894,
	  "ORİJİNAL İSİM": "FENİLCIVA (II) HİDROKSİT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 189400,
	  "UN_NO__1": 1894
	},
	{
	  "BAKANLIK_KOD": 189500,
	  "UN_NO": 1895,
	  "ORİJİNAL İSİM": "FENİLCIVA (II) NİTRAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 189500,
	  "UN_NO__1": 1895
	},
	{
	  "BAKANLIK_KOD": 189700,
	  "UN_NO": 1897,
	  "ORİJİNAL İSİM": "TETRAKLOROETİLEN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 189700,
	  "UN_NO__1": 1897
	},
	{
	  "BAKANLIK_KOD": 189800,
	  "UN_NO": 1898,
	  "ORİJİNAL İSİM": "ASETİL İYODÜR",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 189800,
	  "UN_NO__1": 1898
	},
	{
	  "BAKANLIK_KOD": 190200,
	  "UN_NO": 1902,
	  "ORİJİNAL İSİM": "DİİZOOKTİL ASİT FOSFAT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 190200,
	  "UN_NO__1": 1902
	},
	{
	  "BAKANLIK_KOD": 190301,
	  "UN_NO": 1903,
	  "ORİJİNAL İSİM": "DEZENFEKTAN, SIVI, AŞINDIRICI, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C9",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 190301,
	  "UN_NO__1": 1903
	},
	{
	  "BAKANLIK_KOD": 190302,
	  "UN_NO": 1903,
	  "ORİJİNAL İSİM": "DEZENFEKTAN, SIVI, AŞINDIRICI, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C9",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 190302,
	  "UN_NO__1": 1903
	},
	{
	  "BAKANLIK_KOD": 190303,
	  "UN_NO": 1903,
	  "ORİJİNAL İSİM": "DEZENFEKTAN, SIVI, AŞINDIRICI, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C9",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 190303,
	  "UN_NO__1": 1903
	},
	{
	  "BAKANLIK_KOD": 190500,
	  "UN_NO": 1905,
	  "ORİJİNAL İSİM": "SELENİK ASİT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 190500,
	  "UN_NO__1": 1905
	},
	{
	  "BAKANLIK_KOD": 190600,
	  "UN_NO": 1906,
	  "ORİJİNAL İSİM": "CÜRUF ASİT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 190600,
	  "UN_NO__1": 1906
	},
	{
	  "BAKANLIK_KOD": 190700,
	  "UN_NO": 1907,
	  "ORİJİNAL İSİM": "SODALI KİREÇ %4'ten daha fazla sodyum hidroksit içeren",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C6",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 190700,
	  "UN_NO__1": 1907
	},
	{
	  "BAKANLIK_KOD": 190801,
	  "UN_NO": 1908,
	  "ORİJİNAL İSİM": "KLORİT ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C9",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 190801,
	  "UN_NO__1": 1908
	},
	{
	  "BAKANLIK_KOD": 190802,
	  "UN_NO": 1908,
	  "ORİJİNAL İSİM": "KLORİT ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C9",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 190802,
	  "UN_NO__1": 1908
	},
	{
	  "BAKANLIK_KOD": 191100,
	  "UN_NO": 1911,
	  "ORİJİNAL İSİM": "DİBORAN",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TF",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 191100,
	  "UN_NO__1": 1911
	},
	{
	  "BAKANLIK_KOD": 191200,
	  "UN_NO": 1912,
	  "ORİJİNAL İSİM": "METİL KLORÜR VE METİLEN\n KLORÜR KARIŞIMI",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 191200,
	  "UN_NO__1": 1912
	},
	{
	  "BAKANLIK_KOD": 191300,
	  "UN_NO": 1913,
	  "ORİJİNAL İSİM": "NEON, SOĞUTULMUŞ SIVI",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "3A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 191300,
	  "UN_NO__1": 1913
	},
	{
	  "BAKANLIK_KOD": 191400,
	  "UN_NO": 1914,
	  "ORİJİNAL İSİM": "BÜTİL PROPİONATLAR",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 191400,
	  "UN_NO__1": 1914
	},
	{
	  "BAKANLIK_KOD": 191500,
	  "UN_NO": 1915,
	  "ORİJİNAL İSİM": "SİKLOHEKZANON",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 191500,
	  "UN_NO__1": 1915
	},
	{
	  "BAKANLIK_KOD": 191600,
	  "UN_NO": 1916,
	  "ORİJİNAL İSİM": "2,2'-DİKLORODİETİL ETER",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 191600,
	  "UN_NO__1": 1916
	},
	{
	  "BAKANLIK_KOD": 191700,
	  "UN_NO": 1917,
	  "ORİJİNAL İSİM": "ETİL AKRİLAT, STABİLİZE",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 191700,
	  "UN_NO__1": 1917
	},
	{
	  "BAKANLIK_KOD": 191800,
	  "UN_NO": 1918,
	  "ORİJİNAL İSİM": "İZOPROPİLBENZEN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 191800,
	  "UN_NO__1": 1918
	},
	{
	  "BAKANLIK_KOD": 191900,
	  "UN_NO": 1919,
	  "ORİJİNAL İSİM": "METİL AKRİLAT, STABİLİZE",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 191900,
	  "UN_NO__1": 1919
	},
	{
	  "BAKANLIK_KOD": 192000,
	  "UN_NO": 1920,
	  "ORİJİNAL İSİM": "NONANLAR",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 192000,
	  "UN_NO__1": 1920
	},
	{
	  "BAKANLIK_KOD": 192100,
	  "UN_NO": 1921,
	  "ORİJİNAL İSİM": "PROPİLENİMİN, STABİLİZE",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 192100,
	  "UN_NO__1": 1921
	},
	{
	  "BAKANLIK_KOD": 192200,
	  "UN_NO": 1922,
	  "ORİJİNAL İSİM": "PİROLİDİN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 192200,
	  "UN_NO__1": 1922
	},
	{
	  "BAKANLIK_KOD": 192300,
	  "UN_NO": 1923,
	  "ORİJİNAL İSİM": "KALSİYUM DİTİYONİT (KALSİYUM HİDROSÜLFÜR)",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S4",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 192300,
	  "UN_NO__1": 1923
	},
	{
	  "BAKANLIK_KOD": 192800,
	  "UN_NO": 1928,
	  "ORİJİNAL İSİM": "METİL MAGNEZYUM BROMÜR ETİL ETER İÇİNDE",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 192800,
	  "UN_NO__1": 1928
	},
	{
	  "BAKANLIK_KOD": 192900,
	  "UN_NO": 1929,
	  "ORİJİNAL İSİM": "POTASYUM DİTİYONİT (POTASYUM HİDROSÜLFÜR)",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S4",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 192900,
	  "UN_NO__1": 1929
	},
	{
	  "BAKANLIK_KOD": 193100,
	  "UN_NO": 1931,
	  "ORİJİNAL İSİM": "ÇİNKO DİTİYONİT (ÇİNKO HİDROSÜLFÜR)",
	  "SINIF": 9,
	  "SINIFLANDIRMA_KODU": "M11",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 193100,
	  "UN_NO__1": 1931
	},
	{
	  "BAKANLIK_KOD": 193200,
	  "UN_NO": 1932,
	  "ORİJİNAL İSİM": "ZİRKONYUM HURDASI",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S4",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 193200,
	  "UN_NO__1": 1932
	},
	{
	  "BAKANLIK_KOD": 193501,
	  "UN_NO": 1935,
	  "ORİJİNAL İSİM": "SİYANÜR ÇÖZELTİSİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T4",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 193501,
	  "UN_NO__1": 1935
	},
	{
	  "BAKANLIK_KOD": 193502,
	  "UN_NO": 1935,
	  "ORİJİNAL İSİM": "SİYANÜR ÇÖZELTİSİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T4",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 193502,
	  "UN_NO__1": 1935
	},
	{
	  "BAKANLIK_KOD": 193503,
	  "UN_NO": 1935,
	  "ORİJİNAL İSİM": "SİYANÜR ÇÖZELTİSİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T4",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 193503,
	  "UN_NO__1": 1935
	},
	{
	  "BAKANLIK_KOD": 193801,
	  "UN_NO": 1938,
	  "ORİJİNAL İSİM": "BROMOASETİK ASİT ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 193801,
	  "UN_NO__1": 1938
	},
	{
	  "BAKANLIK_KOD": 193802,
	  "UN_NO": 1938,
	  "ORİJİNAL İSİM": "BROMOASETİK ASİT ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 193802,
	  "UN_NO__1": 1938
	},
	{
	  "BAKANLIK_KOD": 193900,
	  "UN_NO": 1939,
	  "ORİJİNAL İSİM": "FOSFOR OKSİBROMÜR",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 193900,
	  "UN_NO__1": 1939
	},
	{
	  "BAKANLIK_KOD": 194000,
	  "UN_NO": 1940,
	  "ORİJİNAL İSİM": "TİYOGLİKOLİK ASİT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 194000,
	  "UN_NO__1": 1940
	},
	{
	  "BAKANLIK_KOD": 194100,
	  "UN_NO": 1941,
	  "ORİJİNAL İSİM": "DİBROMODİFLORO-METAN",
	  "SINIF": 9,
	  "SINIFLANDIRMA_KODU": "M11",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 194100,
	  "UN_NO__1": 1941
	},
	{
	  "BAKANLIK_KOD": 194200,
	  "UN_NO": 1942,
	  "ORİJİNAL İSİM": "AMONYUM NİTRAT eklenen herhangi bir diğer madde hariç tutularak, karbon olarak hesaplanan herhangi bir organik madde dahil olmak üzere, %0,2'den fazla tutuşabilir madde bulunmayan",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 194200,
	  "UN_NO__1": 1942
	},
	{
	  "BAKANLIK_KOD": 194400,
	  "UN_NO": 1944,
	  "ORİJİNAL İSİM": "KİBRİTLERİ, EMNİYET (paket, karton veya kutu)",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 194400,
	  "UN_NO__1": 1944
	},
	{
	  "BAKANLIK_KOD": 194500,
	  "UN_NO": 1945,
	  "ORİJİNAL İSİM": "KİBRİTLER, MUMLU 'VESTA'",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 194500,
	  "UN_NO__1": 1945
	},
	{
	  "BAKANLIK_KOD": 195001,
	  "UN_NO": 1950,
	  "ORİJİNAL İSİM": "AEROSOLLER, asfiksant",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "5A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 195001,
	  "UN_NO__1": 1950
	},
	{
	  "BAKANLIK_KOD": 195002,
	  "UN_NO": 1950,
	  "ORİJİNAL İSİM": "AEROSOLLER, aşındırıcı",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "5C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 195002,
	  "UN_NO__1": 1950
	},
	{
	  "BAKANLIK_KOD": 195003,
	  "UN_NO": 1950,
	  "ORİJİNAL İSİM": "AEROSOLLER, aşındırıcı, yükseltgen",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "5CO",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 195003,
	  "UN_NO__1": 1950
	},
	{
	  "BAKANLIK_KOD": 195004,
	  "UN_NO": 1950,
	  "ORİJİNAL İSİM": "AEROSOLLER, alevlenebilir",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "5F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 195004,
	  "UN_NO__1": 1950
	},
	{
	  "BAKANLIK_KOD": 195005,
	  "UN_NO": 1950,
	  "ORİJİNAL İSİM": "AEROSOLLER, alevlenebilir, aşındırıcı",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "5FC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 195005,
	  "UN_NO__1": 1950
	},
	{
	  "BAKANLIK_KOD": 195006,
	  "UN_NO": 1950,
	  "ORİJİNAL İSİM": "AEROSOLLER, yükseltgen",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "5O",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 195006,
	  "UN_NO__1": 1950
	},
	{
	  "BAKANLIK_KOD": 195007,
	  "UN_NO": 1950,
	  "ORİJİNAL İSİM": "AEROSOLLER, zehirli",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "5T",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 195007,
	  "UN_NO__1": 1950
	},
	{
	  "BAKANLIK_KOD": 195008,
	  "UN_NO": 1950,
	  "ORİJİNAL İSİM": "AEROSOLLER, zehirli, aşındırıcı",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "5TC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 195008,
	  "UN_NO__1": 1950
	},
	{
	  "BAKANLIK_KOD": 195009,
	  "UN_NO": 1950,
	  "ORİJİNAL İSİM": "AEROSOLLER, zehirli, alevlenebilir",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "5TF",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 195009,
	  "UN_NO__1": 1950
	},
	{
	  "BAKANLIK_KOD": 195010,
	  "UN_NO": 1950,
	  "ORİJİNAL İSİM": "AEROSOLLER, zehirli, alevlenebilir, aşındırıcı",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "5TFC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 195010,
	  "UN_NO__1": 1950
	},
	{
	  "BAKANLIK_KOD": 195011,
	  "UN_NO": 1950,
	  "ORİJİNAL İSİM": "AEROSOLLER, zehirli, yükseltgen",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "5TO",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 195011,
	  "UN_NO__1": 1950
	},
	{
	  "BAKANLIK_KOD": 195012,
	  "UN_NO": 1950,
	  "ORİJİNAL İSİM": "AEROSOLLER, zehirli, yükseltgen, aşındırıcı",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "5TOC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 195012,
	  "UN_NO__1": 1950
	},
	{
	  "BAKANLIK_KOD": 195100,
	  "UN_NO": 1951,
	  "ORİJİNAL İSİM": "ARGON, SOĞUTULMUŞ SIVI",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "3A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 195100,
	  "UN_NO__1": 1951
	},
	{
	  "BAKANLIK_KOD": 195200,
	  "UN_NO": 1952,
	  "ORİJİNAL İSİM": "ETİLEN OKSİT VE KARBON DİOKSİT KARIŞIMI %9'dan az etilen oksit içeren",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 195200,
	  "UN_NO__1": 1952
	},
	{
	  "BAKANLIK_KOD": 195300,
	  "UN_NO": 1953,
	  "ORİJİNAL İSİM": "SIKIŞTIRILMIŞ GAZ, ZEHİRLİ, ALEVLENEBİLİR, B.B.B.",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "1TF",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 195300,
	  "UN_NO__1": 1953
	},
	{
	  "BAKANLIK_KOD": 195400,
	  "UN_NO": 1954,
	  "ORİJİNAL İSİM": "SIKIŞTIRILMIŞ GAZ, ALEVLENEBİLİR, B.B.B.",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "1F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 195400,
	  "UN_NO__1": 1954
	},
	{
	  "BAKANLIK_KOD": 195500,
	  "UN_NO": 1955,
	  "ORİJİNAL İSİM": "SIKIŞTIRILMIŞ GAZ, ZEHİRLİ, B.B.B.",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "1T",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 195500,
	  "UN_NO__1": 1955
	},
	{
	  "BAKANLIK_KOD": 195600,
	  "UN_NO": 1956,
	  "ORİJİNAL İSİM": "SIKIŞTIRILMIŞ GAZ, B.B.B.",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "1A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 195600,
	  "UN_NO__1": 1956
	},
	{
	  "BAKANLIK_KOD": 195700,
	  "UN_NO": 1957,
	  "ORİJİNAL İSİM": "DÖTERYUM, SIKIŞTIRILMIŞ",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "1F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 195700,
	  "UN_NO__1": 1957
	},
	{
	  "BAKANLIK_KOD": 195800,
	  "UN_NO": 1958,
	  "ORİJİNAL İSİM": "1,2-DİKLORO-1,1,2,2- TETRAFLOROETAN (SOĞUTUCU GAZ R 114)",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 195800,
	  "UN_NO__1": 1958
	},
	{
	  "BAKANLIK_KOD": 195900,
	  "UN_NO": 1959,
	  "ORİJİNAL İSİM": "1,1-DİFLOROOETİLEN (SOĞUTUCU GAZ R 1132a)",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 195900,
	  "UN_NO__1": 1959
	},
	{
	  "BAKANLIK_KOD": 196100,
	  "UN_NO": 1961,
	  "ORİJİNAL İSİM": "ETAN, SOĞUTULMUŞ SIVI",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "3F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 196100,
	  "UN_NO__1": 1961
	},
	{
	  "BAKANLIK_KOD": 196200,
	  "UN_NO": 1962,
	  "ORİJİNAL İSİM": "ETİLEN",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 196200,
	  "UN_NO__1": 1962
	},
	{
	  "BAKANLIK_KOD": 196300,
	  "UN_NO": 1963,
	  "ORİJİNAL İSİM": "HELYUM, SOĞUTULMUŞ SIVI",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "3A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 196300,
	  "UN_NO__1": 1963
	},
	{
	  "BAKANLIK_KOD": 196400,
	  "UN_NO": 1964,
	  "ORİJİNAL İSİM": "HİDROKARBON GAZ KARIŞIMI, SIKIŞTIRILMIŞ, B.B.B.",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "1F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 196400,
	  "UN_NO__1": 1964
	},
	{
	  "BAKANLIK_KOD": 196500,
	  "UN_NO": 1965,
	  "ORİJİNAL İSİM": "HİDROKARBON GAZ KARIŞIMI, SIVILAŞTIRILMIŞ, B.B.B. A, A01, A02, A0, A1, B1, B2, B veya C karışımları gibi",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 196500,
	  "UN_NO__1": 1965
	},
	{
	  "BAKANLIK_KOD": 196600,
	  "UN_NO": 1966,
	  "ORİJİNAL İSİM": "HİDROJEN, SOĞUTULMUŞ SIVI",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "3F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 196600,
	  "UN_NO__1": 1966
	},
	{
	  "BAKANLIK_KOD": 196700,
	  "UN_NO": 1967,
	  "ORİJİNAL İSİM": "İNSEKTİSİT GAZ, ZEHİRLİ, B.B.B.",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2T",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 196700,
	  "UN_NO__1": 1967
	},
	{
	  "BAKANLIK_KOD": 196800,
	  "UN_NO": 1968,
	  "ORİJİNAL İSİM": "İNSEKTİSİT GAZ, B.B.B.",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 196800,
	  "UN_NO__1": 1968
	},
	{
	  "BAKANLIK_KOD": 196900,
	  "UN_NO": 1969,
	  "ORİJİNAL İSİM": "İZOBÜTAN",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 196900,
	  "UN_NO__1": 1969
	},
	{
	  "BAKANLIK_KOD": 197000,
	  "UN_NO": 1970,
	  "ORİJİNAL İSİM": "KRİPTON, SOĞUTULMUŞ SIVI",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "3A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 197000,
	  "UN_NO__1": 1970
	},
	{
	  "BAKANLIK_KOD": 197100,
	  "UN_NO": 1971,
	  "ORİJİNAL İSİM": "METAN, SIKIŞTIRILMIŞ veya DOĞAL GAZ, SIKIŞTIRILMIŞ yüksek metan içeren",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "1F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 197100,
	  "UN_NO__1": 1971
	},
	{
	  "BAKANLIK_KOD": 197200,
	  "UN_NO": 1972,
	  "ORİJİNAL İSİM": "METAN, SOĞUTULMUŞ SIVI veya DOĞAL GAZ, SOĞUTULMUŞ SIVI,\n yüksek metan içeren",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "3F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 197200,
	  "UN_NO__1": 1972
	},
	{
	  "BAKANLIK_KOD": 197300,
	  "UN_NO": 1973,
	  "ORİJİNAL İSİM": "KLORODİFLORO-METAN VE KLOROPENTAFLORO-ETAN KARIŞIMI sabit kaynama noktası olan ve yaklaşık %49 klorodiflorometan içeren (SOĞUTUCU GAZ R 502)",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 197300,
	  "UN_NO__1": 1973
	},
	{
	  "BAKANLIK_KOD": 197400,
	  "UN_NO": 1974,
	  "ORİJİNAL İSİM": "KLORODİFLOROBROMO-METAN (SOĞUTUCU GAZ R 12B1)",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 197400,
	  "UN_NO__1": 1974
	},
	{
	  "BAKANLIK_KOD": 197500,
	  "UN_NO": 1975,
	  "ORİJİNAL İSİM": "NİTRİK OKSİT VE DİAZOT TETROKSİT KARIŞIMI (NİTRİK OKSİT VE AZOT DİOKSİT KARIŞIMI)",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TOC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 197500,
	  "UN_NO__1": 1975
	},
	{
	  "BAKANLIK_KOD": 197600,
	  "UN_NO": 1976,
	  "ORİJİNAL İSİM": "OKTAFLOROSİKLO-BÜTAN (SOĞUTUCU GAZ RC 318)",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 197600,
	  "UN_NO__1": 1976
	},
	{
	  "BAKANLIK_KOD": 197700,
	  "UN_NO": 1977,
	  "ORİJİNAL İSİM": "AZOT, SOĞUTULMUŞ SIVI",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "3A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 197700,
	  "UN_NO__1": 1977
	},
	{
	  "BAKANLIK_KOD": 197800,
	  "UN_NO": 1978,
	  "ORİJİNAL İSİM": "PROPAN",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 197800,
	  "UN_NO__1": 1978
	},
	{
	  "BAKANLIK_KOD": 198200,
	  "UN_NO": 1982,
	  "ORİJİNAL İSİM": "TETLAFLOROMETAN (SOĞUTUCU GAZ R 14)",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 198200,
	  "UN_NO__1": 1982
	},
	{
	  "BAKANLIK_KOD": 198300,
	  "UN_NO": 1983,
	  "ORİJİNAL İSİM": "1-KLORO-2,2,2-TRİFLOROETAN (SOĞUTUCU GAZ R 133a)",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 198300,
	  "UN_NO__1": 1983
	},
	{
	  "BAKANLIK_KOD": 198400,
	  "UN_NO": 1984,
	  "ORİJİNAL İSİM": "TRİFLOROMETAN (SOĞUTUCU GAZ R 23)",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 198400,
	  "UN_NO__1": 1984
	},
	{
	  "BAKANLIK_KOD": 198601,
	  "UN_NO": 1986,
	  "ORİJİNAL İSİM": "ALKOLLER, ALEVLENEBİLİR, ZEHİRLİ, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 198601,
	  "UN_NO__1": 1986
	},
	{
	  "BAKANLIK_KOD": 198602,
	  "UN_NO": 1986,
	  "ORİJİNAL İSİM": "ALKOLLER, ALEVLENEBİLİR, ZEHİRLİ, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 198602,
	  "UN_NO__1": 1986
	},
	{
	  "BAKANLIK_KOD": 198603,
	  "UN_NO": 1986,
	  "ORİJİNAL İSİM": "ALKOLLER, ALEVLENEBİLİR, ZEHİRLİ, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 198603,
	  "UN_NO__1": 1986
	},
	{
	  "BAKANLIK_KOD": 198701,
	  "UN_NO": 1987,
	  "ORİJİNAL İSİM": "ALKOLLER, B.B.B (50 °C'de buhar basıncı 110 kPa?dan daha yüksek olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 198701,
	  "UN_NO__1": 1987
	},
	{
	  "BAKANLIK_KOD": 198702,
	  "UN_NO": 1987,
	  "ORİJİNAL İSİM": "ALKOLLER, B.B.B (50 °C'de buhar basıncı 110 kPa?a eşit veya daha düşük olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 198702,
	  "UN_NO__1": 1987
	},
	{
	  "BAKANLIK_KOD": 198703,
	  "UN_NO": 1987,
	  "ORİJİNAL İSİM": "ALKOLLER, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 198703,
	  "UN_NO__1": 1987
	},
	{
	  "BAKANLIK_KOD": 198801,
	  "UN_NO": 1988,
	  "ORİJİNAL İSİM": "ALDEHİTLER, ALEVLENEBİLİR, ZEHİRLİ, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 198801,
	  "UN_NO__1": 1988
	},
	{
	  "BAKANLIK_KOD": 198802,
	  "UN_NO": 1988,
	  "ORİJİNAL İSİM": "ALDEHİTLER, ALEVLENEBİLİR, ZEHİRLİ, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 198802,
	  "UN_NO__1": 1988
	},
	{
	  "BAKANLIK_KOD": 198803,
	  "UN_NO": 1988,
	  "ORİJİNAL İSİM": "ALDEHİTLER, ALEVLENEBİLİR, ZEHİRLİ, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 198803,
	  "UN_NO__1": 1988
	},
	{
	  "BAKANLIK_KOD": 198901,
	  "UN_NO": 1989,
	  "ORİJİNAL İSİM": "ALDEHİTLER, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 198901,
	  "UN_NO__1": 1989
	},
	{
	  "BAKANLIK_KOD": 198902,
	  "UN_NO": 1989,
	  "ORİJİNAL İSİM": "ALDEHİTLER, B.B.B (50 °C'de buhar basıncı 110 kPa'dan daha yüksek olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 198902,
	  "UN_NO__1": 1989
	},
	{
	  "BAKANLIK_KOD": 198903,
	  "UN_NO": 1989,
	  "ORİJİNAL İSİM": "ALDEHİTLER, B.B.B (50 °C'de buhar basıncı 110 kPa?a eşit veya daha düşük olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 198903,
	  "UN_NO__1": 1989
	},
	{
	  "BAKANLIK_KOD": 198904,
	  "UN_NO": 1989,
	  "ORİJİNAL İSİM": "ALDEHİTLER, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 198904,
	  "UN_NO__1": 1989
	},
	{
	  "BAKANLIK_KOD": 199000,
	  "UN_NO": 1990,
	  "ORİJİNAL İSİM": "BENZALDEHİT",
	  "SINIF": 9,
	  "SINIFLANDIRMA_KODU": "M11",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 199000,
	  "UN_NO__1": 1990
	},
	{
	  "BAKANLIK_KOD": 199100,
	  "UN_NO": 1991,
	  "ORİJİNAL İSİM": "KLOROPREN, STABİLİZE",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 199100,
	  "UN_NO__1": 1991
	},
	{
	  "BAKANLIK_KOD": 199201,
	  "UN_NO": 1992,
	  "ORİJİNAL İSİM": "ALEVLENEBİLİR SIVI, ZEHİRLİ, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 199201,
	  "UN_NO__1": 1992
	},
	{
	  "BAKANLIK_KOD": 199202,
	  "UN_NO": 1992,
	  "ORİJİNAL İSİM": "ALEVLENEBİLİR SIVI, ZEHİRLİ, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 199202,
	  "UN_NO__1": 1992
	},
	{
	  "BAKANLIK_KOD": 199203,
	  "UN_NO": 1992,
	  "ORİJİNAL İSİM": "ALEVLENEBİLİR SIVI, ZEHİRLİ, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 199203,
	  "UN_NO__1": 1992
	},
	{
	  "BAKANLIK_KOD": 199301,
	  "UN_NO": 1993,
	  "ORİJİNAL İSİM": "ALEVLENEBİLİR SIVI, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 199301,
	  "UN_NO__1": 1993
	},
	{
	  "BAKANLIK_KOD": 199302,
	  "UN_NO": 1993,
	  "ORİJİNAL İSİM": "ALEVLENEBİLİR SIVI, B.B.B (50 °C'de buhar basıncı 110 kPa?dan daha yüksek olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 199302,
	  "UN_NO__1": 1993
	},
	{
	  "BAKANLIK_KOD": 199303,
	  "UN_NO": 1993,
	  "ORİJİNAL İSİM": "ALEVLENEBİLİR SIVI, B.B.B (50 °C'de buhar basıncı 110 kPa?a eşit veya daha düşük olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 199303,
	  "UN_NO__1": 1993
	},
	{
	  "BAKANLIK_KOD": 199304,
	  "UN_NO": 1993,
	  "ORİJİNAL İSİM": "ALEVLENEBİLİR SIVI, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 199304,
	  "UN_NO__1": 1993
	},
	{
	  "BAKANLIK_KOD": 199305,
	  "UN_NO": 1993,
	  "ORİJİNAL İSİM": "ALEVLENEBİLİR SIVI, B.B.B. (2.2.3.1.4 uyarınca akmaz ve parlama noktası 23 °C'nin altında) (50 °C'de buhar basıncı 110 kPa?dan daha yüksek olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 199305,
	  "UN_NO__1": 1993
	},
	{
	  "BAKANLIK_KOD": 199306,
	  "UN_NO": 1993,
	  "ORİJİNAL İSİM": "ALEVLENEBİLİR SIVI, B.B.B. (2.2.3.1.4 uyarınca viskoz ve parlama noktası 23 °C'nin altında) (50 °C'de buhar basıncı 110 kPa?a eşit veya daha düşük olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 199306,
	  "UN_NO__1": 1993
	},
	{
	  "BAKANLIK_KOD": 199400,
	  "UN_NO": 1994,
	  "ORİJİNAL İSİM": "DEMİR PENTAKARBONİL",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 199400,
	  "UN_NO__1": 1994
	},
	{
	  "BAKANLIK_KOD": 199901,
	  "UN_NO": 1999,
	  "ORİJİNAL İSİM": "KATRANLAR, SIVI, yol yağı ve inceltilmiş bitümler dahil (50 °C'de buhar basıncı 110 kPa?dan daha yüksek olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 199901,
	  "UN_NO__1": 1999
	},
	{
	  "BAKANLIK_KOD": 199902,
	  "UN_NO": 1999,
	  "ORİJİNAL İSİM": "KATRANLAR, SIVI, yol yağları ve inceltilmiş bitümler dahil (50 °C'de buhar basıncı 110 kPa?a eşit veya daha düşük olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 199902,
	  "UN_NO__1": 1999
	},
	{
	  "BAKANLIK_KOD": 199903,
	  "UN_NO": 1999,
	  "ORİJİNAL İSİM": "KATRANLAR, SIVI, yol yağları ve inceltilmiş bitümler dahil",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 199903,
	  "UN_NO__1": 1999
	},
	{
	  "BAKANLIK_KOD": 199904,
	  "UN_NO": 1999,
	  "ORİJİNAL İSİM": "KATRANLAR, SIVI, yol yağları ve inceltilmiş bitümler dahil (2.2.3.1.4 uyarınca viskoz ve parlama noktası 23 °C'nin altında) (50 °C'de buhar basıncı 110 kPa?dan daha yüksek olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 199904,
	  "UN_NO__1": 1999
	},
	{
	  "BAKANLIK_KOD": 199905,
	  "UN_NO": 1999,
	  "ORİJİNAL İSİM": "KATRANLAR, SIVI, yol yağları ve inceltilmiş bitümler dahil (2.2.3.1.4 uyarınca viskoz ve parlama noktası 23 °C'nin altında) (50 °C'de buhar basıncı 110 kPa?a eşit veya daha düşük olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 199905,
	  "UN_NO__1": 1999
	},
	{
	  "BAKANLIK_KOD": 200000,
	  "UN_NO": 2000,
	  "ORİJİNAL İSİM": "SELÜLOİT blok, çubuk, rulo, tabaka, tüpler, vb. halinde, hurda dışında",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 200000,
	  "UN_NO__1": 2000
	},
	{
	  "BAKANLIK_KOD": 200100,
	  "UN_NO": 2001,
	  "ORİJİNAL İSİM": "KOBALT NAFTENATLAR, TOZ",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 200100,
	  "UN_NO__1": 2001
	},
	{
	  "BAKANLIK_KOD": 200200,
	  "UN_NO": 2002,
	  "ORİJİNAL İSİM": "SELÜLOİT HURDA",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 200200,
	  "UN_NO__1": 2002
	},
	{
	  "BAKANLIK_KOD": 200400,
	  "UN_NO": 2004,
	  "ORİJİNAL İSİM": "MAGNEZYUM DİAMİD",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S4",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 200400,
	  "UN_NO__1": 2004
	},
	{
	  "BAKANLIK_KOD": 200600,
	  "UN_NO": 2006,
	  "ORİJİNAL İSİM": "PLASTİKLER, NİTROSELÜLOZ ESASLI, KENDİLİĞİNDEN ISINAN, B.B.B.",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 200600,
	  "UN_NO__1": 2006
	},
	{
	  "BAKANLIK_KOD": 200801,
	  "UN_NO": 2008,
	  "ORİJİNAL İSİM": "ZİRKONYUM TOZU, KURU",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S4",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 200801,
	  "UN_NO__1": 2008
	},
	{
	  "BAKANLIK_KOD": 200802,
	  "UN_NO": 2008,
	  "ORİJİNAL İSİM": "ZİRKONYUM TOZU, KURU",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S4",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 200802,
	  "UN_NO__1": 2008
	},
	{
	  "BAKANLIK_KOD": 200803,
	  "UN_NO": 2008,
	  "ORİJİNAL İSİM": "ZİRKONYUM TOZU, KURU",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S4",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 200803,
	  "UN_NO__1": 2008
	},
	{
	  "BAKANLIK_KOD": 200900,
	  "UN_NO": 2009,
	  "ORİJİNAL İSİM": "ZİRKONYUM, KURU, işlenmiş tabakalar, şeritler veya sarmal tel şeklinde",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S4",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 200900,
	  "UN_NO__1": 2009
	},
	{
	  "BAKANLIK_KOD": 201000,
	  "UN_NO": 2010,
	  "ORİJİNAL İSİM": "MAGNEZYUM HİDRİT",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 201000,
	  "UN_NO__1": 2010
	},
	{
	  "BAKANLIK_KOD": 201100,
	  "UN_NO": 2011,
	  "ORİJİNAL İSİM": "MAGNEZYUM FOSFÜR",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WT2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 201100,
	  "UN_NO__1": 2011
	},
	{
	  "BAKANLIK_KOD": 201200,
	  "UN_NO": 2012,
	  "ORİJİNAL İSİM": "POTASYUM FOSFÜR",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WT2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 201200,
	  "UN_NO__1": 2012
	},
	{
	  "BAKANLIK_KOD": 201300,
	  "UN_NO": 2013,
	  "ORİJİNAL İSİM": "STRONSİYUM FOSFÜR",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WT2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 201300,
	  "UN_NO__1": 2013
	},
	{
	  "BAKANLIK_KOD": 201400,
	  "UN_NO": 2014,
	  "ORİJİNAL İSİM": "HİDROJEN PEROKSİT, SULU ÇÖZELTİ hidrojen peroksit oranı %20'den fazla, ancak %60'tan az (gerektiği gibi stabilize)",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OC1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 201400,
	  "UN_NO__1": 2014
	},
	{
	  "BAKANLIK_KOD": 201501,
	  "UN_NO": 2015,
	  "ORİJİNAL İSİM": "HİDROJEN PEROKSİT, SULU ÇÖZELTİ, STABİLİZE %70'den fazla hidrojen peroksit ile",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OC1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 201501,
	  "UN_NO__1": 2015
	},
	{
	  "BAKANLIK_KOD": 201502,
	  "UN_NO": 2015,
	  "ORİJİNAL İSİM": "HİDROJEN PEROKSİT, SULU ÇÖZELTİ, STABİLİZE %60'tan fazla ancak %70'den az hidrojen peroksit ile",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OC1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 201502,
	  "UN_NO__1": 2015
	},
	{
	  "BAKANLIK_KOD": 201600,
	  "UN_NO": 2016,
	  "ORİJİNAL İSİM": "MÜHİMMAT, ZEHİRLİ, PATLAYICI OLMAYAN paralama hakkı veya fırlatma yükü olmayan, fünyesiz",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 201600,
	  "UN_NO__1": 2016
	},
	{
	  "BAKANLIK_KOD": 201700,
	  "UN_NO": 2017,
	  "ORİJİNAL İSİM": "MÜHİMMAT, GÖZ YAŞARTICI, PATLAYICI OLMAYAN paralama hakkı veya fırlatma yükü olmayan, fünyesiz",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TC2",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 201700,
	  "UN_NO__1": 2017
	},
	{
	  "BAKANLIK_KOD": 201800,
	  "UN_NO": 2018,
	  "ORİJİNAL İSİM": "KLOROANİLİNLER, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 201800,
	  "UN_NO__1": 2018
	},
	{
	  "BAKANLIK_KOD": 201900,
	  "UN_NO": 2019,
	  "ORİJİNAL İSİM": "KLOROANİLİNLER, SIVI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 201900,
	  "UN_NO__1": 2019
	},
	{
	  "BAKANLIK_KOD": 202000,
	  "UN_NO": 2020,
	  "ORİJİNAL İSİM": "KLOROFENOLLER, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 202000,
	  "UN_NO__1": 2020
	},
	{
	  "BAKANLIK_KOD": 202100,
	  "UN_NO": 2021,
	  "ORİJİNAL İSİM": "KLOROFENOLLER, SIVI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 202100,
	  "UN_NO__1": 2021
	},
	{
	  "BAKANLIK_KOD": 202200,
	  "UN_NO": 2022,
	  "ORİJİNAL İSİM": "KRESİLİK ASİT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TC1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 202200,
	  "UN_NO__1": 2022
	},
	{
	  "BAKANLIK_KOD": 202300,
	  "UN_NO": 2023,
	  "ORİJİNAL İSİM": "EPİKLOROHİDRİN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 202300,
	  "UN_NO__1": 2023
	},
	{
	  "BAKANLIK_KOD": 202401,
	  "UN_NO": 2024,
	  "ORİJİNAL İSİM": "CIVA BİLEŞİĞİ, SIVI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T4",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 202401,
	  "UN_NO__1": 2024
	},
	{
	  "BAKANLIK_KOD": 202402,
	  "UN_NO": 2024,
	  "ORİJİNAL İSİM": "CIVA BİLEŞİĞİ, SIVI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T4",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 202402,
	  "UN_NO__1": 2024
	},
	{
	  "BAKANLIK_KOD": 202403,
	  "UN_NO": 2024,
	  "ORİJİNAL İSİM": "CIVA BİLEŞİĞİ, SIVI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T4",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 202403,
	  "UN_NO__1": 2024
	},
	{
	  "BAKANLIK_KOD": 202501,
	  "UN_NO": 2025,
	  "ORİJİNAL İSİM": "CIVA BİLEŞİĞİ, KATI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 202501,
	  "UN_NO__1": 2025
	},
	{
	  "BAKANLIK_KOD": 202502,
	  "UN_NO": 2025,
	  "ORİJİNAL İSİM": "CIVA BİLEŞİĞİ, KATI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 202502,
	  "UN_NO__1": 2025
	},
	{
	  "BAKANLIK_KOD": 202503,
	  "UN_NO": 2025,
	  "ORİJİNAL İSİM": "CIVA BİLEŞİĞİ, KATI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 202503,
	  "UN_NO__1": 2025
	},
	{
	  "BAKANLIK_KOD": 202601,
	  "UN_NO": 2026,
	  "ORİJİNAL İSİM": "FENİLCIVA BİLEŞİĞİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T3",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 202601,
	  "UN_NO__1": 2026
	},
	{
	  "BAKANLIK_KOD": 202602,
	  "UN_NO": 2026,
	  "ORİJİNAL İSİM": "FENİLCIVA BİLEŞİĞİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 202602,
	  "UN_NO__1": 2026
	},
	{
	  "BAKANLIK_KOD": 202603,
	  "UN_NO": 2026,
	  "ORİJİNAL İSİM": "FENİLCIVA BİLEŞİĞİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 202603,
	  "UN_NO__1": 2026
	},
	{
	  "BAKANLIK_KOD": 202700,
	  "UN_NO": 2027,
	  "ORİJİNAL İSİM": "SODYUM ARSENİT, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 202700,
	  "UN_NO__1": 2027
	},
	{
	  "BAKANLIK_KOD": 202800,
	  "UN_NO": 2028,
	  "ORİJİNAL İSİM": "BOMBALAR, SİS, PATLAYICI OLMAYAN aşındırıcı sıvı içeren, tepkime başlatma düzeneği olmayan",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C11",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 202800,
	  "UN_NO__1": 2028
	},
	{
	  "BAKANLIK_KOD": 202900,
	  "UN_NO": 2029,
	  "ORİJİNAL İSİM": "HİDRAZİN, SUSUZ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CFT",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 202900,
	  "UN_NO__1": 2029
	},
	{
	  "BAKANLIK_KOD": 203001,
	  "UN_NO": 2030,
	  "ORİJİNAL İSİM": "HİDRAZİN SULU ÇÖZELTİ, kütlece %37'den fazla hidrazin içeren",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CT1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 203001,
	  "UN_NO__1": 2030
	},
	{
	  "BAKANLIK_KOD": 203002,
	  "UN_NO": 2030,
	  "ORİJİNAL İSİM": "HİDRAZİN SULU ÇÖZELTİ, kütlece %37'den fazla hidrazin içeren",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CT1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 203002,
	  "UN_NO__1": 2030
	},
	{
	  "BAKANLIK_KOD": 203003,
	  "UN_NO": 2030,
	  "ORİJİNAL İSİM": "HİDRAZİN SULU ÇÖZELTİ, kütlece %37'den fazla hidrazin içeren",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CT1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 203003,
	  "UN_NO__1": 2030
	},
	{
	  "BAKANLIK_KOD": 203101,
	  "UN_NO": 2031,
	  "ORİJİNAL İSİM": "NİTRİK ASİT, kırmızı dumanlı dışında, %70'den fazla nitrik asit içeren",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CO1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 203101,
	  "UN_NO__1": 2031
	},
	{
	  "BAKANLIK_KOD": 203102,
	  "UN_NO": 2031,
	  "ORİJİNAL İSİM": "NİTRİK ASİT, en az %65 kırmızı dumanlı dışında, %70'ten fazla olmayan nitrik asit içeren",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CO1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 203102,
	  "UN_NO__1": 2031
	},
	{
	  "BAKANLIK_KOD": 203103,
	  "UN_NO": 2031,
	  "ORİJİNAL İSİM": "NİTRİK ASİT, kırmızı dumanlı dışında, %65'ten az nitrik asit içeren",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 203103,
	  "UN_NO__1": 2031
	},
	{
	  "BAKANLIK_KOD": 203200,
	  "UN_NO": 2032,
	  "ORİJİNAL İSİM": "NİTRİK ASİT, KIRMIZI DUMANLI",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "COT",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 203200,
	  "UN_NO__1": 2032
	},
	{
	  "BAKANLIK_KOD": 203300,
	  "UN_NO": 2033,
	  "ORİJİNAL İSİM": "POTASYUM MONOKSİT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C6",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 203300,
	  "UN_NO__1": 2033
	},
	{
	  "BAKANLIK_KOD": 203400,
	  "UN_NO": 2034,
	  "ORİJİNAL İSİM": "HİDROJEN VE METAN KARIŞIMI, SIKIŞTIRILMIŞ",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "1F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 203400,
	  "UN_NO__1": 2034
	},
	{
	  "BAKANLIK_KOD": 203500,
	  "UN_NO": 2035,
	  "ORİJİNAL İSİM": "1,1,1-TRİFLOROETAN (SOĞUTUCU GAZ R 143a)",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 203500,
	  "UN_NO__1": 2035
	},
	{
	  "BAKANLIK_KOD": 203600,
	  "UN_NO": 2036,
	  "ORİJİNAL İSİM": "KSENON",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 203600,
	  "UN_NO__1": 2036
	},
	{
	  "BAKANLIK_KOD": 203701,
	  "UN_NO": 2037,
	  "ORİJİNAL İSİM": "KAPLAR, KÜÇÜK, GAZ İÇEREN (GAZ KARTUŞLARI) tahliye düzeneği olmayan ve yeniden doldurulamayan",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "5A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 203701,
	  "UN_NO__1": 2037
	},
	{
	  "BAKANLIK_KOD": 203702,
	  "UN_NO": 2037,
	  "ORİJİNAL İSİM": "KAPLAR, KÜÇÜK, GAZ İÇEREN (GAZ KARTUŞLARI) tahliye düzeneği olmayan ve yeniden doldurulamayan",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "5F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 203702,
	  "UN_NO__1": 2037
	},
	{
	  "BAKANLIK_KOD": 203703,
	  "UN_NO": 2037,
	  "ORİJİNAL İSİM": "KAPLAR, KÜÇÜK, GAZ İÇEREN (GAZ KARTUŞLARI) tahliye düzeneği olmayan ve yeniden doldurulamayan",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "5O",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 203703,
	  "UN_NO__1": 2037
	},
	{
	  "BAKANLIK_KOD": 203704,
	  "UN_NO": 2037,
	  "ORİJİNAL İSİM": "KAPLAR, KÜÇÜK, GAZ İÇEREN (GAZ KARTUŞLARI) tahliye düzeneği olmayan ve yeniden doldurulamayan",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "5T",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 203704,
	  "UN_NO__1": 2037
	},
	{
	  "BAKANLIK_KOD": 203705,
	  "UN_NO": 2037,
	  "ORİJİNAL İSİM": "KAPLAR, KÜÇÜK, GAZ İÇEREN (GAZ KARTUŞLARI) tahliye düzeneği olmayan ve yeniden doldurulamayan",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "5TC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 203705,
	  "UN_NO__1": 2037
	},
	{
	  "BAKANLIK_KOD": 203706,
	  "UN_NO": 2037,
	  "ORİJİNAL İSİM": "KAPLAR, KÜÇÜK, GAZ İÇEREN (GAZ KARTUŞLARI) tahliye düzeneği olmayan ve yeniden doldurulamayan",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "5TF",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 203706,
	  "UN_NO__1": 2037
	},
	{
	  "BAKANLIK_KOD": 203707,
	  "UN_NO": 2037,
	  "ORİJİNAL İSİM": "KAPLAR, KÜÇÜK, GAZ İÇEREN (GAZ KARTUŞLARI) tahliye düzeneği olmayan ve yeniden doldurulamayan",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "5TFC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 203707,
	  "UN_NO__1": 2037
	},
	{
	  "BAKANLIK_KOD": 203708,
	  "UN_NO": 2037,
	  "ORİJİNAL İSİM": "KAPLAR, KÜÇÜK, GAZ İÇEREN (GAZ KARTUŞLARI) tahliye düzeneği olmayan ve yeniden doldurulamayan",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "5TO",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 203708,
	  "UN_NO__1": 2037
	},
	{
	  "BAKANLIK_KOD": 203709,
	  "UN_NO": 2037,
	  "ORİJİNAL İSİM": "KAPLAR, KÜÇÜK, GAZ İÇEREN (GAZ KARTUŞLARI) tahliye düzeneği olmayan ve yeniden doldurulamayan",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "5TOC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 203709,
	  "UN_NO__1": 2037
	},
	{
	  "BAKANLIK_KOD": 203800,
	  "UN_NO": 2038,
	  "ORİJİNAL İSİM": "DİNİTROTOLUENLER, SIVI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 203800,
	  "UN_NO__1": 2038
	},
	{
	  "BAKANLIK_KOD": 204400,
	  "UN_NO": 2044,
	  "ORİJİNAL İSİM": "2,2-DİMETİLPROPAN",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 204400,
	  "UN_NO__1": 2044
	},
	{
	  "BAKANLIK_KOD": 204500,
	  "UN_NO": 2045,
	  "ORİJİNAL İSİM": "İZOBÜTİRALDEHİT (İZOBÜTİL ALDEHİT)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 204500,
	  "UN_NO__1": 2045
	},
	{
	  "BAKANLIK_KOD": 204600,
	  "UN_NO": 2046,
	  "ORİJİNAL İSİM": "SİMENLER",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 204600,
	  "UN_NO__1": 2046
	},
	{
	  "BAKANLIK_KOD": 204701,
	  "UN_NO": 2047,
	  "ORİJİNAL İSİM": "DİKLOROPROPENLER",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 204701,
	  "UN_NO__1": 2047
	},
	{
	  "BAKANLIK_KOD": 204702,
	  "UN_NO": 2047,
	  "ORİJİNAL İSİM": "DİKLOROPROPENLER",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 204702,
	  "UN_NO__1": 2047
	},
	{
	  "BAKANLIK_KOD": 204800,
	  "UN_NO": 2048,
	  "ORİJİNAL İSİM": "DİSİKLOPENTADİEN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 204800,
	  "UN_NO__1": 2048
	},
	{
	  "BAKANLIK_KOD": 204900,
	  "UN_NO": 2049,
	  "ORİJİNAL İSİM": "DİETİLBENZEN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 204900,
	  "UN_NO__1": 2049
	},
	{
	  "BAKANLIK_KOD": 205000,
	  "UN_NO": 2050,
	  "ORİJİNAL İSİM": "DİİZOBÜTİLEN, İZOMERİK BİLEŞİKLER",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 205000,
	  "UN_NO__1": 2050
	},
	{
	  "BAKANLIK_KOD": 205100,
	  "UN_NO": 2051,
	  "ORİJİNAL İSİM": "2-DİMETİLAMİNO-ETANOL",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CF1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 205100,
	  "UN_NO__1": 2051
	},
	{
	  "BAKANLIK_KOD": 205200,
	  "UN_NO": 2052,
	  "ORİJİNAL İSİM": "DİPENTEN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 205200,
	  "UN_NO__1": 2052
	},
	{
	  "BAKANLIK_KOD": 205300,
	  "UN_NO": 2053,
	  "ORİJİNAL İSİM": "METİL İZOBÜTİL KARBİNOL",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 205300,
	  "UN_NO__1": 2053
	},
	{
	  "BAKANLIK_KOD": 205400,
	  "UN_NO": 2054,
	  "ORİJİNAL İSİM": "MORFOLİN",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 205400,
	  "UN_NO__1": 2054
	},
	{
	  "BAKANLIK_KOD": 205500,
	  "UN_NO": 2055,
	  "ORİJİNAL İSİM": "STRİEN MONOMER, STABİLİZE",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 205500,
	  "UN_NO__1": 2055
	},
	{
	  "BAKANLIK_KOD": 205600,
	  "UN_NO": 2056,
	  "ORİJİNAL İSİM": "TETRAHİDROFURAN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 205600,
	  "UN_NO__1": 2056
	},
	{
	  "BAKANLIK_KOD": 205701,
	  "UN_NO": 2057,
	  "ORİJİNAL İSİM": "TRİPROPİLEN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 205701,
	  "UN_NO__1": 2057
	},
	{
	  "BAKANLIK_KOD": 205702,
	  "UN_NO": 2057,
	  "ORİJİNAL İSİM": "TRİPROPİLEN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 205702,
	  "UN_NO__1": 2057
	},
	{
	  "BAKANLIK_KOD": 205800,
	  "UN_NO": 2058,
	  "ORİJİNAL İSİM": "VALERALDEHİT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 205800,
	  "UN_NO__1": 2058
	},
	{
	  "BAKANLIK_KOD": 205901,
	  "UN_NO": 2059,
	  "ORİJİNAL İSİM": "NİTROSELÜLOZ ÇÖZELTİSİ, ALEVLENEBİLİR kuru kütlece %12,6'dan fazla azot ve %55'ten fazla nitroselüloz içermeyen",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "D",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 205901,
	  "UN_NO__1": 2059
	},
	{
	  "BAKANLIK_KOD": 205902,
	  "UN_NO": 2059,
	  "ORİJİNAL İSİM": "NİTROSELÜLOZ ÇÖZELTİSİ, ALEVLENEBİLİR kuru kütlece %12,6'dan fazla azot ve %55'ten fazla nitroselüloz içermeyen (50 °C'deki buhar basıncı 110 kPa?dan daha yüksek olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "D",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 205902,
	  "UN_NO__1": 2059
	},
	{
	  "BAKANLIK_KOD": 205903,
	  "UN_NO": 2059,
	  "ORİJİNAL İSİM": "NİTROSELÜLOZ ÇÖZELTİSİ, ALEVLENEBİLİR kuru kütlece %12,6'dan fazla azot ve %55'ten fazla nitroselüloz içermeyen (50 °C'deki buhar basıncı 110 kPa?a eşit veya daha düşük olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "D",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 205903,
	  "UN_NO__1": 2059
	},
	{
	  "BAKANLIK_KOD": 205904,
	  "UN_NO": 2059,
	  "ORİJİNAL İSİM": "NİTROSELÜLOZ ÇÖZELTİSİ, ALEVLENEBİLİR kuru kütlece %12,6'dan fazla azot ve %55'ten fazla nitroselüloz içermeyen",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "D",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 205904,
	  "UN_NO__1": 2059
	},
	{
	  "BAKANLIK_KOD": 206700,
	  "UN_NO": 2067,
	  "ORİJİNAL İSİM": "AMONYUM NİTRAT ESASLI GÜBRELER",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 206700,
	  "UN_NO__1": 2067
	},
	{
	  "BAKANLIK_KOD": 207100,
	  "UN_NO": 2071,
	  "ORİJİNAL İSİM": "AMONYUM NİTRAT ESASLI GÜBRELER",
	  "SINIF": 9,
	  "SINIFLANDIRMA_KODU": "M11",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 207100,
	  "UN_NO__1": 2071
	},
	{
	  "BAKANLIK_KOD": 207300,
	  "UN_NO": 2073,
	  "ORİJİNAL İSİM": "AMONYAK ÇÖZELTİSİ, 15 °C'de su içerisinde bağıl yoğunluğu 0,880'den az olan ve %35'ten fazla ama %50'den az amonyak içeren",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "4A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 207300,
	  "UN_NO__1": 2073
	},
	{
	  "BAKANLIK_KOD": 207400,
	  "UN_NO": 2074,
	  "ORİJİNAL İSİM": "AKRİLAMİD, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 207400,
	  "UN_NO__1": 2074
	},
	{
	  "BAKANLIK_KOD": 207500,
	  "UN_NO": 2075,
	  "ORİJİNAL İSİM": "KLORAL, SUSUZ, STABİLİZE",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 207500,
	  "UN_NO__1": 2075
	},
	{
	  "BAKANLIK_KOD": 207600,
	  "UN_NO": 2076,
	  "ORİJİNAL İSİM": "KREZOLLER, SIVI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TC1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 207600,
	  "UN_NO__1": 2076
	},
	{
	  "BAKANLIK_KOD": 207700,
	  "UN_NO": 2077,
	  "ORİJİNAL İSİM": "alfa-NAFTİLAMİN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 207700,
	  "UN_NO__1": 2077
	},
	{
	  "BAKANLIK_KOD": 207800,
	  "UN_NO": 2078,
	  "ORİJİNAL İSİM": "TOLUEN DİİZOSİYANAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 207800,
	  "UN_NO__1": 2078
	},
	{
	  "BAKANLIK_KOD": 207900,
	  "UN_NO": 2079,
	  "ORİJİNAL İSİM": "DİETİLENTRİAMİN",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C7",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 207900,
	  "UN_NO__1": 2079
	},
	{
	  "BAKANLIK_KOD": 218700,
	  "UN_NO": 2187,
	  "ORİJİNAL İSİM": "KARBON DİOKSİT, SOĞUTULMUŞ SIVI",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "3A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 218700,
	  "UN_NO__1": 2187
	},
	{
	  "BAKANLIK_KOD": 218800,
	  "UN_NO": 2188,
	  "ORİJİNAL İSİM": "ARSİN",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TF",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 218800,
	  "UN_NO__1": 2188
	},
	{
	  "BAKANLIK_KOD": 218900,
	  "UN_NO": 2189,
	  "ORİJİNAL İSİM": "DİKLOROSİLAN",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TFC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 218900,
	  "UN_NO__1": 2189
	},
	{
	  "BAKANLIK_KOD": 219000,
	  "UN_NO": 2190,
	  "ORİJİNAL İSİM": "OKSİJEN DİFLORÜR, SIKIŞTIRILMIŞ",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "1TOC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 219000,
	  "UN_NO__1": 2190
	},
	{
	  "BAKANLIK_KOD": 219100,
	  "UN_NO": 2191,
	  "ORİJİNAL İSİM": "SÜLFÜRİL FLORÜR",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2T",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 219100,
	  "UN_NO__1": 2191
	},
	{
	  "BAKANLIK_KOD": 219200,
	  "UN_NO": 2192,
	  "ORİJİNAL İSİM": "GERMAN",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TF",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 219200,
	  "UN_NO__1": 2192
	},
	{
	  "BAKANLIK_KOD": 219300,
	  "UN_NO": 2193,
	  "ORİJİNAL İSİM": "HEKZAFLOROETAN (SOĞUTUCU GAZ R 116)",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 219300,
	  "UN_NO__1": 2193
	},
	{
	  "BAKANLIK_KOD": 219400,
	  "UN_NO": 2194,
	  "ORİJİNAL İSİM": "SELENYUM HEKZAFLORÜR",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 219400,
	  "UN_NO__1": 2194
	},
	{
	  "BAKANLIK_KOD": 219500,
	  "UN_NO": 2195,
	  "ORİJİNAL İSİM": "TELLÜR HEKZAFLORÜR",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 219500,
	  "UN_NO__1": 2195
	},
	{
	  "BAKANLIK_KOD": 219600,
	  "UN_NO": 2196,
	  "ORİJİNAL İSİM": "TUNGSTEN HEKZAFLORÜR",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 219600,
	  "UN_NO__1": 2196
	},
	{
	  "BAKANLIK_KOD": 219700,
	  "UN_NO": 2197,
	  "ORİJİNAL İSİM": "HİDROJEN İYODÜR, SUSUZ",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 219700,
	  "UN_NO__1": 2197
	},
	{
	  "BAKANLIK_KOD": 219800,
	  "UN_NO": 2198,
	  "ORİJİNAL İSİM": "FOSFOR PENTAFLORÜR",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 219800,
	  "UN_NO__1": 2198
	},
	{
	  "BAKANLIK_KOD": 219900,
	  "UN_NO": 2199,
	  "ORİJİNAL İSİM": "FOSFİN",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TF",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 219900,
	  "UN_NO__1": 2199
	},
	{
	  "BAKANLIK_KOD": 220000,
	  "UN_NO": 2200,
	  "ORİJİNAL İSİM": "PROPADİEN, STABİLİZE",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 220000,
	  "UN_NO__1": 2200
	},
	{
	  "BAKANLIK_KOD": 220100,
	  "UN_NO": 2201,
	  "ORİJİNAL İSİM": "AZOT OKSİT, SOĞUTULMUŞ SIVI",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "3O",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 220100,
	  "UN_NO__1": 2201
	},
	{
	  "BAKANLIK_KOD": 220200,
	  "UN_NO": 2202,
	  "ORİJİNAL İSİM": "HİDROJEN SELENÜR, SUSUZ",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TF",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 220200,
	  "UN_NO__1": 2202
	},
	{
	  "BAKANLIK_KOD": 220300,
	  "UN_NO": 2203,
	  "ORİJİNAL İSİM": "SİLAN",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 220300,
	  "UN_NO__1": 2203
	},
	{
	  "BAKANLIK_KOD": 220400,
	  "UN_NO": 2204,
	  "ORİJİNAL İSİM": "KARBONİL SÜLFÜR",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TF",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 220400,
	  "UN_NO__1": 2204
	},
	{
	  "BAKANLIK_KOD": 220500,
	  "UN_NO": 2205,
	  "ORİJİNAL İSİM": "ADİPONİTRİL",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 220500,
	  "UN_NO__1": 2205
	},
	{
	  "BAKANLIK_KOD": 220601,
	  "UN_NO": 2206,
	  "ORİJİNAL İSİM": "İZOSİYANATLAR, ZEHİRLİ, B.B.B. veya İZOSİYANAT ÇÖZELTİSİ, ZEHİRLİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 220601,
	  "UN_NO__1": 2206
	},
	{
	  "BAKANLIK_KOD": 220602,
	  "UN_NO": 2206,
	  "ORİJİNAL İSİM": "İZOSİYANATLAR, ZEHİRLİ, B.B.B. veya İZOSİYANAT ÇÖZELTİSİ, ZEHİRLİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 220602,
	  "UN_NO__1": 2206
	},
	{
	  "BAKANLIK_KOD": 220800,
	  "UN_NO": 2208,
	  "ORİJİNAL İSİM": "KALSİYUM HİPOKLORİT KARIŞIMI, KURU %10'dan fazla ancak%39'dan az hazır klor içeren",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 220800,
	  "UN_NO__1": 2208
	},
	{
	  "BAKANLIK_KOD": 220900,
	  "UN_NO": 2209,
	  "ORİJİNAL İSİM": "FORMALDEHİT ÇÖZELTİ %25'ten fazla formaldehit içeren",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C9",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 220900,
	  "UN_NO__1": 2209
	},
	{
	  "BAKANLIK_KOD": 221000,
	  "UN_NO": 2210,
	  "ORİJİNAL İSİM": "MANEB veya MANEB MÜSTAHZARI %60'tan fazla maneb içeren",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "SW",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 221000,
	  "UN_NO__1": 2210
	},
	{
	  "BAKANLIK_KOD": 221100,
	  "UN_NO": 2211,
	  "ORİJİNAL İSİM": "POLİMERİK BONCUKLAR, GENLEŞEBİLİR, alevlenebilir buhar açığa çıkaran",
	  "SINIF": 9,
	  "SINIFLANDIRMA_KODU": "M3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 221100,
	  "UN_NO__1": 2211
	},
	{
	  "BAKANLIK_KOD": 221200,
	  "UN_NO": 2212,
	  "ORİJİNAL İSİM": "ASBEST, AMFİBOL (amosit, tremolit, aktinolit, antofilit, krokidolit)",
	  "SINIF": 9,
	  "SINIFLANDIRMA_KODU": "M1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 221200,
	  "UN_NO__1": 2212
	},
	{
	  "BAKANLIK_KOD": 221300,
	  "UN_NO": 2213,
	  "ORİJİNAL İSİM": "PARAFORMALDEHİT",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 221300,
	  "UN_NO__1": 2213
	},
	{
	  "BAKANLIK_KOD": 221400,
	  "UN_NO": 2214,
	  "ORİJİNAL İSİM": "FİTALİK ANHİDRİT %0,05'ten fazla maleik anhidrit içeren",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C4",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 221400,
	  "UN_NO__1": 2214
	},
	{
	  "BAKANLIK_KOD": 221501,
	  "UN_NO": 2215,
	  "ORİJİNAL İSİM": "MALEİK ANHİDRİT, ERİMİŞ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 221501,
	  "UN_NO__1": 2215
	},
	{
	  "BAKANLIK_KOD": 221502,
	  "UN_NO": 2215,
	  "ORİJİNAL İSİM": "MALEİK ANHİDRİT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C4",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 221502,
	  "UN_NO__1": 2215
	},
	{
	  "BAKANLIK_KOD": 221700,
	  "UN_NO": 2217,
	  "ORİJİNAL İSİM": "TOHUM KÜSPESİ kütlece %1,5'ten az yağ ve kütlece %11'den az nem içeren",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 221700,
	  "UN_NO__1": 2217
	},
	{
	  "BAKANLIK_KOD": 221800,
	  "UN_NO": 2218,
	  "ORİJİNAL İSİM": "AKRİLİK ASİT, STABİLİZE",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CF1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 221800,
	  "UN_NO__1": 2218
	},
	{
	  "BAKANLIK_KOD": 221900,
	  "UN_NO": 2219,
	  "ORİJİNAL İSİM": "ALİL GLİSİDİL ETER",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 221900,
	  "UN_NO__1": 2219
	},
	{
	  "BAKANLIK_KOD": 222200,
	  "UN_NO": 2222,
	  "ORİJİNAL İSİM": "ANİZOL",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 222200,
	  "UN_NO__1": 2222
	},
	{
	  "BAKANLIK_KOD": 222400,
	  "UN_NO": 2224,
	  "ORİJİNAL İSİM": "BENZONİTRİL",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 222400,
	  "UN_NO__1": 2224
	},
	{
	  "BAKANLIK_KOD": 222500,
	  "UN_NO": 2225,
	  "ORİJİNAL İSİM": "BENZENSÜLFONİL KLORÜR",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 222500,
	  "UN_NO__1": 2225
	},
	{
	  "BAKANLIK_KOD": 222600,
	  "UN_NO": 2226,
	  "ORİJİNAL İSİM": "BENZOTRİKLORÜR",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C9",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 222600,
	  "UN_NO__1": 2226
	},
	{
	  "BAKANLIK_KOD": 222700,
	  "UN_NO": 2227,
	  "ORİJİNAL İSİM": "n-BÜTİL METAKRİLAT, STABİLİZE",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 222700,
	  "UN_NO__1": 2227
	},
	{
	  "BAKANLIK_KOD": 223200,
	  "UN_NO": 2232,
	  "ORİJİNAL İSİM": "2-KLOROETANAL",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 223200,
	  "UN_NO__1": 2232
	},
	{
	  "BAKANLIK_KOD": 223300,
	  "UN_NO": 2233,
	  "ORİJİNAL İSİM": "KLOROANİSİDİNLER",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 223300,
	  "UN_NO__1": 2233
	},
	{
	  "BAKANLIK_KOD": 223400,
	  "UN_NO": 2234,
	  "ORİJİNAL İSİM": "KLOROBENZOTRİ-FLORÜRLER",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 223400,
	  "UN_NO__1": 2234
	},
	{
	  "BAKANLIK_KOD": 223500,
	  "UN_NO": 2235,
	  "ORİJİNAL İSİM": "KLOROBENZİL KLORÜRLER, SIVI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 223500,
	  "UN_NO__1": 2235
	},
	{
	  "BAKANLIK_KOD": 223600,
	  "UN_NO": 2236,
	  "ORİJİNAL İSİM": "3-KLORO-4-METİLFENİL İZOSİYANAT, SIVI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 223600,
	  "UN_NO__1": 2236
	},
	{
	  "BAKANLIK_KOD": 223700,
	  "UN_NO": 2237,
	  "ORİJİNAL İSİM": "KLORONİTROANİLİNLER",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 223700,
	  "UN_NO__1": 2237
	},
	{
	  "BAKANLIK_KOD": 223800,
	  "UN_NO": 2238,
	  "ORİJİNAL İSİM": "KLOROTOLUENLER",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 223800,
	  "UN_NO__1": 2238
	},
	{
	  "BAKANLIK_KOD": 223900,
	  "UN_NO": 2239,
	  "ORİJİNAL İSİM": "KLOROTOLUİDİNLER, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 223900,
	  "UN_NO__1": 2239
	},
	{
	  "BAKANLIK_KOD": 224000,
	  "UN_NO": 2240,
	  "ORİJİNAL İSİM": "KROMOSÜLFÜRİK ASİT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 224000,
	  "UN_NO__1": 2240
	},
	{
	  "BAKANLIK_KOD": 224100,
	  "UN_NO": 2241,
	  "ORİJİNAL İSİM": "SİKLOHEPTAN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 224100,
	  "UN_NO__1": 2241
	},
	{
	  "BAKANLIK_KOD": 224200,
	  "UN_NO": 2242,
	  "ORİJİNAL İSİM": "SİKLOHEPTEN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 224200,
	  "UN_NO__1": 2242
	},
	{
	  "BAKANLIK_KOD": 224300,
	  "UN_NO": 2243,
	  "ORİJİNAL İSİM": "SİKLOHEKSİL ASETAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 224300,
	  "UN_NO__1": 2243
	},
	{
	  "BAKANLIK_KOD": 224400,
	  "UN_NO": 2244,
	  "ORİJİNAL İSİM": "SİKLOPENTANOL",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 224400,
	  "UN_NO__1": 2244
	},
	{
	  "BAKANLIK_KOD": 224500,
	  "UN_NO": 2245,
	  "ORİJİNAL İSİM": "SİKLOPENTANON",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 224500,
	  "UN_NO__1": 2245
	},
	{
	  "BAKANLIK_KOD": 224600,
	  "UN_NO": 2246,
	  "ORİJİNAL İSİM": "SİKLOPENTEN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 224600,
	  "UN_NO__1": 2246
	},
	{
	  "BAKANLIK_KOD": 224700,
	  "UN_NO": 2247,
	  "ORİJİNAL İSİM": "n-DEKAN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 224700,
	  "UN_NO__1": 2247
	},
	{
	  "BAKANLIK_KOD": 224800,
	  "UN_NO": 2248,
	  "ORİJİNAL İSİM": "Dİ-n-BÜTİLAMİN",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CF1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 224800,
	  "UN_NO__1": 2248
	},
	{
	  "BAKANLIK_KOD": 225000,
	  "UN_NO": 2250,
	  "ORİJİNAL İSİM": "DİKLOROFENİL İZOSİYANATLAR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 225000,
	  "UN_NO__1": 2250
	},
	{
	  "BAKANLIK_KOD": 225100,
	  "UN_NO": 2251,
	  "ORİJİNAL İSİM": "BİSİKLO[2.2.1]HEPTA-2,5-DİEN, STABİLİZE (2,5-NORBORNADİEN, STABİLİZE)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 225100,
	  "UN_NO__1": 2251
	},
	{
	  "BAKANLIK_KOD": 225200,
	  "UN_NO": 2252,
	  "ORİJİNAL İSİM": "1,2-DİMETOKSİETAN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 225200,
	  "UN_NO__1": 2252
	},
	{
	  "BAKANLIK_KOD": 225300,
	  "UN_NO": 2253,
	  "ORİJİNAL İSİM": "N,N-DİMETİLANİLİN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 225300,
	  "UN_NO__1": 2253
	},
	{
	  "BAKANLIK_KOD": 225400,
	  "UN_NO": 2254,
	  "ORİJİNAL İSİM": "KİBRİTLER, İRİ BAŞLI",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 225400,
	  "UN_NO__1": 2254
	},
	{
	  "BAKANLIK_KOD": 225600,
	  "UN_NO": 2256,
	  "ORİJİNAL İSİM": "SİKLOHEKSEN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 225600,
	  "UN_NO__1": 2256
	},
	{
	  "BAKANLIK_KOD": 225700,
	  "UN_NO": 2257,
	  "ORİJİNAL İSİM": "POTASYUM",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 225700,
	  "UN_NO__1": 2257
	},
	{
	  "BAKANLIK_KOD": 225800,
	  "UN_NO": 2258,
	  "ORİJİNAL İSİM": "1,2-PROPİLENDİAMİN",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CF1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 225800,
	  "UN_NO__1": 2258
	},
	{
	  "BAKANLIK_KOD": 225900,
	  "UN_NO": 2259,
	  "ORİJİNAL İSİM": "TRİETİLENTETRAMİN",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C7",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 225900,
	  "UN_NO__1": 2259
	},
	{
	  "BAKANLIK_KOD": 226000,
	  "UN_NO": 2260,
	  "ORİJİNAL İSİM": "TRİPROPİLAMİN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 226000,
	  "UN_NO__1": 2260
	},
	{
	  "BAKANLIK_KOD": 226100,
	  "UN_NO": 2261,
	  "ORİJİNAL İSİM": "KSİLENOLLER, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 226100,
	  "UN_NO__1": 2261
	},
	{
	  "BAKANLIK_KOD": 226200,
	  "UN_NO": 2262,
	  "ORİJİNAL İSİM": "DİMETİLKARBAMOİL KLORÜR",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 226200,
	  "UN_NO__1": 2262
	},
	{
	  "BAKANLIK_KOD": 226300,
	  "UN_NO": 2263,
	  "ORİJİNAL İSİM": "DİMETİL-SİKLOHEKZANLAR",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 226300,
	  "UN_NO__1": 2263
	},
	{
	  "BAKANLIK_KOD": 226400,
	  "UN_NO": 2264,
	  "ORİJİNAL İSİM": "N,N-DİMETİL-SİKLOHEKZİLAMİN",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CF1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 226400,
	  "UN_NO__1": 2264
	},
	{
	  "BAKANLIK_KOD": 226500,
	  "UN_NO": 2265,
	  "ORİJİNAL İSİM": "N,N-DİMETİL-FORMAMİD",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 226500,
	  "UN_NO__1": 2265
	},
	{
	  "BAKANLIK_KOD": 226600,
	  "UN_NO": 2266,
	  "ORİJİNAL İSİM": "DİMETİL-N-PROPİLAMİN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 226600,
	  "UN_NO__1": 2266
	},
	{
	  "BAKANLIK_KOD": 226700,
	  "UN_NO": 2267,
	  "ORİJİNAL İSİM": "DİMETİL TİYOFOSFORİL KLORÜR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TC1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 226700,
	  "UN_NO__1": 2267
	},
	{
	  "BAKANLIK_KOD": 226900,
	  "UN_NO": 2269,
	  "ORİJİNAL İSİM": "3,3'-İMİNODİPROPİLAMİN",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C7",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 226900,
	  "UN_NO__1": 2269
	},
	{
	  "BAKANLIK_KOD": 227000,
	  "UN_NO": 2270,
	  "ORİJİNAL İSİM": "ETİLAMİN, SULU ÇÖZELTİ kütlece %50'den fazla ancak %70'ten az etilamin içeren",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 227000,
	  "UN_NO__1": 2270
	},
	{
	  "BAKANLIK_KOD": 227100,
	  "UN_NO": 2271,
	  "ORİJİNAL İSİM": "ETİL AMİL KETON",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 227100,
	  "UN_NO__1": 2271
	},
	{
	  "BAKANLIK_KOD": 227200,
	  "UN_NO": 2272,
	  "ORİJİNAL İSİM": "N-ETİLANİLİN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 227200,
	  "UN_NO__1": 2272
	},
	{
	  "BAKANLIK_KOD": 227300,
	  "UN_NO": 2273,
	  "ORİJİNAL İSİM": "2-ETİLANİLİN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 227300,
	  "UN_NO__1": 2273
	},
	{
	  "BAKANLIK_KOD": 227400,
	  "UN_NO": 2274,
	  "ORİJİNAL İSİM": "N-ETİL-N-BENZİLANİLİN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 227400,
	  "UN_NO__1": 2274
	},
	{
	  "BAKANLIK_KOD": 227500,
	  "UN_NO": 2275,
	  "ORİJİNAL İSİM": "2-ETİLBÜTANOL",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 227500,
	  "UN_NO__1": 2275
	},
	{
	  "BAKANLIK_KOD": 227600,
	  "UN_NO": 2276,
	  "ORİJİNAL İSİM": "2-ETİLHEKZİLAMİN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 227600,
	  "UN_NO__1": 2276
	},
	{
	  "BAKANLIK_KOD": 227700,
	  "UN_NO": 2277,
	  "ORİJİNAL İSİM": "ETİL METAKRİLAT, STABİLİZE",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 227700,
	  "UN_NO__1": 2277
	},
	{
	  "BAKANLIK_KOD": 227800,
	  "UN_NO": 2278,
	  "ORİJİNAL İSİM": "n-HEPTEN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 227800,
	  "UN_NO__1": 2278
	},
	{
	  "BAKANLIK_KOD": 227900,
	  "UN_NO": 2279,
	  "ORİJİNAL İSİM": "HEKZAKLOROBÜTADİEN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 227900,
	  "UN_NO__1": 2279
	},
	{
	  "BAKANLIK_KOD": 228000,
	  "UN_NO": 2280,
	  "ORİJİNAL İSİM": "HEKZAMETİLEN-DİAMİN, KATI",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C8",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 228000,
	  "UN_NO__1": 2280
	},
	{
	  "BAKANLIK_KOD": 228100,
	  "UN_NO": 2281,
	  "ORİJİNAL İSİM": "HEKZAMETİLEN DİİZOSİYANAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 228100,
	  "UN_NO__1": 2281
	},
	{
	  "BAKANLIK_KOD": 228200,
	  "UN_NO": 2282,
	  "ORİJİNAL İSİM": "HEKZANOLLER",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 228200,
	  "UN_NO__1": 2282
	},
	{
	  "BAKANLIK_KOD": 228300,
	  "UN_NO": 2283,
	  "ORİJİNAL İSİM": "İZOBÜTİL METAKRİLAT, STABİLİZE",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 228300,
	  "UN_NO__1": 2283
	},
	{
	  "BAKANLIK_KOD": 228400,
	  "UN_NO": 2284,
	  "ORİJİNAL İSİM": "İZOBÜTİRONİTRİL",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 228400,
	  "UN_NO__1": 2284
	},
	{
	  "BAKANLIK_KOD": 228500,
	  "UN_NO": 2285,
	  "ORİJİNAL İSİM": "İZOSİYANATOBENZO- TRİFLORÜRLER",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 228500,
	  "UN_NO__1": 2285
	},
	{
	  "BAKANLIK_KOD": 228600,
	  "UN_NO": 2286,
	  "ORİJİNAL İSİM": "PENTAMETİLHEPTAN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 228600,
	  "UN_NO__1": 2286
	},
	{
	  "BAKANLIK_KOD": 228700,
	  "UN_NO": 2287,
	  "ORİJİNAL İSİM": "İZOHEPTEN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 228700,
	  "UN_NO__1": 2287
	},
	{
	  "BAKANLIK_KOD": 228800,
	  "UN_NO": 2288,
	  "ORİJİNAL İSİM": "İZOHEKSEN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 228800,
	  "UN_NO__1": 2288
	},
	{
	  "BAKANLIK_KOD": 228900,
	  "UN_NO": 2289,
	  "ORİJİNAL İSİM": "İZOFORONDİAMİN",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C7",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 228900,
	  "UN_NO__1": 2289
	},
	{
	  "BAKANLIK_KOD": 229000,
	  "UN_NO": 2290,
	  "ORİJİNAL İSİM": "İZOFORON DİİZOSİYANAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 229000,
	  "UN_NO__1": 2290
	},
	{
	  "BAKANLIK_KOD": 229100,
	  "UN_NO": 2291,
	  "ORİJİNAL İSİM": "KURŞUN BİLEŞİĞİ, KATI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 229100,
	  "UN_NO__1": 2291
	},
	{
	  "BAKANLIK_KOD": 229300,
	  "UN_NO": 2293,
	  "ORİJİNAL İSİM": "4-METOKSİ-4-METİLPENTAN-2-ON",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 229300,
	  "UN_NO__1": 2293
	},
	{
	  "BAKANLIK_KOD": 229400,
	  "UN_NO": 2294,
	  "ORİJİNAL İSİM": "N-METİLANİLİN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 229400,
	  "UN_NO__1": 2294
	},
	{
	  "BAKANLIK_KOD": 229500,
	  "UN_NO": 2295,
	  "ORİJİNAL İSİM": "METİL KLOROASETAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 229500,
	  "UN_NO__1": 2295
	},
	{
	  "BAKANLIK_KOD": 229600,
	  "UN_NO": 2296,
	  "ORİJİNAL İSİM": "METİLSİKLOHEKZAN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 229600,
	  "UN_NO__1": 2296
	},
	{
	  "BAKANLIK_KOD": 229700,
	  "UN_NO": 2297,
	  "ORİJİNAL İSİM": "METİLSİKLO-HEKZANON",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 229700,
	  "UN_NO__1": 2297
	},
	{
	  "BAKANLIK_KOD": 229800,
	  "UN_NO": 2298,
	  "ORİJİNAL İSİM": "METİLSİKLOPENTAN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 229800,
	  "UN_NO__1": 2298
	},
	{
	  "BAKANLIK_KOD": 229900,
	  "UN_NO": 2299,
	  "ORİJİNAL İSİM": "METİL DİKLOROASETAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 229900,
	  "UN_NO__1": 2299
	},
	{
	  "BAKANLIK_KOD": 230000,
	  "UN_NO": 2300,
	  "ORİJİNAL İSİM": "2-METİL-5-ETİLPİRİDİN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 230000,
	  "UN_NO__1": 2300
	},
	{
	  "BAKANLIK_KOD": 230100,
	  "UN_NO": 2301,
	  "ORİJİNAL İSİM": "2-METİLFURAN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 230100,
	  "UN_NO__1": 2301
	},
	{
	  "BAKANLIK_KOD": 230200,
	  "UN_NO": 2302,
	  "ORİJİNAL İSİM": "5-METİLHEKZAN-2-ON",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 230200,
	  "UN_NO__1": 2302
	},
	{
	  "BAKANLIK_KOD": 230300,
	  "UN_NO": 2303,
	  "ORİJİNAL İSİM": "İZOPROPENİLBENZEN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 230300,
	  "UN_NO__1": 2303
	},
	{
	  "BAKANLIK_KOD": 230400,
	  "UN_NO": 2304,
	  "ORİJİNAL İSİM": "NAFTALİN, ERİMİŞ",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 230400,
	  "UN_NO__1": 2304
	},
	{
	  "BAKANLIK_KOD": 230500,
	  "UN_NO": 2305,
	  "ORİJİNAL İSİM": "NİTROBENZEN-SÜLFONİK ASİT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C4",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 230500,
	  "UN_NO__1": 2305
	},
	{
	  "BAKANLIK_KOD": 230600,
	  "UN_NO": 2306,
	  "ORİJİNAL İSİM": "NİTROBENZOTRİ-FLORÜRLER, sıvı",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 230600,
	  "UN_NO__1": 2306
	},
	{
	  "BAKANLIK_KOD": 230700,
	  "UN_NO": 2307,
	  "ORİJİNAL İSİM": "3-NİTRO-4-KLORO- BENZOTRİFLORÜR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 230700,
	  "UN_NO__1": 2307
	},
	{
	  "BAKANLIK_KOD": 230800,
	  "UN_NO": 2308,
	  "ORİJİNAL İSİM": "NİTROSİLSÜLFÜRİK ASİT, SIVI",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 230800,
	  "UN_NO__1": 2308
	},
	{
	  "BAKANLIK_KOD": 230900,
	  "UN_NO": 2309,
	  "ORİJİNAL İSİM": "OKTADİENLER",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 230900,
	  "UN_NO__1": 2309
	},
	{
	  "BAKANLIK_KOD": 231000,
	  "UN_NO": 2310,
	  "ORİJİNAL İSİM": "PENTAN-2,4-DİON",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 231000,
	  "UN_NO__1": 2310
	},
	{
	  "BAKANLIK_KOD": 231100,
	  "UN_NO": 2311,
	  "ORİJİNAL İSİM": "FENETİDİNLER",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 231100,
	  "UN_NO__1": 2311
	},
	{
	  "BAKANLIK_KOD": 231200,
	  "UN_NO": 2312,
	  "ORİJİNAL İSİM": "FENOL, ERİMİŞ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 231200,
	  "UN_NO__1": 2312
	},
	{
	  "BAKANLIK_KOD": 231300,
	  "UN_NO": 2313,
	  "ORİJİNAL İSİM": "PİKOLİNLER",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 231300,
	  "UN_NO__1": 2313
	},
	{
	  "BAKANLIK_KOD": 231500,
	  "UN_NO": 2315,
	  "ORİJİNAL İSİM": "POLİKLORİNLENMİŞ BİFENİLLER, SIVI",
	  "SINIF": 9,
	  "SINIFLANDIRMA_KODU": "M2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 231500,
	  "UN_NO__1": 2315
	},
	{
	  "BAKANLIK_KOD": 231600,
	  "UN_NO": 2316,
	  "ORİJİNAL İSİM": "SODYUM KUPROSİYANÜR, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 231600,
	  "UN_NO__1": 2316
	},
	{
	  "BAKANLIK_KOD": 231700,
	  "UN_NO": 2317,
	  "ORİJİNAL İSİM": "SODYUM KUPROSİYANÜR ÇÖZELTİSİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T4",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 231700,
	  "UN_NO__1": 2317
	},
	{
	  "BAKANLIK_KOD": 231800,
	  "UN_NO": 2318,
	  "ORİJİNAL İSİM": "SODYUM HİDROSÜLFÜR %25'ten az kristalizasyon suyu içeren",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S4",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 231800,
	  "UN_NO__1": 2318
	},
	{
	  "BAKANLIK_KOD": 231900,
	  "UN_NO": 2319,
	  "ORİJİNAL İSİM": "TERPEN HİDROKARBONLAR, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 231900,
	  "UN_NO__1": 2319
	},
	{
	  "BAKANLIK_KOD": 232000,
	  "UN_NO": 2320,
	  "ORİJİNAL İSİM": "TETRAETİLEN-PENTAMİN",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C7",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 232000,
	  "UN_NO__1": 2320
	},
	{
	  "BAKANLIK_KOD": 232100,
	  "UN_NO": 2321,
	  "ORİJİNAL İSİM": "TRİKLOROBENZENLER, SIVI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 232100,
	  "UN_NO__1": 2321
	},
	{
	  "BAKANLIK_KOD": 232200,
	  "UN_NO": 2322,
	  "ORİJİNAL İSİM": "TRİKLOROBÜTEN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 232200,
	  "UN_NO__1": 2322
	},
	{
	  "BAKANLIK_KOD": 232300,
	  "UN_NO": 2323,
	  "ORİJİNAL İSİM": "TRİETİL FOSFİT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 232300,
	  "UN_NO__1": 2323
	},
	{
	  "BAKANLIK_KOD": 232400,
	  "UN_NO": 2324,
	  "ORİJİNAL İSİM": "TRİİZOBÜTİLEN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 232400,
	  "UN_NO__1": 2324
	},
	{
	  "BAKANLIK_KOD": 232500,
	  "UN_NO": 2325,
	  "ORİJİNAL İSİM": "1,3,5-TRİMETİLBENZEN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 232500,
	  "UN_NO__1": 2325
	},
	{
	  "BAKANLIK_KOD": 232600,
	  "UN_NO": 2326,
	  "ORİJİNAL İSİM": "TRİMETİLSİKLO-HEKZİLAMİN",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C7",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 232600,
	  "UN_NO__1": 2326
	},
	{
	  "BAKANLIK_KOD": 232700,
	  "UN_NO": 2327,
	  "ORİJİNAL İSİM": "TRİMETİLHEKZA- METİLENDİAMİNLER",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C7",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 232700,
	  "UN_NO__1": 2327
	},
	{
	  "BAKANLIK_KOD": 232800,
	  "UN_NO": 2328,
	  "ORİJİNAL İSİM": "TRİMETİLHEKZA-METİLEN DİİZOSİYANAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 232800,
	  "UN_NO__1": 2328
	},
	{
	  "BAKANLIK_KOD": 232900,
	  "UN_NO": 2329,
	  "ORİJİNAL İSİM": "TRİMETİL FOSFİT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 232900,
	  "UN_NO__1": 2329
	},
	{
	  "BAKANLIK_KOD": 233000,
	  "UN_NO": 2330,
	  "ORİJİNAL İSİM": "UNDEKAN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 233000,
	  "UN_NO__1": 2330
	},
	{
	  "BAKANLIK_KOD": 233100,
	  "UN_NO": 2331,
	  "ORİJİNAL İSİM": "ÇİNKO KLORÜR, SUSUZ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 233100,
	  "UN_NO__1": 2331
	},
	{
	  "BAKANLIK_KOD": 233200,
	  "UN_NO": 2332,
	  "ORİJİNAL İSİM": "ASETALDEHİT OKSİM",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 233200,
	  "UN_NO__1": 2332
	},
	{
	  "BAKANLIK_KOD": 233300,
	  "UN_NO": 2333,
	  "ORİJİNAL İSİM": "ALİL ASETAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 233300,
	  "UN_NO__1": 2333
	},
	{
	  "BAKANLIK_KOD": 233400,
	  "UN_NO": 2334,
	  "ORİJİNAL İSİM": "ALİLAMİN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 233400,
	  "UN_NO__1": 2334
	},
	{
	  "BAKANLIK_KOD": 233500,
	  "UN_NO": 2335,
	  "ORİJİNAL İSİM": "ALİL ETİL ETER",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 233500,
	  "UN_NO__1": 2335
	},
	{
	  "BAKANLIK_KOD": 233600,
	  "UN_NO": 2336,
	  "ORİJİNAL İSİM": "ALİL FORMAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 233600,
	  "UN_NO__1": 2336
	},
	{
	  "BAKANLIK_KOD": 233700,
	  "UN_NO": 2337,
	  "ORİJİNAL İSİM": "FENİL MERKAPTAN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 233700,
	  "UN_NO__1": 2337
	},
	{
	  "BAKANLIK_KOD": 233800,
	  "UN_NO": 2338,
	  "ORİJİNAL İSİM": "BENZOTRİFLORÜR",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 233800,
	  "UN_NO__1": 2338
	},
	{
	  "BAKANLIK_KOD": 233900,
	  "UN_NO": 2339,
	  "ORİJİNAL İSİM": "2-BROMOBÜTAN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 233900,
	  "UN_NO__1": 2339
	},
	{
	  "BAKANLIK_KOD": 234000,
	  "UN_NO": 2340,
	  "ORİJİNAL İSİM": "2-BROMOETİL ETİL ETER",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 234000,
	  "UN_NO__1": 2340
	},
	{
	  "BAKANLIK_KOD": 234100,
	  "UN_NO": 2341,
	  "ORİJİNAL İSİM": "1-BROMO-3-METİLBÜTAN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 234100,
	  "UN_NO__1": 2341
	},
	{
	  "BAKANLIK_KOD": 234200,
	  "UN_NO": 2342,
	  "ORİJİNAL İSİM": "BROMOMETİL-PROPANLAR",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 234200,
	  "UN_NO__1": 2342
	},
	{
	  "BAKANLIK_KOD": 234300,
	  "UN_NO": 2343,
	  "ORİJİNAL İSİM": "2-BROMOPENTAN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 234300,
	  "UN_NO__1": 2343
	},
	{
	  "BAKANLIK_KOD": 234401,
	  "UN_NO": 2344,
	  "ORİJİNAL İSİM": "BROMOPROPANLAR",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 234401,
	  "UN_NO__1": 2344
	},
	{
	  "BAKANLIK_KOD": 234402,
	  "UN_NO": 2344,
	  "ORİJİNAL İSİM": "BROMOPROPANLAR",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 234402,
	  "UN_NO__1": 2344
	},
	{
	  "BAKANLIK_KOD": 234500,
	  "UN_NO": 2345,
	  "ORİJİNAL İSİM": "3-BROMOPROPİN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 234500,
	  "UN_NO__1": 2345
	},
	{
	  "BAKANLIK_KOD": 234600,
	  "UN_NO": 2346,
	  "ORİJİNAL İSİM": "BÜTANDİON",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 234600,
	  "UN_NO__1": 2346
	},
	{
	  "BAKANLIK_KOD": 234700,
	  "UN_NO": 2347,
	  "ORİJİNAL İSİM": "BÜTİL MERKAPTAN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 234700,
	  "UN_NO__1": 2347
	},
	{
	  "BAKANLIK_KOD": 234800,
	  "UN_NO": 2348,
	  "ORİJİNAL İSİM": "BÜTİL AKRİLATLAR, STABİLİZE",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 234800,
	  "UN_NO__1": 2348
	},
	{
	  "BAKANLIK_KOD": 235000,
	  "UN_NO": 2350,
	  "ORİJİNAL İSİM": "BÜTİL METİL ETER",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 235000,
	  "UN_NO__1": 2350
	},
	{
	  "BAKANLIK_KOD": 235101,
	  "UN_NO": 2351,
	  "ORİJİNAL İSİM": "BÜTİL NİTRİTLER",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 235101,
	  "UN_NO__1": 2351
	},
	{
	  "BAKANLIK_KOD": 235102,
	  "UN_NO": 2351,
	  "ORİJİNAL İSİM": "BÜTİL NİTRİTLER",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 235102,
	  "UN_NO__1": 2351
	},
	{
	  "BAKANLIK_KOD": 235200,
	  "UN_NO": 2352,
	  "ORİJİNAL İSİM": "BÜTİL VİNİL ETER, STABİLİZE",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 235200,
	  "UN_NO__1": 2352
	},
	{
	  "BAKANLIK_KOD": 235300,
	  "UN_NO": 2353,
	  "ORİJİNAL İSİM": "BÜTİRİL KLORÜR",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 235300,
	  "UN_NO__1": 2353
	},
	{
	  "BAKANLIK_KOD": 235400,
	  "UN_NO": 2354,
	  "ORİJİNAL İSİM": "KLOROMETİL ETİL ETER",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 235400,
	  "UN_NO__1": 2354
	},
	{
	  "BAKANLIK_KOD": 235600,
	  "UN_NO": 2356,
	  "ORİJİNAL İSİM": "2-KLOROPROPAN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 235600,
	  "UN_NO__1": 2356
	},
	{
	  "BAKANLIK_KOD": 235700,
	  "UN_NO": 2357,
	  "ORİJİNAL İSİM": "SİKLOHEKZİLAMİN",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CF1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 235700,
	  "UN_NO__1": 2357
	},
	{
	  "BAKANLIK_KOD": 235800,
	  "UN_NO": 2358,
	  "ORİJİNAL İSİM": "SİKLOOKTATETRAEN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 235800,
	  "UN_NO__1": 2358
	},
	{
	  "BAKANLIK_KOD": 235900,
	  "UN_NO": 2359,
	  "ORİJİNAL İSİM": "DİALİLAMİN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FTC",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 235900,
	  "UN_NO__1": 2359
	},
	{
	  "BAKANLIK_KOD": 236000,
	  "UN_NO": 2360,
	  "ORİJİNAL İSİM": "DİALİL ETER",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 236000,
	  "UN_NO__1": 2360
	},
	{
	  "BAKANLIK_KOD": 236100,
	  "UN_NO": 2361,
	  "ORİJİNAL İSİM": "DİİZOBÜTİLAMİN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 236100,
	  "UN_NO__1": 2361
	},
	{
	  "BAKANLIK_KOD": 236200,
	  "UN_NO": 2362,
	  "ORİJİNAL İSİM": "1,1-DİKLOROETAN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 236200,
	  "UN_NO__1": 2362
	},
	{
	  "BAKANLIK_KOD": 236300,
	  "UN_NO": 2363,
	  "ORİJİNAL İSİM": "ETİL MERKAPTAN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 236300,
	  "UN_NO__1": 2363
	},
	{
	  "BAKANLIK_KOD": 236400,
	  "UN_NO": 2364,
	  "ORİJİNAL İSİM": "n-PROPİLBENZEN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 236400,
	  "UN_NO__1": 2364
	},
	{
	  "BAKANLIK_KOD": 236600,
	  "UN_NO": 2366,
	  "ORİJİNAL İSİM": "DİETİL KARBONAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 236600,
	  "UN_NO__1": 2366
	},
	{
	  "BAKANLIK_KOD": 236700,
	  "UN_NO": 2367,
	  "ORİJİNAL İSİM": "alfa-METİL-VALERALDEHİT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 236700,
	  "UN_NO__1": 2367
	},
	{
	  "BAKANLIK_KOD": 236800,
	  "UN_NO": 2368,
	  "ORİJİNAL İSİM": "alfa-PİNEN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 236800,
	  "UN_NO__1": 2368
	},
	{
	  "BAKANLIK_KOD": 237000,
	  "UN_NO": 2370,
	  "ORİJİNAL İSİM": "1-HEKSEN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 237000,
	  "UN_NO__1": 2370
	},
	{
	  "BAKANLIK_KOD": 237100,
	  "UN_NO": 2371,
	  "ORİJİNAL İSİM": "İZOPENTENLER",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 237100,
	  "UN_NO__1": 2371
	},
	{
	  "BAKANLIK_KOD": 237200,
	  "UN_NO": 2372,
	  "ORİJİNAL İSİM": "1,2-Dİ-(DİMETİLAMİNO) ETAN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 237200,
	  "UN_NO__1": 2372
	},
	{
	  "BAKANLIK_KOD": 237300,
	  "UN_NO": 2373,
	  "ORİJİNAL İSİM": "DİETOKSİMETAN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 237300,
	  "UN_NO__1": 2373
	},
	{
	  "BAKANLIK_KOD": 237400,
	  "UN_NO": 2374,
	  "ORİJİNAL İSİM": "3,3-DİETOKSİPROPEN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 237400,
	  "UN_NO__1": 2374
	},
	{
	  "BAKANLIK_KOD": 237500,
	  "UN_NO": 2375,
	  "ORİJİNAL İSİM": "DİETİL SÜLFÜR",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 237500,
	  "UN_NO__1": 2375
	},
	{
	  "BAKANLIK_KOD": 237600,
	  "UN_NO": 2376,
	  "ORİJİNAL İSİM": "2,3-DİHİDROPİRAN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 237600,
	  "UN_NO__1": 2376
	},
	{
	  "BAKANLIK_KOD": 237700,
	  "UN_NO": 2377,
	  "ORİJİNAL İSİM": "1,1-DİMETOKSİETAN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 237700,
	  "UN_NO__1": 2377
	},
	{
	  "BAKANLIK_KOD": 237800,
	  "UN_NO": 2378,
	  "ORİJİNAL İSİM": "2-DİMETİLAMİNO- ASETONİTRİL",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 237800,
	  "UN_NO__1": 2378
	},
	{
	  "BAKANLIK_KOD": 237900,
	  "UN_NO": 2379,
	  "ORİJİNAL İSİM": "1,3-DİMETİL-BÜTİLAMİN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 237900,
	  "UN_NO__1": 2379
	},
	{
	  "BAKANLIK_KOD": 238000,
	  "UN_NO": 2380,
	  "ORİJİNAL İSİM": "DİMETİLDİKLORO- SİLAN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 238000,
	  "UN_NO__1": 2380
	},
	{
	  "BAKANLIK_KOD": 238100,
	  "UN_NO": 2381,
	  "ORİJİNAL İSİM": "DİMETİL DİSÜLFÜR",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 238100,
	  "UN_NO__1": 2381
	},
	{
	  "BAKANLIK_KOD": 238200,
	  "UN_NO": 2382,
	  "ORİJİNAL İSİM": "DİMETİLHİDRAZİN,\n SİMETRİK",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 238200,
	  "UN_NO__1": 2382
	},
	{
	  "BAKANLIK_KOD": 238300,
	  "UN_NO": 2383,
	  "ORİJİNAL İSİM": "DİPROPİLAMİN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 238300,
	  "UN_NO__1": 2383
	},
	{
	  "BAKANLIK_KOD": 238400,
	  "UN_NO": 2384,
	  "ORİJİNAL İSİM": "Dİ-n-PROPİL ETER",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 238400,
	  "UN_NO__1": 2384
	},
	{
	  "BAKANLIK_KOD": 238500,
	  "UN_NO": 2385,
	  "ORİJİNAL İSİM": "ETİL İZOBÜTİRAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 238500,
	  "UN_NO__1": 2385
	},
	{
	  "BAKANLIK_KOD": 238600,
	  "UN_NO": 2386,
	  "ORİJİNAL İSİM": "1-ETİLPİPERİDİN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 238600,
	  "UN_NO__1": 2386
	},
	{
	  "BAKANLIK_KOD": 238700,
	  "UN_NO": 2387,
	  "ORİJİNAL İSİM": "FLOROBENZEN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 238700,
	  "UN_NO__1": 2387
	},
	{
	  "BAKANLIK_KOD": 238800,
	  "UN_NO": 2388,
	  "ORİJİNAL İSİM": "FLOROTOLUENLER",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 238800,
	  "UN_NO__1": 2388
	},
	{
	  "BAKANLIK_KOD": 238900,
	  "UN_NO": 2389,
	  "ORİJİNAL İSİM": "FURAN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 238900,
	  "UN_NO__1": 2389
	},
	{
	  "BAKANLIK_KOD": 239000,
	  "UN_NO": 2390,
	  "ORİJİNAL İSİM": "2-İYODOBÜTAN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 239000,
	  "UN_NO__1": 2390
	},
	{
	  "BAKANLIK_KOD": 239100,
	  "UN_NO": 2391,
	  "ORİJİNAL İSİM": "İYODOMETİLPROPANLAR",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 239100,
	  "UN_NO__1": 2391
	},
	{
	  "BAKANLIK_KOD": 239200,
	  "UN_NO": 2392,
	  "ORİJİNAL İSİM": "İYODOPROPANLAR",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 239200,
	  "UN_NO__1": 2392
	},
	{
	  "BAKANLIK_KOD": 239300,
	  "UN_NO": 2393,
	  "ORİJİNAL İSİM": "İZOBÜTİL FORMAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 239300,
	  "UN_NO__1": 2393
	},
	{
	  "BAKANLIK_KOD": 239400,
	  "UN_NO": 2394,
	  "ORİJİNAL İSİM": "İZOBÜTİL PROPİONAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 239400,
	  "UN_NO__1": 2394
	},
	{
	  "BAKANLIK_KOD": 239500,
	  "UN_NO": 2395,
	  "ORİJİNAL İSİM": "İZOBÜTİRİL KLORÜR",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 239500,
	  "UN_NO__1": 2395
	},
	{
	  "BAKANLIK_KOD": 239600,
	  "UN_NO": 2396,
	  "ORİJİNAL İSİM": "METAKRİLALDEHİT, STABİLİZE",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 239600,
	  "UN_NO__1": 2396
	},
	{
	  "BAKANLIK_KOD": 239700,
	  "UN_NO": 2397,
	  "ORİJİNAL İSİM": "3-METİLBÜTAN-2-ON",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 239700,
	  "UN_NO__1": 2397
	},
	{
	  "BAKANLIK_KOD": 239800,
	  "UN_NO": 2398,
	  "ORİJİNAL İSİM": "METİL tert-BÜTİL ETER",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 239800,
	  "UN_NO__1": 2398
	},
	{
	  "BAKANLIK_KOD": 239900,
	  "UN_NO": 2399,
	  "ORİJİNAL İSİM": "1-METİLPİPERİDİN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 239900,
	  "UN_NO__1": 2399
	},
	{
	  "BAKANLIK_KOD": 240000,
	  "UN_NO": 2400,
	  "ORİJİNAL İSİM": "METİL İZOVALERAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 240000,
	  "UN_NO__1": 2400
	},
	{
	  "BAKANLIK_KOD": 240100,
	  "UN_NO": 2401,
	  "ORİJİNAL İSİM": "PİPERİDİN",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 240100,
	  "UN_NO__1": 2401
	},
	{
	  "BAKANLIK_KOD": 240200,
	  "UN_NO": 2402,
	  "ORİJİNAL İSİM": "PROPANETİYOLLER",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 240200,
	  "UN_NO__1": 2402
	},
	{
	  "BAKANLIK_KOD": 240300,
	  "UN_NO": 2403,
	  "ORİJİNAL İSİM": "İZOPROPENİL ASETAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 240300,
	  "UN_NO__1": 2403
	},
	{
	  "BAKANLIK_KOD": 240400,
	  "UN_NO": 2404,
	  "ORİJİNAL İSİM": "PROPİONİTRİL",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 240400,
	  "UN_NO__1": 2404
	},
	{
	  "BAKANLIK_KOD": 240500,
	  "UN_NO": 2405,
	  "ORİJİNAL İSİM": "İZOPROPİL BÜTİRAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 240500,
	  "UN_NO__1": 2405
	},
	{
	  "BAKANLIK_KOD": 240600,
	  "UN_NO": 2406,
	  "ORİJİNAL İSİM": "İZOPROPİL İZOBÜTİRAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 240600,
	  "UN_NO__1": 2406
	},
	{
	  "BAKANLIK_KOD": 240700,
	  "UN_NO": 2407,
	  "ORİJİNAL İSİM": "İZOPROPİL KLOROFORMAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TFC",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 240700,
	  "UN_NO__1": 2407
	},
	{
	  "BAKANLIK_KOD": 240900,
	  "UN_NO": 2409,
	  "ORİJİNAL İSİM": "İZOPROPİL PROPİONAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 240900,
	  "UN_NO__1": 2409
	},
	{
	  "BAKANLIK_KOD": 241000,
	  "UN_NO": 2410,
	  "ORİJİNAL İSİM": "1,2,3,6-TETRAHİDROPİRİDİN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 241000,
	  "UN_NO__1": 2410
	},
	{
	  "BAKANLIK_KOD": 241100,
	  "UN_NO": 2411,
	  "ORİJİNAL İSİM": "BÜTİRONİTRİL",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 241100,
	  "UN_NO__1": 2411
	},
	{
	  "BAKANLIK_KOD": 241200,
	  "UN_NO": 2412,
	  "ORİJİNAL İSİM": "TETRAHİDROTİYOFEN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 241200,
	  "UN_NO__1": 2412
	},
	{
	  "BAKANLIK_KOD": 241300,
	  "UN_NO": 2413,
	  "ORİJİNAL İSİM": "TETRAPROPİL ORTOTİTANAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 241300,
	  "UN_NO__1": 2413
	},
	{
	  "BAKANLIK_KOD": 241400,
	  "UN_NO": 2414,
	  "ORİJİNAL İSİM": "TİYOFEN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 241400,
	  "UN_NO__1": 2414
	},
	{
	  "BAKANLIK_KOD": 241600,
	  "UN_NO": 2416,
	  "ORİJİNAL İSİM": "TRİMETİL BORAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 241600,
	  "UN_NO__1": 2416
	},
	{
	  "BAKANLIK_KOD": 241700,
	  "UN_NO": 2417,
	  "ORİJİNAL İSİM": "KARBONİL FLORÜR",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 241700,
	  "UN_NO__1": 2417
	},
	{
	  "BAKANLIK_KOD": 241800,
	  "UN_NO": 2418,
	  "ORİJİNAL İSİM": "SÜLFÜR TETRAFLORÜR",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 241800,
	  "UN_NO__1": 2418
	},
	{
	  "BAKANLIK_KOD": 241900,
	  "UN_NO": 2419,
	  "ORİJİNAL İSİM": "BROMOTRİFLORO-ETİLEN",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 241900,
	  "UN_NO__1": 2419
	},
	{
	  "BAKANLIK_KOD": 242000,
	  "UN_NO": 2420,
	  "ORİJİNAL İSİM": "HEKZAFLOROASETON",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 242000,
	  "UN_NO__1": 2420
	},
	{
	  "BAKANLIK_KOD": 242200,
	  "UN_NO": 2422,
	  "ORİJİNAL İSİM": "OKTAFLOROBUT-2-ENE (SOĞUTUCU GAZ R 1318)",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 242200,
	  "UN_NO__1": 2422
	},
	{
	  "BAKANLIK_KOD": 242400,
	  "UN_NO": 2424,
	  "ORİJİNAL İSİM": "OKTAFLOROPROPAN (SOĞUTUCU GAZ R 218)",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 242400,
	  "UN_NO__1": 2424
	},
	{
	  "BAKANLIK_KOD": 242600,
	  "UN_NO": 2426,
	  "ORİJİNAL İSİM": "AMONYUM NİTRAT, SIVI, sıcak konsantre çözelti, %80'den fazla ancak %93'ten az konsantrasyonda",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O1",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 242600,
	  "UN_NO__1": 2426
	},
	{
	  "BAKANLIK_KOD": 242701,
	  "UN_NO": 2427,
	  "ORİJİNAL İSİM": "POTASYUM KLORAT, SULU ÇÖZELTİ",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 242701,
	  "UN_NO__1": 2427
	},
	{
	  "BAKANLIK_KOD": 242702,
	  "UN_NO": 2427,
	  "ORİJİNAL İSİM": "POTASYUM KLORAT, SULU ÇÖZELTİ",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 242702,
	  "UN_NO__1": 2427
	},
	{
	  "BAKANLIK_KOD": 242801,
	  "UN_NO": 2428,
	  "ORİJİNAL İSİM": "SODYUM KLORAT, SULU ÇÖZELTİ",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 242801,
	  "UN_NO__1": 2428
	},
	{
	  "BAKANLIK_KOD": 242802,
	  "UN_NO": 2428,
	  "ORİJİNAL İSİM": "SODYUM KLORAT, SULU ÇÖZELTİ",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 242802,
	  "UN_NO__1": 2428
	},
	{
	  "BAKANLIK_KOD": 242901,
	  "UN_NO": 2429,
	  "ORİJİNAL İSİM": "KALSİYUM KLORAT, SULU ÇÖZELTİ",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 242901,
	  "UN_NO__1": 2429
	},
	{
	  "BAKANLIK_KOD": 242902,
	  "UN_NO": 2429,
	  "ORİJİNAL İSİM": "KALSİYUM KLORAT, SULU ÇÖZELTİ",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 242902,
	  "UN_NO__1": 2429
	},
	{
	  "BAKANLIK_KOD": 243001,
	  "UN_NO": 2430,
	  "ORİJİNAL İSİM": "ALKİLFENOLLER, KATI, B.B.B. (C2-C12 homologlar dahil)",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C4",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 243001,
	  "UN_NO__1": 2430
	},
	{
	  "BAKANLIK_KOD": 243002,
	  "UN_NO": 2430,
	  "ORİJİNAL İSİM": "ALKİLFENOLLER, KATI, B.B.B. (C2-C12 homologlar dahil)",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C4",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 243002,
	  "UN_NO__1": 2430
	},
	{
	  "BAKANLIK_KOD": 243003,
	  "UN_NO": 2430,
	  "ORİJİNAL İSİM": "ALKİLFENOLLER, KATI, B.B.B. (C2-C12 homologlar dahil)",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C4",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 243003,
	  "UN_NO__1": 2430
	},
	{
	  "BAKANLIK_KOD": 243100,
	  "UN_NO": 2431,
	  "ORİJİNAL İSİM": "ANİSİDİNLER",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 243100,
	  "UN_NO__1": 2431
	},
	{
	  "BAKANLIK_KOD": 243200,
	  "UN_NO": 2432,
	  "ORİJİNAL İSİM": "N,N-DİETİLANİLİN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 243200,
	  "UN_NO__1": 2432
	},
	{
	  "BAKANLIK_KOD": 243300,
	  "UN_NO": 2433,
	  "ORİJİNAL İSİM": "KLORONİTROTOLUENLER, SIVI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 243300,
	  "UN_NO__1": 2433
	},
	{
	  "BAKANLIK_KOD": 243400,
	  "UN_NO": 2434,
	  "ORİJİNAL İSİM": "DİBENZİL-DİKLOROSİLAN",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 243400,
	  "UN_NO__1": 2434
	},
	{
	  "BAKANLIK_KOD": 243500,
	  "UN_NO": 2435,
	  "ORİJİNAL İSİM": "ETİLFENİL-DİKLOROSİLAN",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 243500,
	  "UN_NO__1": 2435
	},
	{
	  "BAKANLIK_KOD": 243600,
	  "UN_NO": 2436,
	  "ORİJİNAL İSİM": "TİYOASETİK ASİT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 243600,
	  "UN_NO__1": 2436
	},
	{
	  "BAKANLIK_KOD": 243700,
	  "UN_NO": 2437,
	  "ORİJİNAL İSİM": "METİLFENİL-DİKLOROSİLAN",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 243700,
	  "UN_NO__1": 2437
	},
	{
	  "BAKANLIK_KOD": 243800,
	  "UN_NO": 2438,
	  "ORİJİNAL İSİM": "TRİMETİLASETİL KLORÜR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TFC",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 243800,
	  "UN_NO__1": 2438
	},
	{
	  "BAKANLIK_KOD": 243900,
	  "UN_NO": 2439,
	  "ORİJİNAL İSİM": "SODYUM HİDROJENDİFLORÜR",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 243900,
	  "UN_NO__1": 2439
	},
	{
	  "BAKANLIK_KOD": 244000,
	  "UN_NO": 2440,
	  "ORİJİNAL İSİM": "KALAY KLORÜR PENTAHİDRAT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 244000,
	  "UN_NO__1": 2440
	},
	{
	  "BAKANLIK_KOD": 244100,
	  "UN_NO": 2441,
	  "ORİJİNAL İSİM": "TİTANYUM TRİKLORÜR, PİROFORİK veya TİTANYUM TRİKLORÜR KARIŞIMI, PİROFORİK",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "SC4",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 244100,
	  "UN_NO__1": 2441
	},
	{
	  "BAKANLIK_KOD": 244200,
	  "UN_NO": 2442,
	  "ORİJİNAL İSİM": "TRİKLOROASETİL KLORÜR",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 244200,
	  "UN_NO__1": 2442
	},
	{
	  "BAKANLIK_KOD": 244300,
	  "UN_NO": 2443,
	  "ORİJİNAL İSİM": "VANADYUM OKSİTRİKLORÜR",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 244300,
	  "UN_NO__1": 2443
	},
	{
	  "BAKANLIK_KOD": 244400,
	  "UN_NO": 2444,
	  "ORİJİNAL İSİM": "VANADYUM TETRAKLORÜR",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 244400,
	  "UN_NO__1": 2444
	},
	{
	  "BAKANLIK_KOD": 244600,
	  "UN_NO": 2446,
	  "ORİJİNAL İSİM": "NİTROKRESOLLER, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 244600,
	  "UN_NO__1": 2446
	},
	{
	  "BAKANLIK_KOD": 244700,
	  "UN_NO": 2447,
	  "ORİJİNAL İSİM": "FOSFOR, BEYAZ, ERİMİŞ",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "ST3",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 244700,
	  "UN_NO__1": 2447
	},
	{
	  "BAKANLIK_KOD": 244800,
	  "UN_NO": 2448,
	  "ORİJİNAL İSİM": "SÜLFÜR, ERİMİŞ",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 244800,
	  "UN_NO__1": 2448
	},
	{
	  "BAKANLIK_KOD": 245100,
	  "UN_NO": 2451,
	  "ORİJİNAL İSİM": "AZOT TRİFLORÜR",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2O",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 245100,
	  "UN_NO__1": 2451
	},
	{
	  "BAKANLIK_KOD": 245200,
	  "UN_NO": 2452,
	  "ORİJİNAL İSİM": "ETİL ASETİLEN, STABİLİZE",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 245200,
	  "UN_NO__1": 2452
	},
	{
	  "BAKANLIK_KOD": 245300,
	  "UN_NO": 2453,
	  "ORİJİNAL İSİM": "ETİL FLORÜR (SOĞUTUCU GAZ R 161)",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 245300,
	  "UN_NO__1": 2453
	},
	{
	  "BAKANLIK_KOD": 245400,
	  "UN_NO": 2454,
	  "ORİJİNAL İSİM": "METİL FLORÜR (SOĞUTUCU GAZ R 41)",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 245400,
	  "UN_NO__1": 2454
	},
	{
	  "BAKANLIK_KOD": 245600,
	  "UN_NO": 2456,
	  "ORİJİNAL İSİM": "2-KLOROPROPEN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 245600,
	  "UN_NO__1": 2456
	},
	{
	  "BAKANLIK_KOD": 245700,
	  "UN_NO": 2457,
	  "ORİJİNAL İSİM": "2,3-DİMETİLBÜTAN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 245700,
	  "UN_NO__1": 2457
	},
	{
	  "BAKANLIK_KOD": 245800,
	  "UN_NO": 2458,
	  "ORİJİNAL İSİM": "HEKZADİENLER",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 245800,
	  "UN_NO__1": 2458
	},
	{
	  "BAKANLIK_KOD": 245900,
	  "UN_NO": 2459,
	  "ORİJİNAL İSİM": "2-METİL-1-BÜTEN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 245900,
	  "UN_NO__1": 2459
	},
	{
	  "BAKANLIK_KOD": 246000,
	  "UN_NO": 2460,
	  "ORİJİNAL İSİM": "2-METİL-2-BÜTEN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 246000,
	  "UN_NO__1": 2460
	},
	{
	  "BAKANLIK_KOD": 246100,
	  "UN_NO": 2461,
	  "ORİJİNAL İSİM": "METİLPENTADİEN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 246100,
	  "UN_NO__1": 2461
	},
	{
	  "BAKANLIK_KOD": 246300,
	  "UN_NO": 2463,
	  "ORİJİNAL İSİM": "ALÜMİNYUM HİDRİT",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 246300,
	  "UN_NO__1": 2463
	},
	{
	  "BAKANLIK_KOD": 246400,
	  "UN_NO": 2464,
	  "ORİJİNAL İSİM": "BERİLYUM NİTRAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OT2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 246400,
	  "UN_NO__1": 2464
	},
	{
	  "BAKANLIK_KOD": 246500,
	  "UN_NO": 2465,
	  "ORİJİNAL İSİM": "DİKLOROİZOSİYANÜRİK ASİT, KURU veya DİKLOROİZOSİYANÜRİK ASİT TUZLARI",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 246500,
	  "UN_NO__1": 2465
	},
	{
	  "BAKANLIK_KOD": 246600,
	  "UN_NO": 2466,
	  "ORİJİNAL İSİM": "POTASYUM SÜPEROKSİT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 246600,
	  "UN_NO__1": 2466
	},
	{
	  "BAKANLIK_KOD": 246800,
	  "UN_NO": 2468,
	  "ORİJİNAL İSİM": "TRİKLOROİZOSİYANÜRİK ASİT, KURU",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 246800,
	  "UN_NO__1": 2468
	},
	{
	  "BAKANLIK_KOD": 246900,
	  "UN_NO": 2469,
	  "ORİJİNAL İSİM": "ÇİNKO BROMAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 246900,
	  "UN_NO__1": 2469
	},
	{
	  "BAKANLIK_KOD": 247000,
	  "UN_NO": 2470,
	  "ORİJİNAL İSİM": "FENİLASETONİTRİL, SIVI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 247000,
	  "UN_NO__1": 2470
	},
	{
	  "BAKANLIK_KOD": 247100,
	  "UN_NO": 2471,
	  "ORİJİNAL İSİM": "OSMİYUM TETROKSİT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 247100,
	  "UN_NO__1": 2471
	},
	{
	  "BAKANLIK_KOD": 247300,
	  "UN_NO": 2473,
	  "ORİJİNAL İSİM": "SODYUM ARSANİLAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 247300,
	  "UN_NO__1": 2473
	},
	{
	  "BAKANLIK_KOD": 247400,
	  "UN_NO": 2474,
	  "ORİJİNAL İSİM": "TİYOFOSJEN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 247400,
	  "UN_NO__1": 2474
	},
	{
	  "BAKANLIK_KOD": 247500,
	  "UN_NO": 2475,
	  "ORİJİNAL İSİM": "VANADYUM TRİKLORÜR",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 247500,
	  "UN_NO__1": 2475
	},
	{
	  "BAKANLIK_KOD": 247700,
	  "UN_NO": 2477,
	  "ORİJİNAL İSİM": "METİL İZOTİYOSİYANAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 247700,
	  "UN_NO__1": 2477
	},
	{
	  "BAKANLIK_KOD": 247801,
	  "UN_NO": 2478,
	  "ORİJİNAL İSİM": "İZOSİYANATLAR, ALEVLENEBİLİR, ZEHİRLİ, B.B.B. veya İZOSİYANAT ÇÖZELTİSİ, ALEVLENEBİLİR, ZEHİRLİ, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 247801,
	  "UN_NO__1": 2478
	},
	{
	  "BAKANLIK_KOD": 247802,
	  "UN_NO": 2478,
	  "ORİJİNAL İSİM": "İZOSİYANATLAR, ALEVLENEBİLİR, ZEHİRLİ, B.B.B. veya İZOSİYANAT ÇÖZELTİSİ, ALEVLENEBİLİR, ZEHİRLİ, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 247802,
	  "UN_NO__1": 2478
	},
	{
	  "BAKANLIK_KOD": 248000,
	  "UN_NO": 2480,
	  "ORİJİNAL İSİM": "METİL İZOSİYANAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 248000,
	  "UN_NO__1": 2480
	},
	{
	  "BAKANLIK_KOD": 248100,
	  "UN_NO": 2481,
	  "ORİJİNAL İSİM": "ETİL İZOSİYANAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 248100,
	  "UN_NO__1": 2481
	},
	{
	  "BAKANLIK_KOD": 248200,
	  "UN_NO": 2482,
	  "ORİJİNAL İSİM": "n-PROPİL İZOSİYANAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 248200,
	  "UN_NO__1": 2482
	},
	{
	  "BAKANLIK_KOD": 248300,
	  "UN_NO": 2483,
	  "ORİJİNAL İSİM": "İZOPROPİL İZOSİYANAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 248300,
	  "UN_NO__1": 2483
	},
	{
	  "BAKANLIK_KOD": 248400,
	  "UN_NO": 2484,
	  "ORİJİNAL İSİM": "tert-BÜTİL İZOSİYANAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 248400,
	  "UN_NO__1": 2484
	},
	{
	  "BAKANLIK_KOD": 248500,
	  "UN_NO": 2485,
	  "ORİJİNAL İSİM": "n-BÜTİL İZOSİYANAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 248500,
	  "UN_NO__1": 2485
	},
	{
	  "BAKANLIK_KOD": 248600,
	  "UN_NO": 2486,
	  "ORİJİNAL İSİM": "İZOBÜTİL İZOSİYANAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 248600,
	  "UN_NO__1": 2486
	},
	{
	  "BAKANLIK_KOD": 248700,
	  "UN_NO": 2487,
	  "ORİJİNAL İSİM": "FENİL İZOSİYANAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 248700,
	  "UN_NO__1": 2487
	},
	{
	  "BAKANLIK_KOD": 248800,
	  "UN_NO": 2488,
	  "ORİJİNAL İSİM": "SİKLOHEKSİL İZOSİYANAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 248800,
	  "UN_NO__1": 2488
	},
	{
	  "BAKANLIK_KOD": 249000,
	  "UN_NO": 2490,
	  "ORİJİNAL İSİM": "DİKLOROİZOPROPİL ETER",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 249000,
	  "UN_NO__1": 2490
	},
	{
	  "BAKANLIK_KOD": 249100,
	  "UN_NO": 2491,
	  "ORİJİNAL İSİM": "ETANOLAMİN veya ETANOLAMİN ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C7",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 249100,
	  "UN_NO__1": 2491
	},
	{
	  "BAKANLIK_KOD": 249300,
	  "UN_NO": 2493,
	  "ORİJİNAL İSİM": "HEKZAMETİLENİMİN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 249300,
	  "UN_NO__1": 2493
	},
	{
	  "BAKANLIK_KOD": 249500,
	  "UN_NO": 2495,
	  "ORİJİNAL İSİM": "İYOT PENTAFLORÜR",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OTC",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 249500,
	  "UN_NO__1": 2495
	},
	{
	  "BAKANLIK_KOD": 249600,
	  "UN_NO": 2496,
	  "ORİJİNAL İSİM": "PROPİYONİK ANHİDRİT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 249600,
	  "UN_NO__1": 2496
	},
	{
	  "BAKANLIK_KOD": 249800,
	  "UN_NO": 2498,
	  "ORİJİNAL İSİM": "1,2,3,6- TETRAHİDROBENZALDEHİT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 249800,
	  "UN_NO__1": 2498
	},
	{
	  "BAKANLIK_KOD": 250101,
	  "UN_NO": 2501,
	  "ORİJİNAL İSİM": "TRİS-(1-AZİRİDİNİL) FOSFİN OKSİT ÇÖZELTİSİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 250101,
	  "UN_NO__1": 2501
	},
	{
	  "BAKANLIK_KOD": 250102,
	  "UN_NO": 2501,
	  "ORİJİNAL İSİM": "TRİS-(1-AZİRİDİNİL) FOSFİN OKSİT ÇÖZELTİSİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 250102,
	  "UN_NO__1": 2501
	},
	{
	  "BAKANLIK_KOD": 250200,
	  "UN_NO": 2502,
	  "ORİJİNAL İSİM": "VALERİL KLORÜR",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CF1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 250200,
	  "UN_NO__1": 2502
	},
	{
	  "BAKANLIK_KOD": 250300,
	  "UN_NO": 2503,
	  "ORİJİNAL İSİM": "ZİRKONYUM TETRAKLORÜR",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 250300,
	  "UN_NO__1": 2503
	},
	{
	  "BAKANLIK_KOD": 250400,
	  "UN_NO": 2504,
	  "ORİJİNAL İSİM": "TETRABROMOETAN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 250400,
	  "UN_NO__1": 2504
	},
	{
	  "BAKANLIK_KOD": 250500,
	  "UN_NO": 2505,
	  "ORİJİNAL İSİM": "AMONYUM FLORÜR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 250500,
	  "UN_NO__1": 2505
	},
	{
	  "BAKANLIK_KOD": 250600,
	  "UN_NO": 2506,
	  "ORİJİNAL İSİM": "AMONYUM HİDROJEN SÜLFAT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 250600,
	  "UN_NO__1": 2506
	},
	{
	  "BAKANLIK_KOD": 250700,
	  "UN_NO": 2507,
	  "ORİJİNAL İSİM": "KLOROPLATİNİK ASİT, KATI",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 250700,
	  "UN_NO__1": 2507
	},
	{
	  "BAKANLIK_KOD": 250800,
	  "UN_NO": 2508,
	  "ORİJİNAL İSİM": "MOLİBDEN PENTAKLORÜR",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 250800,
	  "UN_NO__1": 2508
	},
	{
	  "BAKANLIK_KOD": 250900,
	  "UN_NO": 2509,
	  "ORİJİNAL İSİM": "POTASYUM HİDROJEN SÜLFAT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 250900,
	  "UN_NO__1": 2509
	},
	{
	  "BAKANLIK_KOD": 251100,
	  "UN_NO": 2511,
	  "ORİJİNAL İSİM": "2-KLOROPROPİYONİK ASİT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 251100,
	  "UN_NO__1": 2511
	},
	{
	  "BAKANLIK_KOD": 251200,
	  "UN_NO": 2512,
	  "ORİJİNAL İSİM": "AMİNOFENOLLER (o-, m-, p-)",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 251200,
	  "UN_NO__1": 2512
	},
	{
	  "BAKANLIK_KOD": 251300,
	  "UN_NO": 2513,
	  "ORİJİNAL İSİM": "BROMOASETİL BROMÜR",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 251300,
	  "UN_NO__1": 2513
	},
	{
	  "BAKANLIK_KOD": 251400,
	  "UN_NO": 2514,
	  "ORİJİNAL İSİM": "BROMOBENZEN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 251400,
	  "UN_NO__1": 2514
	},
	{
	  "BAKANLIK_KOD": 251500,
	  "UN_NO": 2515,
	  "ORİJİNAL İSİM": "BROMOFORM",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 251500,
	  "UN_NO__1": 2515
	},
	{
	  "BAKANLIK_KOD": 251600,
	  "UN_NO": 2516,
	  "ORİJİNAL İSİM": "KARBON TETRABROMÜR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 251600,
	  "UN_NO__1": 2516
	},
	{
	  "BAKANLIK_KOD": 251700,
	  "UN_NO": 2517,
	  "ORİJİNAL İSİM": "1-KLORO-1,1-DİFLOROETAN (SOĞUTUCU GAZ R 142b)",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 251700,
	  "UN_NO__1": 2517
	},
	{
	  "BAKANLIK_KOD": 251800,
	  "UN_NO": 2518,
	  "ORİJİNAL İSİM": "1,5,9-SİKLODODEKATRİEN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 251800,
	  "UN_NO__1": 2518
	},
	{
	  "BAKANLIK_KOD": 252000,
	  "UN_NO": 2520,
	  "ORİJİNAL İSİM": "SİKLOOKTADİENLER",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 252000,
	  "UN_NO__1": 2520
	},
	{
	  "BAKANLIK_KOD": 252100,
	  "UN_NO": 2521,
	  "ORİJİNAL İSİM": "DİKETEN, STABİLİZE",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 252100,
	  "UN_NO__1": 2521
	},
	{
	  "BAKANLIK_KOD": 252200,
	  "UN_NO": 2522,
	  "ORİJİNAL İSİM": "2-DİMETİLAMİNOETİL METAKRİLAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 252200,
	  "UN_NO__1": 2522
	},
	{
	  "BAKANLIK_KOD": 252400,
	  "UN_NO": 2524,
	  "ORİJİNAL İSİM": "ETİL ORTOFORMAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 252400,
	  "UN_NO__1": 2524
	},
	{
	  "BAKANLIK_KOD": 252500,
	  "UN_NO": 2525,
	  "ORİJİNAL İSİM": "ETİL OKSALAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 252500,
	  "UN_NO__1": 2525
	},
	{
	  "BAKANLIK_KOD": 252600,
	  "UN_NO": 2526,
	  "ORİJİNAL İSİM": "FURFURİLAMİN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 252600,
	  "UN_NO__1": 2526
	},
	{
	  "BAKANLIK_KOD": 252700,
	  "UN_NO": 2527,
	  "ORİJİNAL İSİM": "İZOBÜTİL AKRİLAT, STABİLİZE",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 252700,
	  "UN_NO__1": 2527
	},
	{
	  "BAKANLIK_KOD": 252800,
	  "UN_NO": 2528,
	  "ORİJİNAL İSİM": "İZOBÜTİL İZOBÜTİRAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 252800,
	  "UN_NO__1": 2528
	},
	{
	  "BAKANLIK_KOD": 252900,
	  "UN_NO": 2529,
	  "ORİJİNAL İSİM": "İZOBÜTİRİK ASİT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 252900,
	  "UN_NO__1": 2529
	},
	{
	  "BAKANLIK_KOD": 253100,
	  "UN_NO": 2531,
	  "ORİJİNAL İSİM": "METAKRİLİK ASİT, STABİLİZE",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 253100,
	  "UN_NO__1": 2531
	},
	{
	  "BAKANLIK_KOD": 253300,
	  "UN_NO": 2533,
	  "ORİJİNAL İSİM": "METİL TRİKLOROASETAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 253300,
	  "UN_NO__1": 2533
	},
	{
	  "BAKANLIK_KOD": 253400,
	  "UN_NO": 2534,
	  "ORİJİNAL İSİM": "METİLKLOROSİLAN",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TFC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 253400,
	  "UN_NO__1": 2534
	},
	{
	  "BAKANLIK_KOD": 253500,
	  "UN_NO": 2535,
	  "ORİJİNAL İSİM": "4-METİLMORFOLİN (N-METİLMORFOLİN)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 253500,
	  "UN_NO__1": 2535
	},
	{
	  "BAKANLIK_KOD": 253600,
	  "UN_NO": 2536,
	  "ORİJİNAL İSİM": "METİLTETRAHİDRO-FURAN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 253600,
	  "UN_NO__1": 2536
	},
	{
	  "BAKANLIK_KOD": 253800,
	  "UN_NO": 2538,
	  "ORİJİNAL İSİM": "NİTRONAFTALİN",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 253800,
	  "UN_NO__1": 2538
	},
	{
	  "BAKANLIK_KOD": 254100,
	  "UN_NO": 2541,
	  "ORİJİNAL İSİM": "TERPİNOLEN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 254100,
	  "UN_NO__1": 2541
	},
	{
	  "BAKANLIK_KOD": 254200,
	  "UN_NO": 2542,
	  "ORİJİNAL İSİM": "TRİBÜTİLAMİN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 254200,
	  "UN_NO__1": 2542
	},
	{
	  "BAKANLIK_KOD": 254501,
	  "UN_NO": 2545,
	  "ORİJİNAL İSİM": "HAFNİYUM TOZU, KURU",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S4",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 254501,
	  "UN_NO__1": 2545
	},
	{
	  "BAKANLIK_KOD": 254502,
	  "UN_NO": 2545,
	  "ORİJİNAL İSİM": "HAFNİYUM TOZU, KURU",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S4",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 254502,
	  "UN_NO__1": 2545
	},
	{
	  "BAKANLIK_KOD": 254503,
	  "UN_NO": 2545,
	  "ORİJİNAL İSİM": "HAFNİYUM TOZU, KURU",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S4",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 254503,
	  "UN_NO__1": 2545
	},
	{
	  "BAKANLIK_KOD": 254601,
	  "UN_NO": 2546,
	  "ORİJİNAL İSİM": "TİTANYUM TOZU, KURU",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S4",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 254601,
	  "UN_NO__1": 2546
	},
	{
	  "BAKANLIK_KOD": 254602,
	  "UN_NO": 2546,
	  "ORİJİNAL İSİM": "TİTANYUM TOZU, KURU",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S4",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 254602,
	  "UN_NO__1": 2546
	},
	{
	  "BAKANLIK_KOD": 254603,
	  "UN_NO": 2546,
	  "ORİJİNAL İSİM": "TİTANYUM TOZU, KURU",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S4",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 254603,
	  "UN_NO__1": 2546
	},
	{
	  "BAKANLIK_KOD": 254700,
	  "UN_NO": 2547,
	  "ORİJİNAL İSİM": "SODYUM SÜPEROKSİT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 254700,
	  "UN_NO__1": 2547
	},
	{
	  "BAKANLIK_KOD": 254800,
	  "UN_NO": 2548,
	  "ORİJİNAL İSİM": "KLOR PENTAFLORÜR",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TOC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 254800,
	  "UN_NO__1": 2548
	},
	{
	  "BAKANLIK_KOD": 255200,
	  "UN_NO": 2552,
	  "ORİJİNAL İSİM": "HEKZAFLOROASETON HİDRAT, SIVI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 255200,
	  "UN_NO__1": 2552
	},
	{
	  "BAKANLIK_KOD": 255400,
	  "UN_NO": 2554,
	  "ORİJİNAL İSİM": "METİLALİL KLORÜR",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 255400,
	  "UN_NO__1": 2554
	},
	{
	  "BAKANLIK_KOD": 255500,
	  "UN_NO": 2555,
	  "ORİJİNAL İSİM": "NİTROSELÜLOZ, SULU (kütlece %25'ten az olmayan su ile)",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "D",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 255500,
	  "UN_NO__1": 2555
	},
	{
	  "BAKANLIK_KOD": 255600,
	  "UN_NO": 2556,
	  "ORİJİNAL İSİM": "NİTROSELÜLOZ, ALKOLLÜ (kütlece %25'ten az olmayan alkol içeren ve kuru kütle bazında azot miktarı %12,6'dan fazla olmayan)",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "D",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 255600,
	  "UN_NO__1": 2556
	},
	{
	  "BAKANLIK_KOD": 255700,
	  "UN_NO": 2557,
	  "ORİJİNAL İSİM": "NİTROSELÜLOZ, kuru kütle bazında azot miktarı %12,6'dan fazla olmayan, PLASTİKLEŞTİRİCİ İÇEREN veya İÇERMEYEN, PİGMENT İÇEREN veya İÇERMEYEN KARIŞIM",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "D",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 255700,
	  "UN_NO__1": 2557
	},
	{
	  "BAKANLIK_KOD": 255800,
	  "UN_NO": 2558,
	  "ORİJİNAL İSİM": "EPİBROMOHİDRİN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 255800,
	  "UN_NO__1": 2558
	},
	{
	  "BAKANLIK_KOD": 256000,
	  "UN_NO": 2560,
	  "ORİJİNAL İSİM": "2-METİLPENTAN-2-OL",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 256000,
	  "UN_NO__1": 2560
	},
	{
	  "BAKANLIK_KOD": 256100,
	  "UN_NO": 2561,
	  "ORİJİNAL İSİM": "3-METİL-1-BÜTEN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 256100,
	  "UN_NO__1": 2561
	},
	{
	  "BAKANLIK_KOD": 256401,
	  "UN_NO": 2564,
	  "ORİJİNAL İSİM": "TRİKLOROASETİK ASİT ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 256401,
	  "UN_NO__1": 2564
	},
	{
	  "BAKANLIK_KOD": 256402,
	  "UN_NO": 2564,
	  "ORİJİNAL İSİM": "TRİKLOROASETİK ASİT ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 256402,
	  "UN_NO__1": 2564
	},
	{
	  "BAKANLIK_KOD": 256500,
	  "UN_NO": 2565,
	  "ORİJİNAL İSİM": "DİSİKLOHEKZİLAMİN",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C7",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 256500,
	  "UN_NO__1": 2565
	},
	{
	  "BAKANLIK_KOD": 256700,
	  "UN_NO": 2567,
	  "ORİJİNAL İSİM": "SODYUM PENTAKLOROFENAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 256700,
	  "UN_NO__1": 2567
	},
	{
	  "BAKANLIK_KOD": 257001,
	  "UN_NO": 2570,
	  "ORİJİNAL İSİM": "KADMİYUM BİLEŞİĞİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 257001,
	  "UN_NO__1": 2570
	},
	{
	  "BAKANLIK_KOD": 257002,
	  "UN_NO": 2570,
	  "ORİJİNAL İSİM": "KADMİYUM BİLEŞİĞİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 257002,
	  "UN_NO__1": 2570
	},
	{
	  "BAKANLIK_KOD": 257003,
	  "UN_NO": 2570,
	  "ORİJİNAL İSİM": "KADMİYUM BİLEŞİĞİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 257003,
	  "UN_NO__1": 2570
	},
	{
	  "BAKANLIK_KOD": 257100,
	  "UN_NO": 2571,
	  "ORİJİNAL İSİM": "ALKİLSÜLFÜRİK ASİTLER",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 257100,
	  "UN_NO__1": 2571
	},
	{
	  "BAKANLIK_KOD": 257200,
	  "UN_NO": 2572,
	  "ORİJİNAL İSİM": "FENİLHİDRAZİN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 257200,
	  "UN_NO__1": 2572
	},
	{
	  "BAKANLIK_KOD": 257300,
	  "UN_NO": 2573,
	  "ORİJİNAL İSİM": "TALYUM KLORAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OT2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 257300,
	  "UN_NO__1": 2573
	},
	{
	  "BAKANLIK_KOD": 257400,
	  "UN_NO": 2574,
	  "ORİJİNAL İSİM": "TRİKRESİL FOSFAT %3'ten fazla orto izomer içeren",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 257400,
	  "UN_NO__1": 2574
	},
	{
	  "BAKANLIK_KOD": 257600,
	  "UN_NO": 2576,
	  "ORİJİNAL İSİM": "FOSFOR, OKSİBROMÜR, ERİMİŞ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 257600,
	  "UN_NO__1": 2576
	},
	{
	  "BAKANLIK_KOD": 257700,
	  "UN_NO": 2577,
	  "ORİJİNAL İSİM": "FENİLASETİL KLORÜR",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 257700,
	  "UN_NO__1": 2577
	},
	{
	  "BAKANLIK_KOD": 257800,
	  "UN_NO": 2578,
	  "ORİJİNAL İSİM": "FOSFOR TRİOKSİT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 257800,
	  "UN_NO__1": 2578
	},
	{
	  "BAKANLIK_KOD": 257900,
	  "UN_NO": 2579,
	  "ORİJİNAL İSİM": "PİPERAZİN",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C8",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 257900,
	  "UN_NO__1": 2579
	},
	{
	  "BAKANLIK_KOD": 258000,
	  "UN_NO": 2580,
	  "ORİJİNAL İSİM": "ALÜMİNYUM BROMÜR ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 258000,
	  "UN_NO__1": 2580
	},
	{
	  "BAKANLIK_KOD": 258100,
	  "UN_NO": 2581,
	  "ORİJİNAL İSİM": "ALÜMİNYUM KLORÜR ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 258100,
	  "UN_NO__1": 2581
	},
	{
	  "BAKANLIK_KOD": 258200,
	  "UN_NO": 2582,
	  "ORİJİNAL İSİM": "DEMİR (III) KLORÜR ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 258200,
	  "UN_NO__1": 2582
	},
	{
	  "BAKANLIK_KOD": 258300,
	  "UN_NO": 2583,
	  "ORİJİNAL İSİM": "ALKİLSÜLFONİK ASİTLER, KATI veya ARİLSÜLFONİK ASİTLER, KATI %5'ten fazla serbest sülfürik asit içeren",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 258300,
	  "UN_NO__1": 2583
	},
	{
	  "BAKANLIK_KOD": 258400,
	  "UN_NO": 2584,
	  "ORİJİNAL İSİM": "ALKİLSÜLFONİK ASİTLER, SIVI veya ARİLSÜLFONİK ASİTLER, SIVI %5'ten fazla serbest sülfürik asit içeren",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 258400,
	  "UN_NO__1": 2584
	},
	{
	  "BAKANLIK_KOD": 258500,
	  "UN_NO": 2585,
	  "ORİJİNAL İSİM": "ALKİLSÜLFONİK ASİTLER, KATI veya ARİLSÜLFONİK ASİTLER, KATI %5'ten az serbest sülfürik asit içeren",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C4",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 258500,
	  "UN_NO__1": 2585
	},
	{
	  "BAKANLIK_KOD": 258600,
	  "UN_NO": 2586,
	  "ORİJİNAL İSİM": "ALKİLSÜLFONİK ASİTLER, SIVI veya ARİLSÜLFONİK ASİTLER, SIVI %5'ten az serbest sülfürik asit içeren",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 258600,
	  "UN_NO__1": 2586
	},
	{
	  "BAKANLIK_KOD": 258700,
	  "UN_NO": 2587,
	  "ORİJİNAL İSİM": "BENZOKUİNON",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 258700,
	  "UN_NO__1": 2587
	},
	{
	  "BAKANLIK_KOD": 258801,
	  "UN_NO": 2588,
	  "ORİJİNAL İSİM": "PESTİSİT, KATI, ZEHİRLİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 258801,
	  "UN_NO__1": 2588
	},
	{
	  "BAKANLIK_KOD": 258802,
	  "UN_NO": 2588,
	  "ORİJİNAL İSİM": "PESTİSİT, KATI, ZEHİRLİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 258802,
	  "UN_NO__1": 2588
	},
	{
	  "BAKANLIK_KOD": 258803,
	  "UN_NO": 2588,
	  "ORİJİNAL İSİM": "PESTİSİT, KATI, ZEHİRLİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 258803,
	  "UN_NO__1": 2588
	},
	{
	  "BAKANLIK_KOD": 258900,
	  "UN_NO": 2589,
	  "ORİJİNAL İSİM": "VİNİL KLOROASETAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 258900,
	  "UN_NO__1": 2589
	},
	{
	  "BAKANLIK_KOD": 259000,
	  "UN_NO": 2590,
	  "ORİJİNAL İSİM": "ASBEST, KRİZOTİL",
	  "SINIF": 9,
	  "SINIFLANDIRMA_KODU": "M1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 259000,
	  "UN_NO__1": 2590
	},
	{
	  "BAKANLIK_KOD": 259100,
	  "UN_NO": 2591,
	  "ORİJİNAL İSİM": "KSENON, SOĞUTULMUŞ SIVI",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "3A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 259100,
	  "UN_NO__1": 2591
	},
	{
	  "BAKANLIK_KOD": 259900,
	  "UN_NO": 2599,
	  "ORİJİNAL İSİM": "KLOROTRİFLORO-METAN ve TRİFLOROMETAN AZEOTROPİK KARIŞIM yaklaşık %60 klorodiflorometan içeren (SOĞUTUCU GAZ R 503)",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 259900,
	  "UN_NO__1": 2599
	},
	{
	  "BAKANLIK_KOD": 260100,
	  "UN_NO": 2601,
	  "ORİJİNAL İSİM": "SİKLOBÜTAN",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 260100,
	  "UN_NO__1": 2601
	},
	{
	  "BAKANLIK_KOD": 260200,
	  "UN_NO": 2602,
	  "ORİJİNAL İSİM": "DİKLOROTRİFLORO-METAN ve 1,1-DİFLOROMETAN AZEOTROPİK KARIŞIMI yaklaşık %74 diklorodiflorometan içeren (SOĞUTUCU GAZ R 500)",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 260200,
	  "UN_NO__1": 2602
	},
	{
	  "BAKANLIK_KOD": 260300,
	  "UN_NO": 2603,
	  "ORİJİNAL İSİM": "SİKLOHEPTATRİEN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 260300,
	  "UN_NO__1": 2603
	},
	{
	  "BAKANLIK_KOD": 260400,
	  "UN_NO": 2604,
	  "ORİJİNAL İSİM": "BOR TRİFLORÜR DİETİL ETERAT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 260400,
	  "UN_NO__1": 2604
	},
	{
	  "BAKANLIK_KOD": 260500,
	  "UN_NO": 2605,
	  "ORİJİNAL İSİM": "METOKSİMETİL İZOSİYANAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 260500,
	  "UN_NO__1": 2605
	},
	{
	  "BAKANLIK_KOD": 260600,
	  "UN_NO": 2606,
	  "ORİJİNAL İSİM": "METİL ORTOSİLİKAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 260600,
	  "UN_NO__1": 2606
	},
	{
	  "BAKANLIK_KOD": 260700,
	  "UN_NO": 2607,
	  "ORİJİNAL İSİM": "AKROLEİN DİMER, STABİLİZE",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 260700,
	  "UN_NO__1": 2607
	},
	{
	  "BAKANLIK_KOD": 260800,
	  "UN_NO": 2608,
	  "ORİJİNAL İSİM": "NİTROPROPANLAR",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 260800,
	  "UN_NO__1": 2608
	},
	{
	  "BAKANLIK_KOD": 260900,
	  "UN_NO": 2609,
	  "ORİJİNAL İSİM": "TRİALİL BORAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 260900,
	  "UN_NO__1": 2609
	},
	{
	  "BAKANLIK_KOD": 261000,
	  "UN_NO": 2610,
	  "ORİJİNAL İSİM": "TRİALİLAMİN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 261000,
	  "UN_NO__1": 2610
	},
	{
	  "BAKANLIK_KOD": 261100,
	  "UN_NO": 2611,
	  "ORİJİNAL İSİM": "PROPİLEN KLOROHİDRİN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 261100,
	  "UN_NO__1": 2611
	},
	{
	  "BAKANLIK_KOD": 261200,
	  "UN_NO": 2612,
	  "ORİJİNAL İSİM": "METİL PROPİL ETER",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 261200,
	  "UN_NO__1": 2612
	},
	{
	  "BAKANLIK_KOD": 261400,
	  "UN_NO": 2614,
	  "ORİJİNAL İSİM": "METALİL ALKOL",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 261400,
	  "UN_NO__1": 2614
	},
	{
	  "BAKANLIK_KOD": 261500,
	  "UN_NO": 2615,
	  "ORİJİNAL İSİM": "ETİL PROPİL ETER",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 261500,
	  "UN_NO__1": 2615
	},
	{
	  "BAKANLIK_KOD": 261601,
	  "UN_NO": 2616,
	  "ORİJİNAL İSİM": "TRİİZOPROPİL BORAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 261601,
	  "UN_NO__1": 2616
	},
	{
	  "BAKANLIK_KOD": 261602,
	  "UN_NO": 2616,
	  "ORİJİNAL İSİM": "TRİİZOPROPİL BORAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 261602,
	  "UN_NO__1": 2616
	},
	{
	  "BAKANLIK_KOD": 261700,
	  "UN_NO": 2617,
	  "ORİJİNAL İSİM": "METİLSİKLO-HEKZANOLLER, alevlenebilir",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 261700,
	  "UN_NO__1": 2617
	},
	{
	  "BAKANLIK_KOD": 261800,
	  "UN_NO": 2618,
	  "ORİJİNAL İSİM": "VİNİLTOLUENLER, STABİLİZE",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 261800,
	  "UN_NO__1": 2618
	},
	{
	  "BAKANLIK_KOD": 261900,
	  "UN_NO": 2619,
	  "ORİJİNAL İSİM": "BENZİLDİMETİLAMİN",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CF1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 261900,
	  "UN_NO__1": 2619
	},
	{
	  "BAKANLIK_KOD": 262000,
	  "UN_NO": 2620,
	  "ORİJİNAL İSİM": "AMİL BÜTİRATLAR",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 262000,
	  "UN_NO__1": 2620
	},
	{
	  "BAKANLIK_KOD": 262100,
	  "UN_NO": 2621,
	  "ORİJİNAL İSİM": "ASETİL METİL KARBİNOL",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 262100,
	  "UN_NO__1": 2621
	},
	{
	  "BAKANLIK_KOD": 262200,
	  "UN_NO": 2622,
	  "ORİJİNAL İSİM": "GLİSİDALDEHİT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 262200,
	  "UN_NO__1": 2622
	},
	{
	  "BAKANLIK_KOD": 262300,
	  "UN_NO": 2623,
	  "ORİJİNAL İSİM": "ATEŞLEME ÇAKMAKLARI, KATI alevlenebilir sıvı ile",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 262300,
	  "UN_NO__1": 2623
	},
	{
	  "BAKANLIK_KOD": 262400,
	  "UN_NO": 2624,
	  "ORİJİNAL İSİM": "MAGNEZYUM SİLİSİD",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 262400,
	  "UN_NO__1": 2624
	},
	{
	  "BAKANLIK_KOD": 262600,
	  "UN_NO": 2626,
	  "ORİJİNAL İSİM": "KLORİK ASİT, SULU ÇÖZELTİ klorik asit oranı %10'dan fazla olmayan",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 262600,
	  "UN_NO__1": 2626
	},
	{
	  "BAKANLIK_KOD": 262700,
	  "UN_NO": 2627,
	  "ORİJİNAL İSİM": "NİTRİTLER, İNORGANİK, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 262700,
	  "UN_NO__1": 2627
	},
	{
	  "BAKANLIK_KOD": 262800,
	  "UN_NO": 2628,
	  "ORİJİNAL İSİM": "POTASYUM FLOROASETAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 262800,
	  "UN_NO__1": 2628
	},
	{
	  "BAKANLIK_KOD": 262900,
	  "UN_NO": 2629,
	  "ORİJİNAL İSİM": "SODYUM FLOROASETAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 262900,
	  "UN_NO__1": 2629
	},
	{
	  "BAKANLIK_KOD": 263000,
	  "UN_NO": 2630,
	  "ORİJİNAL İSİM": "SELENATLAR veya SELENİTLER",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 263000,
	  "UN_NO__1": 2630
	},
	{
	  "BAKANLIK_KOD": 264200,
	  "UN_NO": 2642,
	  "ORİJİNAL İSİM": "FLOROASETİK ASİT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 264200,
	  "UN_NO__1": 2642
	},
	{
	  "BAKANLIK_KOD": 264300,
	  "UN_NO": 2643,
	  "ORİJİNAL İSİM": "METİL BROMOASETAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 264300,
	  "UN_NO__1": 2643
	},
	{
	  "BAKANLIK_KOD": 264400,
	  "UN_NO": 2644,
	  "ORİJİNAL İSİM": "METİL İYODÜR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 264400,
	  "UN_NO__1": 2644
	},
	{
	  "BAKANLIK_KOD": 264500,
	  "UN_NO": 2645,
	  "ORİJİNAL İSİM": "FENASİL BROMÜR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 264500,
	  "UN_NO__1": 2645
	},
	{
	  "BAKANLIK_KOD": 264600,
	  "UN_NO": 2646,
	  "ORİJİNAL İSİM": "HEKZAKLOROSİKLO- PENTADİEN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 264600,
	  "UN_NO__1": 2646
	},
	{
	  "BAKANLIK_KOD": 264700,
	  "UN_NO": 2647,
	  "ORİJİNAL İSİM": "MALONONİTRİL",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 264700,
	  "UN_NO__1": 2647
	},
	{
	  "BAKANLIK_KOD": 264800,
	  "UN_NO": 2648,
	  "ORİJİNAL İSİM": "1,2-DİBROMOBÜTAN-3-ON",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 264800,
	  "UN_NO__1": 2648
	},
	{
	  "BAKANLIK_KOD": 264900,
	  "UN_NO": 2649,
	  "ORİJİNAL İSİM": "1,3-DİKLOROASETON",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 264900,
	  "UN_NO__1": 2649
	},
	{
	  "BAKANLIK_KOD": 265000,
	  "UN_NO": 2650,
	  "ORİJİNAL İSİM": "1,1-DİKLORO-1-NİTROETAN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 265000,
	  "UN_NO__1": 2650
	},
	{
	  "BAKANLIK_KOD": 265100,
	  "UN_NO": 2651,
	  "ORİJİNAL İSİM": "4,4'-DİAMİNODİFENİL-METAN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 265100,
	  "UN_NO__1": 2651
	},
	{
	  "BAKANLIK_KOD": 265300,
	  "UN_NO": 2653,
	  "ORİJİNAL İSİM": "BENZİL İYODÜR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 265300,
	  "UN_NO__1": 2653
	},
	{
	  "BAKANLIK_KOD": 265500,
	  "UN_NO": 2655,
	  "ORİJİNAL İSİM": "POTASYUM FLOROSİLİKAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 265500,
	  "UN_NO__1": 2655
	},
	{
	  "BAKANLIK_KOD": 265600,
	  "UN_NO": 2656,
	  "ORİJİNAL İSİM": "KUİNOLİN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 265600,
	  "UN_NO__1": 2656
	},
	{
	  "BAKANLIK_KOD": 265700,
	  "UN_NO": 2657,
	  "ORİJİNAL İSİM": "SELENYUM DİSÜLFÜR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 265700,
	  "UN_NO__1": 2657
	},
	{
	  "BAKANLIK_KOD": 265900,
	  "UN_NO": 2659,
	  "ORİJİNAL İSİM": "SODYUM KLOROASETAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 265900,
	  "UN_NO__1": 2659
	},
	{
	  "BAKANLIK_KOD": 266000,
	  "UN_NO": 2660,
	  "ORİJİNAL İSİM": "NİTROTOLUİDİNLER (MONO)",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 266000,
	  "UN_NO__1": 2660
	},
	{
	  "BAKANLIK_KOD": 266100,
	  "UN_NO": 2661,
	  "ORİJİNAL İSİM": "HEKZAKLOROASETON",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 266100,
	  "UN_NO__1": 2661
	},
	{
	  "BAKANLIK_KOD": 266400,
	  "UN_NO": 2664,
	  "ORİJİNAL İSİM": "DİBROMOMETAN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 266400,
	  "UN_NO__1": 2664
	},
	{
	  "BAKANLIK_KOD": 266700,
	  "UN_NO": 2667,
	  "ORİJİNAL İSİM": "BÜTİLTOLUENLER",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 266700,
	  "UN_NO__1": 2667
	},
	{
	  "BAKANLIK_KOD": 266800,
	  "UN_NO": 2668,
	  "ORİJİNAL İSİM": "KLOROASETONİTRİL",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 266800,
	  "UN_NO__1": 2668
	},
	{
	  "BAKANLIK_KOD": 266901,
	  "UN_NO": 2669,
	  "ORİJİNAL İSİM": "KLOROKRESOLLER ÇÖZELTİSİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 266901,
	  "UN_NO__1": 2669
	},
	{
	  "BAKANLIK_KOD": 266902,
	  "UN_NO": 2669,
	  "ORİJİNAL İSİM": "KLOROKRESOLLER ÇÖZELTİSİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 266902,
	  "UN_NO__1": 2669
	},
	{
	  "BAKANLIK_KOD": 267000,
	  "UN_NO": 2670,
	  "ORİJİNAL İSİM": "SİYANÜRİK KLORÜR",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C4",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 267000,
	  "UN_NO__1": 2670
	},
	{
	  "BAKANLIK_KOD": 267100,
	  "UN_NO": 2671,
	  "ORİJİNAL İSİM": "AMİNOPİRİDİNLER (o-, m-, p-)",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 267100,
	  "UN_NO__1": 2671
	},
	{
	  "BAKANLIK_KOD": 267200,
	  "UN_NO": 2672,
	  "ORİJİNAL İSİM": "AMONYAK ÇÖZELTİSİ, 15 °C'de su içerisinde bağıl yoğunluğu 0,880 veya 0,957 arasında olan ve %10'dan fazla ama %35'ten az amonyak içeren",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C5",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 267200,
	  "UN_NO__1": 2672
	},
	{
	  "BAKANLIK_KOD": 267300,
	  "UN_NO": 2673,
	  "ORİJİNAL İSİM": "2-AMİNO-4-KLOROFENOL",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 267300,
	  "UN_NO__1": 2673
	},
	{
	  "BAKANLIK_KOD": 267400,
	  "UN_NO": 2674,
	  "ORİJİNAL İSİM": "SODYUM FLOROSİLİKAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 267400,
	  "UN_NO__1": 2674
	},
	{
	  "BAKANLIK_KOD": 267600,
	  "UN_NO": 2676,
	  "ORİJİNAL İSİM": "STİBİN",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TF",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 267600,
	  "UN_NO__1": 2676
	},
	{
	  "BAKANLIK_KOD": 267701,
	  "UN_NO": 2677,
	  "ORİJİNAL İSİM": "RUBİDYUM HİDROKSİT ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 267701,
	  "UN_NO__1": 2677
	},
	{
	  "BAKANLIK_KOD": 267702,
	  "UN_NO": 2677,
	  "ORİJİNAL İSİM": "RUBİDYUM HİDROKSİT ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C5",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 267702,
	  "UN_NO__1": 2677
	},
	{
	  "BAKANLIK_KOD": 267800,
	  "UN_NO": 2678,
	  "ORİJİNAL İSİM": "RUBİDYUM HİDROKSİT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C6",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 267800,
	  "UN_NO__1": 2678
	},
	{
	  "BAKANLIK_KOD": 267901,
	  "UN_NO": 2679,
	  "ORİJİNAL İSİM": "LİTYUM HİDROKSİT ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 267901,
	  "UN_NO__1": 2679
	},
	{
	  "BAKANLIK_KOD": 267902,
	  "UN_NO": 2679,
	  "ORİJİNAL İSİM": "LİTYUM HİDROKSİT ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C5",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 267902,
	  "UN_NO__1": 2679
	},
	{
	  "BAKANLIK_KOD": 268000,
	  "UN_NO": 2680,
	  "ORİJİNAL İSİM": "LİTYUM HİDROKSİT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C6",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 268000,
	  "UN_NO__1": 2680
	},
	{
	  "BAKANLIK_KOD": 268101,
	  "UN_NO": 2681,
	  "ORİJİNAL İSİM": "SEZYUM HİDROKSİT ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 268101,
	  "UN_NO__1": 2681
	},
	{
	  "BAKANLIK_KOD": 268102,
	  "UN_NO": 2681,
	  "ORİJİNAL İSİM": "SEZYUM HİDROKSİT ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C5",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 268102,
	  "UN_NO__1": 2681
	},
	{
	  "BAKANLIK_KOD": 268200,
	  "UN_NO": 2682,
	  "ORİJİNAL İSİM": "SEZYUM HİDROKSİT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C6",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 268200,
	  "UN_NO__1": 2682
	},
	{
	  "BAKANLIK_KOD": 268300,
	  "UN_NO": 2683,
	  "ORİJİNAL İSİM": "AMONYUM SÜLFÜR ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CFT",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 268300,
	  "UN_NO__1": 2683
	},
	{
	  "BAKANLIK_KOD": 268400,
	  "UN_NO": 2684,
	  "ORİJİNAL İSİM": "3-DİETİLAMİNOPROPİL-AMİN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 268400,
	  "UN_NO__1": 2684
	},
	{
	  "BAKANLIK_KOD": 268500,
	  "UN_NO": 2685,
	  "ORİJİNAL İSİM": "N,N-DİETİLETİLEN-DİAMİN",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CF1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 268500,
	  "UN_NO__1": 2685
	},
	{
	  "BAKANLIK_KOD": 268600,
	  "UN_NO": 2686,
	  "ORİJİNAL İSİM": "2-DİETİLAMİNO-ETANOL",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CF1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 268600,
	  "UN_NO__1": 2686
	},
	{
	  "BAKANLIK_KOD": 268700,
	  "UN_NO": 2687,
	  "ORİJİNAL İSİM": "DİSİKLOHEKZİL-AMONYUM NİTRİT",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 268700,
	  "UN_NO__1": 2687
	},
	{
	  "BAKANLIK_KOD": 268800,
	  "UN_NO": 2688,
	  "ORİJİNAL İSİM": "1-BROMO-3-KLOROPROPAN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 268800,
	  "UN_NO__1": 2688
	},
	{
	  "BAKANLIK_KOD": 268900,
	  "UN_NO": 2689,
	  "ORİJİNAL İSİM": "GLİSEROL alfa- MONOKLOROHİDRİN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 268900,
	  "UN_NO__1": 2689
	},
	{
	  "BAKANLIK_KOD": 269000,
	  "UN_NO": 2690,
	  "ORİJİNAL İSİM": "N,n-BÜTİLİMİDAZOL",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 269000,
	  "UN_NO__1": 2690
	},
	{
	  "BAKANLIK_KOD": 269100,
	  "UN_NO": 2691,
	  "ORİJİNAL İSİM": "FOSFOR PENTABROMÜR",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 269100,
	  "UN_NO__1": 2691
	},
	{
	  "BAKANLIK_KOD": 269200,
	  "UN_NO": 2692,
	  "ORİJİNAL İSİM": "BOR TRİBROMÜR",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 269200,
	  "UN_NO__1": 2692
	},
	{
	  "BAKANLIK_KOD": 269300,
	  "UN_NO": 2693,
	  "ORİJİNAL İSİM": "BİSÜLFÜRLER, SULU ÇÖZELTİ, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 269300,
	  "UN_NO__1": 2693
	},
	{
	  "BAKANLIK_KOD": 269800,
	  "UN_NO": 2698,
	  "ORİJİNAL İSİM": "TETRAHİDROFTALİK ANHİDRİTLER maleik anhidritin %0,05'ten fazlasını içeren",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C4",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 269800,
	  "UN_NO__1": 2698
	},
	{
	  "BAKANLIK_KOD": 269900,
	  "UN_NO": 2699,
	  "ORİJİNAL İSİM": "TRİFLOROASETİK ASİT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 269900,
	  "UN_NO__1": 2699
	},
	{
	  "BAKANLIK_KOD": 270500,
	  "UN_NO": 2705,
	  "ORİJİNAL İSİM": "1-PENTOL",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C9",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 270500,
	  "UN_NO__1": 2705
	},
	{
	  "BAKANLIK_KOD": 270701,
	  "UN_NO": 2707,
	  "ORİJİNAL İSİM": "DİMETİLDİOKSANLAR",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 270701,
	  "UN_NO__1": 2707
	},
	{
	  "BAKANLIK_KOD": 270702,
	  "UN_NO": 2707,
	  "ORİJİNAL İSİM": "DİMETİLDİOKSANLAR",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 270702,
	  "UN_NO__1": 2707
	},
	{
	  "BAKANLIK_KOD": 270900,
	  "UN_NO": 2709,
	  "ORİJİNAL İSİM": "BÜTİLBENZENLER",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 270900,
	  "UN_NO__1": 2709
	},
	{
	  "BAKANLIK_KOD": 271000,
	  "UN_NO": 2710,
	  "ORİJİNAL İSİM": "DİPROPİL KETON",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 271000,
	  "UN_NO__1": 2710
	},
	{
	  "BAKANLIK_KOD": 271300,
	  "UN_NO": 2713,
	  "ORİJİNAL İSİM": "AKRİDİN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 271300,
	  "UN_NO__1": 2713
	},
	{
	  "BAKANLIK_KOD": 271400,
	  "UN_NO": 2714,
	  "ORİJİNAL İSİM": "ÇİNKO REZİNAT",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 271400,
	  "UN_NO__1": 2714
	},
	{
	  "BAKANLIK_KOD": 271500,
	  "UN_NO": 2715,
	  "ORİJİNAL İSİM": "ALÜMİNYUM REZİNAT",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 271500,
	  "UN_NO__1": 2715
	},
	{
	  "BAKANLIK_KOD": 271600,
	  "UN_NO": 2716,
	  "ORİJİNAL İSİM": "1,4-BÜTİNDİOL",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 271600,
	  "UN_NO__1": 2716
	},
	{
	  "BAKANLIK_KOD": 271700,
	  "UN_NO": 2717,
	  "ORİJİNAL İSİM": "KAFUR, sentetik",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 271700,
	  "UN_NO__1": 2717
	},
	{
	  "BAKANLIK_KOD": 271900,
	  "UN_NO": 2719,
	  "ORİJİNAL İSİM": "BARYUM BROMAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OT2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 271900,
	  "UN_NO__1": 2719
	},
	{
	  "BAKANLIK_KOD": 272000,
	  "UN_NO": 2720,
	  "ORİJİNAL İSİM": "KROM NİTRAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 272000,
	  "UN_NO__1": 2720
	},
	{
	  "BAKANLIK_KOD": 272100,
	  "UN_NO": 2721,
	  "ORİJİNAL İSİM": "BAKIR KLORAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 272100,
	  "UN_NO__1": 2721
	},
	{
	  "BAKANLIK_KOD": 272200,
	  "UN_NO": 2722,
	  "ORİJİNAL İSİM": "LİTYUM NİTRAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 272200,
	  "UN_NO__1": 2722
	},
	{
	  "BAKANLIK_KOD": 272300,
	  "UN_NO": 2723,
	  "ORİJİNAL İSİM": "MAGNEZYUM KLORAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 272300,
	  "UN_NO__1": 2723
	},
	{
	  "BAKANLIK_KOD": 272400,
	  "UN_NO": 2724,
	  "ORİJİNAL İSİM": "MANGANEZ NİTRAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 272400,
	  "UN_NO__1": 2724
	},
	{
	  "BAKANLIK_KOD": 272500,
	  "UN_NO": 2725,
	  "ORİJİNAL İSİM": "NİKEL NİTRAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 272500,
	  "UN_NO__1": 2725
	},
	{
	  "BAKANLIK_KOD": 272600,
	  "UN_NO": 2726,
	  "ORİJİNAL İSİM": "NİKEL NİTRİT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 272600,
	  "UN_NO__1": 2726
	},
	{
	  "BAKANLIK_KOD": 272700,
	  "UN_NO": 2727,
	  "ORİJİNAL İSİM": "TALYUM NİTRAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TO2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 272700,
	  "UN_NO__1": 2727
	},
	{
	  "BAKANLIK_KOD": 272800,
	  "UN_NO": 2728,
	  "ORİJİNAL İSİM": "ZİRKONYUM NİTRAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 272800,
	  "UN_NO__1": 2728
	},
	{
	  "BAKANLIK_KOD": 272900,
	  "UN_NO": 2729,
	  "ORİJİNAL İSİM": "HEKZAKLOROBENZEN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 272900,
	  "UN_NO__1": 2729
	},
	{
	  "BAKANLIK_KOD": 273000,
	  "UN_NO": 2730,
	  "ORİJİNAL İSİM": "NİTROANİZOLLER, SIVI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 273000,
	  "UN_NO__1": 2730
	},
	{
	  "BAKANLIK_KOD": 273200,
	  "UN_NO": 2732,
	  "ORİJİNAL İSİM": "NİTROBROMOBENZENLER, SIVI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 273200,
	  "UN_NO__1": 2732
	},
	{
	  "BAKANLIK_KOD": 273301,
	  "UN_NO": 2733,
	  "ORİJİNAL İSİM": "AMİNLER, ALEVLENEBİLİR, AŞINDIRICI, B.B.B. veya POLİAMİNLER, ALEVLENEBİLİR, AŞINDIRICI, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 273301,
	  "UN_NO__1": 2733
	},
	{
	  "BAKANLIK_KOD": 273302,
	  "UN_NO": 2733,
	  "ORİJİNAL İSİM": "AMİNLER, ALEVLENEBİLİR, AŞINDIRICI, B.B.B. veya POLİAMİNLER, ALEVLENEBİLİR, AŞINDIRICI, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 273302,
	  "UN_NO__1": 2733
	},
	{
	  "BAKANLIK_KOD": 273303,
	  "UN_NO": 2733,
	  "ORİJİNAL İSİM": "AMİNLER, ALEVLENEBİLİR, AŞINDIRICI, B.B.B. veya POLİAMİNLER, ALEVLENEBİLİR, AŞINDIRICI, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 273303,
	  "UN_NO__1": 2733
	},
	{
	  "BAKANLIK_KOD": 273401,
	  "UN_NO": 2734,
	  "ORİJİNAL İSİM": "AMİNLER, SIVI, AŞINDIRICI, ALEVLENEBİLİR, B.B.B. veya POLİAMİNLER, SIVI, AŞINDIRICI, ALEVLENEBİLİR, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 273401,
	  "UN_NO__1": 2734
	},
	{
	  "BAKANLIK_KOD": 273402,
	  "UN_NO": 2734,
	  "ORİJİNAL İSİM": "AMİNLER, SIVI, AŞINDIRICI, ALEVLENEBİLİR, B.B.B. veya POLİAMİNLER, SIVI, AŞINDIRICI, ALEVLENEBİLİR, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CF1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 273402,
	  "UN_NO__1": 2734
	},
	{
	  "BAKANLIK_KOD": 273501,
	  "UN_NO": 2735,
	  "ORİJİNAL İSİM": "AMİNLER, SIVI, AŞINDIRICI, B.B.B. veya POLİAMİNLER, SIVI, AŞINDIRICI, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C7",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 273501,
	  "UN_NO__1": 2735
	},
	{
	  "BAKANLIK_KOD": 273502,
	  "UN_NO": 2735,
	  "ORİJİNAL İSİM": "AMİNLER, SIVI, AŞINDIRICI, B.B.B. veya POLİAMİNLER, SIVI, AŞINDIRICI, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C7",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 273502,
	  "UN_NO__1": 2735
	},
	{
	  "BAKANLIK_KOD": 273503,
	  "UN_NO": 2735,
	  "ORİJİNAL İSİM": "AMİNLER, SIVI, AŞINDIRICI, B.B.B. veya POLİAMİNLER, SIVI, AŞINDIRICI, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C7",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 273503,
	  "UN_NO__1": 2735
	},
	{
	  "BAKANLIK_KOD": 273800,
	  "UN_NO": 2738,
	  "ORİJİNAL İSİM": "N-BÜTİLANİLİN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 273800,
	  "UN_NO__1": 2738
	},
	{
	  "BAKANLIK_KOD": 273900,
	  "UN_NO": 2739,
	  "ORİJİNAL İSİM": "BÜTİRİK ANHİDRİT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 273900,
	  "UN_NO__1": 2739
	},
	{
	  "BAKANLIK_KOD": 274000,
	  "UN_NO": 2740,
	  "ORİJİNAL İSİM": "n-PROPİL KLOROFORMAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TFC",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 274000,
	  "UN_NO__1": 2740
	},
	{
	  "BAKANLIK_KOD": 274100,
	  "UN_NO": 2741,
	  "ORİJİNAL İSİM": "BARYUM HİPOKLORİT %22'den fazla hazır klor içeren",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OT2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 274100,
	  "UN_NO__1": 2741
	},
	{
	  "BAKANLIK_KOD": 274200,
	  "UN_NO": 2742,
	  "ORİJİNAL İSİM": "KLOROFORMATLAR, ZEHİRLİ, AŞINDIRICI, ALEVLENEBİLİR, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TFC",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 274200,
	  "UN_NO__1": 2742
	},
	{
	  "BAKANLIK_KOD": 274300,
	  "UN_NO": 2743,
	  "ORİJİNAL İSİM": "n-BÜTİL KLOROFORMAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TFC",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 274300,
	  "UN_NO__1": 2743
	},
	{
	  "BAKANLIK_KOD": 274400,
	  "UN_NO": 2744,
	  "ORİJİNAL İSİM": "SİKLOBÜTİL KLOROFORMAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TFC",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 274400,
	  "UN_NO__1": 2744
	},
	{
	  "BAKANLIK_KOD": 274500,
	  "UN_NO": 2745,
	  "ORİJİNAL İSİM": "KLOROMETİL KLOROFORMAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TC1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 274500,
	  "UN_NO__1": 2745
	},
	{
	  "BAKANLIK_KOD": 274600,
	  "UN_NO": 2746,
	  "ORİJİNAL İSİM": "FENİL KLOROFORMAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TC1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 274600,
	  "UN_NO__1": 2746
	},
	{
	  "BAKANLIK_KOD": 274700,
	  "UN_NO": 2747,
	  "ORİJİNAL İSİM": "tert-BÜTİLSİKLOHEKZİL KLOROFORMAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 274700,
	  "UN_NO__1": 2747
	},
	{
	  "BAKANLIK_KOD": 274800,
	  "UN_NO": 2748,
	  "ORİJİNAL İSİM": "2-ETİLHEKZİL KLOROFORMAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TC1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 274800,
	  "UN_NO__1": 2748
	},
	{
	  "BAKANLIK_KOD": 274900,
	  "UN_NO": 2749,
	  "ORİJİNAL İSİM": "TETRAMETİLSİLAN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 274900,
	  "UN_NO__1": 2749
	},
	{
	  "BAKANLIK_KOD": 275000,
	  "UN_NO": 2750,
	  "ORİJİNAL İSİM": "1,3-DİKLOROPROPANOL-2",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 275000,
	  "UN_NO__1": 2750
	},
	{
	  "BAKANLIK_KOD": 275100,
	  "UN_NO": 2751,
	  "ORİJİNAL İSİM": "DİETİLTİYO-FOSFORİL KLORÜR",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 275100,
	  "UN_NO__1": 2751
	},
	{
	  "BAKANLIK_KOD": 275200,
	  "UN_NO": 2752,
	  "ORİJİNAL İSİM": "1,2-EPOKSİ-3-ETOKSİPROPAN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 275200,
	  "UN_NO__1": 2752
	},
	{
	  "BAKANLIK_KOD": 275300,
	  "UN_NO": 2753,
	  "ORİJİNAL İSİM": "N-ETİLBENZİL-TOLUİDİNLER, SIVI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 275300,
	  "UN_NO__1": 2753
	},
	{
	  "BAKANLIK_KOD": 275400,
	  "UN_NO": 2754,
	  "ORİJİNAL İSİM": "N-ETİLTOLUİDİNLER",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 275400,
	  "UN_NO__1": 2754
	},
	{
	  "BAKANLIK_KOD": 275701,
	  "UN_NO": 2757,
	  "ORİJİNAL İSİM": "KARBAMAT PESTİSİT, KATI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 275701,
	  "UN_NO__1": 2757
	},
	{
	  "BAKANLIK_KOD": 275702,
	  "UN_NO": 2757,
	  "ORİJİNAL İSİM": "KARBAMAT PESTİSİT, KATI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 275702,
	  "UN_NO__1": 2757
	},
	{
	  "BAKANLIK_KOD": 275703,
	  "UN_NO": 2757,
	  "ORİJİNAL İSİM": "KARBAMAT PESTİSİT, KATI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 275703,
	  "UN_NO__1": 2757
	},
	{
	  "BAKANLIK_KOD": 275801,
	  "UN_NO": 2758,
	  "ORİJİNAL İSİM": "KARBAMAT PESTİSİT, SIVI, ALEVLENEBİLİR, ZEHİRLİ, parlama noktası 23 °C'den düşük olan",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 275801,
	  "UN_NO__1": 2758
	},
	{
	  "BAKANLIK_KOD": 275802,
	  "UN_NO": 2758,
	  "ORİJİNAL İSİM": "KARBAMAT PESTİSİT, SIVI, ALEVLENEBİLİR, ZEHİRLİ, parlama noktası 23 °C'den düşük olan",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 275802,
	  "UN_NO__1": 2758
	},
	{
	  "BAKANLIK_KOD": 275901,
	  "UN_NO": 2759,
	  "ORİJİNAL İSİM": "ARSENİKLİ PESTİSİT, KATI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 275901,
	  "UN_NO__1": 2759
	},
	{
	  "BAKANLIK_KOD": 275902,
	  "UN_NO": 2759,
	  "ORİJİNAL İSİM": "ARSENİKLİ PESTİSİT, KATI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 275902,
	  "UN_NO__1": 2759
	},
	{
	  "BAKANLIK_KOD": 275903,
	  "UN_NO": 2759,
	  "ORİJİNAL İSİM": "ARSENİKLİ PESTİSİT, KATI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 275903,
	  "UN_NO__1": 2759
	},
	{
	  "BAKANLIK_KOD": 276001,
	  "UN_NO": 2760,
	  "ORİJİNAL İSİM": "ARSENİKLİ PESTİSİT, SIVI, ALEVLENEBİLİR, ZEHİRLİ, parlama noktası 23 °C'den düşük olan",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 276001,
	  "UN_NO__1": 2760
	},
	{
	  "BAKANLIK_KOD": 276002,
	  "UN_NO": 2760,
	  "ORİJİNAL İSİM": "ARSENİKLİ PESTİSİT, SIVI, ALEVLENEBİLİR, ZEHİRLİ, parlama noktası 23 °C'den düşük olan",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 276002,
	  "UN_NO__1": 2760
	},
	{
	  "BAKANLIK_KOD": 276101,
	  "UN_NO": 2761,
	  "ORİJİNAL İSİM": "ORGANOKLORLU PESTİSİT, KATI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 276101,
	  "UN_NO__1": 2761
	},
	{
	  "BAKANLIK_KOD": 276102,
	  "UN_NO": 2761,
	  "ORİJİNAL İSİM": "ORGANOKLORLU PESTİSİT, KATI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 276102,
	  "UN_NO__1": 2761
	},
	{
	  "BAKANLIK_KOD": 276103,
	  "UN_NO": 2761,
	  "ORİJİNAL İSİM": "ORGANOKLORLU PESTİSİT, KATI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 276103,
	  "UN_NO__1": 2761
	},
	{
	  "BAKANLIK_KOD": 276201,
	  "UN_NO": 2762,
	  "ORİJİNAL İSİM": "ORGANOKLORLU PESTİSİT, SIVI, ALEVLENEBİLİR, ZEHİRLİ, parlama noktası 23 °C'den düşük olan",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 276201,
	  "UN_NO__1": 2762
	},
	{
	  "BAKANLIK_KOD": 276202,
	  "UN_NO": 2762,
	  "ORİJİNAL İSİM": "ORGANOKLORLU PESTİSİT, SIVI, ALEVLENEBİLİR, ZEHİRLİ, parlama noktası 23 °C'den düşük olan",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 276202,
	  "UN_NO__1": 2762
	},
	{
	  "BAKANLIK_KOD": 276301,
	  "UN_NO": 2763,
	  "ORİJİNAL İSİM": "TRİAZİN PESTİSİT, KATI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 276301,
	  "UN_NO__1": 2763
	},
	{
	  "BAKANLIK_KOD": 276302,
	  "UN_NO": 2763,
	  "ORİJİNAL İSİM": "TRİAZİN PESTİSİT, KATI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 276302,
	  "UN_NO__1": 2763
	},
	{
	  "BAKANLIK_KOD": 276303,
	  "UN_NO": 2763,
	  "ORİJİNAL İSİM": "TRİAZİN PESTİSİT, KATI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 276303,
	  "UN_NO__1": 2763
	},
	{
	  "BAKANLIK_KOD": 276401,
	  "UN_NO": 2764,
	  "ORİJİNAL İSİM": "TRİAZİN PESTİSİT, SIVI, ALEVLENEBİLİR, ZEHİRLİ, parlama noktası 23 °C'den düşük olan",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 276401,
	  "UN_NO__1": 2764
	},
	{
	  "BAKANLIK_KOD": 276402,
	  "UN_NO": 2764,
	  "ORİJİNAL İSİM": "TRİAZİN PESTİSİT, SIVI, ALEVLENEBİLİR, ZEHİRLİ, parlama noktası 23 °C'den düşük olan",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 276402,
	  "UN_NO__1": 2764
	},
	{
	  "BAKANLIK_KOD": 277101,
	  "UN_NO": 2771,
	  "ORİJİNAL İSİM": "TİYOKARBAMAT PESTİSİT, KATI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 277101,
	  "UN_NO__1": 2771
	},
	{
	  "BAKANLIK_KOD": 277102,
	  "UN_NO": 2771,
	  "ORİJİNAL İSİM": "TİYOKARBAMAT PESTİSİT, KATI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 277102,
	  "UN_NO__1": 2771
	},
	{
	  "BAKANLIK_KOD": 277103,
	  "UN_NO": 2771,
	  "ORİJİNAL İSİM": "TİYOKARBAMAT PESTİSİT, KATI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 277103,
	  "UN_NO__1": 2771
	},
	{
	  "BAKANLIK_KOD": 277201,
	  "UN_NO": 2772,
	  "ORİJİNAL İSİM": "TİYOKARBAMAT PESTİSİT, SIVI, ALEVLENEBİLİR, ZEHİRLİ, parlama noktası 23 °C'den düşük olan",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 277201,
	  "UN_NO__1": 2772
	},
	{
	  "BAKANLIK_KOD": 277202,
	  "UN_NO": 2772,
	  "ORİJİNAL İSİM": "TİYOKARBAMAT PESTİSİT, SIVI, ALEVLENEBİLİR, ZEHİRLİ, parlama noktası 23 °C'den düşük olan",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 277202,
	  "UN_NO__1": 2772
	},
	{
	  "BAKANLIK_KOD": 277501,
	  "UN_NO": 2775,
	  "ORİJİNAL İSİM": "BAKIR ESASLI PESTİSİT, KATI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 277501,
	  "UN_NO__1": 2775
	},
	{
	  "BAKANLIK_KOD": 277502,
	  "UN_NO": 2775,
	  "ORİJİNAL İSİM": "BAKIR ESASLI PESTİSİT, KATI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 277502,
	  "UN_NO__1": 2775
	},
	{
	  "BAKANLIK_KOD": 277503,
	  "UN_NO": 2775,
	  "ORİJİNAL İSİM": "BAKIR ESASLI PESTİSİT, KATI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 277503,
	  "UN_NO__1": 2775
	},
	{
	  "BAKANLIK_KOD": 277601,
	  "UN_NO": 2776,
	  "ORİJİNAL İSİM": "BAKIR ESASLI PESTİSİT, SIVI, ALEVLENEBİLİR, ZEHİRLİ, parlama noktası 23 °C'den düşük olan",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 277601,
	  "UN_NO__1": 2776
	},
	{
	  "BAKANLIK_KOD": 277602,
	  "UN_NO": 2776,
	  "ORİJİNAL İSİM": "BAKIR ESASLI PESTİSİT, SIVI, ALEVLENEBİLİR, ZEHİRLİ, parlama noktası 23 °C'den düşük olan",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 277602,
	  "UN_NO__1": 2776
	},
	{
	  "BAKANLIK_KOD": 277701,
	  "UN_NO": 2777,
	  "ORİJİNAL İSİM": "CIVA ESASLI PESTİSİT, KATI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 277701,
	  "UN_NO__1": 2777
	},
	{
	  "BAKANLIK_KOD": 277702,
	  "UN_NO": 2777,
	  "ORİJİNAL İSİM": "CIVA ESASLI PESTİSİT, KATI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 277702,
	  "UN_NO__1": 2777
	},
	{
	  "BAKANLIK_KOD": 277703,
	  "UN_NO": 2777,
	  "ORİJİNAL İSİM": "CIVA ESASLI PESTİSİT, KATI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 277703,
	  "UN_NO__1": 2777
	},
	{
	  "BAKANLIK_KOD": 277801,
	  "UN_NO": 2778,
	  "ORİJİNAL İSİM": "CIVA ESASLI PESTİSİT, SIVI, ALEVLENEBİLİR, ZEHİRLİ, parlama noktası 23 °C'den düşük olan",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 277801,
	  "UN_NO__1": 2778
	},
	{
	  "BAKANLIK_KOD": 277802,
	  "UN_NO": 2778,
	  "ORİJİNAL İSİM": "CIVA ESASLI PESTİSİT, SIVI, ALEVLENEBİLİR, ZEHİRLİ, parlama noktası 23 °C'den düşük olan",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 277802,
	  "UN_NO__1": 2778
	},
	{
	  "BAKANLIK_KOD": 277901,
	  "UN_NO": 2779,
	  "ORİJİNAL İSİM": "İKAMELİ NİTROFENOL PESTİSİT, KATI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 277901,
	  "UN_NO__1": 2779
	},
	{
	  "BAKANLIK_KOD": 277902,
	  "UN_NO": 2779,
	  "ORİJİNAL İSİM": "İKAMELİ NİTROFENOL PESTİSİT, KATI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 277902,
	  "UN_NO__1": 2779
	},
	{
	  "BAKANLIK_KOD": 277903,
	  "UN_NO": 2779,
	  "ORİJİNAL İSİM": "İKAMELİ NİTROFENOL PESTİSİT, KATI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 277903,
	  "UN_NO__1": 2779
	},
	{
	  "BAKANLIK_KOD": 278001,
	  "UN_NO": 2780,
	  "ORİJİNAL İSİM": "İKAMELİ NİTROFENOL PESTİSİT, SIVI, ALEVLENEBİLİR, ZEHİRLİ, parlama noktası 23 °C'den düşük olan",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 278001,
	  "UN_NO__1": 2780
	},
	{
	  "BAKANLIK_KOD": 278002,
	  "UN_NO": 2780,
	  "ORİJİNAL İSİM": "İKAMELİ NİTROFENOL PESTİSİT, SIVI, ALEVLENEBİLİR, ZEHİRLİ, parlama noktası 23 °C'den düşük olan",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 278002,
	  "UN_NO__1": 2780
	},
	{
	  "BAKANLIK_KOD": 278101,
	  "UN_NO": 2781,
	  "ORİJİNAL İSİM": "BİPİRİDİLYUM PESTİSİT, KATI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 278101,
	  "UN_NO__1": 2781
	},
	{
	  "BAKANLIK_KOD": 278102,
	  "UN_NO": 2781,
	  "ORİJİNAL İSİM": "BİPİRİDİLYUM PESTİSİT, KATI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 278102,
	  "UN_NO__1": 2781
	},
	{
	  "BAKANLIK_KOD": 278103,
	  "UN_NO": 2781,
	  "ORİJİNAL İSİM": "BİPİRİDİLYUM PESTİSİT, KATI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 278103,
	  "UN_NO__1": 2781
	},
	{
	  "BAKANLIK_KOD": 278201,
	  "UN_NO": 2782,
	  "ORİJİNAL İSİM": "BİPİRİDİLYUM PESTİSİT, SIVI, ALEVLENEBİLİR, ZEHİRLİ, parlama noktası 23 °C'den düşük olan",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 278201,
	  "UN_NO__1": 2782
	},
	{
	  "BAKANLIK_KOD": 278202,
	  "UN_NO": 2782,
	  "ORİJİNAL İSİM": "BİPİRİDİLYUM PESTİSİT, SIVI, ALEVLENEBİLİR, ZEHİRLİ, parlama noktası 23 °C'den düşük olan",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 278202,
	  "UN_NO__1": 2782
	},
	{
	  "BAKANLIK_KOD": 278301,
	  "UN_NO": 2783,
	  "ORİJİNAL İSİM": "ORGANOFOSFORLU PESTİSİT, KATI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 278301,
	  "UN_NO__1": 2783
	},
	{
	  "BAKANLIK_KOD": 278302,
	  "UN_NO": 2783,
	  "ORİJİNAL İSİM": "ORGANOFOSFORLU PESTİSİT, KATI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 278302,
	  "UN_NO__1": 2783
	},
	{
	  "BAKANLIK_KOD": 278303,
	  "UN_NO": 2783,
	  "ORİJİNAL İSİM": "ORGANOFOSFORLU PESTİSİT, KATI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 278303,
	  "UN_NO__1": 2783
	},
	{
	  "BAKANLIK_KOD": 278401,
	  "UN_NO": 2784,
	  "ORİJİNAL İSİM": "ORGANOFOSFORLU PESTİSİT, SIVI, ALEVLENEBİLİR, ZEHİRLİ,\n parlama noktası 23 °C'den düşük olan",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 278401,
	  "UN_NO__1": 2784
	},
	{
	  "BAKANLIK_KOD": 278402,
	  "UN_NO": 2784,
	  "ORİJİNAL İSİM": "ORGANOFOSFORLU PESTİSİT, SIVI, ALEVLENEBİLİR, ZEHİRLİ, parlama noktası 23 °C'den düşük olan",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 278402,
	  "UN_NO__1": 2784
	},
	{
	  "BAKANLIK_KOD": 278500,
	  "UN_NO": 2785,
	  "ORİJİNAL İSİM": "4-TİYAPENTANAL",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 278500,
	  "UN_NO__1": 2785
	},
	{
	  "BAKANLIK_KOD": 278601,
	  "UN_NO": 2786,
	  "ORİJİNAL İSİM": "ORGANOTİN PESTİSİT, KATI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 278601,
	  "UN_NO__1": 2786
	},
	{
	  "BAKANLIK_KOD": 278602,
	  "UN_NO": 2786,
	  "ORİJİNAL İSİM": "ORGANOTİN PESTİSİT, KATI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 278602,
	  "UN_NO__1": 2786
	},
	{
	  "BAKANLIK_KOD": 278603,
	  "UN_NO": 2786,
	  "ORİJİNAL İSİM": "ORGANOTİN PESTİSİT, KATI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 278603,
	  "UN_NO__1": 2786
	},
	{
	  "BAKANLIK_KOD": 278701,
	  "UN_NO": 2787,
	  "ORİJİNAL İSİM": "ORGANOTİN PESTİSİT, SIVI, ALEVLENEBİLİR, ZEHİRLİ, parlama noktası 23 °C'den düşük olan",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 278701,
	  "UN_NO__1": 2787
	},
	{
	  "BAKANLIK_KOD": 278702,
	  "UN_NO": 2787,
	  "ORİJİNAL İSİM": "ORGANOTİN PESTİSİT, SIVI, ALEVLENEBİLİR, ZEHİRLİ, parlama noktası 23 °C'den düşük olan",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 278702,
	  "UN_NO__1": 2787
	},
	{
	  "BAKANLIK_KOD": 278801,
	  "UN_NO": 2788,
	  "ORİJİNAL İSİM": "ORGANOTİN BİLEŞİĞİ, SIVI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T3",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 278801,
	  "UN_NO__1": 2788
	},
	{
	  "BAKANLIK_KOD": 278802,
	  "UN_NO": 2788,
	  "ORİJİNAL İSİM": "ORGANOTİN BİLEŞİĞİ, SIVI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 278802,
	  "UN_NO__1": 2788
	},
	{
	  "BAKANLIK_KOD": 278803,
	  "UN_NO": 2788,
	  "ORİJİNAL İSİM": "ORGANOTİN BİLEŞİĞİ, SIVI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 278803,
	  "UN_NO__1": 2788
	},
	{
	  "BAKANLIK_KOD": 278900,
	  "UN_NO": 2789,
	  "ORİJİNAL İSİM": "ASETİK ASİT, GLASİYAL veya ASETİK ASİT ÇÖZELTİSİ, kütlece %80'den fazla asit içeren",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CF1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 278900,
	  "UN_NO__1": 2789
	},
	{
	  "BAKANLIK_KOD": 279001,
	  "UN_NO": 2790,
	  "ORİJİNAL İSİM": "ASETİK ASİT ÇÖZELTİSİ, kütlece %50'den fazla ancak %80'den az asit içermeyen",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 279001,
	  "UN_NO__1": 2790
	},
	{
	  "BAKANLIK_KOD": 279002,
	  "UN_NO": 2790,
	  "ORİJİNAL İSİM": "ASETİK ASİT ÇÖZELTİSİ, kütlece %10'dan fazla ancak %50'den az asit içeren",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 279002,
	  "UN_NO__1": 2790
	},
	{
	  "BAKANLIK_KOD": 279300,
	  "UN_NO": 2793,
	  "ORİJİNAL İSİM": "DEMİR (III) METAL TALAŞ, KIRPINTI veya HURDALAR kendiliğinden ısınmaya yatkın halde",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S4",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 279300,
	  "UN_NO__1": 2793
	},
	{
	  "BAKANLIK_KOD": 279400,
	  "UN_NO": 2794,
	  "ORİJİNAL İSİM": "AKÜLER, SULU, ASİT DOLDURULMUŞ, elektrik depolama",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C11",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 279400,
	  "UN_NO__1": 2794
	},
	{
	  "BAKANLIK_KOD": 279500,
	  "UN_NO": 2795,
	  "ORİJİNAL İSİM": "AKÜLER, SULU, ALKALİ DOLDURULMUŞ, elektrik depolama",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C11",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 279500,
	  "UN_NO__1": 2795
	},
	{
	  "BAKANLIK_KOD": 279600,
	  "UN_NO": 2796,
	  "ORİJİNAL İSİM": "SÜLFÜRİK ASİT %51'den az asit içeren veya AKÜ SUYU, ASİTLİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 279600,
	  "UN_NO__1": 2796
	},
	{
	  "BAKANLIK_KOD": 279700,
	  "UN_NO": 2797,
	  "ORİJİNAL İSİM": "AKÜ SUYU, ALKALİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 279700,
	  "UN_NO__1": 2797
	},
	{
	  "BAKANLIK_KOD": 279800,
	  "UN_NO": 2798,
	  "ORİJİNAL İSİM": "FENİLFOSFOR DİKLORÜR",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 279800,
	  "UN_NO__1": 2798
	},
	{
	  "BAKANLIK_KOD": 279900,
	  "UN_NO": 2799,
	  "ORİJİNAL İSİM": "FENİLFOSFOR TİYODİKLORÜR",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 279900,
	  "UN_NO__1": 2799
	},
	{
	  "BAKANLIK_KOD": 280000,
	  "UN_NO": 2800,
	  "ORİJİNAL İSİM": "AKÜLER, SULU, DÖKÜLMEYEN, elektrik depolama",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C11",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 280000,
	  "UN_NO__1": 2800
	},
	{
	  "BAKANLIK_KOD": 280101,
	  "UN_NO": 2801,
	  "ORİJİNAL İSİM": "BOYA, SIVI, AŞINDIRICI, B.B.B. veya BOYA ARA ÜRÜN, SIVI, AŞINDIRICI, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C9",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 280101,
	  "UN_NO__1": 2801
	},
	{
	  "BAKANLIK_KOD": 280102,
	  "UN_NO": 2801,
	  "ORİJİNAL İSİM": "BOYA, SIVI, AŞINDIRICI, B.B.B. veya BOYA ARA ÜRÜN, SIVI, AŞINDIRICI, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C9",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 280102,
	  "UN_NO__1": 2801
	},
	{
	  "BAKANLIK_KOD": 280103,
	  "UN_NO": 2801,
	  "ORİJİNAL İSİM": "BOYA, SIVI, AŞINDIRICI, B.B.B. veya BOYA ARA ÜRÜN, SIVI, AŞINDIRICI, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C9",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 280103,
	  "UN_NO__1": 2801
	},
	{
	  "BAKANLIK_KOD": 280200,
	  "UN_NO": 2802,
	  "ORİJİNAL İSİM": "BAKIR KLORÜR",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 280200,
	  "UN_NO__1": 2802
	},
	{
	  "BAKANLIK_KOD": 280300,
	  "UN_NO": 2803,
	  "ORİJİNAL İSİM": "GALYUM",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C10",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 280300,
	  "UN_NO__1": 2803
	},
	{
	  "BAKANLIK_KOD": 280500,
	  "UN_NO": 2805,
	  "ORİJİNAL İSİM": "LİTYUM HİDRİT, ERGİTİLMİŞ KATI",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 280500,
	  "UN_NO__1": 2805
	},
	{
	  "BAKANLIK_KOD": 280600,
	  "UN_NO": 2806,
	  "ORİJİNAL İSİM": "LİTYUM NİTRİT",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 280600,
	  "UN_NO__1": 2806
	},
	{
	  "BAKANLIK_KOD": 280900,
	  "UN_NO": 2809,
	  "ORİJİNAL İSİM": "CIVA",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CT1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 280900,
	  "UN_NO__1": 2809
	},
	{
	  "BAKANLIK_KOD": 281001,
	  "UN_NO": 2810,
	  "ORİJİNAL İSİM": "ZEHİRLİ SIVI, ORGANİK, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 281001,
	  "UN_NO__1": 2810
	},
	{
	  "BAKANLIK_KOD": 281002,
	  "UN_NO": 2810,
	  "ORİJİNAL İSİM": "ZEHİRLİ SIVI, ORGANİK, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 281002,
	  "UN_NO__1": 2810
	},
	{
	  "BAKANLIK_KOD": 281003,
	  "UN_NO": 2810,
	  "ORİJİNAL İSİM": "ZEHİRLİ SIVI, ORGANİK, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 281003,
	  "UN_NO__1": 2810
	},
	{
	  "BAKANLIK_KOD": 281101,
	  "UN_NO": 2811,
	  "ORİJİNAL İSİM": "ZEHİRLİ KATI, ORGANİK, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 281101,
	  "UN_NO__1": 2811
	},
	{
	  "BAKANLIK_KOD": 281102,
	  "UN_NO": 2811,
	  "ORİJİNAL İSİM": "ZEHİRLİ KATI, ORGANİK, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 281102,
	  "UN_NO__1": 2811
	},
	{
	  "BAKANLIK_KOD": 281103,
	  "UN_NO": 2811,
	  "ORİJİNAL İSİM": "ZEHİRLİ KATI, ORGANİK, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 281103,
	  "UN_NO__1": 2811
	},
	{
	  "BAKANLIK_KOD": 281301,
	  "UN_NO": 2813,
	  "ORİJİNAL İSİM": "SU İLE TEPKİMEYE GİREN, KATI, B.B.B.",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 281301,
	  "UN_NO__1": 2813
	},
	{
	  "BAKANLIK_KOD": 281302,
	  "UN_NO": 2813,
	  "ORİJİNAL İSİM": "SU İLE TEPKİMEYE GİREN, KATI, B.B.B.",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 281302,
	  "UN_NO__1": 2813
	},
	{
	  "BAKANLIK_KOD": 281303,
	  "UN_NO": 2813,
	  "ORİJİNAL İSİM": "SU İLE TEPKİMEYE GİREN, KATI, B.B.B.",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 281303,
	  "UN_NO__1": 2813
	},
	{
	  "BAKANLIK_KOD": 281401,
	  "UN_NO": 2814,
	  "ORİJİNAL İSİM": "BULAŞICI MADDE, İNSANLARI ETKİLEYEN",
	  "SINIF": 6.2,
	  "SINIFLANDIRMA_KODU": "I1",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 281401,
	  "UN_NO__1": 2814
	},
	{
	  "BAKANLIK_KOD": 281402,
	  "UN_NO": 2814,
	  "ORİJİNAL İSİM": "BULAŞICI MADDE, İNSANLARI ETKİLEYEN, soğutulmuş sıvı azot içinde",
	  "SINIF": 6.2,
	  "SINIFLANDIRMA_KODU": "I1",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 281402,
	  "UN_NO__1": 2814
	},
	{
	  "BAKANLIK_KOD": 281403,
	  "UN_NO": 2814,
	  "ORİJİNAL İSİM": "BULAŞICI MADDE, İNSANLARI ETKİLEYEN (yalnız hayvansal malzemeler)",
	  "SINIF": 6.2,
	  "SINIFLANDIRMA_KODU": "I1",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 281403,
	  "UN_NO__1": 2814
	},
	{
	  "BAKANLIK_KOD": 281500,
	  "UN_NO": 2815,
	  "ORİJİNAL İSİM": "N-AMİNOETİLPİPERAZİN",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CT1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 281500,
	  "UN_NO__1": 2815
	},
	{
	  "BAKANLIK_KOD": 281701,
	  "UN_NO": 2817,
	  "ORİJİNAL İSİM": "AMONYUM HİDROJENDİFLORÜR ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CT1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 281701,
	  "UN_NO__1": 2817
	},
	{
	  "BAKANLIK_KOD": 281702,
	  "UN_NO": 2817,
	  "ORİJİNAL İSİM": "AMONYUM HİDROJENDİFLORÜR ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CT1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 281702,
	  "UN_NO__1": 2817
	},
	{
	  "BAKANLIK_KOD": 281801,
	  "UN_NO": 2818,
	  "ORİJİNAL İSİM": "AMONYUM POLİSÜLFÜR ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CT1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 281801,
	  "UN_NO__1": 2818
	},
	{
	  "BAKANLIK_KOD": 281802,
	  "UN_NO": 2818,
	  "ORİJİNAL İSİM": "AMONYUM POLİSÜLFÜR ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CT1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 281802,
	  "UN_NO__1": 2818
	},
	{
	  "BAKANLIK_KOD": 281900,
	  "UN_NO": 2819,
	  "ORİJİNAL İSİM": "AMİL ASİT FOSFAT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 281900,
	  "UN_NO__1": 2819
	},
	{
	  "BAKANLIK_KOD": 282000,
	  "UN_NO": 2820,
	  "ORİJİNAL İSİM": "BÜTİRİK ASİT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 282000,
	  "UN_NO__1": 2820
	},
	{
	  "BAKANLIK_KOD": 282101,
	  "UN_NO": 2821,
	  "ORİJİNAL İSİM": "FENOL ÇÖZELTİSİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 282101,
	  "UN_NO__1": 2821
	},
	{
	  "BAKANLIK_KOD": 282102,
	  "UN_NO": 2821,
	  "ORİJİNAL İSİM": "FENOL ÇÖZELTİSİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 282102,
	  "UN_NO__1": 2821
	},
	{
	  "BAKANLIK_KOD": 282200,
	  "UN_NO": 2822,
	  "ORİJİNAL İSİM": "2-KLOROPİRİDİN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 282200,
	  "UN_NO__1": 2822
	},
	{
	  "BAKANLIK_KOD": 282300,
	  "UN_NO": 2823,
	  "ORİJİNAL İSİM": "KROTONİK ASİT, KATI",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C4",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 282300,
	  "UN_NO__1": 2823
	},
	{
	  "BAKANLIK_KOD": 282600,
	  "UN_NO": 2826,
	  "ORİJİNAL İSİM": "ETİL KLOROOTİYOFORMAT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CF1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 282600,
	  "UN_NO__1": 2826
	},
	{
	  "BAKANLIK_KOD": 282900,
	  "UN_NO": 2829,
	  "ORİJİNAL İSİM": "KAPROİK ASİT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 282900,
	  "UN_NO__1": 2829
	},
	{
	  "BAKANLIK_KOD": 283000,
	  "UN_NO": 2830,
	  "ORİJİNAL İSİM": "LİTYUM FERROSİLİSYUM",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 283000,
	  "UN_NO__1": 2830
	},
	{
	  "BAKANLIK_KOD": 283100,
	  "UN_NO": 2831,
	  "ORİJİNAL İSİM": "1,1,1 -TRİKLOROETAN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 283100,
	  "UN_NO__1": 2831
	},
	{
	  "BAKANLIK_KOD": 283400,
	  "UN_NO": 2834,
	  "ORİJİNAL İSİM": "FOSFOR ASİT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 283400,
	  "UN_NO__1": 2834
	},
	{
	  "BAKANLIK_KOD": 283500,
	  "UN_NO": 2835,
	  "ORİJİNAL İSİM": "SODYUM ALÜMİNYUM HİDRİT",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 283500,
	  "UN_NO__1": 2835
	},
	{
	  "BAKANLIK_KOD": 283701,
	  "UN_NO": 2837,
	  "ORİJİNAL İSİM": "BİSÜLFATLAR, SULU ÇÖZELTİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 283701,
	  "UN_NO__1": 2837
	},
	{
	  "BAKANLIK_KOD": 283702,
	  "UN_NO": 2837,
	  "ORİJİNAL İSİM": "BİSÜLFATLAR, SULU ÇÖZELTİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 283702,
	  "UN_NO__1": 2837
	},
	{
	  "BAKANLIK_KOD": 283800,
	  "UN_NO": 2838,
	  "ORİJİNAL İSİM": "VİNİL BÜTİRAT, STABİLİZE",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 283800,
	  "UN_NO__1": 2838
	},
	{
	  "BAKANLIK_KOD": 283900,
	  "UN_NO": 2839,
	  "ORİJİNAL İSİM": "ALDOL",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 283900,
	  "UN_NO__1": 2839
	},
	{
	  "BAKANLIK_KOD": 284000,
	  "UN_NO": 2840,
	  "ORİJİNAL İSİM": "BÜTİRALDOKSİM",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 284000,
	  "UN_NO__1": 2840
	},
	{
	  "BAKANLIK_KOD": 284100,
	  "UN_NO": 2841,
	  "ORİJİNAL İSİM": "Dİ-n-AMİLAMİN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 284100,
	  "UN_NO__1": 2841
	},
	{
	  "BAKANLIK_KOD": 284200,
	  "UN_NO": 2842,
	  "ORİJİNAL İSİM": "NİTROETAN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 284200,
	  "UN_NO__1": 2842
	},
	{
	  "BAKANLIK_KOD": 284400,
	  "UN_NO": 2844,
	  "ORİJİNAL İSİM": "KALSİYUM MANGANEZ SİLİKON",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 284400,
	  "UN_NO__1": 2844
	},
	{
	  "BAKANLIK_KOD": 284500,
	  "UN_NO": 2845,
	  "ORİJİNAL İSİM": "PİROFORİK SIVI, ORGANİK, B.B.B.",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 284500,
	  "UN_NO__1": 2845
	},
	{
	  "BAKANLIK_KOD": 284600,
	  "UN_NO": 2846,
	  "ORİJİNAL İSİM": "PİROFORİK KATI, ORGANİK, B.B.B.",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 284600,
	  "UN_NO__1": 2846
	},
	{
	  "BAKANLIK_KOD": 284900,
	  "UN_NO": 2849,
	  "ORİJİNAL İSİM": "3-KLOROPROPANOL-1",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 284900,
	  "UN_NO__1": 2849
	},
	{
	  "BAKANLIK_KOD": 285000,
	  "UN_NO": 2850,
	  "ORİJİNAL İSİM": "PROPİLEN TETRAMER",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 285000,
	  "UN_NO__1": 2850
	},
	{
	  "BAKANLIK_KOD": 285100,
	  "UN_NO": 2851,
	  "ORİJİNAL İSİM": "BOR TRİFLORÜR DİHİDRAT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 285100,
	  "UN_NO__1": 2851
	},
	{
	  "BAKANLIK_KOD": 285200,
	  "UN_NO": 2852,
	  "ORİJİNAL İSİM": "DİPİKRİL SÜLFÜR, ISLATILMIŞ kütlece %10'dan az olmayan su ile",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "D",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 285200,
	  "UN_NO__1": 2852
	},
	{
	  "BAKANLIK_KOD": 285300,
	  "UN_NO": 2853,
	  "ORİJİNAL İSİM": "MAGNEZYUM FLOROSİLİKAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 285300,
	  "UN_NO__1": 2853
	},
	{
	  "BAKANLIK_KOD": 285400,
	  "UN_NO": 2854,
	  "ORİJİNAL İSİM": "AMONYUM FLOROSİLİKAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 285400,
	  "UN_NO__1": 2854
	},
	{
	  "BAKANLIK_KOD": 285500,
	  "UN_NO": 2855,
	  "ORİJİNAL İSİM": "ÇİNKO FLOROSİLİKAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 285500,
	  "UN_NO__1": 2855
	},
	{
	  "BAKANLIK_KOD": 285600,
	  "UN_NO": 2856,
	  "ORİJİNAL İSİM": "FLOROSİLİKATLAR, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 285600,
	  "UN_NO__1": 2856
	},
	{
	  "BAKANLIK_KOD": 285700,
	  "UN_NO": 2857,
	  "ORİJİNAL İSİM": "SOĞUTUCU MAKİNELER, alevlenebilir olmayan, zehirsiz gazlar veya amonyak çözeltisi içeren (UN 2672)",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "6A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 285700,
	  "UN_NO__1": 2857
	},
	{
	  "BAKANLIK_KOD": 285800,
	  "UN_NO": 2858,
	  "ORİJİNAL İSİM": "ZİRKONYUM, KURU, sarmallı tel, işlenmiş metal tabakalar, şerit (254 mikrondan ince fakat 18 mikrondan ince olmayan)",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 285800,
	  "UN_NO__1": 2858
	},
	{
	  "BAKANLIK_KOD": 285900,
	  "UN_NO": 2859,
	  "ORİJİNAL İSİM": "AMONYUM METAVANADAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 285900,
	  "UN_NO__1": 2859
	},
	{
	  "BAKANLIK_KOD": 286100,
	  "UN_NO": 2861,
	  "ORİJİNAL İSİM": "AMONYUM POLİVANADAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 286100,
	  "UN_NO__1": 2861
	},
	{
	  "BAKANLIK_KOD": 286200,
	  "UN_NO": 2862,
	  "ORİJİNAL İSİM": "VANADYUM PENTOKSİT, ergitilmemiş biçimde",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 286200,
	  "UN_NO__1": 2862
	},
	{
	  "BAKANLIK_KOD": 286300,
	  "UN_NO": 2863,
	  "ORİJİNAL İSİM": "SODYUM AMONYUM VANADAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 286300,
	  "UN_NO__1": 2863
	},
	{
	  "BAKANLIK_KOD": 286400,
	  "UN_NO": 2864,
	  "ORİJİNAL İSİM": "POTASYUM METAVANADAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 286400,
	  "UN_NO__1": 2864
	},
	{
	  "BAKANLIK_KOD": 286500,
	  "UN_NO": 2865,
	  "ORİJİNAL İSİM": "HİDROKSİLAMİN SÜLFAT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 286500,
	  "UN_NO__1": 2865
	},
	{
	  "BAKANLIK_KOD": 286901,
	  "UN_NO": 2869,
	  "ORİJİNAL İSİM": "TİTANYUM TRİKLORÜR KARIŞIMI",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 286901,
	  "UN_NO__1": 2869
	},
	{
	  "BAKANLIK_KOD": 286902,
	  "UN_NO": 2869,
	  "ORİJİNAL İSİM": "TİTANYUM TRİKLORÜR KARIŞIMI",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 286902,
	  "UN_NO__1": 2869
	},
	{
	  "BAKANLIK_KOD": 287001,
	  "UN_NO": 2870,
	  "ORİJİNAL İSİM": "ALÜMİNYUM BOROHİDRİT",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "SW",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 287001,
	  "UN_NO__1": 2870
	},
	{
	  "BAKANLIK_KOD": 287002,
	  "UN_NO": 2870,
	  "ORİJİNAL İSİM": "ALÜMİNYUM BOROHİDRİT ALETLERDE",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "SW",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 287002,
	  "UN_NO__1": 2870
	},
	{
	  "BAKANLIK_KOD": 287100,
	  "UN_NO": 2871,
	  "ORİJİNAL İSİM": "ANTİMON TOZU",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 287100,
	  "UN_NO__1": 2871
	},
	{
	  "BAKANLIK_KOD": 287201,
	  "UN_NO": 2872,
	  "ORİJİNAL İSİM": "DİBROMOKLORO-PROPANLAR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 287201,
	  "UN_NO__1": 2872
	},
	{
	  "BAKANLIK_KOD": 287202,
	  "UN_NO": 2872,
	  "ORİJİNAL İSİM": "DİBROMOKLORO-PROPANLAR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 287202,
	  "UN_NO__1": 2872
	},
	{
	  "BAKANLIK_KOD": 287300,
	  "UN_NO": 2873,
	  "ORİJİNAL İSİM": "DİBÜTİLAMİNOETANOL",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 287300,
	  "UN_NO__1": 2873
	},
	{
	  "BAKANLIK_KOD": 287400,
	  "UN_NO": 2874,
	  "ORİJİNAL İSİM": "FURFURİL ALKOL",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 287400,
	  "UN_NO__1": 2874
	},
	{
	  "BAKANLIK_KOD": 287500,
	  "UN_NO": 2875,
	  "ORİJİNAL İSİM": "HEKZAKLOROFEN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 287500,
	  "UN_NO__1": 2875
	},
	{
	  "BAKANLIK_KOD": 287600,
	  "UN_NO": 2876,
	  "ORİJİNAL İSİM": "RESORSİNOL",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 287600,
	  "UN_NO__1": 2876
	},
	{
	  "BAKANLIK_KOD": 287800,
	  "UN_NO": 2878,
	  "ORİJİNAL İSİM": "TİTANYUM SÜNGER GRANÜLLERİ veya TİTANYUM SÜNGER TOZLARI",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 287800,
	  "UN_NO__1": 2878
	},
	{
	  "BAKANLIK_KOD": 287900,
	  "UN_NO": 2879,
	  "ORİJİNAL İSİM": "SELENYUM OKSİKLORÜR",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CT1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 287900,
	  "UN_NO__1": 2879
	},
	{
	  "BAKANLIK_KOD": 288001,
	  "UN_NO": 2880,
	  "ORİJİNAL İSİM": "KALSİYUM HİPOKLORİT, HİDRATLANMIŞ veya KALSİYUM HİPOKLORİT, HİDRATLANMIŞ KARIŞIM, %5,5'ten az olmayan ancak %16'dan fazla su içermeyen",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 288001,
	  "UN_NO__1": 2880
	},
	{
	  "BAKANLIK_KOD": 288002,
	  "UN_NO": 2880,
	  "ORİJİNAL İSİM": "KALSİYUM HİPOKLORİT, HİDRATLANMIŞ veya KALSİYUM HİPOKLORİT, HİDRATLANMIŞ KARIŞIM, %5,5'ten az olmayan ancak %16'dan fazla su içermeyen",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 288002,
	  "UN_NO__1": 2880
	},
	{
	  "BAKANLIK_KOD": 288101,
	  "UN_NO": 2881,
	  "ORİJİNAL İSİM": "METAL KATALİZÖR, KURU",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S4",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 288101,
	  "UN_NO__1": 2881
	},
	{
	  "BAKANLIK_KOD": 288102,
	  "UN_NO": 2881,
	  "ORİJİNAL İSİM": "METAL KATALİZÖR, KURU",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S4",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 288102,
	  "UN_NO__1": 2881
	},
	{
	  "BAKANLIK_KOD": 288103,
	  "UN_NO": 2881,
	  "ORİJİNAL İSİM": "METAL KATALİZÖR, KURU",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S4",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 288103,
	  "UN_NO__1": 2881
	},
	{
	  "BAKANLIK_KOD": 290001,
	  "UN_NO": 2900,
	  "ORİJİNAL İSİM": "BULAŞICI MADDE, yalnızca HAYVANLARI ETKİLEYEN",
	  "SINIF": 6.2,
	  "SINIFLANDIRMA_KODU": "I2",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 290001,
	  "UN_NO__1": 2900
	},
	{
	  "BAKANLIK_KOD": 290002,
	  "UN_NO": 2900,
	  "ORİJİNAL İSİM": "BULAŞICI MADDE, yalnızca HAYVANLARI ETKİLEYEN, soğutulmuş sıvı azot içinde",
	  "SINIF": 6.2,
	  "SINIFLANDIRMA_KODU": "I2",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 290002,
	  "UN_NO__1": 2900
	},
	{
	  "BAKANLIK_KOD": 290003,
	  "UN_NO": 2900,
	  "ORİJİNAL İSİM": "BULAŞICI MADDE, yalnızca HAYVANLARI ETKİLEYEN (yalnız hayvansal malzemeler)",
	  "SINIF": 6.2,
	  "SINIFLANDIRMA_KODU": "I2",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 290003,
	  "UN_NO__1": 2900
	},
	{
	  "BAKANLIK_KOD": 290100,
	  "UN_NO": 2901,
	  "ORİJİNAL İSİM": "BROM KLORÜR",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TOC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 290100,
	  "UN_NO__1": 2901
	},
	{
	  "BAKANLIK_KOD": 290201,
	  "UN_NO": 2902,
	  "ORİJİNAL İSİM": "PESTİSİT, SIVI, ZEHİRLİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 290201,
	  "UN_NO__1": 2902
	},
	{
	  "BAKANLIK_KOD": 290202,
	  "UN_NO": 2902,
	  "ORİJİNAL İSİM": "PESTİSİT, SIVI, ZEHİRLİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 290202,
	  "UN_NO__1": 2902
	},
	{
	  "BAKANLIK_KOD": 290203,
	  "UN_NO": 2902,
	  "ORİJİNAL İSİM": "PESTİSİT, SIVI, ZEHİRLİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 290203,
	  "UN_NO__1": 2902
	},
	{
	  "BAKANLIK_KOD": 290301,
	  "UN_NO": 2903,
	  "ORİJİNAL İSİM": "PESTİSİT, SIVI, ZEHİRLİ, ALEVLENEBİLİR, B.B.B., parlama noktası 23 °C'den düşük olmayan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 290301,
	  "UN_NO__1": 2903
	},
	{
	  "BAKANLIK_KOD": 290302,
	  "UN_NO": 2903,
	  "ORİJİNAL İSİM": "PESTİSİT, SIVI, ZEHİRLİ, ALEVLENEBİLİR, B.B.B., parlama noktası 23 °C'den düşük olmayan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 290302,
	  "UN_NO__1": 2903
	},
	{
	  "BAKANLIK_KOD": 290303,
	  "UN_NO": 2903,
	  "ORİJİNAL İSİM": "PESTİSİT, SIVI, ZEHİRLİ, ALEVLENEBİLİR, B.B.B., parlama noktası 23 °C'den düşük olmayan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 290303,
	  "UN_NO__1": 2903
	},
	{
	  "BAKANLIK_KOD": 290400,
	  "UN_NO": 2904,
	  "ORİJİNAL İSİM": "KLOROFENOLATLAR, SIVI veya FENOLATLAR, SIVI",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C9",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 290400,
	  "UN_NO__1": 2904
	},
	{
	  "BAKANLIK_KOD": 290500,
	  "UN_NO": 2905,
	  "ORİJİNAL İSİM": "KLOROFENOLATLAR, KATI veya FENOLATLAR, KATI",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C10",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 290500,
	  "UN_NO__1": 2905
	},
	{
	  "BAKANLIK_KOD": 290700,
	  "UN_NO": 2907,
	  "ORİJİNAL İSİM": "İZOSORBİD DİNİTRAT KARIŞIMI içerdiği laktoz, mannoz, nişasta veya kalsiyum hidrojen fosfat miktarı %60'tan az olmayan",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "D",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 290700,
	  "UN_NO__1": 2907
	},
	{
	  "BAKANLIK_KOD": 290800,
	  "UN_NO": 2908,
	  "ORİJİNAL İSİM": "RADYOAKTİF MALZEME, ADİ PAKET - BOŞ AMBALAJ",
	  "SINIF": 7,
	  "SINIFLANDIRMA_KODU": "",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 290800,
	  "UN_NO__1": 2908
	},
	{
	  "BAKANLIK_KOD": 290900,
	  "UN_NO": 2909,
	  "ORİJİNAL İSİM": "RADYOAKTİF MALZEME, ADİ PAKET - DOĞAL URANYUM veya FAKİRLEŞTİRİLMİŞ URANYUM veya DOĞAL TORYUM'DAN YAPILMIŞ NESNELER",
	  "SINIF": 7,
	  "SINIFLANDIRMA_KODU": "",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 290900,
	  "UN_NO__1": 2909
	},
	{
	  "BAKANLIK_KOD": 291000,
	  "UN_NO": 2910,
	  "ORİJİNAL İSİM": "RADYOAKTİF MALZEME, ADİ PAKET - MALZEME MİKTARI SINIRLANDIRILMIŞ",
	  "SINIF": 7,
	  "SINIFLANDIRMA_KODU": "",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 291000,
	  "UN_NO__1": 2910
	},
	{
	  "BAKANLIK_KOD": 291100,
	  "UN_NO": 2911,
	  "ORİJİNAL İSİM": "RADYOAKTİF MALZEME, ADİ PAKET - ALETLER veya NESNELER",
	  "SINIF": 7,
	  "SINIFLANDIRMA_KODU": "",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 291100,
	  "UN_NO__1": 2911
	},
	{
	  "BAKANLIK_KOD": 291200,
	  "UN_NO": 2912,
	  "ORİJİNAL İSİM": "RADYOAKTİF MALZEME, DÜŞÜK ÖZGÜL AKTİVİTE (LSA-I), bölünebilir olmayan veya istisnai bölünebilir",
	  "SINIF": 7,
	  "SINIFLANDIRMA_KODU": "",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 291200,
	  "UN_NO__1": 2912
	},
	{
	  "BAKANLIK_KOD": 291300,
	  "UN_NO": 2913,
	  "ORİJİNAL İSİM": "RADYOAKTİF MALZEME, YÜZEYİ BULAŞMIŞ NESNELER (SCO-I, SCO-II veya SCO-III), bölünebilir olmayan veya istisnai bölünebilir",
	  "SINIF": 7,
	  "SINIFLANDIRMA_KODU": "",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 291300,
	  "UN_NO__1": 2913
	},
	{
	  "BAKANLIK_KOD": 291500,
	  "UN_NO": 2915,
	  "ORİJİNAL İSİM": "RADYOAKTİF MALZEME, TİP A AMBALAJ, özel hazırlanmamış, bölünebilir olmayan veya istisnai bölünebilir",
	  "SINIF": 7,
	  "SINIFLANDIRMA_KODU": "",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 291500,
	  "UN_NO__1": 2915
	},
	{
	  "BAKANLIK_KOD": 291600,
	  "UN_NO": 2916,
	  "ORİJİNAL İSİM": "RADYOAKTİF MALZEME, TİP B(U) AMBALAJ, bölünebilir olmayan veya istisnai bölünebilir",
	  "SINIF": 7,
	  "SINIFLANDIRMA_KODU": "",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 291600,
	  "UN_NO__1": 2916
	},
	{
	  "BAKANLIK_KOD": 291700,
	  "UN_NO": 2917,
	  "ORİJİNAL İSİM": "RADYOAKTİF MALZEME, TİP B(M) AMBALAJ, bölünebilir olmayan veya istisnai bölünebilir",
	  "SINIF": 7,
	  "SINIFLANDIRMA_KODU": "",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 291700,
	  "UN_NO__1": 2917
	},
	{
	  "BAKANLIK_KOD": 291900,
	  "UN_NO": 2919,
	  "ORİJİNAL İSİM": "RADYOAKTİF MALZEME, TİP B(U) AMBALAJ, bölünebilir olmayan veya istisnai bölünebilir",
	  "SINIF": 7,
	  "SINIFLANDIRMA_KODU": "",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 291900,
	  "UN_NO__1": 2919
	},
	{
	  "BAKANLIK_KOD": 292001,
	  "UN_NO": 2920,
	  "ORİJİNAL İSİM": "AŞINDIRICI SIVI, ALEVLENEBİLİR, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 292001,
	  "UN_NO__1": 2920
	},
	{
	  "BAKANLIK_KOD": 292002,
	  "UN_NO": 2920,
	  "ORİJİNAL İSİM": "AŞINDIRICI SIVI, ALEVLENEBİLİR, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CF1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 292002,
	  "UN_NO__1": 2920
	},
	{
	  "BAKANLIK_KOD": 292101,
	  "UN_NO": 2921,
	  "ORİJİNAL İSİM": "AŞINDIRICI KATI, ALEVLENEBİLİR, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CF2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 292101,
	  "UN_NO__1": 2921
	},
	{
	  "BAKANLIK_KOD": 292102,
	  "UN_NO": 2921,
	  "ORİJİNAL İSİM": "AŞINDIRICI KATI, ALEVLENEBİLİR, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CF2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 292102,
	  "UN_NO__1": 2921
	},
	{
	  "BAKANLIK_KOD": 292201,
	  "UN_NO": 2922,
	  "ORİJİNAL İSİM": "AŞINDIRICI SIVI, ZEHİRLİ, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CT1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 292201,
	  "UN_NO__1": 2922
	},
	{
	  "BAKANLIK_KOD": 292202,
	  "UN_NO": 2922,
	  "ORİJİNAL İSİM": "AŞINDIRICI SIVI, ZEHİRLİ, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CT1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 292202,
	  "UN_NO__1": 2922
	},
	{
	  "BAKANLIK_KOD": 292203,
	  "UN_NO": 2922,
	  "ORİJİNAL İSİM": "AŞINDIRICI SIVI, ZEHİRLİ, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CT1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 292203,
	  "UN_NO__1": 2922
	},
	{
	  "BAKANLIK_KOD": 292301,
	  "UN_NO": 2923,
	  "ORİJİNAL İSİM": "AŞINDIRICI KATI, ZEHİRLİ, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CT2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 292301,
	  "UN_NO__1": 2923
	},
	{
	  "BAKANLIK_KOD": 292302,
	  "UN_NO": 2923,
	  "ORİJİNAL İSİM": "AŞINDIRICI KATI, ZEHİRLİ, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CT2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 292302,
	  "UN_NO__1": 2923
	},
	{
	  "BAKANLIK_KOD": 292303,
	  "UN_NO": 2923,
	  "ORİJİNAL İSİM": "AŞINDIRICI KATI, ZEHİRLİ, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CT2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 292303,
	  "UN_NO__1": 2923
	},
	{
	  "BAKANLIK_KOD": 292401,
	  "UN_NO": 2924,
	  "ORİJİNAL İSİM": "ALEVLENEBİLİR SIVI, AŞINDIRICI, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 292401,
	  "UN_NO__1": 2924
	},
	{
	  "BAKANLIK_KOD": 292402,
	  "UN_NO": 2924,
	  "ORİJİNAL İSİM": "ALEVLENEBİLİR SIVI, AŞINDIRICI, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 292402,
	  "UN_NO__1": 2924
	},
	{
	  "BAKANLIK_KOD": 292403,
	  "UN_NO": 2924,
	  "ORİJİNAL İSİM": "ALEVLENEBİLİR SIVI, AŞINDIRICI, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 292403,
	  "UN_NO__1": 2924
	},
	{
	  "BAKANLIK_KOD": 292501,
	  "UN_NO": 2925,
	  "ORİJİNAL İSİM": "ALEVLENEBİLİR KATI, AŞINDIRICI, ORGANİK, B.B.B.",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "FC1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 292501,
	  "UN_NO__1": 2925
	},
	{
	  "BAKANLIK_KOD": 292502,
	  "UN_NO": 2925,
	  "ORİJİNAL İSİM": "ALEVLENEBİLİR KATI, AŞINDIRICI, ORGANİK, B.B.B.",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "FC1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 292502,
	  "UN_NO__1": 2925
	},
	{
	  "BAKANLIK_KOD": 292601,
	  "UN_NO": 2926,
	  "ORİJİNAL İSİM": "ALEVLENEBİLİR KATI, ZEHİRLİ, ORGANİK, B.B.B.",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 292601,
	  "UN_NO__1": 2926
	},
	{
	  "BAKANLIK_KOD": 292602,
	  "UN_NO": 2926,
	  "ORİJİNAL İSİM": "ALEVLENEBİLİR KATI, ZEHİRLİ, ORGANİK, B.B.B.",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 292602,
	  "UN_NO__1": 2926
	},
	{
	  "BAKANLIK_KOD": 292701,
	  "UN_NO": 2927,
	  "ORİJİNAL İSİM": "ZEHİRLİ SIVI, AŞINDIRICI, ORGANİK, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TC1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 292701,
	  "UN_NO__1": 2927
	},
	{
	  "BAKANLIK_KOD": 292702,
	  "UN_NO": 2927,
	  "ORİJİNAL İSİM": "ZEHİRLİ SIVI, AŞINDIRICI, ORGANİK, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TC1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 292702,
	  "UN_NO__1": 2927
	},
	{
	  "BAKANLIK_KOD": 292801,
	  "UN_NO": 2928,
	  "ORİJİNAL İSİM": "ZEHİRLİ KATI, AŞINDIRICI, ORGANİK, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TC2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 292801,
	  "UN_NO__1": 2928
	},
	{
	  "BAKANLIK_KOD": 292802,
	  "UN_NO": 2928,
	  "ORİJİNAL İSİM": "ZEHİRLİ KATI, AŞINDIRICI, ORGANİK, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TC2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 292802,
	  "UN_NO__1": 2928
	},
	{
	  "BAKANLIK_KOD": 292901,
	  "UN_NO": 2929,
	  "ORİJİNAL İSİM": "ZEHİRLİ SIVI, ALEVLENEBİLİR, ORGANİK, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 292901,
	  "UN_NO__1": 2929
	},
	{
	  "BAKANLIK_KOD": 292902,
	  "UN_NO": 2929,
	  "ORİJİNAL İSİM": "ZEHİRLİ SIVI, ALEVLENEBİLİR, ORGANİK, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 292902,
	  "UN_NO__1": 2929
	},
	{
	  "BAKANLIK_KOD": 293001,
	  "UN_NO": 2930,
	  "ORİJİNAL İSİM": "ZEHİRLİ KATI, ALEVLENEBİLİR, \n ORGANİK, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF3",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 293001,
	  "UN_NO__1": 2930
	},
	{
	  "BAKANLIK_KOD": 293002,
	  "UN_NO": 2930,
	  "ORİJİNAL İSİM": "ZEHİRLİ KATI, ALEVLENEBİLİR, ORGANİK, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 293002,
	  "UN_NO__1": 2930
	},
	{
	  "BAKANLIK_KOD": 293100,
	  "UN_NO": 2931,
	  "ORİJİNAL İSİM": "VANADİL SÜLFAT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 293100,
	  "UN_NO__1": 2931
	},
	{
	  "BAKANLIK_KOD": 293300,
	  "UN_NO": 2933,
	  "ORİJİNAL İSİM": "METİL 2-KLOROPROPİONAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 293300,
	  "UN_NO__1": 2933
	},
	{
	  "BAKANLIK_KOD": 293400,
	  "UN_NO": 2934,
	  "ORİJİNAL İSİM": "İZOPROPİL 2-KLOROPROPİONAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 293400,
	  "UN_NO__1": 2934
	},
	{
	  "BAKANLIK_KOD": 293500,
	  "UN_NO": 2935,
	  "ORİJİNAL İSİM": "ETİL 2-KLOROPROPİONAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 293500,
	  "UN_NO__1": 2935
	},
	{
	  "BAKANLIK_KOD": 293600,
	  "UN_NO": 2936,
	  "ORİJİNAL İSİM": "TİYOLAKTİK ASİT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 293600,
	  "UN_NO__1": 2936
	},
	{
	  "BAKANLIK_KOD": 293700,
	  "UN_NO": 2937,
	  "ORİJİNAL İSİM": "alfa-METİLBENZİL ALKOL, SIVI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 293700,
	  "UN_NO__1": 2937
	},
	{
	  "BAKANLIK_KOD": 294000,
	  "UN_NO": 2940,
	  "ORİJİNAL İSİM": "9-FOSFABİSİKLO-NONANLAR (SİKLOOKTADİEN FOSFİNLER)",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 294000,
	  "UN_NO__1": 2940
	},
	{
	  "BAKANLIK_KOD": 294100,
	  "UN_NO": 2941,
	  "ORİJİNAL İSİM": "FLOROANİLİNLER",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 294100,
	  "UN_NO__1": 2941
	},
	{
	  "BAKANLIK_KOD": 294200,
	  "UN_NO": 2942,
	  "ORİJİNAL İSİM": "2-TRİFLOROMETİL-ANİLİN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 294200,
	  "UN_NO__1": 2942
	},
	{
	  "BAKANLIK_KOD": 294300,
	  "UN_NO": 2943,
	  "ORİJİNAL İSİM": "TETRAHİDROFURFURİL-AMİN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 294300,
	  "UN_NO__1": 2943
	},
	{
	  "BAKANLIK_KOD": 294500,
	  "UN_NO": 2945,
	  "ORİJİNAL İSİM": "N-METİLBÜTİLAMİN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 294500,
	  "UN_NO__1": 2945
	},
	{
	  "BAKANLIK_KOD": 294600,
	  "UN_NO": 2946,
	  "ORİJİNAL İSİM": "2-AMİNO-5-DİETİL- AMİNOPENTAN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 294600,
	  "UN_NO__1": 2946
	},
	{
	  "BAKANLIK_KOD": 294700,
	  "UN_NO": 2947,
	  "ORİJİNAL İSİM": "İZOPROPİL KLOROASETAT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 294700,
	  "UN_NO__1": 2947
	},
	{
	  "BAKANLIK_KOD": 294800,
	  "UN_NO": 2948,
	  "ORİJİNAL İSİM": "3-TRİFLOROMETİL-ANİLİN",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 294800,
	  "UN_NO__1": 2948
	},
	{
	  "BAKANLIK_KOD": 294900,
	  "UN_NO": 2949,
	  "ORİJİNAL İSİM": "SODYUM HİDROSÜLFÜR, HİDRATLANMIŞ %25'ten az kristalizasyon suyu içeren",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C6",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 294900,
	  "UN_NO__1": 2949
	},
	{
	  "BAKANLIK_KOD": 295000,
	  "UN_NO": 2950,
	  "ORİJİNAL İSİM": "MAGNEZYUM GRANÜLLERİ, KAPLANMIŞ, tane boyutu 149 mikrondan az olmayan",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 295000,
	  "UN_NO__1": 2950
	},
	{
	  "BAKANLIK_KOD": 295600,
	  "UN_NO": 2956,
	  "ORİJİNAL İSİM": "5-tert-BÜTİL-2,4,6-TRİNİTRO-m-KSİLEN (MİSK KSİLEN)",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "SR1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 295600,
	  "UN_NO__1": 2956
	},
	{
	  "BAKANLIK_KOD": 296500,
	  "UN_NO": 2965,
	  "ORİJİNAL İSİM": "BOR TRİFLORÜR DİMETİL ETERAT",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WFC",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 296500,
	  "UN_NO__1": 2965
	},
	{
	  "BAKANLIK_KOD": 296600,
	  "UN_NO": 2966,
	  "ORİJİNAL İSİM": "TİYOGLİKOL",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 296600,
	  "UN_NO__1": 2966
	},
	{
	  "BAKANLIK_KOD": 296700,
	  "UN_NO": 2967,
	  "ORİJİNAL İSİM": "SÜLFAMİK ASİT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 296700,
	  "UN_NO__1": 2967
	},
	{
	  "BAKANLIK_KOD": 296800,
	  "UN_NO": 2968,
	  "ORİJİNAL İSİM": "MANEB, STABİLİZE veya MANEB MÜSTAHZARI, STABİLİZE kendiliğinden ısınmaya karşı",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 296800,
	  "UN_NO__1": 2968
	},
	{
	  "BAKANLIK_KOD": 296900,
	  "UN_NO": 2969,
	  "ORİJİNAL İSİM": "HİNTYAĞI TOHUMU veya HİNTYAĞI KÜSPESİ veya HİNTYAĞI POSASI veya HİNTYAĞI PULCUĞU",
	  "SINIF": 9,
	  "SINIFLANDIRMA_KODU": "M11",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 296900,
	  "UN_NO__1": 2969
	},
	{
	  "BAKANLIK_KOD": 297700,
	  "UN_NO": 2977,
	  "ORİJİNAL İSİM": "RADYOAKTİF MALZEME, URANYUM HEKZAFLORÜR, BÖLÜNEBİLİR",
	  "SINIF": 7,
	  "SINIFLANDIRMA_KODU": "",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 297700,
	  "UN_NO__1": 2977
	},
	{
	  "BAKANLIK_KOD": 297800,
	  "UN_NO": 2978,
	  "ORİJİNAL İSİM": "RADYOAKTİF MALZEME, URANYUM HEKZAFLORÜR, bölünebilir olmayan veya istisnai bölünebilir",
	  "SINIF": 7,
	  "SINIFLANDIRMA_KODU": "",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 297800,
	  "UN_NO__1": 2978
	},
	{
	  "BAKANLIK_KOD": 298300,
	  "UN_NO": 2983,
	  "ORİJİNAL İSİM": "ETİLEN OKSİT VE PROPİLEN OKSİT KARIŞIMI %30'dan az etilen oksit içeren",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 298300,
	  "UN_NO__1": 2983
	},
	{
	  "BAKANLIK_KOD": 298400,
	  "UN_NO": 2984,
	  "ORİJİNAL İSİM": "HİDROJEN PEROKSİT, SULU ÇÖZELTİ hidrojen peroksit oranı %8'den fazla, ancak %20'den az (gerektiği gibi stabilize)",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 298400,
	  "UN_NO__1": 2984
	},
	{
	  "BAKANLIK_KOD": 298500,
	  "UN_NO": 2985,
	  "ORİJİNAL İSİM": "KLOROSİLANLAR, ALEVLENEBİLİR, AŞINDIRICI, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 298500,
	  "UN_NO__1": 2985
	},
	{
	  "BAKANLIK_KOD": 298600,
	  "UN_NO": 2986,
	  "ORİJİNAL İSİM": "KLOROSİLANLAR, AŞINDIRICI, ALEVLENEBİLİR, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CF1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 298600,
	  "UN_NO__1": 2986
	},
	{
	  "BAKANLIK_KOD": 298700,
	  "UN_NO": 2987,
	  "ORİJİNAL İSİM": "KLOROSİLANLAR, AŞINDIRICI, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 298700,
	  "UN_NO__1": 2987
	},
	{
	  "BAKANLIK_KOD": 298800,
	  "UN_NO": 2988,
	  "ORİJİNAL İSİM": "KLOROSİLANLAR, SU İLE TEPKİMEYE GİREN, ALEVLENEBİLİR, AŞINDIRICI, B.B.B.",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WFC",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 298800,
	  "UN_NO__1": 2988
	},
	{
	  "BAKANLIK_KOD": 298901,
	  "UN_NO": 2989,
	  "ORİJİNAL İSİM": "KURŞUN FOSFİT, DİBAZİK",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 298901,
	  "UN_NO__1": 2989
	},
	{
	  "BAKANLIK_KOD": 298902,
	  "UN_NO": 2989,
	  "ORİJİNAL İSİM": "KURŞUN FOSFİT, DİBAZİK",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 298902,
	  "UN_NO__1": 2989
	},
	{
	  "BAKANLIK_KOD": 299000,
	  "UN_NO": 2990,
	  "ORİJİNAL İSİM": "CAN KURTARICI ALETLER, KENDİLİĞİNDEN ŞİŞEN",
	  "SINIF": 9,
	  "SINIFLANDIRMA_KODU": "M5",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 299000,
	  "UN_NO__1": 2990
	},
	{
	  "BAKANLIK_KOD": 299101,
	  "UN_NO": 2991,
	  "ORİJİNAL İSİM": "KARBAMAT PESTİSİT, SIVI, ALEVLENEBİLİR, ZEHİRLİ, parlama noktası 23 °C'den düşük olmayan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 299101,
	  "UN_NO__1": 2991
	},
	{
	  "BAKANLIK_KOD": 299102,
	  "UN_NO": 2991,
	  "ORİJİNAL İSİM": "KARBAMAT PESTİSİT, SIVI, ALEVLENEBİLİR, ZEHİRLİ, parlama noktası 23 °C'den düşük olmayan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 299102,
	  "UN_NO__1": 2991
	},
	{
	  "BAKANLIK_KOD": 299103,
	  "UN_NO": 2991,
	  "ORİJİNAL İSİM": "KARBAMAT PESTİSİT, SIVI, ALEVLENEBİLİR, ZEHİRLİ, parlama noktası 23 °C'den düşük olmayan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 299103,
	  "UN_NO__1": 2991
	},
	{
	  "BAKANLIK_KOD": 299201,
	  "UN_NO": 2992,
	  "ORİJİNAL İSİM": "KARBAMAT PESTİSİT, SIVI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 299201,
	  "UN_NO__1": 2992
	},
	{
	  "BAKANLIK_KOD": 299202,
	  "UN_NO": 2992,
	  "ORİJİNAL İSİM": "KARBAMAT PESTİSİT, SIVI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 299202,
	  "UN_NO__1": 2992
	},
	{
	  "BAKANLIK_KOD": 299203,
	  "UN_NO": 2992,
	  "ORİJİNAL İSİM": "KARBAMAT PESTİSİT, SIVI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 299203,
	  "UN_NO__1": 2992
	},
	{
	  "BAKANLIK_KOD": 299301,
	  "UN_NO": 2993,
	  "ORİJİNAL İSİM": "ARSENİKLİ PESTİSİT, SIVI, ZEHİRLİ, ALEVLENEBİLİR, parlama noktası 23 °C'den düşük olmayan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 299301,
	  "UN_NO__1": 2993
	},
	{
	  "BAKANLIK_KOD": 299302,
	  "UN_NO": 2993,
	  "ORİJİNAL İSİM": "ARSENİKLİ PESTİSİT, SIVI, ZEHİRLİ, ALEVLENEBİLİR, parlama noktası 23 °C'den düşük olmayan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 299302,
	  "UN_NO__1": 2993
	},
	{
	  "BAKANLIK_KOD": 299303,
	  "UN_NO": 2993,
	  "ORİJİNAL İSİM": "ARSENİKLİ PESTİSİT, SIVI, ZEHİRLİ, ALEVLENEBİLİR, parlama noktası 23 °C'den düşük olmayan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 299303,
	  "UN_NO__1": 2993
	},
	{
	  "BAKANLIK_KOD": 299401,
	  "UN_NO": 2994,
	  "ORİJİNAL İSİM": "ARSENİKLİ PESTİSİT, SIVI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 299401,
	  "UN_NO__1": 2994
	},
	{
	  "BAKANLIK_KOD": 299402,
	  "UN_NO": 2994,
	  "ORİJİNAL İSİM": "ARSENİKLİ PESTİSİT, SIVI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 299402,
	  "UN_NO__1": 2994
	},
	{
	  "BAKANLIK_KOD": 299403,
	  "UN_NO": 2994,
	  "ORİJİNAL İSİM": "ARSENİKLİ PESTİSİT, SIVI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 299403,
	  "UN_NO__1": 2994
	},
	{
	  "BAKANLIK_KOD": 299501,
	  "UN_NO": 2995,
	  "ORİJİNAL İSİM": "ORGANOKLORLU PESTİSİT, SIVI, ZEHİRLİ, ALEVLENEBİLİR, parlama noktası 23 °C'den düşük olmayan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 299501,
	  "UN_NO__1": 2995
	},
	{
	  "BAKANLIK_KOD": 299502,
	  "UN_NO": 2995,
	  "ORİJİNAL İSİM": "ORGANOKLORLU PESTİSİT, SIVI, ZEHİRLİ, ALEVLENEBİLİR, parlama noktası 23 °C'den düşük olmayan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 299502,
	  "UN_NO__1": 2995
	},
	{
	  "BAKANLIK_KOD": 299503,
	  "UN_NO": 2995,
	  "ORİJİNAL İSİM": "ORGANOKLORLU PESTİSİT, SIVI, ZEHİRLİ, ALEVLENEBİLİR, parlama noktası 23 °C'den düşük olmayan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 299503,
	  "UN_NO__1": 2995
	},
	{
	  "BAKANLIK_KOD": 299601,
	  "UN_NO": 2996,
	  "ORİJİNAL İSİM": "ORGANOKLORLU PESTİSİT, SIVI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 299601,
	  "UN_NO__1": 2996
	},
	{
	  "BAKANLIK_KOD": 299602,
	  "UN_NO": 2996,
	  "ORİJİNAL İSİM": "ORGANOKLORLU PESTİSİT, SIVI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 299602,
	  "UN_NO__1": 2996
	},
	{
	  "BAKANLIK_KOD": 299603,
	  "UN_NO": 2996,
	  "ORİJİNAL İSİM": "ORGANOKLORLU PESTİSİT, SIVI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 299603,
	  "UN_NO__1": 2996
	},
	{
	  "BAKANLIK_KOD": 299701,
	  "UN_NO": 2997,
	  "ORİJİNAL İSİM": "TRİAZİN PESTİSİT, SIVI, ZEHİRLİ, ALEVLENEBİLİR, parlama noktası 23 °C'den düşük olmayan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 299701,
	  "UN_NO__1": 2997
	},
	{
	  "BAKANLIK_KOD": 299702,
	  "UN_NO": 2997,
	  "ORİJİNAL İSİM": "TRİAZİN PESTİSİT, SIVI, ZEHİRLİ, ALEVLENEBİLİR, parlama noktası 23 °C'den düşük olmayan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 299702,
	  "UN_NO__1": 2997
	},
	{
	  "BAKANLIK_KOD": 299703,
	  "UN_NO": 2997,
	  "ORİJİNAL İSİM": "TRİAZİN PESTİSİT, SIVI, ZEHİRLİ, ALEVLENEBİLİR, parlama noktası 23 °C'den düşük olmayan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 299703,
	  "UN_NO__1": 2997
	},
	{
	  "BAKANLIK_KOD": 299801,
	  "UN_NO": 2998,
	  "ORİJİNAL İSİM": "TRİAZİN PESTİSİT, SIVI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 299801,
	  "UN_NO__1": 2998
	},
	{
	  "BAKANLIK_KOD": 299802,
	  "UN_NO": 2998,
	  "ORİJİNAL İSİM": "TRİAZİN PESTİSİT, SIVI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 299802,
	  "UN_NO__1": 2998
	},
	{
	  "BAKANLIK_KOD": 299803,
	  "UN_NO": 2998,
	  "ORİJİNAL İSİM": "TRİAZİN PESTİSİT, SIVI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 299803,
	  "UN_NO__1": 2998
	},
	{
	  "BAKANLIK_KOD": 300501,
	  "UN_NO": 3005,
	  "ORİJİNAL İSİM": "TİYOKARBAMAT PESTİSİT, SIVI, ZEHİRLİ, ALEVLENEBİLİR, parlama noktası 23 °C'den düşük olmayan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 300501,
	  "UN_NO__1": 3005
	},
	{
	  "BAKANLIK_KOD": 300502,
	  "UN_NO": 3005,
	  "ORİJİNAL İSİM": "TİYOKARBAMAT PESTİSİT, SIVI, ZEHİRLİ, ALEVLENEBİLİR, parlama noktası 23 °C'den düşük olmayan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 300502,
	  "UN_NO__1": 3005
	},
	{
	  "BAKANLIK_KOD": 300503,
	  "UN_NO": 3005,
	  "ORİJİNAL İSİM": "TİYOKARBAMAT PESTİSİT, SIVI, ZEHİRLİ, ALEVLENEBİLİR, parlama noktası 23 °C'den düşük olmayan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 300503,
	  "UN_NO__1": 3005
	},
	{
	  "BAKANLIK_KOD": 300601,
	  "UN_NO": 3006,
	  "ORİJİNAL İSİM": "TİYOKARBAMAT PESTİSİT, SIVI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 300601,
	  "UN_NO__1": 3006
	},
	{
	  "BAKANLIK_KOD": 300602,
	  "UN_NO": 3006,
	  "ORİJİNAL İSİM": "TİYOKARBAMAT PESTİSİT, SIVI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 300602,
	  "UN_NO__1": 3006
	},
	{
	  "BAKANLIK_KOD": 300603,
	  "UN_NO": 3006,
	  "ORİJİNAL İSİM": "TİYOKARBAMAT PESTİSİT, SIVI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 300603,
	  "UN_NO__1": 3006
	},
	{
	  "BAKANLIK_KOD": 300901,
	  "UN_NO": 3009,
	  "ORİJİNAL İSİM": "BAKIR ESASLI PESTİSİT, SIVI, ZEHİRLİ, ALEVLENEBİLİR, parlama noktası 23 °C'den düşük değil",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 300901,
	  "UN_NO__1": 3009
	},
	{
	  "BAKANLIK_KOD": 300902,
	  "UN_NO": 3009,
	  "ORİJİNAL İSİM": "BAKIR ESASLI PESTİSİT, SIVI, ZEHİRLİ, ALEVLENEBİLİR, parlama noktası 23 °C'den düşük değil",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 300902,
	  "UN_NO__1": 3009
	},
	{
	  "BAKANLIK_KOD": 300903,
	  "UN_NO": 3009,
	  "ORİJİNAL İSİM": "BAKIR ESASLI PESTİSİT, SIVI, ZEHİRLİ, ALEVLENEBİLİR, parlama noktası 23 °C'den düşük değil",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 300903,
	  "UN_NO__1": 3009
	},
	{
	  "BAKANLIK_KOD": 301001,
	  "UN_NO": 3010,
	  "ORİJİNAL İSİM": "BAKIR ESASLI PESTİSİT, SIVI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 301001,
	  "UN_NO__1": 3010
	},
	{
	  "BAKANLIK_KOD": 301002,
	  "UN_NO": 3010,
	  "ORİJİNAL İSİM": "BAKIR ESASLI PESTİSİT, SIVI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 301002,
	  "UN_NO__1": 3010
	},
	{
	  "BAKANLIK_KOD": 301003,
	  "UN_NO": 3010,
	  "ORİJİNAL İSİM": "BAKIR ESASLI PESTİSİT, SIVI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 301003,
	  "UN_NO__1": 3010
	},
	{
	  "BAKANLIK_KOD": 301101,
	  "UN_NO": 3011,
	  "ORİJİNAL İSİM": "CIVA ESASLI PESTİSİT, SIVI, ZEHİRLİ, ALEVLENEBİLİR, parlama noktası 23 °C'den düşük olmayan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 301101,
	  "UN_NO__1": 3011
	},
	{
	  "BAKANLIK_KOD": 301102,
	  "UN_NO": 3011,
	  "ORİJİNAL İSİM": "CIVA ESASLI PESTİSİT, SIVI, ZEHİRLİ, ALEVLENEBİLİR, parlama noktası 23 °C'den düşük olmayan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 301102,
	  "UN_NO__1": 3011
	},
	{
	  "BAKANLIK_KOD": 301103,
	  "UN_NO": 3011,
	  "ORİJİNAL İSİM": "CIVA ESASLI PESTİSİT, SIVI, ZEHİRLİ, ALEVLENEBİLİR, \n parlama noktası 23 °C'den düşük olmayan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 301103,
	  "UN_NO__1": 3011
	},
	{
	  "BAKANLIK_KOD": 301201,
	  "UN_NO": 3012,
	  "ORİJİNAL İSİM": "CIVA ESASLI PESTİSİT, SIVI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 301201,
	  "UN_NO__1": 3012
	},
	{
	  "BAKANLIK_KOD": 301202,
	  "UN_NO": 3012,
	  "ORİJİNAL İSİM": "CIVA ESASLI PESTİSİT, SIVI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 301202,
	  "UN_NO__1": 3012
	},
	{
	  "BAKANLIK_KOD": 301203,
	  "UN_NO": 3012,
	  "ORİJİNAL İSİM": "CIVA ESASLI PESTİSİT, SIVI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 301203,
	  "UN_NO__1": 3012
	},
	{
	  "BAKANLIK_KOD": 301301,
	  "UN_NO": 3013,
	  "ORİJİNAL İSİM": "İKAMELİ NİTROFENOL PESTİSİT, SIVI, ZEHİRLİ, ALEVLENEBİLİR, parlama noktası 23 °C'den düşük olmayan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 301301,
	  "UN_NO__1": 3013
	},
	{
	  "BAKANLIK_KOD": 301302,
	  "UN_NO": 3013,
	  "ORİJİNAL İSİM": "İKAMELİ NİTROFENOL PESTİSİT, SIVI, ZEHİRLİ, ALEVLENEBİLİR, parlama noktası 23 °C'den düşük olmayan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 301302,
	  "UN_NO__1": 3013
	},
	{
	  "BAKANLIK_KOD": 301303,
	  "UN_NO": 3013,
	  "ORİJİNAL İSİM": "İKAMELİ NİTROFENOL PESTİSİT, SIVI, ZEHİRLİ, ALEVLENEBİLİR, parlama noktası 23 °C'den düşük olmayan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 301303,
	  "UN_NO__1": 3013
	},
	{
	  "BAKANLIK_KOD": 301401,
	  "UN_NO": 3014,
	  "ORİJİNAL İSİM": "İKAMELİ NİTROFENOL PESTİSİT, SIVI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 301401,
	  "UN_NO__1": 3014
	},
	{
	  "BAKANLIK_KOD": 301402,
	  "UN_NO": 3014,
	  "ORİJİNAL İSİM": "İKAMELİ NİTROFENOL PESTİSİT, SIVI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 301402,
	  "UN_NO__1": 3014
	},
	{
	  "BAKANLIK_KOD": 301403,
	  "UN_NO": 3014,
	  "ORİJİNAL İSİM": "İKAMELİ NİTROFENOL PESTİSİT, SIVI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 301403,
	  "UN_NO__1": 3014
	},
	{
	  "BAKANLIK_KOD": 301501,
	  "UN_NO": 3015,
	  "ORİJİNAL İSİM": "BİPİRİDİLYUM PESTİSİT, SIVI, ZEHİRLİ, ALEVLENEBİLİR,\n parlama noktası 23 °C'den düşük olmayan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 301501,
	  "UN_NO__1": 3015
	},
	{
	  "BAKANLIK_KOD": 301502,
	  "UN_NO": 3015,
	  "ORİJİNAL İSİM": "BİPİRİDİLYUM PESTİSİT, SIVI, ZEHİRLİ, ALEVLENEBİLİR, parlama noktası 23 °C'den düşük olmayan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 301502,
	  "UN_NO__1": 3015
	},
	{
	  "BAKANLIK_KOD": 301503,
	  "UN_NO": 3015,
	  "ORİJİNAL İSİM": "BİPİRİDİLYUM PESTİSİT, SIVI, ZEHİRLİ, ALEVLENEBİLİR, parlama noktası 23 °C'den düşük olmayan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 301503,
	  "UN_NO__1": 3015
	},
	{
	  "BAKANLIK_KOD": 301601,
	  "UN_NO": 3016,
	  "ORİJİNAL İSİM": "BİPİRİDİLYUM PESTİSİT, SIVI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 301601,
	  "UN_NO__1": 3016
	},
	{
	  "BAKANLIK_KOD": 301602,
	  "UN_NO": 3016,
	  "ORİJİNAL İSİM": "BİPİRİDİLYUM PESTİSİT, SIVI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 301602,
	  "UN_NO__1": 3016
	},
	{
	  "BAKANLIK_KOD": 301603,
	  "UN_NO": 3016,
	  "ORİJİNAL İSİM": "BİPİRİDİLYUM PESTİSİT, SIVI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 301603,
	  "UN_NO__1": 3016
	},
	{
	  "BAKANLIK_KOD": 301701,
	  "UN_NO": 3017,
	  "ORİJİNAL İSİM": "ORGANOFOSFORLU PESTİSİT, SIVI, ZEHİRLİ, ALEVLENEBİLİR, parlama noktası 23 °C'den düşük olmayan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 301701,
	  "UN_NO__1": 3017
	},
	{
	  "BAKANLIK_KOD": 301702,
	  "UN_NO": 3017,
	  "ORİJİNAL İSİM": "ORGANOFOSFORLU PESTİSİT, SIVI, ZEHİRLİ, ALEVLENEBİLİR, parlama noktası 23 °C'den düşük olmayan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 301702,
	  "UN_NO__1": 3017
	},
	{
	  "BAKANLIK_KOD": 301703,
	  "UN_NO": 3017,
	  "ORİJİNAL İSİM": "ORGANOFOSFORLU PESTİSİT, SIVI, ZEHİRLİ, ALEVLENEBİLİR, parlama noktası 23 °C'den düşük olmayan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 301703,
	  "UN_NO__1": 3017
	},
	{
	  "BAKANLIK_KOD": 301801,
	  "UN_NO": 3018,
	  "ORİJİNAL İSİM": "ORGANOFOSFORLU PESTİSİT, SIVI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 301801,
	  "UN_NO__1": 3018
	},
	{
	  "BAKANLIK_KOD": 301802,
	  "UN_NO": 3018,
	  "ORİJİNAL İSİM": "ORGANOFOSFORLU PESTİSİT, SIVI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 301802,
	  "UN_NO__1": 3018
	},
	{
	  "BAKANLIK_KOD": 301803,
	  "UN_NO": 3018,
	  "ORİJİNAL İSİM": "ORGANOFOSFORLU PESTİSİT, SIVI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 301803,
	  "UN_NO__1": 3018
	},
	{
	  "BAKANLIK_KOD": 301901,
	  "UN_NO": 3019,
	  "ORİJİNAL İSİM": "ORGANOTİN PESTİSİT, SIVI, ZEHİRLİ, ALEVLENEBİLİR, parlama noktası 23 °C'den düşük olmayan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 301901,
	  "UN_NO__1": 3019
	},
	{
	  "BAKANLIK_KOD": 301902,
	  "UN_NO": 3019,
	  "ORİJİNAL İSİM": "ORGANOTİN PESTİSİT, SIVI, ZEHİRLİ, ALEVLENEBİLİR, parlama noktası 23 °C'den düşük olmayan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 301902,
	  "UN_NO__1": 3019
	},
	{
	  "BAKANLIK_KOD": 301903,
	  "UN_NO": 3019,
	  "ORİJİNAL İSİM": "ORGANOTİN PESTİSİT, SIVI, ZEHİRLİ, ALEVLENEBİLİR, parlama noktası 23 °C'den düşük olmayan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 301903,
	  "UN_NO__1": 3019
	},
	{
	  "BAKANLIK_KOD": 302001,
	  "UN_NO": 3020,
	  "ORİJİNAL İSİM": "ORGANOTİN PESTİSİT, SIVI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 302001,
	  "UN_NO__1": 3020
	},
	{
	  "BAKANLIK_KOD": 302002,
	  "UN_NO": 3020,
	  "ORİJİNAL İSİM": "ORGANOTİN PESTİSİT, SIVI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 302002,
	  "UN_NO__1": 3020
	},
	{
	  "BAKANLIK_KOD": 302003,
	  "UN_NO": 3020,
	  "ORİJİNAL İSİM": "ORGANOTİN PESTİSİT, SIVI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 302003,
	  "UN_NO__1": 3020
	},
	{
	  "BAKANLIK_KOD": 302101,
	  "UN_NO": 3021,
	  "ORİJİNAL İSİM": "PESTİSİT, SIVI, ALEVLENEBİLİR, ZEHİRLİ, B.B.B., parlama noktası 23 °C'den düşük olan",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 302101,
	  "UN_NO__1": 3021
	},
	{
	  "BAKANLIK_KOD": 302102,
	  "UN_NO": 3021,
	  "ORİJİNAL İSİM": "PESTİSİT, SIVI, ALEVLENEBİLİR, ZEHİRLİ, B.B.B., parlama noktası 23 °C'den düşük olan",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 302102,
	  "UN_NO__1": 3021
	},
	{
	  "BAKANLIK_KOD": 302200,
	  "UN_NO": 3022,
	  "ORİJİNAL İSİM": "1,2-BÜTİLEN OKSİT, STABİLİZE",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 302200,
	  "UN_NO__1": 3022
	},
	{
	  "BAKANLIK_KOD": 302300,
	  "UN_NO": 3023,
	  "ORİJİNAL İSİM": "2-METİL-2-HEPTANTİYOL",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 302300,
	  "UN_NO__1": 3023
	},
	{
	  "BAKANLIK_KOD": 302401,
	  "UN_NO": 3024,
	  "ORİJİNAL İSİM": "KUMARİN TÜREVLİ PESTİSİT, SIVI, ALEVLENEBİLİR, ZEHİRLİ, parlama noktası 23 °C'den düşük olan",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 302401,
	  "UN_NO__1": 3024
	},
	{
	  "BAKANLIK_KOD": 302402,
	  "UN_NO": 3024,
	  "ORİJİNAL İSİM": "KUMARİN TÜREVLİ PESTİSİT, SIVI, ALEVLENEBİLİR, ZEHİRLİ, parlama noktası 23 °C'den düşük olan",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 302402,
	  "UN_NO__1": 3024
	},
	{
	  "BAKANLIK_KOD": 302501,
	  "UN_NO": 3025,
	  "ORİJİNAL İSİM": "KUMARİN TÜREVLİ PESTİSİT, ALEVLENEBİLİR, SIVI, ZEHİRLİ, parlama noktası 23 °C'den düşük olmayan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 302501,
	  "UN_NO__1": 3025
	},
	{
	  "BAKANLIK_KOD": 302502,
	  "UN_NO": 3025,
	  "ORİJİNAL İSİM": "KUMARİN TÜREVLİ PESTİSİT, ALEVLENEBİLİR, SIVI, ZEHİRLİ, parlama noktası 23 °C'den düşük olmayan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 302502,
	  "UN_NO__1": 3025
	},
	{
	  "BAKANLIK_KOD": 302503,
	  "UN_NO": 3025,
	  "ORİJİNAL İSİM": "KUMARİN TÜREVLİ PESTİSİT, ALEVLENEBİLİR, SIVI, ZEHİRLİ, parlama noktası 23 °C'den düşük olmayan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 302503,
	  "UN_NO__1": 3025
	},
	{
	  "BAKANLIK_KOD": 302601,
	  "UN_NO": 3026,
	  "ORİJİNAL İSİM": "KUMARİN TÜREVLİ PESTİSİT, SIVI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 302601,
	  "UN_NO__1": 3026
	},
	{
	  "BAKANLIK_KOD": 302602,
	  "UN_NO": 3026,
	  "ORİJİNAL İSİM": "KUMARİN TÜREVLİ PESTİSİT, SIVI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 302602,
	  "UN_NO__1": 3026
	},
	{
	  "BAKANLIK_KOD": 302603,
	  "UN_NO": 3026,
	  "ORİJİNAL İSİM": "KUMARİN TÜREVLİ PESTİSİT, SIVI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 302603,
	  "UN_NO__1": 3026
	},
	{
	  "BAKANLIK_KOD": 302701,
	  "UN_NO": 3027,
	  "ORİJİNAL İSİM": "KUMARİN TÜREVLİ PESTİSİT, KATI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 302701,
	  "UN_NO__1": 3027
	},
	{
	  "BAKANLIK_KOD": 302702,
	  "UN_NO": 3027,
	  "ORİJİNAL İSİM": "KUMARİN TÜREVLİ PESTİSİT, KATI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 302702,
	  "UN_NO__1": 3027
	},
	{
	  "BAKANLIK_KOD": 302703,
	  "UN_NO": 3027,
	  "ORİJİNAL İSİM": "KUMARİN TÜREVLİ PESTİSİT, KATI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 302703,
	  "UN_NO__1": 3027
	},
	{
	  "BAKANLIK_KOD": 302800,
	  "UN_NO": 3028,
	  "ORİJİNAL İSİM": "AKÜLER, KURU, POTASYUM HİDROKSİT İÇEREN, KATI, elektrik depolama",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C11",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 302800,
	  "UN_NO__1": 3028
	},
	{
	  "BAKANLIK_KOD": 304800,
	  "UN_NO": 3048,
	  "ORİJİNAL İSİM": "ALÜMİNYUM FOSFÜR PESTİSİT",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 304800,
	  "UN_NO__1": 3048
	},
	{
	  "BAKANLIK_KOD": 305400,
	  "UN_NO": 3054,
	  "ORİJİNAL İSİM": "SİKLOHEKZİL MERKAPTAN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 305400,
	  "UN_NO__1": 3054
	},
	{
	  "BAKANLIK_KOD": 305500,
	  "UN_NO": 3055,
	  "ORİJİNAL İSİM": "2-(2-AMİNOETOKSİ) ETANOL",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C7",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 305500,
	  "UN_NO__1": 3055
	},
	{
	  "BAKANLIK_KOD": 305600,
	  "UN_NO": 3056,
	  "ORİJİNAL İSİM": "n-HEPTALDEHİT",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 305600,
	  "UN_NO__1": 3056
	},
	{
	  "BAKANLIK_KOD": 305700,
	  "UN_NO": 3057,
	  "ORİJİNAL İSİM": "TRİFLOROASETİL KLORÜR",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 305700,
	  "UN_NO__1": 3057
	},
	{
	  "BAKANLIK_KOD": 306400,
	  "UN_NO": 3064,
	  "ORİJİNAL İSİM": "NİTROGLİSERİN ÇÖZELTİSİ ALKOLDE %1'den fazla ama %5'ten daha az nitrogliserin içeren",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "D",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 306400,
	  "UN_NO__1": 3064
	},
	{
	  "BAKANLIK_KOD": 306501,
	  "UN_NO": 3065,
	  "ORİJİNAL İSİM": "ALKOLLÜ İÇKİLER, hacimce %70'den fazla alkol içeren",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 306501,
	  "UN_NO__1": 3065
	},
	{
	  "BAKANLIK_KOD": 306502,
	  "UN_NO": 3065,
	  "ORİJİNAL İSİM": "ALKOLLÜ İÇKİLER, hacimce %24'ten fazla ancak %70'ten az alkol içeren",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 306502,
	  "UN_NO__1": 3065
	},
	{
	  "BAKANLIK_KOD": 306601,
	  "UN_NO": 3066,
	  "ORİJİNAL İSİM": "BOYA (boya, vernik, emaye, renklendirici, lake, cila, parlatıcı, sıvı dolgu ve sıvı vernik bazı dahil) veya BOYA İLE İLGİLİ MALZEME (boya inceltici veya azaltıcı bileşiği dahil)",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C9",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 306601,
	  "UN_NO__1": 3066
	},
	{
	  "BAKANLIK_KOD": 306602,
	  "UN_NO": 3066,
	  "ORİJİNAL İSİM": "BOYA (boya, vernik, emaye, renklendirici, lake, cila, parlatıcı, sıvı dolgu ve sıvı vernik bazı dahil) veya BOYA İLE İLGİLİ MALZEME (boya inceltici veya azaltıcı bileşiği dahil)",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C9",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 306602,
	  "UN_NO__1": 3066
	},
	{
	  "BAKANLIK_KOD": 307000,
	  "UN_NO": 3070,
	  "ORİJİNAL İSİM": "ETİLEN OKSİT VE DİKLORODİFLORO-METAN KARIŞIMI %12,5'ten az etilen oksit içeren",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 307000,
	  "UN_NO__1": 3070
	},
	{
	  "BAKANLIK_KOD": 307100,
	  "UN_NO": 3071,
	  "ORİJİNAL İSİM": "MERKAPTANLAR, SIVI, ZEHİRLİ, ALEVLENEBİLİR, B.B.B. veya MERKAPTAN KARIŞIMI, SIVI, ZEHİRLİ, ALEVLENEBİLİR, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 307100,
	  "UN_NO__1": 3071
	},
	{
	  "BAKANLIK_KOD": 307200,
	  "UN_NO": 3072,
	  "ORİJİNAL İSİM": "CAN KURTARICI ALETLER KENDİLİĞİNDEN ŞİŞMEYEN teçhizat olarak tehlikeli maddeler içeren",
	  "SINIF": 9,
	  "SINIFLANDIRMA_KODU": "M5",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 307200,
	  "UN_NO__1": 3072
	},
	{
	  "BAKANLIK_KOD": 307300,
	  "UN_NO": 3073,
	  "ORİJİNAL İSİM": "VİNİLPİRİDİNLER, STABİLİZE",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TFC",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 307300,
	  "UN_NO__1": 3073
	},
	{
	  "BAKANLIK_KOD": 307700,
	  "UN_NO": 3077,
	  "ORİJİNAL İSİM": "ÇEVREYE ZARARLI MADDE, KATI, B.B.B.",
	  "SINIF": 9,
	  "SINIFLANDIRMA_KODU": "M7",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 307700,
	  "UN_NO__1": 3077
	},
	{
	  "BAKANLIK_KOD": 307800,
	  "UN_NO": 3078,
	  "ORİJİNAL İSİM": "SERYUM, talaş veya kumlu toz",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 307800,
	  "UN_NO__1": 3078
	},
	{
	  "BAKANLIK_KOD": 307900,
	  "UN_NO": 3079,
	  "ORİJİNAL İSİM": "METAKRİLONİTRİL, STABİLİZE",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 307900,
	  "UN_NO__1": 3079
	},
	{
	  "BAKANLIK_KOD": 308000,
	  "UN_NO": 3080,
	  "ORİJİNAL İSİM": "İZOSİYANATLAR, ZEHİRLİ, ALEVLENEBİLİR, B.B.B. veya İZOSİYANAT ÇÖZELTİSİ, ZEHİRLİ, ALEVLENEBİLİR, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 308000,
	  "UN_NO__1": 3080
	},
	{
	  "BAKANLIK_KOD": 308200,
	  "UN_NO": 3082,
	  "ORİJİNAL İSİM": "ÇEVREYE ZARARLI MADDE, SIVI, B.B.B.",
	  "SINIF": 9,
	  "SINIFLANDIRMA_KODU": "M6",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 308200,
	  "UN_NO__1": 3082
	},
	{
	  "BAKANLIK_KOD": 308300,
	  "UN_NO": 3083,
	  "ORİJİNAL İSİM": "PERKLORİL FLORÜR",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TO",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 308300,
	  "UN_NO__1": 3083
	},
	{
	  "BAKANLIK_KOD": 308401,
	  "UN_NO": 3084,
	  "ORİJİNAL İSİM": "AŞINDIRICI KATI, YÜKSELTGEN, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CO2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 308401,
	  "UN_NO__1": 3084
	},
	{
	  "BAKANLIK_KOD": 308402,
	  "UN_NO": 3084,
	  "ORİJİNAL İSİM": "AŞINDIRICI KATI, YÜKSELTGEN, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CO2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 308402,
	  "UN_NO__1": 3084
	},
	{
	  "BAKANLIK_KOD": 308501,
	  "UN_NO": 3085,
	  "ORİJİNAL İSİM": "YÜKSELTGEN KATI, AŞINDIRICI, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OC2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 308501,
	  "UN_NO__1": 3085
	},
	{
	  "BAKANLIK_KOD": 308502,
	  "UN_NO": 3085,
	  "ORİJİNAL İSİM": "YÜKSELTGEN KATI, AŞINDIRICI, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OC2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 308502,
	  "UN_NO__1": 3085
	},
	{
	  "BAKANLIK_KOD": 308503,
	  "UN_NO": 3085,
	  "ORİJİNAL İSİM": "YÜKSELTGEN KATI, AŞINDIRICI, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OC2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 308503,
	  "UN_NO__1": 3085
	},
	{
	  "BAKANLIK_KOD": 308601,
	  "UN_NO": 3086,
	  "ORİJİNAL İSİM": "ZEHİRLİ KATI, YÜKSELTGEN, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TO2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 308601,
	  "UN_NO__1": 3086
	},
	{
	  "BAKANLIK_KOD": 308602,
	  "UN_NO": 3086,
	  "ORİJİNAL İSİM": "ZEHİRLİ KATI, YÜKSELTGEN, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TO2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 308602,
	  "UN_NO__1": 3086
	},
	{
	  "BAKANLIK_KOD": 308701,
	  "UN_NO": 3087,
	  "ORİJİNAL İSİM": "YÜKSELTGEN KATI, ZEHİRLİ, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OT2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 308701,
	  "UN_NO__1": 3087
	},
	{
	  "BAKANLIK_KOD": 308702,
	  "UN_NO": 3087,
	  "ORİJİNAL İSİM": "YÜKSELTGEN KATI, ZEHİRLİ, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OT2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 308702,
	  "UN_NO__1": 3087
	},
	{
	  "BAKANLIK_KOD": 308703,
	  "UN_NO": 3087,
	  "ORİJİNAL İSİM": "YÜKSELTGEN KATI, ZEHİRLİ, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OT2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 308703,
	  "UN_NO__1": 3087
	},
	{
	  "BAKANLIK_KOD": 308801,
	  "UN_NO": 3088,
	  "ORİJİNAL İSİM": "KENDİLİĞİNDEN ISINAN KATI, ORGANİK, B.B.B.",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 308801,
	  "UN_NO__1": 3088
	},
	{
	  "BAKANLIK_KOD": 308802,
	  "UN_NO": 3088,
	  "ORİJİNAL İSİM": "KENDİLİĞİNDEN ISINAN KATI, ORGANİK, B.B.B.",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 308802,
	  "UN_NO__1": 3088
	},
	{
	  "BAKANLIK_KOD": 308901,
	  "UN_NO": 3089,
	  "ORİJİNAL İSİM": "METAL TOZU, ALEVLENEBİLİR, B.B.B.",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 308901,
	  "UN_NO__1": 3089
	},
	{
	  "BAKANLIK_KOD": 308902,
	  "UN_NO": 3089,
	  "ORİJİNAL İSİM": "METAL TOZU, ALEVLENEBİLİR, B.B.B.",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 308902,
	  "UN_NO__1": 3089
	},
	{
	  "BAKANLIK_KOD": 309000,
	  "UN_NO": 3090,
	  "ORİJİNAL İSİM": "LİTYUM METAL BATARYALAR (lityum alaşımlı bataryalar dahil)",
	  "SINIF": 9,
	  "SINIFLANDIRMA_KODU": "M4",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 309000,
	  "UN_NO__1": 3090
	},
	{
	  "BAKANLIK_KOD": 309100,
	  "UN_NO": 3091,
	  "ORİJİNAL İSİM": "LİTYUM METAL BATARYALAR TEÇHİZAT İÇERİSİNDE veya LİTYUM METAL BATARYALAR TEÇHİZATLI AMBALAJLANMIŞ (lityum alaşımlı bataryalar dahil)",
	  "SINIF": 9,
	  "SINIFLANDIRMA_KODU": "M4",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 309100,
	  "UN_NO__1": 3091
	},
	{
	  "BAKANLIK_KOD": 309200,
	  "UN_NO": 3092,
	  "ORİJİNAL İSİM": "1-METOKSİ-2-PROPANOL",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 309200,
	  "UN_NO__1": 3092
	},
	{
	  "BAKANLIK_KOD": 309301,
	  "UN_NO": 3093,
	  "ORİJİNAL İSİM": "AŞINDIRICI SIVI, YÜKSELTGEN, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CO1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 309301,
	  "UN_NO__1": 3093
	},
	{
	  "BAKANLIK_KOD": 309302,
	  "UN_NO": 3093,
	  "ORİJİNAL İSİM": "AŞINDIRICI SIVI, YÜKSELTGEN, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CO1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 309302,
	  "UN_NO__1": 3093
	},
	{
	  "BAKANLIK_KOD": 309401,
	  "UN_NO": 3094,
	  "ORİJİNAL İSİM": "AŞINDIRICI SIVI, SU İLE TEPKİMEYE GİREN, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CW1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 309401,
	  "UN_NO__1": 3094
	},
	{
	  "BAKANLIK_KOD": 309402,
	  "UN_NO": 3094,
	  "ORİJİNAL İSİM": "AŞINDIRICI SIVI, SU İLE TEPKİMEYE GİREN, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CW1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 309402,
	  "UN_NO__1": 3094
	},
	{
	  "BAKANLIK_KOD": 309501,
	  "UN_NO": 3095,
	  "ORİJİNAL İSİM": "AŞINDIRICI KATI, KENDİLİĞİNDEN ISINAN, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CS2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 309501,
	  "UN_NO__1": 3095
	},
	{
	  "BAKANLIK_KOD": 309502,
	  "UN_NO": 3095,
	  "ORİJİNAL İSİM": "AŞINDIRICI KATI, KENDİLİĞİNDEN ISINAN, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CS2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 309502,
	  "UN_NO__1": 3095
	},
	{
	  "BAKANLIK_KOD": 309601,
	  "UN_NO": 3096,
	  "ORİJİNAL İSİM": "AŞINDIRICI KATI, SU İLE TEPKİMEYE GİREN, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CW2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 309601,
	  "UN_NO__1": 3096
	},
	{
	  "BAKANLIK_KOD": 309602,
	  "UN_NO": 3096,
	  "ORİJİNAL İSİM": "AŞINDIRICI KATI, SU İLE TEPKİMEYE GİREN, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CW2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 309602,
	  "UN_NO__1": 3096
	},
	{
	  "BAKANLIK_KOD": 309801,
	  "UN_NO": 3098,
	  "ORİJİNAL İSİM": "YÜKSELTGEN SIVI, AŞINDIRICI, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OC1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 309801,
	  "UN_NO__1": 3098
	},
	{
	  "BAKANLIK_KOD": 309802,
	  "UN_NO": 3098,
	  "ORİJİNAL İSİM": "YÜKSELTGEN SIVI, AŞINDIRICI, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OC1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 309802,
	  "UN_NO__1": 3098
	},
	{
	  "BAKANLIK_KOD": 309803,
	  "UN_NO": 3098,
	  "ORİJİNAL İSİM": "YÜKSELTGEN SIVI, AŞINDIRICI, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OC1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 309803,
	  "UN_NO__1": 3098
	},
	{
	  "BAKANLIK_KOD": 309901,
	  "UN_NO": 3099,
	  "ORİJİNAL İSİM": "YÜKSELTGEN SIVI, ZEHİRLİ, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OT1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 309901,
	  "UN_NO__1": 3099
	},
	{
	  "BAKANLIK_KOD": 309902,
	  "UN_NO": 3099,
	  "ORİJİNAL İSİM": "YÜKSELTGEN SIVI, ZEHİRLİ, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OT1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 309902,
	  "UN_NO__1": 3099
	},
	{
	  "BAKANLIK_KOD": 309903,
	  "UN_NO": 3099,
	  "ORİJİNAL İSİM": "YÜKSELTGEN SIVI, ZEHİRLİ, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OT1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 309903,
	  "UN_NO__1": 3099
	},
	{
	  "BAKANLIK_KOD": 310100,
	  "UN_NO": 3101,
	  "ORİJİNAL İSİM": "ORGANİK PEROKSİT TİP B, SIVI",
	  "SINIF": 5.2,
	  "SINIFLANDIRMA_KODU": "P1",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 310100,
	  "UN_NO__1": 3101
	},
	{
	  "BAKANLIK_KOD": 310200,
	  "UN_NO": 3102,
	  "ORİJİNAL İSİM": "ORGANİK PEROKSİT TİP B, KATI",
	  "SINIF": 5.2,
	  "SINIFLANDIRMA_KODU": "P1",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 310200,
	  "UN_NO__1": 3102
	},
	{
	  "BAKANLIK_KOD": 310300,
	  "UN_NO": 3103,
	  "ORİJİNAL İSİM": "ORGANİK PEROKSİT TİP C, SIVI",
	  "SINIF": 5.2,
	  "SINIFLANDIRMA_KODU": "P1",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 310300,
	  "UN_NO__1": 3103
	},
	{
	  "BAKANLIK_KOD": 310400,
	  "UN_NO": 3104,
	  "ORİJİNAL İSİM": "ORGANİK PEROKSİT TİP C, KATI",
	  "SINIF": 5.2,
	  "SINIFLANDIRMA_KODU": "P1",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 310400,
	  "UN_NO__1": 3104
	},
	{
	  "BAKANLIK_KOD": 310500,
	  "UN_NO": 3105,
	  "ORİJİNAL İSİM": "ORGANİK PEROKSİT TİP D, SIVI",
	  "SINIF": 5.2,
	  "SINIFLANDIRMA_KODU": "P1",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 310500,
	  "UN_NO__1": 3105
	},
	{
	  "BAKANLIK_KOD": 310600,
	  "UN_NO": 3106,
	  "ORİJİNAL İSİM": "ORGANİK PEROKSİT TİP D, KATI",
	  "SINIF": 5.2,
	  "SINIFLANDIRMA_KODU": "P1",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 310600,
	  "UN_NO__1": 3106
	},
	{
	  "BAKANLIK_KOD": 310700,
	  "UN_NO": 3107,
	  "ORİJİNAL İSİM": "ORGANİK PEROKSİT TİP E, SIVI",
	  "SINIF": 5.2,
	  "SINIFLANDIRMA_KODU": "P1",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 310700,
	  "UN_NO__1": 3107
	},
	{
	  "BAKANLIK_KOD": 310800,
	  "UN_NO": 3108,
	  "ORİJİNAL İSİM": "ORGANİK PEROKSİT TİP E, KATI",
	  "SINIF": 5.2,
	  "SINIFLANDIRMA_KODU": "P1",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 310800,
	  "UN_NO__1": 3108
	},
	{
	  "BAKANLIK_KOD": 310900,
	  "UN_NO": 3109,
	  "ORİJİNAL İSİM": "ORGANİK PEROKSİT TİP F, SIVI",
	  "SINIF": 5.2,
	  "SINIFLANDIRMA_KODU": "P1",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 310900,
	  "UN_NO__1": 3109
	},
	{
	  "BAKANLIK_KOD": 311000,
	  "UN_NO": 3110,
	  "ORİJİNAL İSİM": "ORGANİK PEROKSİT TİP F, KATI",
	  "SINIF": 5.2,
	  "SINIFLANDIRMA_KODU": "P1",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 311000,
	  "UN_NO__1": 3110
	},
	{
	  "BAKANLIK_KOD": 311100,
	  "UN_NO": 3111,
	  "ORİJİNAL İSİM": "ORGANİK PEROKSİT TİP B, SIVI, SICAKLIK KONTROLLÜ",
	  "SINIF": 5.2,
	  "SINIFLANDIRMA_KODU": "P2",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 311100,
	  "UN_NO__1": 3111
	},
	{
	  "BAKANLIK_KOD": 311200,
	  "UN_NO": 3112,
	  "ORİJİNAL İSİM": "ORGANİK PEROKSİT TİP B, KATI, SICAKLIK KONTROLLÜ",
	  "SINIF": 5.2,
	  "SINIFLANDIRMA_KODU": "P2",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 311200,
	  "UN_NO__1": 3112
	},
	{
	  "BAKANLIK_KOD": 311300,
	  "UN_NO": 3113,
	  "ORİJİNAL İSİM": "ORGANİK PEROKSİT TİP C, SIVI, SICAKLIK KONTROLLÜ",
	  "SINIF": 5.2,
	  "SINIFLANDIRMA_KODU": "P2",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 311300,
	  "UN_NO__1": 3113
	},
	{
	  "BAKANLIK_KOD": 311400,
	  "UN_NO": 3114,
	  "ORİJİNAL İSİM": "ORGANİK PEROKSİT TİP C, KATI, SICAKLIK KONTROLLÜ",
	  "SINIF": 5.2,
	  "SINIFLANDIRMA_KODU": "P2",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 311400,
	  "UN_NO__1": 3114
	},
	{
	  "BAKANLIK_KOD": 311500,
	  "UN_NO": 3115,
	  "ORİJİNAL İSİM": "ORGANİK PEROKSİT TİP D, SIVI, SICAKLIK KONTROLLÜ",
	  "SINIF": 5.2,
	  "SINIFLANDIRMA_KODU": "P2",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 311500,
	  "UN_NO__1": 3115
	},
	{
	  "BAKANLIK_KOD": 311600,
	  "UN_NO": 3116,
	  "ORİJİNAL İSİM": "ORGANİK PEROKSİT TİP D, KATI, SICAKLIK KONTROLLÜ",
	  "SINIF": 5.2,
	  "SINIFLANDIRMA_KODU": "P2",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 311600,
	  "UN_NO__1": 3116
	},
	{
	  "BAKANLIK_KOD": 311700,
	  "UN_NO": 3117,
	  "ORİJİNAL İSİM": "ORGANİK PEROKSİT TİP E, SIVI, SICAKLIK KONTROLLÜ",
	  "SINIF": 5.2,
	  "SINIFLANDIRMA_KODU": "P2",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 311700,
	  "UN_NO__1": 3117
	},
	{
	  "BAKANLIK_KOD": 311800,
	  "UN_NO": 3118,
	  "ORİJİNAL İSİM": "ORGANİK PEROKSİT TİP E, KATI, SICAKLIK KONTROLLÜ",
	  "SINIF": 5.2,
	  "SINIFLANDIRMA_KODU": "P2",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 311800,
	  "UN_NO__1": 3118
	},
	{
	  "BAKANLIK_KOD": 311900,
	  "UN_NO": 3119,
	  "ORİJİNAL İSİM": "ORGANİK PEROKSİT TİP F, SIVI, SICAKLIK KONTROLLÜ",
	  "SINIF": 5.2,
	  "SINIFLANDIRMA_KODU": "P2",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 311900,
	  "UN_NO__1": 3119
	},
	{
	  "BAKANLIK_KOD": 312000,
	  "UN_NO": 3120,
	  "ORİJİNAL İSİM": "ORGANİK PEROKSİT TİP F, KATI, SICAKLIK KONTROLLÜ",
	  "SINIF": 5.2,
	  "SINIFLANDIRMA_KODU": "P2",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 312000,
	  "UN_NO__1": 3120
	},
	{
	  "BAKANLIK_KOD": 312201,
	  "UN_NO": 3122,
	  "ORİJİNAL İSİM": "ZEHİRLİ SIVI, YÜKSELTGEN, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TO1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 312201,
	  "UN_NO__1": 3122
	},
	{
	  "BAKANLIK_KOD": 312202,
	  "UN_NO": 3122,
	  "ORİJİNAL İSİM": "ZEHİRLİ SIVI, YÜKSELTGEN, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TO1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 312202,
	  "UN_NO__1": 3122
	},
	{
	  "BAKANLIK_KOD": 312301,
	  "UN_NO": 3123,
	  "ORİJİNAL İSİM": "ZEHİRLİ SIVI, SU İLE TEPKİMEYE GİREN, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TW1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 312301,
	  "UN_NO__1": 3123
	},
	{
	  "BAKANLIK_KOD": 312302,
	  "UN_NO": 3123,
	  "ORİJİNAL İSİM": "ZEHİRLİ SIVI, SU İLE TEPKİMEYE GİREN, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TW1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 312302,
	  "UN_NO__1": 3123
	},
	{
	  "BAKANLIK_KOD": 312401,
	  "UN_NO": 3124,
	  "ORİJİNAL İSİM": "ZEHİRLİ KATI, KENDİLİĞİNDEN ISINAN, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TS",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 312401,
	  "UN_NO__1": 3124
	},
	{
	  "BAKANLIK_KOD": 312402,
	  "UN_NO": 3124,
	  "ORİJİNAL İSİM": "ZEHİRLİ KATI, KENDİLİĞİNDEN ISINAN, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TS",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 312402,
	  "UN_NO__1": 3124
	},
	{
	  "BAKANLIK_KOD": 312501,
	  "UN_NO": 3125,
	  "ORİJİNAL İSİM": "ZEHİRLİ KATI, SU İLE TEPKİMEYE GİREN, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TW2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 312501,
	  "UN_NO__1": 3125
	},
	{
	  "BAKANLIK_KOD": 312502,
	  "UN_NO": 3125,
	  "ORİJİNAL İSİM": "ZEHİRLİ KATI, SU İLE TEPKİMEYE GİREN, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TW2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 312502,
	  "UN_NO__1": 3125
	},
	{
	  "BAKANLIK_KOD": 312601,
	  "UN_NO": 3126,
	  "ORİJİNAL İSİM": "KENDİLİĞİNDEN ISINAN KATI, AŞINDIRICI, ORGANİK, B.B.B.",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "SC2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 312601,
	  "UN_NO__1": 3126
	},
	{
	  "BAKANLIK_KOD": 312602,
	  "UN_NO": 3126,
	  "ORİJİNAL İSİM": "KENDİLİĞİNDEN ISINAN KATI, AŞINDIRICI, ORGANİK, B.B.B.",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "SC2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 312602,
	  "UN_NO__1": 3126
	},
	{
	  "BAKANLIK_KOD": 312801,
	  "UN_NO": 3128,
	  "ORİJİNAL İSİM": "KENDİLİĞİNDEN ISINAN KATI, ZEHİRLİ, ORGANİK, B.B.B.",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "ST2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 312801,
	  "UN_NO__1": 3128
	},
	{
	  "BAKANLIK_KOD": 312802,
	  "UN_NO": 3128,
	  "ORİJİNAL İSİM": "KENDİLİĞİNDEN ISINAN KATI, ZEHİRLİ, ORGANİK, B.B.B.",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "ST2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 312802,
	  "UN_NO__1": 3128
	},
	{
	  "BAKANLIK_KOD": 312901,
	  "UN_NO": 3129,
	  "ORİJİNAL İSİM": "SU İLE TEPKİMEYE GİREN SIVI, AŞINDIRICI, B.B.B.",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WC1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 312901,
	  "UN_NO__1": 3129
	},
	{
	  "BAKANLIK_KOD": 312902,
	  "UN_NO": 3129,
	  "ORİJİNAL İSİM": "SU İLE TEPKİMEYE GİREN SIVI, AŞINDIRICI, B.B.B.",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WC1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 312902,
	  "UN_NO__1": 3129
	},
	{
	  "BAKANLIK_KOD": 312903,
	  "UN_NO": 3129,
	  "ORİJİNAL İSİM": "SU İLE TEPKİMEYE GİREN SIVI, AŞINDIRICI, B.B.B.",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WC1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 312903,
	  "UN_NO__1": 3129
	},
	{
	  "BAKANLIK_KOD": 313001,
	  "UN_NO": 3130,
	  "ORİJİNAL İSİM": "SU İLE TEPKİMEYE GİREN SIVI, ZEHİRLİ, B.B.B.",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WT1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 313001,
	  "UN_NO__1": 3130
	},
	{
	  "BAKANLIK_KOD": 313002,
	  "UN_NO": 3130,
	  "ORİJİNAL İSİM": "SU İLE TEPKİMEYE GİREN SIVI, ZEHİRLİ, B.B.B.",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WT1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 313002,
	  "UN_NO__1": 3130
	},
	{
	  "BAKANLIK_KOD": 313003,
	  "UN_NO": 3130,
	  "ORİJİNAL İSİM": "SU İLE TEPKİMEYE GİREN SIVI, ZEHİRLİ, B.B.B.",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WT1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 313003,
	  "UN_NO__1": 3130
	},
	{
	  "BAKANLIK_KOD": 313101,
	  "UN_NO": 3131,
	  "ORİJİNAL İSİM": "SU İLE TEPKİMEYE GİREN KATI, AŞINDIRICI, B.B.B.",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WC2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 313101,
	  "UN_NO__1": 3131
	},
	{
	  "BAKANLIK_KOD": 313102,
	  "UN_NO": 3131,
	  "ORİJİNAL İSİM": "SU İLE TEPKİMEYE GİREN KATI, AŞINDIRICI, B.B.B.",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WC2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 313102,
	  "UN_NO__1": 3131
	},
	{
	  "BAKANLIK_KOD": 313103,
	  "UN_NO": 3131,
	  "ORİJİNAL İSİM": "SU İLE TEPKİMEYE GİREN KATI, AŞINDIRICI, B.B.B.",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WC2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 313103,
	  "UN_NO__1": 3131
	},
	{
	  "BAKANLIK_KOD": 313201,
	  "UN_NO": 3132,
	  "ORİJİNAL İSİM": "SU İLE TEPKİMEYE GİREN KATI, ALEVLENEBİLİR, B.B.B.",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WF2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 313201,
	  "UN_NO__1": 3132
	},
	{
	  "BAKANLIK_KOD": 313202,
	  "UN_NO": 3132,
	  "ORİJİNAL İSİM": "SU İLE TEPKİMEYE GİREN KATI, ALEVLENEBİLİR, B.B.B.",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WF2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 313202,
	  "UN_NO__1": 3132
	},
	{
	  "BAKANLIK_KOD": 313203,
	  "UN_NO": 3132,
	  "ORİJİNAL İSİM": "SU İLE TEPKİMEYE GİREN KATI, ALEVLENEBİLİR, B.B.B.",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WF2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 313203,
	  "UN_NO__1": 3132
	},
	{
	  "BAKANLIK_KOD": 313401,
	  "UN_NO": 3134,
	  "ORİJİNAL İSİM": "SU İLE TEPKİMEYE GİREN KATI, ZEHİRLİ, B.B.B.",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WT2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 313401,
	  "UN_NO__1": 3134
	},
	{
	  "BAKANLIK_KOD": 313402,
	  "UN_NO": 3134,
	  "ORİJİNAL İSİM": "SU İLE TEPKİMEYE GİREN KATI, ZEHİRLİ, B.B.B.",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WT2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 313402,
	  "UN_NO__1": 3134
	},
	{
	  "BAKANLIK_KOD": 313403,
	  "UN_NO": 3134,
	  "ORİJİNAL İSİM": "SU İLE TEPKİMEYE GİREN KATI, ZEHİRLİ, B.B.B.",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WT2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 313403,
	  "UN_NO__1": 3134
	},
	{
	  "BAKANLIK_KOD": 313501,
	  "UN_NO": 3135,
	  "ORİJİNAL İSİM": "SU İLE TEPKİMEYE GİREN KATI, KENDİLİĞİNDEN ISINAN, B.B.B.",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WS",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 313501,
	  "UN_NO__1": 3135
	},
	{
	  "BAKANLIK_KOD": 313502,
	  "UN_NO": 3135,
	  "ORİJİNAL İSİM": "SU İLE TEPKİMEYE GİREN KATI, KENDİLİĞİNDEN ISINAN, B.B.B.",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WS",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 313502,
	  "UN_NO__1": 3135
	},
	{
	  "BAKANLIK_KOD": 313503,
	  "UN_NO": 3135,
	  "ORİJİNAL İSİM": "SU İLE TEPKİMEYE GİREN KATI, KENDİLİĞİNDEN ISINAN, B.B.B.",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WS",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 313503,
	  "UN_NO__1": 3135
	},
	{
	  "BAKANLIK_KOD": 313600,
	  "UN_NO": 3136,
	  "ORİJİNAL İSİM": "TRİFLOROMETAN, SOĞUTULMUŞ SIVI",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "3A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 313600,
	  "UN_NO__1": 3136
	},
	{
	  "BAKANLIK_KOD": 313800,
	  "UN_NO": 3138,
	  "ORİJİNAL İSİM": "ETİLEN, ASETİLEN VE PROPİLEN KARIŞIMI, SOĞUTULMUŞ SIVI %6'dan az propilen, %22,5'ten daha az asetilen ve en az %71,5 etilen içeren",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "3F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 313800,
	  "UN_NO__1": 3138
	},
	{
	  "BAKANLIK_KOD": 313901,
	  "UN_NO": 3139,
	  "ORİJİNAL İSİM": "YÜKSELTGEN SIVI, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 313901,
	  "UN_NO__1": 3139
	},
	{
	  "BAKANLIK_KOD": 313902,
	  "UN_NO": 3139,
	  "ORİJİNAL İSİM": "YÜKSELTGEN SIVI, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 313902,
	  "UN_NO__1": 3139
	},
	{
	  "BAKANLIK_KOD": 313903,
	  "UN_NO": 3139,
	  "ORİJİNAL İSİM": "YÜKSELTGEN SIVI, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 313903,
	  "UN_NO__1": 3139
	},
	{
	  "BAKANLIK_KOD": 314001,
	  "UN_NO": 3140,
	  "ORİJİNAL İSİM": "ALKALOİTLER, SIVI, B.B.B. veya ALKALOİT TUZLARI, SIVI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 314001,
	  "UN_NO__1": 3140
	},
	{
	  "BAKANLIK_KOD": 314002,
	  "UN_NO": 3140,
	  "ORİJİNAL İSİM": "ALKALOİTLER, SIVI, B.B.B. veya ALKALOİT TUZLARI, SIVI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 314002,
	  "UN_NO__1": 3140
	},
	{
	  "BAKANLIK_KOD": 314003,
	  "UN_NO": 3140,
	  "ORİJİNAL İSİM": "ALKALOİTLER, SIVI, B.B.B. veya ALKALOİT TUZLARI, SIVI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 314003,
	  "UN_NO__1": 3140
	},
	{
	  "BAKANLIK_KOD": 314100,
	  "UN_NO": 3141,
	  "ORİJİNAL İSİM": "ANTİMON BİLEŞİĞİ, İNORGANİK, SIVI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T4",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 314100,
	  "UN_NO__1": 3141
	},
	{
	  "BAKANLIK_KOD": 314201,
	  "UN_NO": 3142,
	  "ORİJİNAL İSİM": "DEZENFEKTAN, SIVI, ZEHİRLİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 314201,
	  "UN_NO__1": 3142
	},
	{
	  "BAKANLIK_KOD": 314202,
	  "UN_NO": 3142,
	  "ORİJİNAL İSİM": "DEZENFEKTAN, SIVI, ZEHİRLİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 314202,
	  "UN_NO__1": 3142
	},
	{
	  "BAKANLIK_KOD": 314203,
	  "UN_NO": 3142,
	  "ORİJİNAL İSİM": "DEZENFEKTAN, SIVI, ZEHİRLİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 314203,
	  "UN_NO__1": 3142
	},
	{
	  "BAKANLIK_KOD": 314301,
	  "UN_NO": 3143,
	  "ORİJİNAL İSİM": "BOYA, KATI, ZEHİRLİ, B.B.B. veya BOYA ARA ÜRÜN, KATI, ZEHİRLİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 314301,
	  "UN_NO__1": 3143
	},
	{
	  "BAKANLIK_KOD": 314302,
	  "UN_NO": 3143,
	  "ORİJİNAL İSİM": "BOYA, KATI, ZEHİRLİ, B.B.B. veya BOYA ARA ÜRÜN, KATI, ZEHİRLİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 314302,
	  "UN_NO__1": 3143
	},
	{
	  "BAKANLIK_KOD": 314303,
	  "UN_NO": 3143,
	  "ORİJİNAL İSİM": "BOYA, KATI, ZEHİRLİ, B.B.B. veya BOYA ARA ÜRÜN, KATI, ZEHİRLİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 314303,
	  "UN_NO__1": 3143
	},
	{
	  "BAKANLIK_KOD": 314401,
	  "UN_NO": 3144,
	  "ORİJİNAL İSİM": "NİKOTİN BİLEŞİĞİ, SIVI, B.B.B. veya NİKOTİN MÜSTAHZARI, SIVI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 314401,
	  "UN_NO__1": 3144
	},
	{
	  "BAKANLIK_KOD": 314402,
	  "UN_NO": 3144,
	  "ORİJİNAL İSİM": "NİKOTİN BİLEŞİĞİ, SIVI, B.B.B. veya NİKOTİN MÜSTAHZARI, SIVI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 314402,
	  "UN_NO__1": 3144
	},
	{
	  "BAKANLIK_KOD": 314403,
	  "UN_NO": 3144,
	  "ORİJİNAL İSİM": "NİKOTİN BİLEŞİĞİ, SIVI, B.B.B. veya NİKOTİN MÜSTAHZARI, SIVI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 314403,
	  "UN_NO__1": 3144
	},
	{
	  "BAKANLIK_KOD": 314501,
	  "UN_NO": 3145,
	  "ORİJİNAL İSİM": "ALKİLFENOLLER, SIVI, B.B.B. (C2- C12 homologlar dahil)",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 314501,
	  "UN_NO__1": 3145
	},
	{
	  "BAKANLIK_KOD": 314502,
	  "UN_NO": 3145,
	  "ORİJİNAL İSİM": "ALKİLFENOLLER, SIVI, B.B.B. (C2- C12 homologlar dahil)",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 314502,
	  "UN_NO__1": 3145
	},
	{
	  "BAKANLIK_KOD": 314503,
	  "UN_NO": 3145,
	  "ORİJİNAL İSİM": "ALKİLFENOLLER, SIVI, B.B.B. (C2- C12 homologlar dahil)",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 314503,
	  "UN_NO__1": 3145
	},
	{
	  "BAKANLIK_KOD": 314601,
	  "UN_NO": 3146,
	  "ORİJİNAL İSİM": "ORGANOTİN BİLEŞİĞİ, KATI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T3",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 314601,
	  "UN_NO__1": 3146
	},
	{
	  "BAKANLIK_KOD": 314602,
	  "UN_NO": 3146,
	  "ORİJİNAL İSİM": "ORGANOTİN BİLEŞİĞİ, KATI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 314602,
	  "UN_NO__1": 3146
	},
	{
	  "BAKANLIK_KOD": 314603,
	  "UN_NO": 3146,
	  "ORİJİNAL İSİM": "ORGANOTİN BİLEŞİĞİ, KATI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 314603,
	  "UN_NO__1": 3146
	},
	{
	  "BAKANLIK_KOD": 314701,
	  "UN_NO": 3147,
	  "ORİJİNAL İSİM": "BOYA, KATI, AŞINDIRICI, B.B.B. veya BOYA ARA ÜRÜN, KATI, AŞINDIRICI, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C10",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 314701,
	  "UN_NO__1": 3147
	},
	{
	  "BAKANLIK_KOD": 314702,
	  "UN_NO": 3147,
	  "ORİJİNAL İSİM": "BOYA, KATI, AŞINDIRICI, B.B.B. veya BOYA ARA ÜRÜN, KATI, AŞINDIRICI, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C10",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 314702,
	  "UN_NO__1": 3147
	},
	{
	  "BAKANLIK_KOD": 314703,
	  "UN_NO": 3147,
	  "ORİJİNAL İSİM": "BOYA, KATI, AŞINDIRICI, B.B.B. veya BOYA ARA ÜRÜN, KATI,\n AŞINDIRICI, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C10",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 314703,
	  "UN_NO__1": 3147
	},
	{
	  "BAKANLIK_KOD": 314801,
	  "UN_NO": 3148,
	  "ORİJİNAL İSİM": "SU İLE TEPKİMEYE GİREN SIVI, B.B.B.",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 314801,
	  "UN_NO__1": 3148
	},
	{
	  "BAKANLIK_KOD": 314802,
	  "UN_NO": 3148,
	  "ORİJİNAL İSİM": "SU İLE TEPKİMEYE GİREN SIVI, B.B.B.",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 314802,
	  "UN_NO__1": 3148
	},
	{
	  "BAKANLIK_KOD": 314803,
	  "UN_NO": 3148,
	  "ORİJİNAL İSİM": "SU İLE TEPKİMEYE GİREN SIVI, B.B.B.",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 314803,
	  "UN_NO__1": 3148
	},
	{
	  "BAKANLIK_KOD": 314900,
	  "UN_NO": 3149,
	  "ORİJİNAL İSİM": "HİDROJEN PEROKSİT VE PEROKSİASETİK ASİT KARIŞIMI asit(ler), su içeren ve içerdiği peroksiasetik asit oranı %5'ten fazla olmayan; STABİLİZE",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OC1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 314900,
	  "UN_NO__1": 3149
	},
	{
	  "BAKANLIK_KOD": 315000,
	  "UN_NO": 3150,
	  "ORİJİNAL İSİM": "DÜZENEKLER, KÜÇÜK, HİDROKARBON GAZIYLA ÇALIŞAN veya KÜÇÜK DÜZENEKLER İÇİN HİDROKARBON GAZ YEDEKLERİ, tahliye cihazı içeren",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "6F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 315000,
	  "UN_NO__1": 3150
	},
	{
	  "BAKANLIK_KOD": 315100,
	  "UN_NO": 3151,
	  "ORİJİNAL İSİM": "POLİHALOJENLENMİŞ BİFENİLLER, SIVI veya HALOJENLENMİŞ MONOMETİLDİFENİLMETANLAR, SIVI veya POLİHALOJENLENMİŞ TERFENİLLER, SIVI",
	  "SINIF": 9,
	  "SINIFLANDIRMA_KODU": "M2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 315100,
	  "UN_NO__1": 3151
	},
	{
	  "BAKANLIK_KOD": 315200,
	  "UN_NO": 3152,
	  "ORİJİNAL İSİM": "POLİHALOJENLENMİŞ BİFENİLLER, KATI veya HALOJENLENMİŞ MONOMETİLDİFENİLMETANLAR METANLAR, KATI veya POLİHALOJENLENMİŞ ERFENİLLER, KATI",
	  "SINIF": 9,
	  "SINIFLANDIRMA_KODU": "M2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 315200,
	  "UN_NO__1": 3152
	},
	{
	  "BAKANLIK_KOD": 315300,
	  "UN_NO": 3153,
	  "ORİJİNAL İSİM": "PERFLORO(METİL VİNİL ETER)",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 315300,
	  "UN_NO__1": 3153
	},
	{
	  "BAKANLIK_KOD": 315400,
	  "UN_NO": 3154,
	  "ORİJİNAL İSİM": "PERFLORO(ETİL VİNİL ETER)",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 315400,
	  "UN_NO__1": 3154
	},
	{
	  "BAKANLIK_KOD": 315500,
	  "UN_NO": 3155,
	  "ORİJİNAL İSİM": "PENTAKLOROFENOL",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 315500,
	  "UN_NO__1": 3155
	},
	{
	  "BAKANLIK_KOD": 315600,
	  "UN_NO": 3156,
	  "ORİJİNAL İSİM": "SIKIŞTIRILMIŞ GAZ,\n YÜKSELTGEN, B.B.B.",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "1O",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 315600,
	  "UN_NO__1": 3156
	},
	{
	  "BAKANLIK_KOD": 315700,
	  "UN_NO": 3157,
	  "ORİJİNAL İSİM": "SIVILAŞTIRILMIŞ GAZ,\n YÜKSELTGEN, B.B.B.",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2O",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 315700,
	  "UN_NO__1": 3157
	},
	{
	  "BAKANLIK_KOD": 315800,
	  "UN_NO": 3158,
	  "ORİJİNAL İSİM": "GAZ, SOĞUTULMUŞ SIVI, B.B.B.",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "3A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 315800,
	  "UN_NO__1": 3158
	},
	{
	  "BAKANLIK_KOD": 315900,
	  "UN_NO": 3159,
	  "ORİJİNAL İSİM": "1,1,1,2-TETRAFLOROETAN (SOĞUTUCU GAZ R 134a)",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 315900,
	  "UN_NO__1": 3159
	},
	{
	  "BAKANLIK_KOD": 316000,
	  "UN_NO": 3160,
	  "ORİJİNAL İSİM": "SIVILAŞTIRILMIŞ GAZ, ZEHİRLİ, ALEVLENEBİLİR, B.B.B.",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TF",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 316000,
	  "UN_NO__1": 3160
	},
	{
	  "BAKANLIK_KOD": 316100,
	  "UN_NO": 3161,
	  "ORİJİNAL İSİM": "SIVILAŞTIRILMIŞ GAZ, ALEVLENEBİLİR, B.B.B.",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 316100,
	  "UN_NO__1": 3161
	},
	{
	  "BAKANLIK_KOD": 316200,
	  "UN_NO": 3162,
	  "ORİJİNAL İSİM": "SIVILAŞTIRILMIŞ GAZ, ZEHİRLİ, B.B.B.",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2T",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 316200,
	  "UN_NO__1": 3162
	},
	{
	  "BAKANLIK_KOD": 316300,
	  "UN_NO": 3163,
	  "ORİJİNAL İSİM": "SIVILAŞTIRILMIŞ GAZ, B.B.B.",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 316300,
	  "UN_NO__1": 3163
	},
	{
	  "BAKANLIK_KOD": 316400,
	  "UN_NO": 3164,
	  "ORİJİNAL İSİM": "NESNELER, BASINÇLI, PNÖMATİK veya HİDROLİK (alevlenebilir olmayan gaz içeren)",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "6A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 316400,
	  "UN_NO__1": 3164
	},
	{
	  "BAKANLIK_KOD": 316500,
	  "UN_NO": 3165,
	  "ORİJİNAL İSİM": "HAVA ARACI HİDROLİK GÜÇ BİRİMİ YAKIT TANKI (metil hidrazin ve susuz hidrazin karışımı içeren) (M86 yakıt)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FTC",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 316500,
	  "UN_NO__1": 3165
	},
	{
	  "BAKANLIK_KOD": 316600,
	  "UN_NO": 3166,
	  "ORİJİNAL İSİM": "ARAÇ, ALEVLENEBİLİR GAZLA ÇALIŞAN veya ARAÇ, ALEVLENEBİLİR SIVIYLA ÇALIŞAN veya ARAÇ, YAKIT PİLİ, ALEVLENEBİLİR GAZLA ÇALIŞAN veya ARAÇ, YAKIT PİLİ, ALEVLENEBİLİR SIVIYLA ÇALIŞAN",
	  "SINIF": 9,
	  "SINIFLANDIRMA_KODU": "M11",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 316600,
	  "UN_NO__1": 3166
	},
	{
	  "BAKANLIK_KOD": 316700,
	  "UN_NO": 3167,
	  "ORİJİNAL İSİM": "GAZ NUMUNESİ, BASINÇSIZ, ALEVLENEBİLİR, B.B.B.,\n soğutulmamış sıvı",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "7F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 316700,
	  "UN_NO__1": 3167
	},
	{
	  "BAKANLIK_KOD": 316800,
	  "UN_NO": 3168,
	  "ORİJİNAL İSİM": "GAZ NUMUNESİ, BASINÇSIZ, ZEHİRLİ, ALEVLENEBİLİR, B.B.B., soğutulmamış sıvı",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "7TF",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 316800,
	  "UN_NO__1": 3168
	},
	{
	  "BAKANLIK_KOD": 316900,
	  "UN_NO": 3169,
	  "ORİJİNAL İSİM": "GAZ NUMUNESİ, BASINÇSIZ, ZEHİRLİ, B.B.B., soğutulmamış sıvı",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "7T",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 316900,
	  "UN_NO__1": 3169
	},
	{
	  "BAKANLIK_KOD": 317001,
	  "UN_NO": 3170,
	  "ORİJİNAL İSİM": "ALÜMİNYUM İZABESİ YAN ÜRÜNLERİ veya ALÜMİNYUM YENİDEN ERİTME YAN ÜRÜNLERİ",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 317001,
	  "UN_NO__1": 3170
	},
	{
	  "BAKANLIK_KOD": 317002,
	  "UN_NO": 3170,
	  "ORİJİNAL İSİM": "ALÜMİNYUM İZABESİ YAN ÜRÜNLERİ veya ALÜMİNYUM YENİDEN ERİTME YAN ÜRÜNLERİ",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 317002,
	  "UN_NO__1": 3170
	},
	{
	  "BAKANLIK_KOD": 317100,
	  "UN_NO": 3171,
	  "ORİJİNAL İSİM": "BATARYA İLE ÇALIŞAN ARAÇ veya BATARYA İLE ÇALIŞAN DONANIM",
	  "SINIF": 9,
	  "SINIFLANDIRMA_KODU": "M11",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 317100,
	  "UN_NO__1": 3171
	},
	{
	  "BAKANLIK_KOD": 317201,
	  "UN_NO": 3172,
	  "ORİJİNAL İSİM": "TOKSİNLER, CANLI KAYNAKLARDAN AYRIŞTIRILMIŞ, SIVI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 317201,
	  "UN_NO__1": 3172
	},
	{
	  "BAKANLIK_KOD": 317202,
	  "UN_NO": 3172,
	  "ORİJİNAL İSİM": "TOKSİNLER, CANLI KAYNAKLARDAN AYRIŞTIRILMIŞ, SIVI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 317202,
	  "UN_NO__1": 3172
	},
	{
	  "BAKANLIK_KOD": 317203,
	  "UN_NO": 3172,
	  "ORİJİNAL İSİM": "TOKSİNLER, CANLI KAYNAKLARDAN AYRIŞTIRILMIŞ, SIVI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 317203,
	  "UN_NO__1": 3172
	},
	{
	  "BAKANLIK_KOD": 317400,
	  "UN_NO": 3174,
	  "ORİJİNAL İSİM": "TİTANYUM DİSÜLFÜR",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S4",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 317400,
	  "UN_NO__1": 3174
	},
	{
	  "BAKANLIK_KOD": 317500,
	  "UN_NO": 3175,
	  "ORİJİNAL İSİM": "KATILAR veya katı karışımları (müstahzar ve atıklar gibi), parlama noktası 60 °C'ye kadar olan ALEVLENEBİLİR SIVI, B.B.B. İÇEREN",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 317500,
	  "UN_NO__1": 3175
	},
	{
	  "BAKANLIK_KOD": 317601,
	  "UN_NO": 3176,
	  "ORİJİNAL İSİM": "ALEVLENEBİLİR KATI, ORGANİK, ERİMİŞ, B.B.B.",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 317601,
	  "UN_NO__1": 3176
	},
	{
	  "BAKANLIK_KOD": 317602,
	  "UN_NO": 3176,
	  "ORİJİNAL İSİM": "ALEVLENEBİLİR KATI, ORGANİK, ERİMİŞ, B.B.B.",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 317602,
	  "UN_NO__1": 3176
	},
	{
	  "BAKANLIK_KOD": 317801,
	  "UN_NO": 3178,
	  "ORİJİNAL İSİM": "ALEVLENEBİLİR KATI, İNORGANİK, B.B.B.",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 317801,
	  "UN_NO__1": 3178
	},
	{
	  "BAKANLIK_KOD": 317802,
	  "UN_NO": 3178,
	  "ORİJİNAL İSİM": "ALEVLENEBİLİR KATI, İNORGANİK, B.B.B.",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 317802,
	  "UN_NO__1": 3178
	},
	{
	  "BAKANLIK_KOD": 317901,
	  "UN_NO": 3179,
	  "ORİJİNAL İSİM": "ALEVLENEBİLİR KATI, ZEHİRLİ, İNORGANİK, B.B.B.",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "FT2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 317901,
	  "UN_NO__1": 3179
	},
	{
	  "BAKANLIK_KOD": 317902,
	  "UN_NO": 3179,
	  "ORİJİNAL İSİM": "ALEVLENEBİLİR KATI, ZEHİRLİ, İNORGANİK, B.B.B.",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "FT2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 317902,
	  "UN_NO__1": 3179
	},
	{
	  "BAKANLIK_KOD": 318001,
	  "UN_NO": 3180,
	  "ORİJİNAL İSİM": "ALEVLENEBİLİR KATI, AŞINDIRICI, İNORGANİK, B.B.B.",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "FC2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 318001,
	  "UN_NO__1": 3180
	},
	{
	  "BAKANLIK_KOD": 318002,
	  "UN_NO": 3180,
	  "ORİJİNAL İSİM": "ALEVLENEBİLİR KATI, AŞINDIRICI, İNORGANİK, B.B.B.",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "FC2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 318002,
	  "UN_NO__1": 3180
	},
	{
	  "BAKANLIK_KOD": 318101,
	  "UN_NO": 3181,
	  "ORİJİNAL İSİM": "ORGANİK BİLEŞİKLERİN METAL TUZLARI, ALEVLENEBİLİR, B.B.B.",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 318101,
	  "UN_NO__1": 3181
	},
	{
	  "BAKANLIK_KOD": 318102,
	  "UN_NO": 3181,
	  "ORİJİNAL İSİM": "ORGANİK BİLEŞİKLERİN METAL TUZLARI, ALEVLENEBİLİR, B.B.B.",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 318102,
	  "UN_NO__1": 3181
	},
	{
	  "BAKANLIK_KOD": 318201,
	  "UN_NO": 3182,
	  "ORİJİNAL İSİM": "METAL HİDRİTLER, ALEVLENEBİLİR, B.B.B.",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 318201,
	  "UN_NO__1": 3182
	},
	{
	  "BAKANLIK_KOD": 318202,
	  "UN_NO": 3182,
	  "ORİJİNAL İSİM": "METAL HİDRİTLER, ALEVLENEBİLİR, B.B.B.",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 318202,
	  "UN_NO__1": 3182
	},
	{
	  "BAKANLIK_KOD": 318301,
	  "UN_NO": 3183,
	  "ORİJİNAL İSİM": "KENDİLİĞİNDEN ISINAN SIVI, ORGANİK, B.B.B.",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 318301,
	  "UN_NO__1": 3183
	},
	{
	  "BAKANLIK_KOD": 318302,
	  "UN_NO": 3183,
	  "ORİJİNAL İSİM": "KENDİLİĞİNDEN ISINAN SIVI, ORGANİK, B.B.B.",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 318302,
	  "UN_NO__1": 3183
	},
	{
	  "BAKANLIK_KOD": 318401,
	  "UN_NO": 3184,
	  "ORİJİNAL İSİM": "KENDİLİĞİNDEN ISINAN SIVI, ZEHİRLİ, ORGANİK, B.B.B.",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "ST1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 318401,
	  "UN_NO__1": 3184
	},
	{
	  "BAKANLIK_KOD": 318402,
	  "UN_NO": 3184,
	  "ORİJİNAL İSİM": "KENDİLİĞİNDEN ISINAN SIVI, ZEHİRLİ, ORGANİK, B.B.B.",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "ST1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 318402,
	  "UN_NO__1": 3184
	},
	{
	  "BAKANLIK_KOD": 318501,
	  "UN_NO": 3185,
	  "ORİJİNAL İSİM": "KENDİLİĞİNDEN ISINAN SIVI, AŞINDIRICI, ORGANİK, B.B.B.",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "SC1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 318501,
	  "UN_NO__1": 3185
	},
	{
	  "BAKANLIK_KOD": 318502,
	  "UN_NO": 3185,
	  "ORİJİNAL İSİM": "KENDİLİĞİNDEN ISINAN SIVI, AŞINDIRICI, ORGANİK, B.B.B.",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "SC1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 318502,
	  "UN_NO__1": 3185
	},
	{
	  "BAKANLIK_KOD": 318601,
	  "UN_NO": 3186,
	  "ORİJİNAL İSİM": "KENDİLİĞİNDEN ISINAN SIVI, İNORGANİK, B.B.B.",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 318601,
	  "UN_NO__1": 3186
	},
	{
	  "BAKANLIK_KOD": 318602,
	  "UN_NO": 3186,
	  "ORİJİNAL İSİM": "KENDİLİĞİNDEN ISINAN SIVI, İNORGANİK, B.B.B.",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 318602,
	  "UN_NO__1": 3186
	},
	{
	  "BAKANLIK_KOD": 318701,
	  "UN_NO": 3187,
	  "ORİJİNAL İSİM": "KENDİLİĞİNDEN ISINAN SIVI, ZEHİRLİ, İNORGANİK, B.B.B.",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "ST3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 318701,
	  "UN_NO__1": 3187
	},
	{
	  "BAKANLIK_KOD": 318702,
	  "UN_NO": 3187,
	  "ORİJİNAL İSİM": "KENDİLİĞİNDEN ISINAN SIVI, \n ZEHİRLİ, İNORGANİK, B.B.B.",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "ST3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 318702,
	  "UN_NO__1": 3187
	},
	{
	  "BAKANLIK_KOD": 318801,
	  "UN_NO": 3188,
	  "ORİJİNAL İSİM": "KENDİLİĞİNDEN ISINAN SIVI, AŞINDIRICI, İNORGANİK, B.B.B.",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "SC3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 318801,
	  "UN_NO__1": 3188
	},
	{
	  "BAKANLIK_KOD": 318802,
	  "UN_NO": 3188,
	  "ORİJİNAL İSİM": "KENDİLİĞİNDEN ISINAN SIVI, AŞINDIRICI, İNORGANİK, B.B.B.",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "SC3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 318802,
	  "UN_NO__1": 3188
	},
	{
	  "BAKANLIK_KOD": 318901,
	  "UN_NO": 3189,
	  "ORİJİNAL İSİM": "METAL TOZU, KENDİLİĞİNDEN ISINAN, B.B.B.",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S4",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 318901,
	  "UN_NO__1": 3189
	},
	{
	  "BAKANLIK_KOD": 318902,
	  "UN_NO": 3189,
	  "ORİJİNAL İSİM": "METAL TOZU, KENDİLİĞİNDEN ISINAN, B.B.B.",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S4",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 318902,
	  "UN_NO__1": 3189
	},
	{
	  "BAKANLIK_KOD": 319001,
	  "UN_NO": 3190,
	  "ORİJİNAL İSİM": "KENDİLİĞİNDEN ISINAN KATI, İNORGANİK, B.B.B.",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S4",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 319001,
	  "UN_NO__1": 3190
	},
	{
	  "BAKANLIK_KOD": 319002,
	  "UN_NO": 3190,
	  "ORİJİNAL İSİM": "KENDİLİĞİNDEN ISINAN KATI, İNORGANİK, B.B.B.",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S4",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 319002,
	  "UN_NO__1": 3190
	},
	{
	  "BAKANLIK_KOD": 319101,
	  "UN_NO": 3191,
	  "ORİJİNAL İSİM": "KENDİLİĞİNDEN ISINAN KATI, ZEHİRLİ, İNORGANİK, B.B.B.",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "ST4",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 319101,
	  "UN_NO__1": 3191
	},
	{
	  "BAKANLIK_KOD": 319102,
	  "UN_NO": 3191,
	  "ORİJİNAL İSİM": "KENDİLİĞİNDEN ISINAN KATI, ZEHİRLİ, İNORGANİK, B.B.B.",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "ST4",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 319102,
	  "UN_NO__1": 3191
	},
	{
	  "BAKANLIK_KOD": 319201,
	  "UN_NO": 3192,
	  "ORİJİNAL İSİM": "KENDİLİĞİNDEN ISINAN KATI, AŞINDIRICI, İNORGANİK, B.B.B.",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "SC4",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 319201,
	  "UN_NO__1": 3192
	},
	{
	  "BAKANLIK_KOD": 319202,
	  "UN_NO": 3192,
	  "ORİJİNAL İSİM": "KENDİLİĞİNDEN ISINAN KATI, AŞINDIRICI, İNORGANİK, B.B.B.",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "SC4",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 319202,
	  "UN_NO__1": 3192
	},
	{
	  "BAKANLIK_KOD": 319400,
	  "UN_NO": 3194,
	  "ORİJİNAL İSİM": "PİROFORİK SIVI, İNORGANİK, B.B.B.",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S3",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 319400,
	  "UN_NO__1": 3194
	},
	{
	  "BAKANLIK_KOD": 320000,
	  "UN_NO": 3200,
	  "ORİJİNAL İSİM": "PİROFORİK KATI, İNORGANİK, B.B.B.",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S4",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 320000,
	  "UN_NO__1": 3200
	},
	{
	  "BAKANLIK_KOD": 320501,
	  "UN_NO": 3205,
	  "ORİJİNAL İSİM": "ALKALİ TOPRAK METAL ALKOLATLAR, B.B.B.",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S4",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 320501,
	  "UN_NO__1": 3205
	},
	{
	  "BAKANLIK_KOD": 320502,
	  "UN_NO": 3205,
	  "ORİJİNAL İSİM": "ALKALİ TOPRAK METAL ALKOLATLAR, B.B.B.",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S4",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 320502,
	  "UN_NO__1": 3205
	},
	{
	  "BAKANLIK_KOD": 320601,
	  "UN_NO": 3206,
	  "ORİJİNAL İSİM": "ALKALİ METAL ALKOLATLAR, KENDİLİĞİNDEN ISINAN, AŞINDIRICI, B.B.B.",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "SC4",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 320601,
	  "UN_NO__1": 3206
	},
	{
	  "BAKANLIK_KOD": 320602,
	  "UN_NO": 3206,
	  "ORİJİNAL İSİM": "ALKALİ METAL ALKOLATLAR, KENDİLİĞİNDEN ISINAN, AŞINDIRICI, B.B.B.",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "SC4",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 320602,
	  "UN_NO__1": 3206
	},
	{
	  "BAKANLIK_KOD": 320801,
	  "UN_NO": 3208,
	  "ORİJİNAL İSİM": "METALİK MADDE, SU İLE TEPKİMEYE GİREN, B.B.B.",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 320801,
	  "UN_NO__1": 3208
	},
	{
	  "BAKANLIK_KOD": 320802,
	  "UN_NO": 3208,
	  "ORİJİNAL İSİM": "METALİK MADDE, SU İLE TEPKİMEYE GİREN, B.B.B",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 320802,
	  "UN_NO__1": 3208
	},
	{
	  "BAKANLIK_KOD": 320803,
	  "UN_NO": 3208,
	  "ORİJİNAL İSİM": "METALİK MADDE, SU İLE TEPKİMEYE GİREN, B.B.B",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 320803,
	  "UN_NO__1": 3208
	},
	{
	  "BAKANLIK_KOD": 320901,
	  "UN_NO": 3209,
	  "ORİJİNAL İSİM": "METALİK MADDE, SU İLE TEPKİMEYE GİREN, KENDİLİĞİNDEN ISINAN, B.B.B.",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WS",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 320901,
	  "UN_NO__1": 3209
	},
	{
	  "BAKANLIK_KOD": 320902,
	  "UN_NO": 3209,
	  "ORİJİNAL İSİM": "METALİK MADDE, SU İLE TEPKİMEYE GİREN, KENDİLİĞİNDEN ISINAN, B.B.B.",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WS",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 320902,
	  "UN_NO__1": 3209
	},
	{
	  "BAKANLIK_KOD": 320903,
	  "UN_NO": 3209,
	  "ORİJİNAL İSİM": "METALİK MADDE, SU İLE TEPKİMEYE GİREN, KENDİLİĞİNDEN ISINAN, B.B.B.",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WS",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 320903,
	  "UN_NO__1": 3209
	},
	{
	  "BAKANLIK_KOD": 321001,
	  "UN_NO": 3210,
	  "ORİJİNAL İSİM": "KLORATLAR, İNORGANİK, SULU ÇÖZELTİ, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 321001,
	  "UN_NO__1": 3210
	},
	{
	  "BAKANLIK_KOD": 321002,
	  "UN_NO": 3210,
	  "ORİJİNAL İSİM": "KLORATLAR, İNORGANİK, SULU ÇÖZELTİ, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 321002,
	  "UN_NO__1": 3210
	},
	{
	  "BAKANLIK_KOD": 321101,
	  "UN_NO": 3211,
	  "ORİJİNAL İSİM": "PERKLORATLAR, İNORGANİK, SULU ÇÖZELTİ, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 321101,
	  "UN_NO__1": 3211
	},
	{
	  "BAKANLIK_KOD": 321102,
	  "UN_NO": 3211,
	  "ORİJİNAL İSİM": "PERKLORATLAR, İNORGANİK, SULU ÇÖZELTİ, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 321102,
	  "UN_NO__1": 3211
	},
	{
	  "BAKANLIK_KOD": 321200,
	  "UN_NO": 3212,
	  "ORİJİNAL İSİM": "HİPOKLORİTLER, İNORGANİK, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 321200,
	  "UN_NO__1": 3212
	},
	{
	  "BAKANLIK_KOD": 321301,
	  "UN_NO": 3213,
	  "ORİJİNAL İSİM": "BROMATLAR, İNORGANİK, SULU ÇÖZELTİ, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 321301,
	  "UN_NO__1": 3213
	},
	{
	  "BAKANLIK_KOD": 321302,
	  "UN_NO": 3213,
	  "ORİJİNAL İSİM": "BROMATLAR, İNORGANİK, SULU ÇÖZELTİ, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 321302,
	  "UN_NO__1": 3213
	},
	{
	  "BAKANLIK_KOD": 321400,
	  "UN_NO": 3214,
	  "ORİJİNAL İSİM": "PERMANGANATLAR, İNORGANİK, SULU ÇÖZELTİ, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 321400,
	  "UN_NO__1": 3214
	},
	{
	  "BAKANLIK_KOD": 321500,
	  "UN_NO": 3215,
	  "ORİJİNAL İSİM": "PERSÜLFATLAR, İNORGANİK, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 321500,
	  "UN_NO__1": 3215
	},
	{
	  "BAKANLIK_KOD": 321600,
	  "UN_NO": 3216,
	  "ORİJİNAL İSİM": "PERSÜLFATLAR, İNORGANİK, SULU ÇÖZELTİ, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 321600,
	  "UN_NO__1": 3216
	},
	{
	  "BAKANLIK_KOD": 321801,
	  "UN_NO": 3218,
	  "ORİJİNAL İSİM": "NİTRATLAR, İNORGANİK, SULU ÇÖZELTİ, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 321801,
	  "UN_NO__1": 3218
	},
	{
	  "BAKANLIK_KOD": 321802,
	  "UN_NO": 3218,
	  "ORİJİNAL İSİM": "NİTRATLAR, İNORGANİK, SULU ÇÖZELTİ, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 321802,
	  "UN_NO__1": 3218
	},
	{
	  "BAKANLIK_KOD": 321901,
	  "UN_NO": 3219,
	  "ORİJİNAL İSİM": "NİTRİTLER, İNORGANİK, SULU ÇÖZELTİ, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 321901,
	  "UN_NO__1": 3219
	},
	{
	  "BAKANLIK_KOD": 321902,
	  "UN_NO": 3219,
	  "ORİJİNAL İSİM": "NİTRİTLER, İNORGANİK, SULU ÇÖZELTİ, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 321902,
	  "UN_NO__1": 3219
	},
	{
	  "BAKANLIK_KOD": 322000,
	  "UN_NO": 3220,
	  "ORİJİNAL İSİM": "PENTAFLOROETAN (SOĞUTUCU GAZ R 125)",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 322000,
	  "UN_NO__1": 3220
	},
	{
	  "BAKANLIK_KOD": 322100,
	  "UN_NO": 3221,
	  "ORİJİNAL İSİM": "KENDİLİĞİNDEN TEPKİMEYE GİREN SIVI, TİP B",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "SR1",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 322100,
	  "UN_NO__1": 3221
	},
	{
	  "BAKANLIK_KOD": 322200,
	  "UN_NO": 3222,
	  "ORİJİNAL İSİM": "KENDİLİĞİNDEN TEPKİMEYE GİREN KATI, TİP B",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "SR1",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 322200,
	  "UN_NO__1": 3222
	},
	{
	  "BAKANLIK_KOD": 322300,
	  "UN_NO": 3223,
	  "ORİJİNAL İSİM": "KENDİLİĞİNDEN TEPKİMEYE GİREN SIVI, TİP C",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "SR1",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 322300,
	  "UN_NO__1": 3223
	},
	{
	  "BAKANLIK_KOD": 322400,
	  "UN_NO": 3224,
	  "ORİJİNAL İSİM": "KENDİLİĞİNDEN TEPKİMEYE GİREN KATI, TİP C",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "SR1",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 322400,
	  "UN_NO__1": 3224
	},
	{
	  "BAKANLIK_KOD": 322500,
	  "UN_NO": 3225,
	  "ORİJİNAL İSİM": "KENDİLİĞİNDEN TEPKİMEYE GİREN SIVI, TİP D",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "SR1",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 322500,
	  "UN_NO__1": 3225
	},
	{
	  "BAKANLIK_KOD": 322600,
	  "UN_NO": 3226,
	  "ORİJİNAL İSİM": "KENDİLİĞİNDEN TEPKİMEYE GİREN KATI, TİP D",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "SR1",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 322600,
	  "UN_NO__1": 3226
	},
	{
	  "BAKANLIK_KOD": 322700,
	  "UN_NO": 3227,
	  "ORİJİNAL İSİM": "KENDİLİĞİNDEN TEPKİMEYE GİREN SIVI, TİP E",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "SR1",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 322700,
	  "UN_NO__1": 3227
	},
	{
	  "BAKANLIK_KOD": 322800,
	  "UN_NO": 3228,
	  "ORİJİNAL İSİM": "KENDİLİĞİNDEN TEPKİMEYE GİREN KATI, TİP E",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "SR1",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 322800,
	  "UN_NO__1": 3228
	},
	{
	  "BAKANLIK_KOD": 322900,
	  "UN_NO": 3229,
	  "ORİJİNAL İSİM": "KENDİLİĞİNDEN TEPKİMEYE GİREN SIVI TİP F",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "SR1",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 322900,
	  "UN_NO__1": 3229
	},
	{
	  "BAKANLIK_KOD": 323000,
	  "UN_NO": 3230,
	  "ORİJİNAL İSİM": "KENDİLİĞİNDEN TEPKİMEYE GİREN KATI TİP F",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "SR1",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 323000,
	  "UN_NO__1": 3230
	},
	{
	  "BAKANLIK_KOD": 323100,
	  "UN_NO": 3231,
	  "ORİJİNAL İSİM": "KENDİLİĞİNDEN TEPKİMEYE GİREN SIVI, TİP B, SICAKLIK KONTROLLÜ",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "SR2",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 323100,
	  "UN_NO__1": 3231
	},
	{
	  "BAKANLIK_KOD": 323200,
	  "UN_NO": 3232,
	  "ORİJİNAL İSİM": "KENDİLİĞİNDEN TEPKİMEYE GİREN KATI, TİP B, SICAKLIK KONTROLLÜ",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "SR2",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 323200,
	  "UN_NO__1": 3232
	},
	{
	  "BAKANLIK_KOD": 323300,
	  "UN_NO": 3233,
	  "ORİJİNAL İSİM": "KENDİLİĞİNDEN TEPKİMEYE GİREN SIVI, TİP C, SICAKLIK KONTROLLÜ",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "SR2",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 323300,
	  "UN_NO__1": 3233
	},
	{
	  "BAKANLIK_KOD": 323400,
	  "UN_NO": 3234,
	  "ORİJİNAL İSİM": "KENDİLİĞİNDEN TEPKİMEYE GİREN KATI, TİP C, SICAKLIK KONTROLLÜ",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "SR2",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 323400,
	  "UN_NO__1": 3234
	},
	{
	  "BAKANLIK_KOD": 323500,
	  "UN_NO": 3235,
	  "ORİJİNAL İSİM": "KENDİLİĞİNDEN TEPKİMEYE GİREN SIVI, TİP D, SICAKLIK KONTROLLÜ",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "SR2",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 323500,
	  "UN_NO__1": 3235
	},
	{
	  "BAKANLIK_KOD": 323600,
	  "UN_NO": 3236,
	  "ORİJİNAL İSİM": "KENDİLİĞİNDEN TEPKİMEYE GİREN KATI, TİP D, SICAKLIK KONTROLLÜ",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "SR2",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 323600,
	  "UN_NO__1": 3236
	},
	{
	  "BAKANLIK_KOD": 323700,
	  "UN_NO": 3237,
	  "ORİJİNAL İSİM": "KENDİLİĞİNDEN TEPKİMEYE GİREN SIVI, TİP E, SICAKLIK KONTROLLÜ",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "SR2",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 323700,
	  "UN_NO__1": 3237
	},
	{
	  "BAKANLIK_KOD": 323800,
	  "UN_NO": 3238,
	  "ORİJİNAL İSİM": "KENDİLİĞİNDEN TEPKİMEYE GİREN KATI, TİP E, SICAKLIK KONTROLLÜ",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "SR2",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 323800,
	  "UN_NO__1": 3238
	},
	{
	  "BAKANLIK_KOD": 323900,
	  "UN_NO": 3239,
	  "ORİJİNAL İSİM": "KENDİLİĞİNDEN TEPKİMEYE GİREN SIVI TİP F, SICAKLIK KONTROLLÜ",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "SR2",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 323900,
	  "UN_NO__1": 3239
	},
	{
	  "BAKANLIK_KOD": 324000,
	  "UN_NO": 3240,
	  "ORİJİNAL İSİM": "KENDİLİĞİNDEN TEPKİMEYE GİREN KATI TİP F, SICAKLIK KONTROLLÜ",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "SR2",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 324000,
	  "UN_NO__1": 3240
	},
	{
	  "BAKANLIK_KOD": 324100,
	  "UN_NO": 3241,
	  "ORİJİNAL İSİM": "2-BROMO-2-NİTROPROPAN-1,3- DİOL",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "SR1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 324100,
	  "UN_NO__1": 3241
	},
	{
	  "BAKANLIK_KOD": 324200,
	  "UN_NO": 3242,
	  "ORİJİNAL İSİM": "AZODİKARBONAMİD",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "SR1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 324200,
	  "UN_NO__1": 3242
	},
	{
	  "BAKANLIK_KOD": 324300,
	  "UN_NO": 3243,
	  "ORİJİNAL İSİM": "ZEHİRLİ SIVI İÇEREN KATILAR, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T9",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 324300,
	  "UN_NO__1": 3243
	},
	{
	  "BAKANLIK_KOD": 324400,
	  "UN_NO": 3244,
	  "ORİJİNAL İSİM": "AŞINDIRICI SIVI İÇEREN KATILAR, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C10",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 324400,
	  "UN_NO__1": 3244
	},
	{
	  "BAKANLIK_KOD": 324501,
	  "UN_NO": 3245,
	  "ORİJİNAL İSİM": "GENETİĞİ DEĞİŞTİRİLMİŞ MİKROORGANİZMALAR veya GENETİĞİ DEĞİŞTİRİLMİŞ ORGANİZMALAR",
	  "SINIF": 9,
	  "SINIFLANDIRMA_KODU": "M8",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 324501,
	  "UN_NO__1": 3245
	},
	{
	  "BAKANLIK_KOD": 324502,
	  "UN_NO": 3245,
	  "ORİJİNAL İSİM": "GENETİĞİ DEĞİŞTİRİLMİŞ MİKROORGANİZMALAR veya GENETİĞİ DEĞİŞTİRİLMİŞ ORGANİZMALAR, soğutulmuş sıvı azot içinde",
	  "SINIF": 9,
	  "SINIFLANDIRMA_KODU": "M8",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 324502,
	  "UN_NO__1": 3245
	},
	{
	  "BAKANLIK_KOD": 324600,
	  "UN_NO": 3246,
	  "ORİJİNAL İSİM": "METANSÜLFONİL KLORÜR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TC1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 324600,
	  "UN_NO__1": 3246
	},
	{
	  "BAKANLIK_KOD": 324700,
	  "UN_NO": 3247,
	  "ORİJİNAL İSİM": "SODYUM PEROKZOBORAT, SUSUZ",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 324700,
	  "UN_NO__1": 3247
	},
	{
	  "BAKANLIK_KOD": 324801,
	  "UN_NO": 3248,
	  "ORİJİNAL İSİM": "İLAÇ, SIVI, ALEVLENEBİLİR, ZEHİRLİ, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 324801,
	  "UN_NO__1": 3248
	},
	{
	  "BAKANLIK_KOD": 324802,
	  "UN_NO": 3248,
	  "ORİJİNAL İSİM": "İLAÇ, SIVI, ALEVLENEBİLİR, ZEHİRLİ, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 324802,
	  "UN_NO__1": 3248
	},
	{
	  "BAKANLIK_KOD": 324901,
	  "UN_NO": 3249,
	  "ORİJİNAL İSİM": "İLAÇ, KATI, ZEHİRLİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 324901,
	  "UN_NO__1": 3249
	},
	{
	  "BAKANLIK_KOD": 324902,
	  "UN_NO": 3249,
	  "ORİJİNAL İSİM": "İLAÇ, KATI, ZEHİRLİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 324902,
	  "UN_NO__1": 3249
	},
	{
	  "BAKANLIK_KOD": 325000,
	  "UN_NO": 3250,
	  "ORİJİNAL İSİM": "KLOROASETİK ASİT, ERİMİŞ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TC1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 325000,
	  "UN_NO__1": 3250
	},
	{
	  "BAKANLIK_KOD": 325100,
	  "UN_NO": 3251,
	  "ORİJİNAL İSİM": "İZOSORBİT-5-MONONİTRAT",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "SR1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 325100,
	  "UN_NO__1": 3251
	},
	{
	  "BAKANLIK_KOD": 325200,
	  "UN_NO": 3252,
	  "ORİJİNAL İSİM": "DİFLOROMETAN (SOĞUTUCU GAZ R 32)",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 325200,
	  "UN_NO__1": 3252
	},
	{
	  "BAKANLIK_KOD": 325300,
	  "UN_NO": 3253,
	  "ORİJİNAL İSİM": "DİSODYUM TRİOKZOSİLİKAT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C6",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 325300,
	  "UN_NO__1": 3253
	},
	{
	  "BAKANLIK_KOD": 325400,
	  "UN_NO": 3254,
	  "ORİJİNAL İSİM": "TRİBÜTİLFOSFAN",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 325400,
	  "UN_NO__1": 3254
	},
	{
	  "BAKANLIK_KOD": 325601,
	  "UN_NO": 3256,
	  "ORİJİNAL İSİM": "YÜKSEK SICAKLIKLI SIVI, ALEVLENEBİLİR, B.B.B. Parlama noktası 60 °C'nin üstünde, parlama noktasında veya üzerinde ve 100 °C'nin altında",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 325601,
	  "UN_NO__1": 3256
	},
	{
	  "BAKANLIK_KOD": 325602,
	  "UN_NO": 3256,
	  "ORİJİNAL İSİM": "YÜKSEK SICAKLIKLI SIVI, ALEVLENEBİLİR, B.B.B. parlama noktası 60 °C'nin üstünde, parlama noktasında veya üstünde ve 100 °C ve üstünde",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 325602,
	  "UN_NO__1": 3256
	},
	{
	  "BAKANLIK_KOD": 325701,
	  "UN_NO": 3257,
	  "ORİJİNAL İSİM": "YÜKSEK SICAKLIKLI SIVI, B.B.B., 100 °C'de veya üzerinde ve parlama noktasının altında (erimiş metaller ve erimiş metal tuzları vb. dahil), 190 °C'den yüksek sıcaklıkta doldurulmuş",
	  "SINIF": 9,
	  "SINIFLANDIRMA_KODU": "M9",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 325701,
	  "UN_NO__1": 3257
	},
	{
	  "BAKANLIK_KOD": 325702,
	  "UN_NO": 3257,
	  "ORİJİNAL İSİM": "YÜKSEK SICAKLIKLI SIVI, B.B.B., 100 °C'de veya üstünde ve parlama noktasının altında (erimiş metaller ve erimiş metal tuzları vb. dahil), 190 °C'de veya altında sıcaklıkta\n doldurulmuş",
	  "SINIF": 9,
	  "SINIFLANDIRMA_KODU": "M9",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 325702,
	  "UN_NO__1": 3257
	},
	{
	  "BAKANLIK_KOD": 325800,
	  "UN_NO": 3258,
	  "ORİJİNAL İSİM": "YÜKSEK SICAKLIKLI KATI, B.B.B., 240 °C'de veya üstünde",
	  "SINIF": 9,
	  "SINIFLANDIRMA_KODU": "M10",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 325800,
	  "UN_NO__1": 3258
	},
	{
	  "BAKANLIK_KOD": 325901,
	  "UN_NO": 3259,
	  "ORİJİNAL İSİM": "AMİNLER, KATI, ALEVLENEBİLİR, AŞINDIRICI, B.B.B. veya POLİAMİNLER, KATI, AŞINDIRICI, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C8",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 325901,
	  "UN_NO__1": 3259
	},
	{
	  "BAKANLIK_KOD": 325902,
	  "UN_NO": 3259,
	  "ORİJİNAL İSİM": "AMİNLER, KATI, ALEVLENEBİLİR, AŞINDIRICI, B.B.B. veya POLİAMİNLER, KATI, AŞINDIRICI, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C8",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 325902,
	  "UN_NO__1": 3259
	},
	{
	  "BAKANLIK_KOD": 325903,
	  "UN_NO": 3259,
	  "ORİJİNAL İSİM": "AMİNLER, KATI, ALEVLENEBİLİR, AŞINDIRICI, B.B.B. veya POLİAMİNLER, KATI, AŞINDIRICI, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C8",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 325903,
	  "UN_NO__1": 3259
	},
	{
	  "BAKANLIK_KOD": 326001,
	  "UN_NO": 3260,
	  "ORİJİNAL İSİM": "AŞINDIRICI KATI, ASİDİK, İNORGANİK, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 326001,
	  "UN_NO__1": 3260
	},
	{
	  "BAKANLIK_KOD": 326002,
	  "UN_NO": 3260,
	  "ORİJİNAL İSİM": "AŞINDIRICI KATI, ASİDİK, İNORGANİK, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 326002,
	  "UN_NO__1": 3260
	},
	{
	  "BAKANLIK_KOD": 326003,
	  "UN_NO": 3260,
	  "ORİJİNAL İSİM": "AŞINDIRICI KATI, ASİDİK, İNORGANİK, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 326003,
	  "UN_NO__1": 3260
	},
	{
	  "BAKANLIK_KOD": 326101,
	  "UN_NO": 3261,
	  "ORİJİNAL İSİM": "AŞINDIRICI KATI, ASİDİK, ORGANİK, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C4",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 326101,
	  "UN_NO__1": 3261
	},
	{
	  "BAKANLIK_KOD": 326102,
	  "UN_NO": 3261,
	  "ORİJİNAL İSİM": "AŞINDIRICI KATI, ASİDİK, ORGANİK, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C4",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 326102,
	  "UN_NO__1": 3261
	},
	{
	  "BAKANLIK_KOD": 326103,
	  "UN_NO": 3261,
	  "ORİJİNAL İSİM": "AŞINDIRICI KATI, ASİDİK, ORGANİK, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C4",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 326103,
	  "UN_NO__1": 3261
	},
	{
	  "BAKANLIK_KOD": 326201,
	  "UN_NO": 3262,
	  "ORİJİNAL İSİM": "AŞINDIRICI KATI, BAZİK, İNORGANİK, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C6",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 326201,
	  "UN_NO__1": 3262
	},
	{
	  "BAKANLIK_KOD": 326202,
	  "UN_NO": 3262,
	  "ORİJİNAL İSİM": "AŞINDIRICI KATI, BAZİK, İNORGANİK, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C6",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 326202,
	  "UN_NO__1": 3262
	},
	{
	  "BAKANLIK_KOD": 326203,
	  "UN_NO": 3262,
	  "ORİJİNAL İSİM": "AŞINDIRICI KATI, BAZİK, İNORGANİK, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C6",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 326203,
	  "UN_NO__1": 3262
	},
	{
	  "BAKANLIK_KOD": 326301,
	  "UN_NO": 3263,
	  "ORİJİNAL İSİM": "AŞINDIRICI KATI, BAZİK, ORGANİK, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C8",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 326301,
	  "UN_NO__1": 3263
	},
	{
	  "BAKANLIK_KOD": 326302,
	  "UN_NO": 3263,
	  "ORİJİNAL İSİM": "AŞINDIRICI KATI, BAZİK, ORGANİK, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C8",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 326302,
	  "UN_NO__1": 3263
	},
	{
	  "BAKANLIK_KOD": 326303,
	  "UN_NO": 3263,
	  "ORİJİNAL İSİM": "AŞINDIRICI KATI, BAZİK, ORGANİK, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C8",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 326303,
	  "UN_NO__1": 3263
	},
	{
	  "BAKANLIK_KOD": 326401,
	  "UN_NO": 3264,
	  "ORİJİNAL İSİM": "AŞINDIRICI SIVI, ASİDİK, İNORGANİK, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 326401,
	  "UN_NO__1": 3264
	},
	{
	  "BAKANLIK_KOD": 326402,
	  "UN_NO": 3264,
	  "ORİJİNAL İSİM": "AŞINDIRICI SIVI, ASİDİK, İNORGANİK, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 326402,
	  "UN_NO__1": 3264
	},
	{
	  "BAKANLIK_KOD": 326403,
	  "UN_NO": 3264,
	  "ORİJİNAL İSİM": "AŞINDIRICI SIVI, ASİDİK, İNORGANİK, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 326403,
	  "UN_NO__1": 3264
	},
	{
	  "BAKANLIK_KOD": 326501,
	  "UN_NO": 3265,
	  "ORİJİNAL İSİM": "AŞINDIRICI SIVI, ASİDİK, ORGANİK, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 326501,
	  "UN_NO__1": 3265
	},
	{
	  "BAKANLIK_KOD": 326502,
	  "UN_NO": 3265,
	  "ORİJİNAL İSİM": "AŞINDIRICI SIVI, ASİDİK, ORGANİK, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 326502,
	  "UN_NO__1": 3265
	},
	{
	  "BAKANLIK_KOD": 326503,
	  "UN_NO": 3265,
	  "ORİJİNAL İSİM": "AŞINDIRICI SIVI, ASİDİK, ORGANİK, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 326503,
	  "UN_NO__1": 3265
	},
	{
	  "BAKANLIK_KOD": 326601,
	  "UN_NO": 3266,
	  "ORİJİNAL İSİM": "AŞINDIRICI SIVI, BAZİK, İNORGANİK, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C5",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 326601,
	  "UN_NO__1": 3266
	},
	{
	  "BAKANLIK_KOD": 326602,
	  "UN_NO": 3266,
	  "ORİJİNAL İSİM": "AŞINDIRICI SIVI, BAZİK, İNORGANİK, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 326602,
	  "UN_NO__1": 3266
	},
	{
	  "BAKANLIK_KOD": 326603,
	  "UN_NO": 3266,
	  "ORİJİNAL İSİM": "AŞINDIRICI SIVI, BAZİK, İNORGANİK, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C5",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 326603,
	  "UN_NO__1": 3266
	},
	{
	  "BAKANLIK_KOD": 326701,
	  "UN_NO": 3267,
	  "ORİJİNAL İSİM": "AŞINDIRICI SIVI, BAZİK, ORGANİK, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C7",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 326701,
	  "UN_NO__1": 3267
	},
	{
	  "BAKANLIK_KOD": 326702,
	  "UN_NO": 3267,
	  "ORİJİNAL İSİM": "AŞINDIRICI SIVI, BAZİK, ORGANİK, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C7",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 326702,
	  "UN_NO__1": 3267
	},
	{
	  "BAKANLIK_KOD": 326703,
	  "UN_NO": 3267,
	  "ORİJİNAL İSİM": "AŞINDIRICI SIVI, BAZİK, ORGANİK, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C7",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 326703,
	  "UN_NO__1": 3267
	},
	{
	  "BAKANLIK_KOD": 326800,
	  "UN_NO": 3268,
	  "ORİJİNAL İSİM": "GÜVENLİK CİHAZLARI, elektrikle çalışan",
	  "SINIF": 9,
	  "SINIFLANDIRMA_KODU": "M5",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 326800,
	  "UN_NO__1": 3268
	},
	{
	  "BAKANLIK_KOD": 326901,
	  "UN_NO": 3269,
	  "ORİJİNAL İSİM": "POLİESTER REÇİNE KİTİ, sıvı taban malzemesi",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 326901,
	  "UN_NO__1": 3269
	},
	{
	  "BAKANLIK_KOD": 326902,
	  "UN_NO": 3269,
	  "ORİJİNAL İSİM": "POLİESTER REÇİNE KİTİ, sıvı taban malzemesi",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 326902,
	  "UN_NO__1": 3269
	},
	{
	  "BAKANLIK_KOD": 327000,
	  "UN_NO": 3270,
	  "ORİJİNAL İSİM": "NİTROSELÜLOZ MEMBRAN FİLTRELER, kuru kütlece %12,6'dan fazla azot içermeyen",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 327000,
	  "UN_NO__1": 3270
	},
	{
	  "BAKANLIK_KOD": 327101,
	  "UN_NO": 3271,
	  "ORİJİNAL İSİM": "ETERLER, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 327101,
	  "UN_NO__1": 3271
	},
	{
	  "BAKANLIK_KOD": 327102,
	  "UN_NO": 3271,
	  "ORİJİNAL İSİM": "ETERLER, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 327102,
	  "UN_NO__1": 3271
	},
	{
	  "BAKANLIK_KOD": 327201,
	  "UN_NO": 3272,
	  "ORİJİNAL İSİM": "ESTERLER, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 327201,
	  "UN_NO__1": 3272
	},
	{
	  "BAKANLIK_KOD": 327202,
	  "UN_NO": 3272,
	  "ORİJİNAL İSİM": "ESTERLER, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 327202,
	  "UN_NO__1": 3272
	},
	{
	  "BAKANLIK_KOD": 327301,
	  "UN_NO": 3273,
	  "ORİJİNAL İSİM": "NİTRİLLER, ALEVLENEBİLİR, ZEHİRLİ, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 327301,
	  "UN_NO__1": 3273
	},
	{
	  "BAKANLIK_KOD": 327302,
	  "UN_NO": 3273,
	  "ORİJİNAL İSİM": "NİTRİLLER, ALEVLENEBİLİR, ZEHİRLİ, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 327302,
	  "UN_NO__1": 3273
	},
	{
	  "BAKANLIK_KOD": 327400,
	  "UN_NO": 3274,
	  "ORİJİNAL İSİM": "ALKOLATLAR ÇÖZELTİ, B.B.B., alkolde",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 327400,
	  "UN_NO__1": 3274
	},
	{
	  "BAKANLIK_KOD": 327501,
	  "UN_NO": 3275,
	  "ORİJİNAL İSİM": "NİTRİLLER, ZEHİRLİ, ALEVLENEBİLİR, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 327501,
	  "UN_NO__1": 3275
	},
	{
	  "BAKANLIK_KOD": 327502,
	  "UN_NO": 3275,
	  "ORİJİNAL İSİM": "NİTRİLLER, ZEHİRLİ, ALEVLENEBİLİR, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 327502,
	  "UN_NO__1": 3275
	},
	{
	  "BAKANLIK_KOD": 327601,
	  "UN_NO": 3276,
	  "ORİJİNAL İSİM": "NİTRİLLER, SIVI, ZEHİRLİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 327601,
	  "UN_NO__1": 3276
	},
	{
	  "BAKANLIK_KOD": 327602,
	  "UN_NO": 3276,
	  "ORİJİNAL İSİM": "NİTRİLLER, SIVI, ZEHİRLİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 327602,
	  "UN_NO__1": 3276
	},
	{
	  "BAKANLIK_KOD": 327603,
	  "UN_NO": 3276,
	  "ORİJİNAL İSİM": "NİTRİLLER, SIVI, ZEHİRLİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 327603,
	  "UN_NO__1": 3276
	},
	{
	  "BAKANLIK_KOD": 327700,
	  "UN_NO": 3277,
	  "ORİJİNAL İSİM": "KLOROFORMATLAR, ZEHİRLİ, AŞINDIRICI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TC1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 327700,
	  "UN_NO__1": 3277
	},
	{
	  "BAKANLIK_KOD": 327801,
	  "UN_NO": 3278,
	  "ORİJİNAL İSİM": "ORGANOFOSFORLU BİLEŞİK, SIVI, ZEHİRLİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 327801,
	  "UN_NO__1": 3278
	},
	{
	  "BAKANLIK_KOD": 327802,
	  "UN_NO": 3278,
	  "ORİJİNAL İSİM": "ORGANOFOSFORLU BİLEŞİK, SIVI, ZEHİRLİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 327802,
	  "UN_NO__1": 3278
	},
	{
	  "BAKANLIK_KOD": 327803,
	  "UN_NO": 3278,
	  "ORİJİNAL İSİM": "ORGANOFOSFORLU BİLEŞİK, SIVI, ZEHİRLİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 327803,
	  "UN_NO__1": 3278
	},
	{
	  "BAKANLIK_KOD": 327901,
	  "UN_NO": 3279,
	  "ORİJİNAL İSİM": "ORGANOFOSFORLU BİLEŞİK, ZEHİRLİ, ALEVLENEBİLİR, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 327901,
	  "UN_NO__1": 3279
	},
	{
	  "BAKANLIK_KOD": 327902,
	  "UN_NO": 3279,
	  "ORİJİNAL İSİM": "ORGANOFOSFORLU BİLEŞİK, ZEHİRLİ, ALEVLENEBİLİR, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 327902,
	  "UN_NO__1": 3279
	},
	{
	  "BAKANLIK_KOD": 328001,
	  "UN_NO": 3280,
	  "ORİJİNAL İSİM": "ORGANOARSENİK BİLEŞİK, SIVI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T3",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 328001,
	  "UN_NO__1": 3280
	},
	{
	  "BAKANLIK_KOD": 328002,
	  "UN_NO": 3280,
	  "ORİJİNAL İSİM": "ORGANOARSENİK BİLEŞİK, SIVI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 328002,
	  "UN_NO__1": 3280
	},
	{
	  "BAKANLIK_KOD": 328003,
	  "UN_NO": 3280,
	  "ORİJİNAL İSİM": "ORGANOARSENİK BİLEŞİK, SIVI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 328003,
	  "UN_NO__1": 3280
	},
	{
	  "BAKANLIK_KOD": 328101,
	  "UN_NO": 3281,
	  "ORİJİNAL İSİM": "METAL KARBONİLLER, SIVI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T3",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 328101,
	  "UN_NO__1": 3281
	},
	{
	  "BAKANLIK_KOD": 328102,
	  "UN_NO": 3281,
	  "ORİJİNAL İSİM": "METAL KARBONİLLER, SIVI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 328102,
	  "UN_NO__1": 3281
	},
	{
	  "BAKANLIK_KOD": 328103,
	  "UN_NO": 3281,
	  "ORİJİNAL İSİM": "METAL KARBONİLLER, SIVI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 328103,
	  "UN_NO__1": 3281
	},
	{
	  "BAKANLIK_KOD": 328201,
	  "UN_NO": 3282,
	  "ORİJİNAL İSİM": "ORGANOMETALİK BİLEŞİK, SIVI, ZEHİRLİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T3",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 328201,
	  "UN_NO__1": 3282
	},
	{
	  "BAKANLIK_KOD": 328202,
	  "UN_NO": 3282,
	  "ORİJİNAL İSİM": "ORGANOMETALİK BİLEŞİK, SIVI, ZEHİRLİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 328202,
	  "UN_NO__1": 3282
	},
	{
	  "BAKANLIK_KOD": 328203,
	  "UN_NO": 3282,
	  "ORİJİNAL İSİM": "ORGANOMETALİK BİLEŞİK, SIVI, ZEHİRLİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 328203,
	  "UN_NO__1": 3282
	},
	{
	  "BAKANLIK_KOD": 328301,
	  "UN_NO": 3283,
	  "ORİJİNAL İSİM": "SELENYUM BİLEŞİĞİ, KATI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 328301,
	  "UN_NO__1": 3283
	},
	{
	  "BAKANLIK_KOD": 328302,
	  "UN_NO": 3283,
	  "ORİJİNAL İSİM": "SELENYUM BİLEŞİĞİ, KATI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 328302,
	  "UN_NO__1": 3283
	},
	{
	  "BAKANLIK_KOD": 328303,
	  "UN_NO": 3283,
	  "ORİJİNAL İSİM": "SELENYUM BİLEŞİĞİ, KATI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 328303,
	  "UN_NO__1": 3283
	},
	{
	  "BAKANLIK_KOD": 328401,
	  "UN_NO": 3284,
	  "ORİJİNAL İSİM": "TELLÜR BİLEŞİĞİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 328401,
	  "UN_NO__1": 3284
	},
	{
	  "BAKANLIK_KOD": 328402,
	  "UN_NO": 3284,
	  "ORİJİNAL İSİM": "TELLÜR BİLEŞİĞİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 328402,
	  "UN_NO__1": 3284
	},
	{
	  "BAKANLIK_KOD": 328403,
	  "UN_NO": 3284,
	  "ORİJİNAL İSİM": "TELLÜR BİLEŞİĞİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 328403,
	  "UN_NO__1": 3284
	},
	{
	  "BAKANLIK_KOD": 328501,
	  "UN_NO": 3285,
	  "ORİJİNAL İSİM": "VANADYUM BİLEŞİĞİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 328501,
	  "UN_NO__1": 3285
	},
	{
	  "BAKANLIK_KOD": 328502,
	  "UN_NO": 3285,
	  "ORİJİNAL İSİM": "VANADYUM BİLEŞİĞİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 328502,
	  "UN_NO__1": 3285
	},
	{
	  "BAKANLIK_KOD": 328503,
	  "UN_NO": 3285,
	  "ORİJİNAL İSİM": "VANADYUM BİLEŞİĞİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 328503,
	  "UN_NO__1": 3285
	},
	{
	  "BAKANLIK_KOD": 328601,
	  "UN_NO": 3286,
	  "ORİJİNAL İSİM": "ALEVLENEBİLİR SIVI, ZEHİRLİ, AŞINDIRICI, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FTC",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 328601,
	  "UN_NO__1": 3286
	},
	{
	  "BAKANLIK_KOD": 328602,
	  "UN_NO": 3286,
	  "ORİJİNAL İSİM": "ALEVLENEBİLİR SIVI, ZEHİRLİ, AŞINDIRICI, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FTC",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 328602,
	  "UN_NO__1": 3286
	},
	{
	  "BAKANLIK_KOD": 328701,
	  "UN_NO": 3287,
	  "ORİJİNAL İSİM": "ZEHİRLİ SIVI, İNORGANİK, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T4",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 328701,
	  "UN_NO__1": 3287
	},
	{
	  "BAKANLIK_KOD": 328702,
	  "UN_NO": 3287,
	  "ORİJİNAL İSİM": "ZEHİRLİ SIVI, İNORGANİK, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T4",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 328702,
	  "UN_NO__1": 3287
	},
	{
	  "BAKANLIK_KOD": 328703,
	  "UN_NO": 3287,
	  "ORİJİNAL İSİM": "ZEHİRLİ SIVI, İNORGANİK, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T4",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 328703,
	  "UN_NO__1": 3287
	},
	{
	  "BAKANLIK_KOD": 328801,
	  "UN_NO": 3288,
	  "ORİJİNAL İSİM": "ZEHİRLİ KATI, İNORGANİK, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 328801,
	  "UN_NO__1": 3288
	},
	{
	  "BAKANLIK_KOD": 328802,
	  "UN_NO": 3288,
	  "ORİJİNAL İSİM": "ZEHİRLİ KATI, İNORGANİK, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 328802,
	  "UN_NO__1": 3288
	},
	{
	  "BAKANLIK_KOD": 328803,
	  "UN_NO": 3288,
	  "ORİJİNAL İSİM": "ZEHİRLİ KATI, İNORGANİK, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T5",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 328803,
	  "UN_NO__1": 3288
	},
	{
	  "BAKANLIK_KOD": 328901,
	  "UN_NO": 3289,
	  "ORİJİNAL İSİM": "ZEHİRLİ SIVI, AŞINDIRICI, İNORGANİK, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TC3",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 328901,
	  "UN_NO__1": 3289
	},
	{
	  "BAKANLIK_KOD": 328902,
	  "UN_NO": 3289,
	  "ORİJİNAL İSİM": "ZEHİRLİ SIVI, AŞINDIRICI, İNORGANİK, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TC3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 328902,
	  "UN_NO__1": 3289
	},
	{
	  "BAKANLIK_KOD": 329001,
	  "UN_NO": 3290,
	  "ORİJİNAL İSİM": "ZEHİRLİ KATI, AŞINDIRICI, İNORGANİK, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TC4",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 329001,
	  "UN_NO__1": 3290
	},
	{
	  "BAKANLIK_KOD": 329002,
	  "UN_NO": 3290,
	  "ORİJİNAL İSİM": "ZEHİRLİ KATI, AŞINDIRICI, İNORGANİK, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TC4",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 329002,
	  "UN_NO__1": 3290
	},
	{
	  "BAKANLIK_KOD": 329101,
	  "UN_NO": 3291,
	  "ORİJİNAL İSİM": "KLİNİK ATIK, TANIMLANMAMIŞ, B.B.B. veya (BİYOLOJİK) TIBBİ ATIK, B.B.B. veya DÜZENLENMİŞ TIBBİ ATIK, B.B.B.",
	  "SINIF": 6.2,
	  "SINIFLANDIRMA_KODU": "I3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 329101,
	  "UN_NO__1": 3291
	},
	{
	  "BAKANLIK_KOD": 329102,
	  "UN_NO": 3291,
	  "ORİJİNAL İSİM": "KLİNİK ATIK, TANIMLANMAMIŞ, B.B.B. veya (BİYOLOJİK) TIBBİ ATIK, B.B.B. veya DÜZENLENMİŞ TIBBİ ATIK, B.B.B., soğutulmuş sıvı azot içinde",
	  "SINIF": 6.2,
	  "SINIFLANDIRMA_KODU": "I3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 329102,
	  "UN_NO__1": 3291
	},
	{
	  "BAKANLIK_KOD": 329200,
	  "UN_NO": 3292,
	  "ORİJİNAL İSİM": "BATARYALAR, SODYUM İÇEREN veya PİLLER, SODYUM İÇEREN",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W3",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 329200,
	  "UN_NO__1": 3292
	},
	{
	  "BAKANLIK_KOD": 329300,
	  "UN_NO": 3293,
	  "ORİJİNAL İSİM": "HİDRAZİN SULU ÇÖZELTİ, kütlece %37'den az hidrazin içeren",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T4",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 329300,
	  "UN_NO__1": 3293
	},
	{
	  "BAKANLIK_KOD": 329400,
	  "UN_NO": 3294,
	  "ORİJİNAL İSİM": "HİDROJEN SİYANÜR, ALKOLDE ÇÖZELTİ %45'ten az hidrojen siyanür içeren",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 329400,
	  "UN_NO__1": 3294
	},
	{
	  "BAKANLIK_KOD": 329501,
	  "UN_NO": 3295,
	  "ORİJİNAL İSİM": "HİDROKARBONLAR, SIVI, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 329501,
	  "UN_NO__1": 3295
	},
	{
	  "BAKANLIK_KOD": 329502,
	  "UN_NO": 3295,
	  "ORİJİNAL İSİM": "HİDROKARBONLAR, SIVI, B.B.B (50 °C'de buhar basıncı 110 kPa'a eşit veya daha yüksek olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 329502,
	  "UN_NO__1": 3295
	},
	{
	  "BAKANLIK_KOD": 329503,
	  "UN_NO": 3295,
	  "ORİJİNAL İSİM": "HİDROKARBONLAR, SIVI, B.B.B (50 °C'de buhar basıncı 110 kPa?a eşit veya daha düşük olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 329503,
	  "UN_NO__1": 3295
	},
	{
	  "BAKANLIK_KOD": 329504,
	  "UN_NO": 3295,
	  "ORİJİNAL İSİM": "HİDROKARBONLAR, SIVI, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 329504,
	  "UN_NO__1": 3295
	},
	{
	  "BAKANLIK_KOD": 329600,
	  "UN_NO": 3296,
	  "ORİJİNAL İSİM": "HEKZAFLOROPROPAN (SOĞUTUCU GAZ R 227)",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 329600,
	  "UN_NO__1": 3296
	},
	{
	  "BAKANLIK_KOD": 329700,
	  "UN_NO": 3297,
	  "ORİJİNAL İSİM": "ETİLEN OKSİT VE KLOROTETRAFLORO-ETAN KARIŞIMI %8,8'den fazla olmayan etilen oksit ile",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 329700,
	  "UN_NO__1": 3297
	},
	{
	  "BAKANLIK_KOD": 329800,
	  "UN_NO": 3298,
	  "ORİJİNAL İSİM": "ETİLEN OKSİT VE PENTAFLOROETAN KARIŞIMI %7,9'dan fazla olmayan etilen oksit ile",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 329800,
	  "UN_NO__1": 3298
	},
	{
	  "BAKANLIK_KOD": 329900,
	  "UN_NO": 3299,
	  "ORİJİNAL İSİM": "ETİLEN OKSİT VE TETRAFLOROETAN KARIŞIMI %5,6'dan fazla olmayan etilen oksit ile",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 329900,
	  "UN_NO__1": 3299
	},
	{
	  "BAKANLIK_KOD": 330000,
	  "UN_NO": 3300,
	  "ORİJİNAL İSİM": "ETİLEN OKSİT VE KARBON DİOKSİT KARIŞIMI %87'den fazla etilen oksit ile",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TF",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 330000,
	  "UN_NO__1": 3300
	},
	{
	  "BAKANLIK_KOD": 330101,
	  "UN_NO": 3301,
	  "ORİJİNAL İSİM": "AŞINDIRICI SIVI, KENDİLİĞİNDEN ISINAN, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CS1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 330101,
	  "UN_NO__1": 3301
	},
	{
	  "BAKANLIK_KOD": 330102,
	  "UN_NO": 3301,
	  "ORİJİNAL İSİM": "AŞINDIRICI SIVI, KENDİLİĞİNDEN ISINAN, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CS1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 330102,
	  "UN_NO__1": 3301
	},
	{
	  "BAKANLIK_KOD": 330200,
	  "UN_NO": 3302,
	  "ORİJİNAL İSİM": "2-DİMETİLAMİNOETİL-AKRİLAT, STABİLİZE",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 330200,
	  "UN_NO__1": 3302
	},
	{
	  "BAKANLIK_KOD": 330300,
	  "UN_NO": 3303,
	  "ORİJİNAL İSİM": "SIKIŞTIRILMIŞ GAZ, ZEHİRLİ, YÜKSELTGEN, B.B.B.",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "1TO",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 330300,
	  "UN_NO__1": 3303
	},
	{
	  "BAKANLIK_KOD": 330400,
	  "UN_NO": 3304,
	  "ORİJİNAL İSİM": "SIKIŞTIRILMIŞ GAZ, ZEHİRLİ, AŞINDIRICI, B.B.B.",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "1TC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 330400,
	  "UN_NO__1": 3304
	},
	{
	  "BAKANLIK_KOD": 330500,
	  "UN_NO": 3305,
	  "ORİJİNAL İSİM": "SIKIŞTIRILMIŞ GAZ, ZEHİRLİ, ALEVLENEBİLİR, AŞINDIRICI, B.B.B.",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "1TFC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 330500,
	  "UN_NO__1": 3305
	},
	{
	  "BAKANLIK_KOD": 330600,
	  "UN_NO": 3306,
	  "ORİJİNAL İSİM": "SIKIŞTIRILMIŞ GAZ, ZEHİRLİ, YÜKSELTGEN, AŞINDIRICI, B.B.B.",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "1TOC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 330600,
	  "UN_NO__1": 3306
	},
	{
	  "BAKANLIK_KOD": 330700,
	  "UN_NO": 3307,
	  "ORİJİNAL İSİM": "SIVILAŞTIRILMIŞ GAZ, ZEHİRLİ, YÜKSELTGEN, B.B.B.",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TO",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 330700,
	  "UN_NO__1": 3307
	},
	{
	  "BAKANLIK_KOD": 330800,
	  "UN_NO": 3308,
	  "ORİJİNAL İSİM": "SIVILAŞTIRILMIŞ GAZ, ZEHİRLİ, AŞINDIRICI, B.B.B.",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 330800,
	  "UN_NO__1": 3308
	},
	{
	  "BAKANLIK_KOD": 330900,
	  "UN_NO": 3309,
	  "ORİJİNAL İSİM": "SIVILAŞTIRILMIŞ GAZ, ZEHİRLİ, ALEVLENEBİLİR, AŞINDIRICI, B.B.B.",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TFC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 330900,
	  "UN_NO__1": 3309
	},
	{
	  "BAKANLIK_KOD": 331000,
	  "UN_NO": 3310,
	  "ORİJİNAL İSİM": "SIVILAŞTIRILMIŞ GAZ, ZEHİRLİ, YÜKSELTGEN, AŞINDIRICI, B.B.B.",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TOC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 331000,
	  "UN_NO__1": 3310
	},
	{
	  "BAKANLIK_KOD": 331100,
	  "UN_NO": 3311,
	  "ORİJİNAL İSİM": "GAZ, SOĞUTULMUŞ SIVI, YÜKSELTGEN, B.B.B.",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "3O",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 331100,
	  "UN_NO__1": 3311
	},
	{
	  "BAKANLIK_KOD": 331200,
	  "UN_NO": 3312,
	  "ORİJİNAL İSİM": "GAZ, SOĞUTULMUŞ SIVI, ALEVLENEBİLİR, B.B.B.",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "3F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 331200,
	  "UN_NO__1": 3312
	},
	{
	  "BAKANLIK_KOD": 331301,
	  "UN_NO": 3313,
	  "ORİJİNAL İSİM": "ORGANİK PİGMENTLER, KENDİLİĞİNDEN ISINAN",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 331301,
	  "UN_NO__1": 3313
	},
	{
	  "BAKANLIK_KOD": 331302,
	  "UN_NO": 3313,
	  "ORİJİNAL İSİM": "ORGANİK PİGMENTLER, KENDİLİĞİNDEN ISINAN",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 331302,
	  "UN_NO__1": 3313
	},
	{
	  "BAKANLIK_KOD": 331400,
	  "UN_NO": 3314,
	  "ORİJİNAL İSİM": "PLASTİK KALIP BİLEŞİĞİ hamur, tabaka veya çekilmiş kordon formunda olan, alevlenebilir buhar açığa çıkartan",
	  "SINIF": 9,
	  "SINIFLANDIRMA_KODU": "M3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 331400,
	  "UN_NO__1": 3314
	},
	{
	  "BAKANLIK_KOD": 331500,
	  "UN_NO": 3315,
	  "ORİJİNAL İSİM": "KİMYASAL NUMUNE, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T8",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 331500,
	  "UN_NO__1": 3315
	},
	{
	  "BAKANLIK_KOD": 331601,
	  "UN_NO": 3316,
	  "ORİJİNAL İSİM": "KİMYASAL KİTİ veya İLK YARDIM KİTİ",
	  "SINIF": 9,
	  "SINIFLANDIRMA_KODU": "M11",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 331601,
	  "UN_NO__1": 3316
	},
	{
	  "BAKANLIK_KOD": 331602,
	  "UN_NO": 3316,
	  "ORİJİNAL İSİM": "KİMYASAL KİTİ veya İLK YARDIM KİTİ",
	  "SINIF": 9,
	  "SINIFLANDIRMA_KODU": "M11",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 331602,
	  "UN_NO__1": 3316
	},
	{
	  "BAKANLIK_KOD": 331700,
	  "UN_NO": 3317,
	  "ORİJİNAL İSİM": "2-AMİNO-4,6-DİNİTROFENOL, ISLATILMIŞ kütlece %20'den az olmayan su ile",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "D",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 331700,
	  "UN_NO__1": 3317
	},
	{
	  "BAKANLIK_KOD": 331800,
	  "UN_NO": 3318,
	  "ORİJİNAL İSİM": "AMONYAK ÇÖZELTİSİ, 15 °C'de su içerisinde bağıl yoğunluğu 0,880'den az olan ve %50'den fazla amonyak",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "4TC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 331800,
	  "UN_NO__1": 3318
	},
	{
	  "BAKANLIK_KOD": 331900,
	  "UN_NO": 3319,
	  "ORİJİNAL İSİM": "NİTROGLİSERİN KARIŞIMI, DUYARLILIĞI AZALTILMIŞ, KATI, B.B.B. nitrogliserin içeriği kütlece %2'den fazla fakat %10'dan az olan",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "D",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 331900,
	  "UN_NO__1": 3319
	},
	{
	  "BAKANLIK_KOD": 332001,
	  "UN_NO": 3320,
	  "ORİJİNAL İSİM": "SODYUM BOROHİDRİT VE SODYUM HİDROKSİT ÇÖZELTİSİ, kütlece %12'den az sodyum borohidrit ve %40'dan az sodyum hidroksit içeren",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 332001,
	  "UN_NO__1": 3320
	},
	{
	  "BAKANLIK_KOD": 332002,
	  "UN_NO": 3320,
	  "ORİJİNAL İSİM": "SODYUM BOROHİDRİT VE SODYUM HİDROKSİT ÇÖZELTİSİ, kütlece %12'den az sodyum borohidrit ve %40'dan az sodyum hidroksit içeren",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C5",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 332002,
	  "UN_NO__1": 3320
	},
	{
	  "BAKANLIK_KOD": 332100,
	  "UN_NO": 3321,
	  "ORİJİNAL İSİM": "RADYOAKTİF MALZEME, DÜŞÜK ÖZGÜL AKTİVİTE (LSA-II), bölünebilir olmayan veya istisnai bölünebilir",
	  "SINIF": 7,
	  "SINIFLANDIRMA_KODU": "",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 332100,
	  "UN_NO__1": 3321
	},
	{
	  "BAKANLIK_KOD": 332200,
	  "UN_NO": 3322,
	  "ORİJİNAL İSİM": "RADYOAKTİF MALZEME, DÜŞÜK ÖZGÜL AKTİVİTE (LSA-III), bölünebilir olmayan veya istisnai bölünebilir",
	  "SINIF": 7,
	  "SINIFLANDIRMA_KODU": "",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 332200,
	  "UN_NO__1": 3322
	},
	{
	  "BAKANLIK_KOD": 332300,
	  "UN_NO": 3323,
	  "ORİJİNAL İSİM": "RADYOAKTİF MALZEME, TİP C AMBALAJ, bölünebilir olmayan veya istisnai bölünebilir",
	  "SINIF": 7,
	  "SINIFLANDIRMA_KODU": "",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 332300,
	  "UN_NO__1": 3323
	},
	{
	  "BAKANLIK_KOD": 332400,
	  "UN_NO": 3324,
	  "ORİJİNAL İSİM": "RADYOAKTİF MALZEME, DÜŞÜK ÖZGÜL AKTİVİTE (LSA- II), BÖLÜNEBİLİR",
	  "SINIF": 7,
	  "SINIFLANDIRMA_KODU": "",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 332400,
	  "UN_NO__1": 3324
	},
	{
	  "BAKANLIK_KOD": 332500,
	  "UN_NO": 3325,
	  "ORİJİNAL İSİM": "RADYOAKTİF MALZEME, DÜŞÜK ÖZGÜL AKTİVİTE (LSA-III), BÖLÜNEBİLİR",
	  "SINIF": 7,
	  "SINIFLANDIRMA_KODU": "",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 332500,
	  "UN_NO__1": 3325
	},
	{
	  "BAKANLIK_KOD": 332600,
	  "UN_NO": 3326,
	  "ORİJİNAL İSİM": "RADYOAKTİF MALZEME, YÜZEYİ BULAŞMIŞ NESNELER (LSA-I veya LSA-II), BÖLÜNEBİLİR",
	  "SINIF": 7,
	  "SINIFLANDIRMA_KODU": "",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 332600,
	  "UN_NO__1": 3326
	},
	{
	  "BAKANLIK_KOD": 332700,
	  "UN_NO": 3327,
	  "ORİJİNAL İSİM": "RADYOAKTİF MALZEME, TİP A AMBALAJ, BÖLÜNEBİLİR, özel hazırlanmamış",
	  "SINIF": 7,
	  "SINIFLANDIRMA_KODU": "",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 332700,
	  "UN_NO__1": 3327
	},
	{
	  "BAKANLIK_KOD": 332800,
	  "UN_NO": 3328,
	  "ORİJİNAL İSİM": "RADYOAKTİF MALZEME, TİP B(U) AMBALAJ, BÖLÜNEBİLİR",
	  "SINIF": 7,
	  "SINIFLANDIRMA_KODU": "",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 332800,
	  "UN_NO__1": 3328
	},
	{
	  "BAKANLIK_KOD": 332900,
	  "UN_NO": 3329,
	  "ORİJİNAL İSİM": "RADYOAKTİF MALZEME, TİP B(M) AMBALAJ, BÖLÜNEBİLİR",
	  "SINIF": 7,
	  "SINIFLANDIRMA_KODU": "",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 332900,
	  "UN_NO__1": 3329
	},
	{
	  "BAKANLIK_KOD": 333000,
	  "UN_NO": 3330,
	  "ORİJİNAL İSİM": "RADYOAKTİF MALZEME, TİP C AMBALAJ, BÖLÜNEBİLİR",
	  "SINIF": 7,
	  "SINIFLANDIRMA_KODU": "",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 333000,
	  "UN_NO__1": 3330
	},
	{
	  "BAKANLIK_KOD": 333100,
	  "UN_NO": 3331,
	  "ORİJİNAL İSİM": "RADYOAKTİF MALZEME, ÖZEL ANLAŞMA İLE TAŞINAN, BÖLÜNEBİLİR",
	  "SINIF": 7,
	  "SINIFLANDIRMA_KODU": "",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 333100,
	  "UN_NO__1": 3331
	},
	{
	  "BAKANLIK_KOD": 333200,
	  "UN_NO": 3332,
	  "ORİJİNAL İSİM": "RADYOAKTİF MALZEME, TİP A AMBALAJ, ÖZEL HAZIRLANMIŞ, bölünebilir olmayan veya istisnai bölünebilir",
	  "SINIF": 7,
	  "SINIFLANDIRMA_KODU": "",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 333200,
	  "UN_NO__1": 3332
	},
	{
	  "BAKANLIK_KOD": 333300,
	  "UN_NO": 3333,
	  "ORİJİNAL İSİM": "RADYOAKTİF MALZEME, TİP A AMBALAJ, ÖZEL HAZIRLANMIŞ, BÖLÜNEBİLİR",
	  "SINIF": 7,
	  "SINIFLANDIRMA_KODU": "",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 333300,
	  "UN_NO__1": 3333
	},
	{
	  "BAKANLIK_KOD": 333601,
	  "UN_NO": 3336,
	  "ORİJİNAL İSİM": "MERKAPTANLAR, SIVI, ALEVLENEBİLİR, B.B.B. veya MERKAPTAN KARIŞIMI, SIVI, ALEVLENEBİLİR, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 333601,
	  "UN_NO__1": 3336
	},
	{
	  "BAKANLIK_KOD": 333602,
	  "UN_NO": 3336,
	  "ORİJİNAL İSİM": "MERKAPTANLAR, SIVI, ALEVLENEBİLİR, B.B.B. veya MERKAPTAN KARIŞIMI, SIVI, ALEVLENEBİLİR, B.B.B. (50 °C'de buhar basıncı 110 kPa?dan daha yüksek olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 333602,
	  "UN_NO__1": 3336
	},
	{
	  "BAKANLIK_KOD": 333603,
	  "UN_NO": 3336,
	  "ORİJİNAL İSİM": "MERKAPTANLAR, SIVI, ALEVLENEBİLİR, B.B.B. veya MERKAPTAN KARIŞIMI, SIVI, ALEVLENEBİLİR, B.B.B. (50 °C'de buhar basıncı 110 kPa?a eşit veya daha düşük olan)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 333603,
	  "UN_NO__1": 3336
	},
	{
	  "BAKANLIK_KOD": 333604,
	  "UN_NO": 3336,
	  "ORİJİNAL İSİM": "MERKAPTANLAR, SIVI, ALEVLENEBİLİR, B.B.B. veya MERKAPTAN KARIŞIMI, SIVI, ALEVLENEBİLİR, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 333604,
	  "UN_NO__1": 3336
	},
	{
	  "BAKANLIK_KOD": 333700,
	  "UN_NO": 3337,
	  "ORİJİNAL İSİM": "SOĞUTUCU GAZ R 404A (takriben %44 pentafloroetan ve %52 1,1,1- trifloroetan içeren pentafloroetan, 1,1,1-trifloroetan ve 1,1,1,2-tetrafloroetan zeotropik karışımı)",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 333700,
	  "UN_NO__1": 3337
	},
	{
	  "BAKANLIK_KOD": 333800,
	  "UN_NO": 3338,
	  "ORİJİNAL İSİM": "SOĞUTUCU GAZ R 407A (takriben %40 pentafloroetan ve %20 diflorometan içeren diflorometan, pentafloroetan ve 1,1,1,2- tetrafloroetan zeotropik karışımı)",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 333800,
	  "UN_NO__1": 3338
	},
	{
	  "BAKANLIK_KOD": 333900,
	  "UN_NO": 3339,
	  "ORİJİNAL İSİM": "SOĞUTUCU GAZ R 407B (takriben %70 pentafloroetan ve %10 diflorometan içeren diflorometan, pentafloroetan ve 1,1,1,2- tetrafloroetan zeotropik karışımı)",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 333900,
	  "UN_NO__1": 3339
	},
	{
	  "BAKANLIK_KOD": 334000,
	  "UN_NO": 3340,
	  "ORİJİNAL İSİM": "SOĞUTUCU GAZ R 407A (takriben %25 pentafloroetan ve %23 diflorometan içeren diflorometan, pentafloroetan ve 1,1,1,2- tetrafloroetan zeotropik karışımı)",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 334000,
	  "UN_NO__1": 3340
	},
	{
	  "BAKANLIK_KOD": 334101,
	  "UN_NO": 3341,
	  "ORİJİNAL İSİM": "TİYOÜRE DİOKSİT",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 334101,
	  "UN_NO__1": 3341
	},
	{
	  "BAKANLIK_KOD": 334102,
	  "UN_NO": 3341,
	  "ORİJİNAL İSİM": "TİYOÜRE DİOKSİT",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 334102,
	  "UN_NO__1": 3341
	},
	{
	  "BAKANLIK_KOD": 334201,
	  "UN_NO": 3342,
	  "ORİJİNAL İSİM": "KSANTATLAR",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 334201,
	  "UN_NO__1": 3342
	},
	{
	  "BAKANLIK_KOD": 334202,
	  "UN_NO": 3342,
	  "ORİJİNAL İSİM": "KSANTATLAR",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 334202,
	  "UN_NO__1": 3342
	},
	{
	  "BAKANLIK_KOD": 334300,
	  "UN_NO": 3343,
	  "ORİJİNAL İSİM": "NİTROGLİSERİN KARIŞIMI, DUYARLILIĞI AZALTILMIŞ, SIVI, ALEVLENEBİLİR, B.B.B. kütlece %30'dan az nitrogliserin içeren",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "D",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 334300,
	  "UN_NO__1": 3343
	},
	{
	  "BAKANLIK_KOD": 334400,
	  "UN_NO": 3344,
	  "ORİJİNAL İSİM": "PENTAERİTRİT TETRANİTRAT (PENTAERİTRİTOL TETRANİTRAT; PETN) KARIŞIMI, DUYARLILIĞI AZALTILMIŞ, KATI, B.B.B., kütlece %10'dan fazla fakat %20'den az PETN içeren",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "D",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 334400,
	  "UN_NO__1": 3344
	},
	{
	  "BAKANLIK_KOD": 334501,
	  "UN_NO": 3345,
	  "ORİJİNAL İSİM": "FENOKSİASETİK ASİT TÜREVLİ PESTİSİT, KATI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 334501,
	  "UN_NO__1": 3345
	},
	{
	  "BAKANLIK_KOD": 334502,
	  "UN_NO": 3345,
	  "ORİJİNAL İSİM": "FENOKSİASETİK ASİT TÜREVLİ PESTİSİT, KATI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 334502,
	  "UN_NO__1": 3345
	},
	{
	  "BAKANLIK_KOD": 334503,
	  "UN_NO": 3345,
	  "ORİJİNAL İSİM": "FENOKSİASETİK ASİT TÜREVLİ PESTİSİT, KATI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 334503,
	  "UN_NO__1": 3345
	},
	{
	  "BAKANLIK_KOD": 334601,
	  "UN_NO": 3346,
	  "ORİJİNAL İSİM": "FENOKSİASETİK ASİT TÜREVLİ PESTİSİT, SIVI, ALEVLENEBİLİR, ZEHİRLİ, parlama noktası 23 °C'den düşük olan",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 334601,
	  "UN_NO__1": 3346
	},
	{
	  "BAKANLIK_KOD": 334602,
	  "UN_NO": 3346,
	  "ORİJİNAL İSİM": "FENOKSİASETİK ASİT TÜREVLİ PESTİSİT, SIVI, ALEVLENEBİLİR, ZEHİRLİ, parlama noktası 23 °C'den düşük olan",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 334602,
	  "UN_NO__1": 3346
	},
	{
	  "BAKANLIK_KOD": 334701,
	  "UN_NO": 3347,
	  "ORİJİNAL İSİM": "FENOKSİASETİK ASİT TÜREVLİ PESTİSİT, SIVI, ZEHİRLİ, ALEVLENEBİLİR, parlama noktası 23 °C'den düşük olmayan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 334701,
	  "UN_NO__1": 3347
	},
	{
	  "BAKANLIK_KOD": 334702,
	  "UN_NO": 3347,
	  "ORİJİNAL İSİM": "FENOKSİASETİK ASİT TÜREVLİ PESTİSİT, SIVI, ZEHİRLİ, ALEVLENEBİLİR, parlama noktası 23 °C'den düşük olmayan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 334702,
	  "UN_NO__1": 3347
	},
	{
	  "BAKANLIK_KOD": 334703,
	  "UN_NO": 3347,
	  "ORİJİNAL İSİM": "FENOKSİASETİK ASİT TÜREVLİ PESTİSİT, SIVI, ZEHİRLİ, ALEVLENEBİLİR, parlama noktası 23 °C'den düşük olmayan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 334703,
	  "UN_NO__1": 3347
	},
	{
	  "BAKANLIK_KOD": 334801,
	  "UN_NO": 3348,
	  "ORİJİNAL İSİM": "FENOKSİASETİK ASİT TÜREVLİ PESTİSİT, SIVI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 334801,
	  "UN_NO__1": 3348
	},
	{
	  "BAKANLIK_KOD": 334802,
	  "UN_NO": 3348,
	  "ORİJİNAL İSİM": "FENOKSİASETİK ASİT TÜREVLİ PESTİSİT, SIVI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 334802,
	  "UN_NO__1": 3348
	},
	{
	  "BAKANLIK_KOD": 334803,
	  "UN_NO": 3348,
	  "ORİJİNAL İSİM": "FENOKSİASETİK ASİT TÜREVLİ PESTİSİT, SIVI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 334803,
	  "UN_NO__1": 3348
	},
	{
	  "BAKANLIK_KOD": 334901,
	  "UN_NO": 3349,
	  "ORİJİNAL İSİM": "PİRETROİD PESTİSİT, KATI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 334901,
	  "UN_NO__1": 3349
	},
	{
	  "BAKANLIK_KOD": 334902,
	  "UN_NO": 3349,
	  "ORİJİNAL İSİM": "PİRETROİD PESTİSİT, KATI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 334902,
	  "UN_NO__1": 3349
	},
	{
	  "BAKANLIK_KOD": 334903,
	  "UN_NO": 3349,
	  "ORİJİNAL İSİM": "PİRETROİD PESTİSİT, KATI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T7",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 334903,
	  "UN_NO__1": 3349
	},
	{
	  "BAKANLIK_KOD": 335001,
	  "UN_NO": 3350,
	  "ORİJİNAL İSİM": "PİRETROİD PESTİSİT, SIVI, ALEVLENEBİLİR, ZEHİRLİ, parlama noktası 23 °C'den düşük olan",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 335001,
	  "UN_NO__1": 3350
	},
	{
	  "BAKANLIK_KOD": 335002,
	  "UN_NO": 3350,
	  "ORİJİNAL İSİM": "PİRETROİD PESTİSİT, SIVI, ALEVLENEBİLİR, ZEHİRLİ, parlama noktası 23 °C'den düşük olan",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 335002,
	  "UN_NO__1": 3350
	},
	{
	  "BAKANLIK_KOD": 335101,
	  "UN_NO": 3351,
	  "ORİJİNAL İSİM": "PİRETROİD PESTİSİT, SIVI, ZEHİRLİ, ALEVLENEBİLİR, parlama noktası 23 °C'den düşük olmayan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 335101,
	  "UN_NO__1": 3351
	},
	{
	  "BAKANLIK_KOD": 335102,
	  "UN_NO": 3351,
	  "ORİJİNAL İSİM": "PİRETROİD PESTİSİT, SIVI, ZEHİRLİ, ALEVLENEBİLİR, parlama noktası 23 °C'den düşük olmayan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 335102,
	  "UN_NO__1": 3351
	},
	{
	  "BAKANLIK_KOD": 335103,
	  "UN_NO": 3351,
	  "ORİJİNAL İSİM": "PİRETROİD PESTİSİT, SIVI, ZEHİRLİ, ALEVLENEBİLİR, parlama noktası 23 °C'den düşük olmayan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 335103,
	  "UN_NO__1": 3351
	},
	{
	  "BAKANLIK_KOD": 335201,
	  "UN_NO": 3352,
	  "ORİJİNAL İSİM": "PİRETROİD PESTİSİT, SIVI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 335201,
	  "UN_NO__1": 3352
	},
	{
	  "BAKANLIK_KOD": 335202,
	  "UN_NO": 3352,
	  "ORİJİNAL İSİM": "PİRETROİD PESTİSİT, SIVI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 335202,
	  "UN_NO__1": 3352
	},
	{
	  "BAKANLIK_KOD": 335203,
	  "UN_NO": 3352,
	  "ORİJİNAL İSİM": "PİRETROİD PESTİSİT, SIVI, ZEHİRLİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T6",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 335203,
	  "UN_NO__1": 3352
	},
	{
	  "BAKANLIK_KOD": 335400,
	  "UN_NO": 3354,
	  "ORİJİNAL İSİM": "İNSEKTİSİT GAZ, ALEVLENEBİLİR, B.B.B.",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 335400,
	  "UN_NO__1": 3354
	},
	{
	  "BAKANLIK_KOD": 335500,
	  "UN_NO": 3355,
	  "ORİJİNAL İSİM": "İNSEKTİSİT GAZ, ZEHİRLİ, ALEVLENEBİLİR, B.B.B.",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2TF",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 335500,
	  "UN_NO__1": 3355
	},
	{
	  "BAKANLIK_KOD": 335600,
	  "UN_NO": 3356,
	  "ORİJİNAL İSİM": "OKSİJEN ÜRETECİ, KİMYASAL",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O3",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 335600,
	  "UN_NO__1": 3356
	},
	{
	  "BAKANLIK_KOD": 335700,
	  "UN_NO": 3357,
	  "ORİJİNAL İSİM": "NİTROGLİSERİN KARIŞIMI, DUYARLILIĞI AZALTILMIŞ, SIVI, B.B.B. kütlece %30'dan az nitrogliserin içeren",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "D",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 335700,
	  "UN_NO__1": 3357
	},
	{
	  "BAKANLIK_KOD": 335800,
	  "UN_NO": 3358,
	  "ORİJİNAL İSİM": "SOĞUTUCU MAKİNELER alevlenebilir, zehirli olmayan, sıvılaştırılmış gaz içeren",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "6F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 335800,
	  "UN_NO__1": 3358
	},
	{
	  "BAKANLIK_KOD": 335900,
	  "UN_NO": 3359,
	  "ORİJİNAL İSİM": "FÜMİGEEDİLMİŞ KARGO TAŞIMA ÜNİTESİ",
	  "SINIF": 9,
	  "SINIFLANDIRMA_KODU": "M11",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 335900,
	  "UN_NO__1": 3359
	},
	{
	  "BAKANLIK_KOD": 336100,
	  "UN_NO": 3361,
	  "ORİJİNAL İSİM": "KLOROSİLANLAR, ZEHİRLİ, AŞINDIRICI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TC1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 336100,
	  "UN_NO__1": 3361
	},
	{
	  "BAKANLIK_KOD": 336200,
	  "UN_NO": 3362,
	  "ORİJİNAL İSİM": "KLOROSİLANLAR, ZEHİRLİ, AŞINDIRICI, ALEVLENEBİLİR, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TFC",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 336200,
	  "UN_NO__1": 3362
	},
	{
	  "BAKANLIK_KOD": 336300,
	  "UN_NO": 3363,
	  "ORİJİNAL İSİM": "NESNELER İÇİNDE TEHLİKELİ MALLAR veya MAKİNE İÇİNDE TEHLİKELİ MALLAR ya da APARAT İÇİNDE TEHLİKELİ MALLAR",
	  "SINIF": 9,
	  "SINIFLANDIRMA_KODU": "M11",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 336300,
	  "UN_NO__1": 3363
	},
	{
	  "BAKANLIK_KOD": 336400,
	  "UN_NO": 3364,
	  "ORİJİNAL İSİM": "TRİNİTROFENOL (PİKRİK ASİT) ISLATILMIŞ kütlece %10'dan az olmayan su ile",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "D",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 336400,
	  "UN_NO__1": 3364
	},
	{
	  "BAKANLIK_KOD": 336500,
	  "UN_NO": 3365,
	  "ORİJİNAL İSİM": "TRİNİTROKLOROBENZEN (PİKRİL KLORÜR), ISLATILMIŞ kütlece %10'dan az olmayan su ile",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "D",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 336500,
	  "UN_NO__1": 3365
	},
	{
	  "BAKANLIK_KOD": 336600,
	  "UN_NO": 3366,
	  "ORİJİNAL İSİM": "TRİNİTROTOLUEN (TNT), ISLATILMIŞ kütlece %10'dan az olmayan su ile",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "D",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 336600,
	  "UN_NO__1": 3366
	},
	{
	  "BAKANLIK_KOD": 336700,
	  "UN_NO": 3367,
	  "ORİJİNAL İSİM": "TRİNİTROBENZEN, ISLATILMIŞ kütlece %10'dan az olmayan su ile",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "D",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 336700,
	  "UN_NO__1": 3367
	},
	{
	  "BAKANLIK_KOD": 336800,
	  "UN_NO": 3368,
	  "ORİJİNAL İSİM": "TRİNİTROBENZOİK ASİT, ISLATILMIŞ kütlece %10'dan az olmayan su ile",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "D",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 336800,
	  "UN_NO__1": 3368
	},
	{
	  "BAKANLIK_KOD": 336900,
	  "UN_NO": 3369,
	  "ORİJİNAL İSİM": "SODYUM DİNİTRO-o-KRESOLAT, ISLATILMIŞ kütlece %10'dan az olmayan su ile",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "DT",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 336900,
	  "UN_NO__1": 3369
	},
	{
	  "BAKANLIK_KOD": 337000,
	  "UN_NO": 3370,
	  "ORİJİNAL İSİM": "ÜRE NİTRAT, ISLATILMIŞ kütlece %10'dan az olmayan su ile",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "D",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 337000,
	  "UN_NO__1": 3370
	},
	{
	  "BAKANLIK_KOD": 337100,
	  "UN_NO": 3371,
	  "ORİJİNAL İSİM": "2-METİLBÜTANAL",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 337100,
	  "UN_NO__1": 3371
	},
	{
	  "BAKANLIK_KOD": 337301,
	  "UN_NO": 3373,
	  "ORİJİNAL İSİM": "BİYOLOJİK MADDE, KATEGORİ B",
	  "SINIF": 6.2,
	  "SINIFLANDIRMA_KODU": "I4",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 337301,
	  "UN_NO__1": 3373
	},
	{
	  "BAKANLIK_KOD": 337302,
	  "UN_NO": 3373,
	  "ORİJİNAL İSİM": "BİYOLOJİK MADDE, KATEGORİ B (yalnız hayvansal malzeme)",
	  "SINIF": 6.2,
	  "SINIFLANDIRMA_KODU": "I4",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 337302,
	  "UN_NO__1": 3373
	},
	{
	  "BAKANLIK_KOD": 337400,
	  "UN_NO": 3374,
	  "ORİJİNAL İSİM": "ASETİLEN, ÇÖZÜCÜSÜZ",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "2F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 337400,
	  "UN_NO__1": 3374
	},
	{
	  "BAKANLIK_KOD": 337501,
	  "UN_NO": 3375,
	  "ORİJİNAL İSİM": "AMONYUM NİTRAT EMÜLSİYON veya SÜSPANSİYON veya JEL, tahripli patlayıcılar için ara ürün, sıvı",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 337501,
	  "UN_NO__1": 3375
	},
	{
	  "BAKANLIK_KOD": 337502,
	  "UN_NO": 3375,
	  "ORİJİNAL İSİM": "AMONYUM NİTRAT EMÜLSİYON veya SÜSPANSİYON veya JEL, tahripli patlayıcılar için ara ürün, katı",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 337502,
	  "UN_NO__1": 3375
	},
	{
	  "BAKANLIK_KOD": 337600,
	  "UN_NO": 3376,
	  "ORİJİNAL İSİM": "4-NİTROFENİL-HİDRAZİN, kütlece %30'dan az olmayan",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "D",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 337600,
	  "UN_NO__1": 3376
	},
	{
	  "BAKANLIK_KOD": 337700,
	  "UN_NO": 3377,
	  "ORİJİNAL İSİM": "SODYUM PERBORAT MONOHİDRAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 337700,
	  "UN_NO__1": 3377
	},
	{
	  "BAKANLIK_KOD": 337801,
	  "UN_NO": 3378,
	  "ORİJİNAL İSİM": "SODYUM KARBONAT PEROKSİHİDRAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 337801,
	  "UN_NO__1": 3378
	},
	{
	  "BAKANLIK_KOD": 337802,
	  "UN_NO": 3378,
	  "ORİJİNAL İSİM": "SODYUM KARBONAT PEROKSİHİDRAT",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 337802,
	  "UN_NO__1": 3378
	},
	{
	  "BAKANLIK_KOD": 337900,
	  "UN_NO": 3379,
	  "ORİJİNAL İSİM": "DUYARLILIĞI AZALTILMIŞ PATLAYICI, SIVI, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "D",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 337900,
	  "UN_NO__1": 3379
	},
	{
	  "BAKANLIK_KOD": 338000,
	  "UN_NO": 3380,
	  "ORİJİNAL İSİM": "DUYARLILIĞI AZALTILMIŞ PATLAYICI, KATI, B.B.B.",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "D",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 338000,
	  "UN_NO__1": 3380
	},
	{
	  "BAKANLIK_KOD": 338100,
	  "UN_NO": 3381,
	  "ORİJİNAL İSİM": "SOLUMA İLE ZEHİRLİ SIVI, B.B.B, 200 ml/m3'ten düşük veya eşit LC50 değerine sahip olan ve doymuş buhar konsantrasyonu 500 LC50'ye eşit veya daha yüksek olan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1 or T4",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 338100,
	  "UN_NO__1": 3381
	},
	{
	  "BAKANLIK_KOD": 338200,
	  "UN_NO": 3382,
	  "ORİJİNAL İSİM": "SOLUMA İLE ZEHİRLİ SIVI, B.B.B, 1000 ml/m3'ten düşük veya eşit LC50 değerine sahip olan ve doymuş buhar konsantrasyonu 10 LC50'ye eşit veya daha yüksek olan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1 or T4",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 338200,
	  "UN_NO__1": 3382
	},
	{
	  "BAKANLIK_KOD": 338300,
	  "UN_NO": 3383,
	  "ORİJİNAL İSİM": "SOLUMA İLE ZEHİRLİ SIVI, ALEVLENEBİLİR, B.B.B, 200 ml/m3'ten düşük veya eşit LC50 değerine sahip olan ve doymuş buhar konsantrasyonu 500 LC50'ye eşit veya daha yüksek olan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 338300,
	  "UN_NO__1": 3383
	},
	{
	  "BAKANLIK_KOD": 338400,
	  "UN_NO": 3384,
	  "ORİJİNAL İSİM": "SOLUMA İLE ZEHİRLİ SIVI, ALEVLENEBİLİR, B.B.B, 1000 ml/m3'ten düşük veya eşit LC50 değerine sahip olan ve doymuş buhar konsantrasyonu 10 LC50'ye eşit veya daha yüksek olan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 338400,
	  "UN_NO__1": 3384
	},
	{
	  "BAKANLIK_KOD": 338500,
	  "UN_NO": 3385,
	  "ORİJİNAL İSİM": "SOLUMA İLE ZEHİRLİ SIVI, SU İLE TEPKİMEYE GİREN, B.B.B, 200 ml/m3'ten düşük veya eşit LC50 değerine sahip olan ve doymuş buhar konsantrasyonu 500 LC50'ye eşit veya daha yüksek olan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TW1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 338500,
	  "UN_NO__1": 3385
	},
	{
	  "BAKANLIK_KOD": 338600,
	  "UN_NO": 3386,
	  "ORİJİNAL İSİM": "SOLUMA İLE ZEHİRLİ SIVI, SU İLE TEPKİMEYE GİREN, B.B.B, 1000 ml/m3'ten düşük veya eşit LC50 değerine sahip olan ve doymuş buhar konsantrasyonu 10 LC50'ye eşit veya daha yüksek olan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TW1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 338600,
	  "UN_NO__1": 3386
	},
	{
	  "BAKANLIK_KOD": 338700,
	  "UN_NO": 3387,
	  "ORİJİNAL İSİM": "SOLUMA İLE ZEHİRLİ SIVI, YÜKSELTGEN, B.B.B, 200 ml/m3'ten düşük veya eşit LC50 değerine sahip olan ve doymuş buhar konsantrasyonu 500 LC50'ye eşit veya daha yüksek olan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TO1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 338700,
	  "UN_NO__1": 3387
	},
	{
	  "BAKANLIK_KOD": 338800,
	  "UN_NO": 3388,
	  "ORİJİNAL İSİM": "SOLUMA İLE ZEHİRLİ SIVI, YÜKSELTGEN, B.B.B, 1000 ml/m3'ten düşük veya eşit LC50 değerine sahip olan ve doymuş buhar konsantrasyonu 10 LC50'ye eşit veya daha yüksek olan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TO1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 338800,
	  "UN_NO__1": 3388
	},
	{
	  "BAKANLIK_KOD": 338900,
	  "UN_NO": 3389,
	  "ORİJİNAL İSİM": "SOLUMA İLE ZEHİRLİ SIVI, AŞINDIRICI, B.B.B, 200 ml/m3'ten düşük veya eşit LC50 değerine sahip olan ve doymuş buhar konsantrasyonu 500 LC50'ye eşit veya daha yüksek olan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TC1 or\n TC3",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 338900,
	  "UN_NO__1": 3389
	},
	{
	  "BAKANLIK_KOD": 339000,
	  "UN_NO": 3390,
	  "ORİJİNAL İSİM": "SOLUMA İLE ZEHİRLİ SIVI, AŞINDIRICI, B.B.B, 1000 ml/m3'ten düşük veya eşit LC50 değerine sahip olan ve doymuş buhar konsantrasyonu 10 LC50'ye eşit veya daha yüksek olan",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TC1 or\n TC3",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 339000,
	  "UN_NO__1": 3390
	},
	{
	  "BAKANLIK_KOD": 339100,
	  "UN_NO": 3391,
	  "ORİJİNAL İSİM": "ORGANOMETALİK MADDE, KATI, PİROFORİK",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S5",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 339100,
	  "UN_NO__1": 3391
	},
	{
	  "BAKANLIK_KOD": 339200,
	  "UN_NO": 3392,
	  "ORİJİNAL İSİM": "ORGANOMETALİK MADDE, SIVI, PİROFORİK",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S5",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 339200,
	  "UN_NO__1": 3392
	},
	{
	  "BAKANLIK_KOD": 339300,
	  "UN_NO": 3393,
	  "ORİJİNAL İSİM": "ORGANOMETALİK MADDE, KATI, PİROFORİK, SU İLE TEPKİMEYE GİREN",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "SW",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 339300,
	  "UN_NO__1": 3393
	},
	{
	  "BAKANLIK_KOD": 339400,
	  "UN_NO": 3394,
	  "ORİJİNAL İSİM": "ORGANOMETALİK MADDE, SIVI, PİROFORİK, SU İLE TEPKİMEYE GİREN",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "SW",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 339400,
	  "UN_NO__1": 3394
	},
	{
	  "BAKANLIK_KOD": 339501,
	  "UN_NO": 3395,
	  "ORİJİNAL İSİM": "ORGANOMETALİK MADDE, KATI, SU İLE TEPKİMEYE GİREN",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 339501,
	  "UN_NO__1": 3395
	},
	{
	  "BAKANLIK_KOD": 339502,
	  "UN_NO": 3395,
	  "ORİJİNAL İSİM": "ORGANOMETALİK MADDE, KATI, SU İLE TEPKİMEYE GİREN",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 339502,
	  "UN_NO__1": 3395
	},
	{
	  "BAKANLIK_KOD": 339503,
	  "UN_NO": 3395,
	  "ORİJİNAL İSİM": "ORGANOMETALİK MADDE, KATI, SU İLE TEPKİMEYE GİREN",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 339503,
	  "UN_NO__1": 3395
	},
	{
	  "BAKANLIK_KOD": 339601,
	  "UN_NO": 3396,
	  "ORİJİNAL İSİM": "ORGANOMETALİK MADDE, KATI, SU İLE TEPKİMEYE GİREN, ALEVLENEBİLİR",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WF2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 339601,
	  "UN_NO__1": 3396
	},
	{
	  "BAKANLIK_KOD": 339602,
	  "UN_NO": 3396,
	  "ORİJİNAL İSİM": "ORGANOMETALİK MADDE, KATI, SU İLE TEPKİMEYE GİREN, ALEVLENEBİLİR",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WF2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 339602,
	  "UN_NO__1": 3396
	},
	{
	  "BAKANLIK_KOD": 339603,
	  "UN_NO": 3396,
	  "ORİJİNAL İSİM": "ORGANOMETALİK MADDE, KATI, SU İLE TEPKİMEYE GİREN, ALEVLENEBİLİR",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WF2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 339603,
	  "UN_NO__1": 3396
	},
	{
	  "BAKANLIK_KOD": 339701,
	  "UN_NO": 3397,
	  "ORİJİNAL İSİM": "ORGANOMETALİK MADDE, KATI, SU İLE TEPKİMEYE GİREN, KENDİLİĞİNDEN ISINAN",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WS",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 339701,
	  "UN_NO__1": 3397
	},
	{
	  "BAKANLIK_KOD": 339702,
	  "UN_NO": 3397,
	  "ORİJİNAL İSİM": "ORGANOMETALİK MADDE, KATI, SU İLE TEPKİMEYE GİREN, KENDİLİĞİNDEN ISINAN",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WS",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 339702,
	  "UN_NO__1": 3397
	},
	{
	  "BAKANLIK_KOD": 339703,
	  "UN_NO": 3397,
	  "ORİJİNAL İSİM": "ORGANOMETALİK MADDE, KATI, SU İLE TEPKİMEYE GİREN, KENDİLİĞİNDEN ISINAN",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WS",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 339703,
	  "UN_NO__1": 3397
	},
	{
	  "BAKANLIK_KOD": 339801,
	  "UN_NO": 3398,
	  "ORİJİNAL İSİM": "ORGANOMETALİK MADDE, SIVI, SU İLE TEPKİMEYE GİREN",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 339801,
	  "UN_NO__1": 3398
	},
	{
	  "BAKANLIK_KOD": 339802,
	  "UN_NO": 3398,
	  "ORİJİNAL İSİM": "ORGANOMETALİK MADDE, SIVI, SU İLE TEPKİMEYE GİREN",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 339802,
	  "UN_NO__1": 3398
	},
	{
	  "BAKANLIK_KOD": 339803,
	  "UN_NO": 3398,
	  "ORİJİNAL İSİM": "ORGANOMETALİK MADDE, SIVI, SU İLE TEPKİMEYE GİREN",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 339803,
	  "UN_NO__1": 3398
	},
	{
	  "BAKANLIK_KOD": 339901,
	  "UN_NO": 3399,
	  "ORİJİNAL İSİM": "ORGANOMETALİK MADDE, SIVI, SU İLE TEPKİMEYE GİREN, ALEVLENEBİLİR",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 339901,
	  "UN_NO__1": 3399
	},
	{
	  "BAKANLIK_KOD": 339902,
	  "UN_NO": 3399,
	  "ORİJİNAL İSİM": "ORGANOMETALİK MADDE, SIVI, SU İLE TEPKİMEYE GİREN, ALEVLENEBİLİR",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WF1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 339902,
	  "UN_NO__1": 3399
	},
	{
	  "BAKANLIK_KOD": 339903,
	  "UN_NO": 3399,
	  "ORİJİNAL İSİM": "ORGANOMETALİK MADDE, SIVI, SU İLE TEPKİMEYE GİREN, ALEVLENEBİLİR",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WF1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 339903,
	  "UN_NO__1": 3399
	},
	{
	  "BAKANLIK_KOD": 340001,
	  "UN_NO": 3400,
	  "ORİJİNAL İSİM": "ORGANOMETALİK MADDE, KATI, KENDİLİĞİNDEN ISINAN",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S5",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 340001,
	  "UN_NO__1": 3400
	},
	{
	  "BAKANLIK_KOD": 340002,
	  "UN_NO": 3400,
	  "ORİJİNAL İSİM": "ORGANOMETALİK MADDE, KATI, KENDİLİĞİNDEN ISINAN",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S5",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 340002,
	  "UN_NO__1": 3400
	},
	{
	  "BAKANLIK_KOD": 340100,
	  "UN_NO": 3401,
	  "ORİJİNAL İSİM": "ALKALİ METAL AMALGAM, KATI",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 340100,
	  "UN_NO__1": 3401
	},
	{
	  "BAKANLIK_KOD": 340200,
	  "UN_NO": 3402,
	  "ORİJİNAL İSİM": "ALKALİ TOPRAK METAL AMALGAM, KATI",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 340200,
	  "UN_NO__1": 3402
	},
	{
	  "BAKANLIK_KOD": 340300,
	  "UN_NO": 3403,
	  "ORİJİNAL İSİM": "POTASYUM METAL ALAŞIMLARI, KATI",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 340300,
	  "UN_NO__1": 3403
	},
	{
	  "BAKANLIK_KOD": 340400,
	  "UN_NO": 3404,
	  "ORİJİNAL İSİM": "POTASYUM SODYUM ALAŞIMLARI, KATI",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 340400,
	  "UN_NO__1": 3404
	},
	{
	  "BAKANLIK_KOD": 340501,
	  "UN_NO": 3405,
	  "ORİJİNAL İSİM": "BARYUM KLORAT ÇÖZELTİSİ",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OT1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 340501,
	  "UN_NO__1": 3405
	},
	{
	  "BAKANLIK_KOD": 340502,
	  "UN_NO": 3405,
	  "ORİJİNAL İSİM": "BARYUM KLORAT ÇÖZELTİSİ",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OT1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 340502,
	  "UN_NO__1": 3405
	},
	{
	  "BAKANLIK_KOD": 340601,
	  "UN_NO": 3406,
	  "ORİJİNAL İSİM": "BARYUM PERKLORAT ÇÖZELTİSİ",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OT1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 340601,
	  "UN_NO__1": 3406
	},
	{
	  "BAKANLIK_KOD": 340602,
	  "UN_NO": 3406,
	  "ORİJİNAL İSİM": "BARYUM PERKLORAT ÇÖZELTİSİ",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OT1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 340602,
	  "UN_NO__1": 3406
	},
	{
	  "BAKANLIK_KOD": 340701,
	  "UN_NO": 3407,
	  "ORİJİNAL İSİM": "KLORAT VE MAGNEZYUM KLORÜR ÇÖZELTİSİ",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 340701,
	  "UN_NO__1": 3407
	},
	{
	  "BAKANLIK_KOD": 340702,
	  "UN_NO": 3407,
	  "ORİJİNAL İSİM": "KLORAT VE MAGNEZYUM KLORÜR ÇÖZELTİSİ",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 340702,
	  "UN_NO__1": 3407
	},
	{
	  "BAKANLIK_KOD": 340801,
	  "UN_NO": 3408,
	  "ORİJİNAL İSİM": "KURŞUN PERKLORAT ÇÖZELTİSİ",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OT1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 340801,
	  "UN_NO__1": 3408
	},
	{
	  "BAKANLIK_KOD": 340802,
	  "UN_NO": 3408,
	  "ORİJİNAL İSİM": "KURŞUN PERKLORAT ÇÖZELTİSİ",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OT1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 340802,
	  "UN_NO__1": 3408
	},
	{
	  "BAKANLIK_KOD": 340900,
	  "UN_NO": 3409,
	  "ORİJİNAL İSİM": "KLORONİTROBENZENLER, SIVI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 340900,
	  "UN_NO__1": 3409
	},
	{
	  "BAKANLIK_KOD": 341000,
	  "UN_NO": 3410,
	  "ORİJİNAL İSİM": "4-KLORO-o-TOLUİDİN HİDROKLORÜR ÇÖZELTİSİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 341000,
	  "UN_NO__1": 3410
	},
	{
	  "BAKANLIK_KOD": 341101,
	  "UN_NO": 3411,
	  "ORİJİNAL İSİM": "beta-NAFTİLAMİN ÇÖZELTİSİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 341101,
	  "UN_NO__1": 3411
	},
	{
	  "BAKANLIK_KOD": 341102,
	  "UN_NO": 3411,
	  "ORİJİNAL İSİM": "beta-NAFTİLAMİN ÇÖZELTİSİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 341102,
	  "UN_NO__1": 3411
	},
	{
	  "BAKANLIK_KOD": 341201,
	  "UN_NO": 3412,
	  "ORİJİNAL İSİM": "FORMİK ASİT, kütlece %10'dan fazla ancak %85'ten az asit içeren",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 341201,
	  "UN_NO__1": 3412
	},
	{
	  "BAKANLIK_KOD": 341202,
	  "UN_NO": 3412,
	  "ORİJİNAL İSİM": "FORMİK ASİT, kütlece %5'ten fazla ancak %10'dan az asit içeren",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 341202,
	  "UN_NO__1": 3412
	},
	{
	  "BAKANLIK_KOD": 341301,
	  "UN_NO": 3413,
	  "ORİJİNAL İSİM": "POTASYUM SİYANÜR ÇÖZELTİSİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T4",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 341301,
	  "UN_NO__1": 3413
	},
	{
	  "BAKANLIK_KOD": 341302,
	  "UN_NO": 3413,
	  "ORİJİNAL İSİM": "POTASYUM SİYANÜR ÇÖZELTİSİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T4",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 341302,
	  "UN_NO__1": 3413
	},
	{
	  "BAKANLIK_KOD": 341303,
	  "UN_NO": 3413,
	  "ORİJİNAL İSİM": "POTASYUM SİYANÜR ÇÖZELTİSİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T4",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 341303,
	  "UN_NO__1": 3413
	},
	{
	  "BAKANLIK_KOD": 341401,
	  "UN_NO": 3414,
	  "ORİJİNAL İSİM": "SODYUM SİYANÜR ÇÖZELTİSİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T4",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 341401,
	  "UN_NO__1": 3414
	},
	{
	  "BAKANLIK_KOD": 341402,
	  "UN_NO": 3414,
	  "ORİJİNAL İSİM": "SODYUM SİYANÜR ÇÖZELTİSİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T4",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 341402,
	  "UN_NO__1": 3414
	},
	{
	  "BAKANLIK_KOD": 341403,
	  "UN_NO": 3414,
	  "ORİJİNAL İSİM": "SODYUM SİYANÜR ÇÖZELTİSİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T4",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 341403,
	  "UN_NO__1": 3414
	},
	{
	  "BAKANLIK_KOD": 341500,
	  "UN_NO": 3415,
	  "ORİJİNAL İSİM": "SODYUM FLORÜR ÇÖZELTİSİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T4",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 341500,
	  "UN_NO__1": 3415
	},
	{
	  "BAKANLIK_KOD": 341600,
	  "UN_NO": 3416,
	  "ORİJİNAL İSİM": "KLOROASETO-FENON, SIVI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 341600,
	  "UN_NO__1": 3416
	},
	{
	  "BAKANLIK_KOD": 341700,
	  "UN_NO": 3417,
	  "ORİJİNAL İSİM": "KSİLİL BROMÜR, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 341700,
	  "UN_NO__1": 3417
	},
	{
	  "BAKANLIK_KOD": 341800,
	  "UN_NO": 3418,
	  "ORİJİNAL İSİM": "2,4-TOLUİLENDİAMİN ÇÖZELTİSİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 341800,
	  "UN_NO__1": 3418
	},
	{
	  "BAKANLIK_KOD": 341900,
	  "UN_NO": 3419,
	  "ORİJİNAL İSİM": "BOR TRİFLORÜR ASETİK ASİT KOMPLEKSİ, KATI",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C4",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 341900,
	  "UN_NO__1": 3419
	},
	{
	  "BAKANLIK_KOD": 342000,
	  "UN_NO": 3420,
	  "ORİJİNAL İSİM": "BOR TRİFLORÜR PROPİYONİK ASİT KOMPLEKSİ, KATI",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C4",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 342000,
	  "UN_NO__1": 3420
	},
	{
	  "BAKANLIK_KOD": 342101,
	  "UN_NO": 3421,
	  "ORİJİNAL İSİM": "POTASYUM HİDROJENDİFLORÜR ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CT1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 342101,
	  "UN_NO__1": 3421
	},
	{
	  "BAKANLIK_KOD": 342102,
	  "UN_NO": 3421,
	  "ORİJİNAL İSİM": "POTASYUM HİDROJENDİFLORÜR ÇÖZELTİSİ",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CT1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 342102,
	  "UN_NO__1": 3421
	},
	{
	  "BAKANLIK_KOD": 342200,
	  "UN_NO": 3422,
	  "ORİJİNAL İSİM": "POTASYUM FLORÜR ÇÖZELTİSİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T4",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 342200,
	  "UN_NO__1": 3422
	},
	{
	  "BAKANLIK_KOD": 342300,
	  "UN_NO": 3423,
	  "ORİJİNAL İSİM": "TETRAMETİL-AMONYUM HİDROKSİT, KATI",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C8",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 342300,
	  "UN_NO__1": 3423
	},
	{
	  "BAKANLIK_KOD": 342401,
	  "UN_NO": 3424,
	  "ORİJİNAL İSİM": "AMONYUM DİNİTRO-o-KRESOLAT ÇÖZELTİSİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 342401,
	  "UN_NO__1": 3424
	},
	{
	  "BAKANLIK_KOD": 342402,
	  "UN_NO": 3424,
	  "ORİJİNAL İSİM": "AMONYUM DİNİTRO-o- KRESOLAT ÇÖZELTİSİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 342402,
	  "UN_NO__1": 3424
	},
	{
	  "BAKANLIK_KOD": 342500,
	  "UN_NO": 3425,
	  "ORİJİNAL İSİM": "BROMOASETİK ASİT, KATI",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C4",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 342500,
	  "UN_NO__1": 3425
	},
	{
	  "BAKANLIK_KOD": 342600,
	  "UN_NO": 3426,
	  "ORİJİNAL İSİM": "AKRİLAMİD ÇÖZELTİSİ",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 342600,
	  "UN_NO__1": 3426
	},
	{
	  "BAKANLIK_KOD": 342700,
	  "UN_NO": 3427,
	  "ORİJİNAL İSİM": "KLOROBENZİL KLORÜRLER, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 342700,
	  "UN_NO__1": 3427
	},
	{
	  "BAKANLIK_KOD": 342800,
	  "UN_NO": 3428,
	  "ORİJİNAL İSİM": "3-KLORO-4-METİLFENİL İZOSİYANAT, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 342800,
	  "UN_NO__1": 3428
	},
	{
	  "BAKANLIK_KOD": 342900,
	  "UN_NO": 3429,
	  "ORİJİNAL İSİM": "KLOROTOLUİDİNLER, SIVI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 342900,
	  "UN_NO__1": 3429
	},
	{
	  "BAKANLIK_KOD": 343000,
	  "UN_NO": 3430,
	  "ORİJİNAL İSİM": "KSİLENOLLER, SIVI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 343000,
	  "UN_NO__1": 3430
	},
	{
	  "BAKANLIK_KOD": 343100,
	  "UN_NO": 3431,
	  "ORİJİNAL İSİM": "NİTROBENZO-TRİFLORÜRLER, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 343100,
	  "UN_NO__1": 3431
	},
	{
	  "BAKANLIK_KOD": 343200,
	  "UN_NO": 3432,
	  "ORİJİNAL İSİM": "POLİKLORİNLENMİŞ BİFENİLLER, KATI",
	  "SINIF": 9,
	  "SINIFLANDIRMA_KODU": "M2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 343200,
	  "UN_NO__1": 3432
	},
	{
	  "BAKANLIK_KOD": 343400,
	  "UN_NO": 3434,
	  "ORİJİNAL İSİM": "NİTROKRESOLLER, SIVI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 343400,
	  "UN_NO__1": 3434
	},
	{
	  "BAKANLIK_KOD": 343600,
	  "UN_NO": 3436,
	  "ORİJİNAL İSİM": "HEKZAFLOROASETON HİDRAT, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 343600,
	  "UN_NO__1": 3436
	},
	{
	  "BAKANLIK_KOD": 343700,
	  "UN_NO": 3437,
	  "ORİJİNAL İSİM": "KLOROKRESOLLER, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 343700,
	  "UN_NO__1": 3437
	},
	{
	  "BAKANLIK_KOD": 343800,
	  "UN_NO": 3438,
	  "ORİJİNAL İSİM": "alfa-METİLBENZİL ALKOL, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 343800,
	  "UN_NO__1": 3438
	},
	{
	  "BAKANLIK_KOD": 343901,
	  "UN_NO": 3439,
	  "ORİJİNAL İSİM": "NİTRİLLER, KATI, ZEHİRLİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 343901,
	  "UN_NO__1": 3439
	},
	{
	  "BAKANLIK_KOD": 343902,
	  "UN_NO": 3439,
	  "ORİJİNAL İSİM": "NİTRİLLER, KATI, ZEHİRLİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 343902,
	  "UN_NO__1": 3439
	},
	{
	  "BAKANLIK_KOD": 343903,
	  "UN_NO": 3439,
	  "ORİJİNAL İSİM": "NİTRİLLER, KATI, ZEHİRLİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 343903,
	  "UN_NO__1": 3439
	},
	{
	  "BAKANLIK_KOD": 344001,
	  "UN_NO": 3440,
	  "ORİJİNAL İSİM": "SELENYUM BİLEŞİĞİ, SIVI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T4",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 344001,
	  "UN_NO__1": 3440
	},
	{
	  "BAKANLIK_KOD": 344002,
	  "UN_NO": 3440,
	  "ORİJİNAL İSİM": "SELENYUM BİLEŞİĞİ, SIVI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T4",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 344002,
	  "UN_NO__1": 3440
	},
	{
	  "BAKANLIK_KOD": 344003,
	  "UN_NO": 3440,
	  "ORİJİNAL İSİM": "SELENYUM BİLEŞİĞİ, SIVI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T4",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 344003,
	  "UN_NO__1": 3440
	},
	{
	  "BAKANLIK_KOD": 344100,
	  "UN_NO": 3441,
	  "ORİJİNAL İSİM": "KLORODİNİTROBENZENLER, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 344100,
	  "UN_NO__1": 3441
	},
	{
	  "BAKANLIK_KOD": 344200,
	  "UN_NO": 3442,
	  "ORİJİNAL İSİM": "DİKLOROANİLİNLER, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 344200,
	  "UN_NO__1": 3442
	},
	{
	  "BAKANLIK_KOD": 344300,
	  "UN_NO": 3443,
	  "ORİJİNAL İSİM": "DİNİTROBENZENLER, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 344300,
	  "UN_NO__1": 3443
	},
	{
	  "BAKANLIK_KOD": 344400,
	  "UN_NO": 3444,
	  "ORİJİNAL İSİM": "NİKOTİN HİDROKLORÜR, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 344400,
	  "UN_NO__1": 3444
	},
	{
	  "BAKANLIK_KOD": 344500,
	  "UN_NO": 3445,
	  "ORİJİNAL İSİM": "NİKOTİN SÜLFAT, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 344500,
	  "UN_NO__1": 3445
	},
	{
	  "BAKANLIK_KOD": 344600,
	  "UN_NO": 3446,
	  "ORİJİNAL İSİM": "NİTROTOLUENLER, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 344600,
	  "UN_NO__1": 3446
	},
	{
	  "BAKANLIK_KOD": 344700,
	  "UN_NO": 3447,
	  "ORİJİNAL İSİM": "NİTROKSİLENLER, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 344700,
	  "UN_NO__1": 3447
	},
	{
	  "BAKANLIK_KOD": 344801,
	  "UN_NO": 3448,
	  "ORİJİNAL İSİM": "GÖZ YAŞARTICI GAZ MADDESİ, KATI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 344801,
	  "UN_NO__1": 3448
	},
	{
	  "BAKANLIK_KOD": 344802,
	  "UN_NO": 3448,
	  "ORİJİNAL İSİM": "GÖZ YAŞARTICI GAZ MADDESİ, KATI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 344802,
	  "UN_NO__1": 3448
	},
	{
	  "BAKANLIK_KOD": 344900,
	  "UN_NO": 3449,
	  "ORİJİNAL İSİM": "BROMOBENZİL SİYANÜRLER, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 344900,
	  "UN_NO__1": 3449
	},
	{
	  "BAKANLIK_KOD": 345000,
	  "UN_NO": 3450,
	  "ORİJİNAL İSİM": "DİFENİLKLORO-ARSİN, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T3",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 345000,
	  "UN_NO__1": 3450
	},
	{
	  "BAKANLIK_KOD": 345100,
	  "UN_NO": 3451,
	  "ORİJİNAL İSİM": "TOLUDİNLER, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 345100,
	  "UN_NO__1": 3451
	},
	{
	  "BAKANLIK_KOD": 345200,
	  "UN_NO": 3452,
	  "ORİJİNAL İSİM": "KSİLİDİNLER, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 345200,
	  "UN_NO__1": 3452
	},
	{
	  "BAKANLIK_KOD": 345300,
	  "UN_NO": 3453,
	  "ORİJİNAL İSİM": "FOSFORİK ASİT, KATI",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 345300,
	  "UN_NO__1": 3453
	},
	{
	  "BAKANLIK_KOD": 345400,
	  "UN_NO": 3454,
	  "ORİJİNAL İSİM": "DİNİTROTOLUENLER, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 345400,
	  "UN_NO__1": 3454
	},
	{
	  "BAKANLIK_KOD": 345500,
	  "UN_NO": 3455,
	  "ORİJİNAL İSİM": "KRESOLLER, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TC2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 345500,
	  "UN_NO__1": 3455
	},
	{
	  "BAKANLIK_KOD": 345600,
	  "UN_NO": 3456,
	  "ORİJİNAL İSİM": "NİTROSİLSÜLFÜRİK ASİT, KATI",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 345600,
	  "UN_NO__1": 3456
	},
	{
	  "BAKANLIK_KOD": 345700,
	  "UN_NO": 3457,
	  "ORİJİNAL İSİM": "KLORONİTROTOLUENLER, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 345700,
	  "UN_NO__1": 3457
	},
	{
	  "BAKANLIK_KOD": 345800,
	  "UN_NO": 3458,
	  "ORİJİNAL İSİM": "NİTROANİZOLLER, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 345800,
	  "UN_NO__1": 3458
	},
	{
	  "BAKANLIK_KOD": 345900,
	  "UN_NO": 3459,
	  "ORİJİNAL İSİM": "NİTROBROMOBENZENLER, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 345900,
	  "UN_NO__1": 3459
	},
	{
	  "BAKANLIK_KOD": 346000,
	  "UN_NO": 3460,
	  "ORİJİNAL İSİM": "N-ETİLBENZİL-TOLUİDİNLER, KATI",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 346000,
	  "UN_NO__1": 3460
	},
	{
	  "BAKANLIK_KOD": 346201,
	  "UN_NO": 3462,
	  "ORİJİNAL İSİM": "TOKSİNLER, CANLI KAYNAKLARDAN AYRIŞTIRILMIŞ, KATI, B.B.B",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 346201,
	  "UN_NO__1": 3462
	},
	{
	  "BAKANLIK_KOD": 346202,
	  "UN_NO": 3462,
	  "ORİJİNAL İSİM": "TOKSİNLER, CANLI KAYNAKLARDAN AYRIŞTIRILMIŞ, KATI, B.B.B",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 346202,
	  "UN_NO__1": 3462
	},
	{
	  "BAKANLIK_KOD": 346203,
	  "UN_NO": 3462,
	  "ORİJİNAL İSİM": "TOKSİNLER, CANLI KAYNAKLARDAN AYRIŞTIRILMIŞ, KATI, B.B.B",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 346203,
	  "UN_NO__1": 3462
	},
	{
	  "BAKANLIK_KOD": 346300,
	  "UN_NO": 3463,
	  "ORİJİNAL İSİM": "PROPİYONİK ASİT kütlece %90'dan az olmayan",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CF1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 346300,
	  "UN_NO__1": 3463
	},
	{
	  "BAKANLIK_KOD": 346401,
	  "UN_NO": 3464,
	  "ORİJİNAL İSİM": "ORGANOFOSFORLU BİLEŞİK, KATI, ZEHİRLİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 346401,
	  "UN_NO__1": 3464
	},
	{
	  "BAKANLIK_KOD": 346402,
	  "UN_NO": 3464,
	  "ORİJİNAL İSİM": "ORGANOFOSFORLU BİLEŞİK, KATI, ZEHİRLİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 346402,
	  "UN_NO__1": 3464
	},
	{
	  "BAKANLIK_KOD": 346403,
	  "UN_NO": 3464,
	  "ORİJİNAL İSİM": "ORGANOFOSFORLU BİLEŞİK, KATI, ZEHİRLİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 346403,
	  "UN_NO__1": 3464
	},
	{
	  "BAKANLIK_KOD": 346501,
	  "UN_NO": 3465,
	  "ORİJİNAL İSİM": "ORGANOARSENİK BİLEŞİK, KATI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T3",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 346501,
	  "UN_NO__1": 3465
	},
	{
	  "BAKANLIK_KOD": 346502,
	  "UN_NO": 3465,
	  "ORİJİNAL İSİM": "ORGANOARSENİK BİLEŞİK, KATI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 346502,
	  "UN_NO__1": 3465
	},
	{
	  "BAKANLIK_KOD": 346503,
	  "UN_NO": 3465,
	  "ORİJİNAL İSİM": "ORGANOARSENİK BİLEŞİK, KATI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 346503,
	  "UN_NO__1": 3465
	},
	{
	  "BAKANLIK_KOD": 346601,
	  "UN_NO": 3466,
	  "ORİJİNAL İSİM": "METAL KARBONİLLER, KATI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T3",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 346601,
	  "UN_NO__1": 3466
	},
	{
	  "BAKANLIK_KOD": 346602,
	  "UN_NO": 3466,
	  "ORİJİNAL İSİM": "METAL KARBONİLLER, KATI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 346602,
	  "UN_NO__1": 3466
	},
	{
	  "BAKANLIK_KOD": 346603,
	  "UN_NO": 3466,
	  "ORİJİNAL İSİM": "METAL KARBONİLLER, KATI, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 346603,
	  "UN_NO__1": 3466
	},
	{
	  "BAKANLIK_KOD": 346701,
	  "UN_NO": 3467,
	  "ORİJİNAL İSİM": "ORGANOMETALİK BİLEŞİK, KATI, ZEHİRLİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T3",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 346701,
	  "UN_NO__1": 3467
	},
	{
	  "BAKANLIK_KOD": 346702,
	  "UN_NO": 3467,
	  "ORİJİNAL İSİM": "ORGANOMETALİK BİLEŞİK, KATI, ZEHİRLİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 346702,
	  "UN_NO__1": 3467
	},
	{
	  "BAKANLIK_KOD": 346703,
	  "UN_NO": 3467,
	  "ORİJİNAL İSİM": "ORGANOMETALİK BİLEŞİK, KATI, ZEHİRLİ, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 346703,
	  "UN_NO__1": 3467
	},
	{
	  "BAKANLIK_KOD": 346800,
	  "UN_NO": 3468,
	  "ORİJİNAL İSİM": "METAL HİDRİT DEPOLAMA SİSTEMİ İÇİNDE HİDROJEN veya TEÇHİZAT İÇERİSİNDE BULUNAN METAL HİDRİT DEPOLAMA SİSTEMİ İÇİNDE HİDROJEN veya TEÇHİZAT İLE AMBALAJLANMIŞ METAL HİDRİT DEPOLAMA SİSTEMİ İÇİNDE HİDROJEN",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "1F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 346800,
	  "UN_NO__1": 3468
	},
	{
	  "BAKANLIK_KOD": 346901,
	  "UN_NO": 3469,
	  "ORİJİNAL İSİM": "BOYA, ALEVLENEBİLİR, AŞINDIRICI (boya, vernik, emaye, renklendirici, lake, cila, parlatıcı sıvı dolgu ve sıvı vernik bazı dahil) veya BOYA İLE İLGİLİ MALZEME, ALEVLENEBİLİR, AŞINDIRICI (boya inceltici veya azaltıcı bileşiği dahil)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 346901,
	  "UN_NO__1": 3469
	},
	{
	  "BAKANLIK_KOD": 346902,
	  "UN_NO": 3469,
	  "ORİJİNAL İSİM": "BOYA, ALEVLENEBİLİR, AŞINDIRICI (boya, vernik, emaye, renklendirici, lake, cila, parlatıcı sıvı dolgu ve sıvı vernik bazı dahil) veya BOYA İLE İLGİLİ MALZEME, ALEVLENEBİLİR, AŞINDIRICI (boya inceltici veya azaltıcı bileşiği dahil)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 346902,
	  "UN_NO__1": 3469
	},
	{
	  "BAKANLIK_KOD": 346903,
	  "UN_NO": 3469,
	  "ORİJİNAL İSİM": "BOYA, ALEVLENEBİLİR, AŞINDIRICI (boya, vernik, emaye, renklendirici, lake, cila, parlatıcı sıvı dolgu ve sıvı vernik bazı dahil) veya BOYA İLE İLGİLİ MALZEME, ALEVLENEBİLİR, AŞINDIRICI (boya inceltici veya azaltıcı bileşiği dahil)",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FC",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 346903,
	  "UN_NO__1": 3469
	},
	{
	  "BAKANLIK_KOD": 347000,
	  "UN_NO": 3470,
	  "ORİJİNAL İSİM": "BOYA, AŞINDIRICI, ALEVLENEBİLİR (boya, vernik, emaye, renklendirici, lake, cila, parlatıcı, sıvı dolgu ve sıvı vernik bazı dahil) veya BOYA İLE İLGİLİ MALZEME, AŞINDIRICI, ALEVLENEBİLİR (boya inceltici veya azaltıcı bileşiği dahil)",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CF1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 347000,
	  "UN_NO__1": 3470
	},
	{
	  "BAKANLIK_KOD": 347101,
	  "UN_NO": 3471,
	  "ORİJİNAL İSİM": "HİDROJENDİFLORÜRLER ÇÖZELTİSİ, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CT1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 347101,
	  "UN_NO__1": 3471
	},
	{
	  "BAKANLIK_KOD": 347102,
	  "UN_NO": 3471,
	  "ORİJİNAL İSİM": "HİDROJENDİFLORÜRLER ÇÖZELTİSİ, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CT1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 347102,
	  "UN_NO__1": 3471
	},
	{
	  "BAKANLIK_KOD": 347200,
	  "UN_NO": 3472,
	  "ORİJİNAL İSİM": "KROTONİK ASİT, SIVI",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C3",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 347200,
	  "UN_NO__1": 3472
	},
	{
	  "BAKANLIK_KOD": 347300,
	  "UN_NO": 3473,
	  "ORİJİNAL İSİM": "YAKIT PİLLİ KARTUŞLAR veya TEÇHİZAT İÇERİSİNDEKİ YAKIT PİLLİ KARTUŞLAR veya TEÇHİZAT İLE AMBALAJLANMIŞ YAKIT PİLLİ KARTUŞLAR alevlenebilir sıvılar içeren",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F3",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 347300,
	  "UN_NO__1": 3473
	},
	{
	  "BAKANLIK_KOD": 347400,
	  "UN_NO": 3474,
	  "ORİJİNAL İSİM": "1 -HİDROKSİBENZOTTRİAZOL MONOHİDRAT",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "D",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 347400,
	  "UN_NO__1": 3474
	},
	{
	  "BAKANLIK_KOD": 347500,
	  "UN_NO": 3475,
	  "ORİJİNAL İSİM": "ETANOL VE BENZİN KARIŞIMI, %10'dan fazla etanol ile",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 347500,
	  "UN_NO__1": 3475
	},
	{
	  "BAKANLIK_KOD": 347600,
	  "UN_NO": 3476,
	  "ORİJİNAL İSİM": "YAKIT PİLLİ KARTUŞLAR veya TEÇHİZAT İÇERİSİNDEKİ YAKIT PİLLİ KARTUŞLAR veya TEÇHİZAT İLE AMBALAJLANMIŞ YAKIT PİLLİ KARTUŞLAR, su ile\n tepkimeye giren maddeler içeren",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W3",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 347600,
	  "UN_NO__1": 3476
	},
	{
	  "BAKANLIK_KOD": 347700,
	  "UN_NO": 3477,
	  "ORİJİNAL İSİM": "YAKIT PİLLİ KARTUŞLAR veya TEÇHİZAT İÇERİSİNDEKİ YAKIT PİLLİ KARTUŞLAR veya TEÇHİZAT İLE AMBALAJLANMIŞ YAKIT PİLLİ KARTUŞLAR, aşındırıcı maddeler içeren",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C11",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 347700,
	  "UN_NO__1": 3477
	},
	{
	  "BAKANLIK_KOD": 347800,
	  "UN_NO": 3478,
	  "ORİJİNAL İSİM": "YAKIT PİLLİ KARTUŞLAR veya TEÇHİZAT İÇERİSİNDEKİ YAKIT PİLLİ KARTUŞLAR veya TEÇHİZAT İLE AMBALAJLANMIŞ YAKIT PİLLİ KARTUŞLAR sıvılaştırılmış alevlenebilir gaz içeren",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "6F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 347800,
	  "UN_NO__1": 3478
	},
	{
	  "BAKANLIK_KOD": 347900,
	  "UN_NO": 3479,
	  "ORİJİNAL İSİM": "YAKIT PİLLİ KARTUŞLAR veya TEÇHİZAT İÇERİSİNDEKİ YAKIT PİLLİ KARTUŞLAR veya TEÇHİZAT İLE AMBALAJLANMIŞ YAKIT PİLLİ KARTUŞLAR metal hidrit içinde hidrojen içeren",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "6F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 347900,
	  "UN_NO__1": 3479
	},
	{
	  "BAKANLIK_KOD": 348000,
	  "UN_NO": 3480,
	  "ORİJİNAL İSİM": "LİTYUM METAL BATARYALAR (lityum iyon polimer bataryalar dahil)",
	  "SINIF": 9,
	  "SINIFLANDIRMA_KODU": "M4",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 348000,
	  "UN_NO__1": 3480
	},
	{
	  "BAKANLIK_KOD": 348100,
	  "UN_NO": 3481,
	  "ORİJİNAL İSİM": "LİTYUM İYON BATARYALAR TEÇHİZAT İÇERİSİNDE veya LİTYUM İYON BATARYALAR TEÇHİZATLI AMBALAJLANMIŞ (lityum iyon polimer bataryalar dahil)",
	  "SINIF": 9,
	  "SINIFLANDIRMA_KODU": "M4",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 348100,
	  "UN_NO__1": 3481
	},
	{
	  "BAKANLIK_KOD": 348200,
	  "UN_NO": 3482,
	  "ORİJİNAL İSİM": "ALKALİ METAL DAĞILIMI, ALEVLENEBİLİR veya ALKALİ TOPRAK METAL DAĞILIMI, ALEVLENEBİLİR",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "WF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 348200,
	  "UN_NO__1": 3482
	},
	{
	  "BAKANLIK_KOD": 348300,
	  "UN_NO": 3483,
	  "ORİJİNAL İSİM": "MOTOR YAKITI VURUNTU ÖNLEYİCİ KARIŞIM, ALEVLENEBİLİR",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 348300,
	  "UN_NO__1": 3483
	},
	{
	  "BAKANLIK_KOD": 348400,
	  "UN_NO": 3484,
	  "ORİJİNAL İSİM": "HİDRAZİN SULU ÇÖZELTİ, ALEVLENEBİLİR kütlece %37'den fazla hidrazin içeren",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CFT",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 348400,
	  "UN_NO__1": 3484
	},
	{
	  "BAKANLIK_KOD": 348500,
	  "UN_NO": 3485,
	  "ORİJİNAL İSİM": "KALSİYUM HİPOKLORİT, KURU, AŞINDIRICI veya KALSİYUM HİPOKLORİT KARIŞIMI, KURU, AŞINDIRICI %39'dan fazla hazır klor (%8,8 hazır oksijen) ile",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OC2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 348500,
	  "UN_NO__1": 3485
	},
	{
	  "BAKANLIK_KOD": 348600,
	  "UN_NO": 3486,
	  "ORİJİNAL İSİM": "KALSİYUM HİPOKLORİT KARIŞIMI, KURU, AŞINDIRICI %10'dan fazla ancak %39'dan az hazır klor içeren",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OC2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 348600,
	  "UN_NO__1": 3486
	},
	{
	  "BAKANLIK_KOD": 348701,
	  "UN_NO": 3487,
	  "ORİJİNAL İSİM": "KALSİYUM HİPOKLORİT, HİDRATLANMIŞ, AŞINDIRICI veya KALSİYUM HİPOKLORİT, HİDRATLANMIŞ KARIŞIM, AŞINDIRICI %5,5'ten az olmayan ancak %16'dan fazla su içermeyen",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OC2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 348701,
	  "UN_NO__1": 3487
	},
	{
	  "BAKANLIK_KOD": 348702,
	  "UN_NO": 3487,
	  "ORİJİNAL İSİM": "KALSİYUM HİPOKLORİT, HİDRATLANMIŞ, AŞINDIRICI veya KALSİYUM HİPOKLORİT, HİDRATLANMIŞ KARIŞIM, AŞINDIRICI %5,5'ten az olmayan ancak %16'dan fazla su içermeyen",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "OC2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 348702,
	  "UN_NO__1": 3487
	},
	{
	  "BAKANLIK_KOD": 348800,
	  "UN_NO": 3488,
	  "ORİJİNAL İSİM": "SOLUMAYLA ZEHİRLİ SIVI, ALEVLENEBİLİR AŞINDIRICI, B.B.B. 200 ml/m3'ten düşük veya eşit LC50 değerine sahip olan ve doymuş buhar konsantrasyonu 500 LC50'ye eşit veya daha yüksek",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TFC",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 348800,
	  "UN_NO__1": 3488
	},
	{
	  "BAKANLIK_KOD": 348900,
	  "UN_NO": 3489,
	  "ORİJİNAL İSİM": "SOLUMAYLA ZEHİRLİ SIVI, ALEVLENEBİLİR, AŞINDIRICI, B.B.B, 1000 ml/m3'ten düşük veya eşit LC50 değerine sahip olan ve doymuş buhar konsantrasyonu 10 LC50'ye eşit veya daha yüksek",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TFC",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 348900,
	  "UN_NO__1": 3489
	},
	{
	  "BAKANLIK_KOD": 349000,
	  "UN_NO": 3490,
	  "ORİJİNAL İSİM": "SOLUMAYLA ZEHİRLİ SIVI, SU İLE TEPKİMEYE GİREN, ALEVLENEBİLİR, B.B.B. 200 ml/m3 den düşük veya eşit LC50 değerine sahip olan ve doymuş buhar konsantrasyonu 500 LC50'ye eşit veya daha yüksek",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TFW",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 349000,
	  "UN_NO__1": 3490
	},
	{
	  "BAKANLIK_KOD": 349100,
	  "UN_NO": 3491,
	  "ORİJİNAL İSİM": "SOLUMAYLA ZEHİRLİ SIVI, SU İLE TEPKİMEYE GİREN, ALEVLENEBİLİR B.B.B, 1000 ml/m3'ten düşük veya eşit LC50 değerine sahip olan ve doymuş buhar\n konsantrasyonu 10 LC50'ye eşit veya daha yüksek",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TFW",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 349100,
	  "UN_NO__1": 3491
	},
	{
	  "BAKANLIK_KOD": 349401,
	  "UN_NO": 3494,
	  "ORİJİNAL İSİM": "KÜKÜRTLÜ HAM PETROL, ALEVLENEBİLİR, ZEHİRLİ",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 349401,
	  "UN_NO__1": 3494
	},
	{
	  "BAKANLIK_KOD": 349402,
	  "UN_NO": 3494,
	  "ORİJİNAL İSİM": "KÜKÜRTLÜ HAM PETROL, ALEVLENEBİLİR, ZEHİRLİ",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 349402,
	  "UN_NO__1": 3494
	},
	{
	  "BAKANLIK_KOD": 349403,
	  "UN_NO": 3494,
	  "ORİJİNAL İSİM": "KÜKÜRTLÜ HAM PETROL, ALEVLENEBİLİR, ZEHİRLİ",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "FT1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 349403,
	  "UN_NO__1": 3494
	},
	{
	  "BAKANLIK_KOD": 349500,
	  "UN_NO": 3495,
	  "ORİJİNAL İSİM": "İYOT",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CT2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 349500,
	  "UN_NO__1": 3495
	},
	{
	  "BAKANLIK_KOD": 349701,
	  "UN_NO": 3497,
	  "ORİJİNAL İSİM": "KRİL KÜSPESİ",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S2",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 349701,
	  "UN_NO__1": 3497
	},
	{
	  "BAKANLIK_KOD": 349702,
	  "UN_NO": 3497,
	  "ORİJİNAL İSİM": "KRİL KÜSPESİ",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 349702,
	  "UN_NO__1": 3497
	},
	{
	  "BAKANLIK_KOD": 349800,
	  "UN_NO": 3498,
	  "ORİJİNAL İSİM": "İYOT MONOKLORÜR, SIVI",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C1",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 349800,
	  "UN_NO__1": 3498
	},
	{
	  "BAKANLIK_KOD": 349900,
	  "UN_NO": 3499,
	  "ORİJİNAL İSİM": "KAPASİTÖR, ELEKTRİKLİ ÇİFT KATMANLI (0,3 Wh'den daha büyük enerji depolama kapasitesine sahip)",
	  "SINIF": 9,
	  "SINIFLANDIRMA_KODU": "M11",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 349900,
	  "UN_NO__1": 3499
	},
	{
	  "BAKANLIK_KOD": 350000,
	  "UN_NO": 3500,
	  "ORİJİNAL İSİM": "BASINÇ ALTINDA KİMYASAL, B.B.B.",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "8A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 350000,
	  "UN_NO__1": 3500
	},
	{
	  "BAKANLIK_KOD": 350100,
	  "UN_NO": 3501,
	  "ORİJİNAL İSİM": "BASINÇ ALTINDA KİMYASAL, ALEVLENEBİLİR, B.B.B.",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "8F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 350100,
	  "UN_NO__1": 3501
	},
	{
	  "BAKANLIK_KOD": 350200,
	  "UN_NO": 3502,
	  "ORİJİNAL İSİM": "BASINÇ ALTINDA KİMYASAL, ZEHİRLİ, B.B.B.",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "8T",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 350200,
	  "UN_NO__1": 3502
	},
	{
	  "BAKANLIK_KOD": 350300,
	  "UN_NO": 3503,
	  "ORİJİNAL İSİM": "BASINÇ ALTINDA KİMYASAL, AŞINDIRICI, B.B.B.",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "8C",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 350300,
	  "UN_NO__1": 3503
	},
	{
	  "BAKANLIK_KOD": 350400,
	  "UN_NO": 3504,
	  "ORİJİNAL İSİM": "BASINÇ ALTINDA KİMYASAL, ALEVLENEBİLİR, ZEHİRLİ, B.B.B.",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "8TF",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 350400,
	  "UN_NO__1": 3504
	},
	{
	  "BAKANLIK_KOD": 350500,
	  "UN_NO": 3505,
	  "ORİJİNAL İSİM": "BASINÇ ALTINDA KİMYASAL, ALEVLENEBİLİR, AŞINDIRICI, B.B.B.",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "8FC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 350500,
	  "UN_NO__1": 3505
	},
	{
	  "BAKANLIK_KOD": 350600,
	  "UN_NO": 3506,
	  "ORİJİNAL İSİM": "ÜRETİLMİŞ NESNELERİN İÇERDİĞİ CIVA",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "CT3",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 350600,
	  "UN_NO__1": 3506
	},
	{
	  "BAKANLIK_KOD": 350700,
	  "UN_NO": 3507,
	  "ORİJİNAL İSİM": "URANYUM HEKSAFLORÜR, RADYOAKTİF MALZEME, ADİ PAKET, ambalaj başına 0,1 kg'dan daha az, bölünebilir olmayan ya da istisnai bölünebilir",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 350700,
	  "UN_NO__1": 3507
	},
	{
	  "BAKANLIK_KOD": 350800,
	  "UN_NO": 3508,
	  "ORİJİNAL İSİM": "KAPASİTÖR, ASİMETRİK (0,3 Wh'den yüksek enerji depolama kapasitesine sahip)",
	  "SINIF": 9,
	  "SINIFLANDIRMA_KODU": "M11",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 350800,
	  "UN_NO__1": 3508
	},
	{
	  "BAKANLIK_KOD": 350900,
	  "UN_NO": 3509,
	  "ORİJİNAL İSİM": "AMBALAJLAR, ISKARTA, BOŞ, TEMİZLENMEMİŞ",
	  "SINIF": 9,
	  "SINIFLANDIRMA_KODU": "M11",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 350900,
	  "UN_NO__1": 3509
	},
	{
	  "BAKANLIK_KOD": 351000,
	  "UN_NO": 3510,
	  "ORİJİNAL İSİM": "ADSORBE GAZ, ALEVLENEBİLİR, B.B.B.",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "9F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 351000,
	  "UN_NO__1": 3510
	},
	{
	  "BAKANLIK_KOD": 351100,
	  "UN_NO": 3511,
	  "ORİJİNAL İSİM": "ADSORBE GAZ, B.B.B.",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "9A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 351100,
	  "UN_NO__1": 3511
	},
	{
	  "BAKANLIK_KOD": 351200,
	  "UN_NO": 3512,
	  "ORİJİNAL İSİM": "ADSORBE GAZ, ZEHİRLİ, B.B.B.",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "9T",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 351200,
	  "UN_NO__1": 3512
	},
	{
	  "BAKANLIK_KOD": 351300,
	  "UN_NO": 3513,
	  "ORİJİNAL İSİM": "ADSORBE GAZ, YÜKSELTGEN, B.B.B.",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "9O",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 351300,
	  "UN_NO__1": 3513
	},
	{
	  "BAKANLIK_KOD": 351400,
	  "UN_NO": 3514,
	  "ORİJİNAL İSİM": "ADSORBE GAZ, ZEHİRLİ, ALEVLENEBİLİR, B.B.B.",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "9TF",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 351400,
	  "UN_NO__1": 3514
	},
	{
	  "BAKANLIK_KOD": 351500,
	  "UN_NO": 3515,
	  "ORİJİNAL İSİM": "ADSORBE GAZ, ZEHİRLİ, YÜKSELTGEN, B.B.B.",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "9TO",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 351500,
	  "UN_NO__1": 3515
	},
	{
	  "BAKANLIK_KOD": 351600,
	  "UN_NO": 3516,
	  "ORİJİNAL İSİM": "ADSORBE GAZ, ZEHİRLİ, AŞINDIRICI, B.B.B.",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "9TC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 351600,
	  "UN_NO__1": 3516
	},
	{
	  "BAKANLIK_KOD": 351700,
	  "UN_NO": 3517,
	  "ORİJİNAL İSİM": "ADSORBE GAZ, ZEHİRLİ, ALEVLENEBİLİR, AŞINDIRICI, B.B.B.",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "9TFC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 351700,
	  "UN_NO__1": 3517
	},
	{
	  "BAKANLIK_KOD": 351800,
	  "UN_NO": 3518,
	  "ORİJİNAL İSİM": "ADSORBE GAZ, ZEHİRLİ, YÜKSELTGEN, AŞINDIRICI, B.B.B.",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "9TOC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 351800,
	  "UN_NO__1": 3518
	},
	{
	  "BAKANLIK_KOD": 351900,
	  "UN_NO": 3519,
	  "ORİJİNAL İSİM": "BOR TRİFLORÜR, ADSORBE",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "9TC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 351900,
	  "UN_NO__1": 3519
	},
	{
	  "BAKANLIK_KOD": 352000,
	  "UN_NO": 3520,
	  "ORİJİNAL İSİM": "KLOR, ADSORBE",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "9TOC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 352000,
	  "UN_NO__1": 3520
	},
	{
	  "BAKANLIK_KOD": 352100,
	  "UN_NO": 3521,
	  "ORİJİNAL İSİM": "SİLİKON TETRAFLORÜR, ADSORBE",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "9TC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 352100,
	  "UN_NO__1": 3521
	},
	{
	  "BAKANLIK_KOD": 352200,
	  "UN_NO": 3522,
	  "ORİJİNAL İSİM": "ARSİN, ADSORBE",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "9TF",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 352200,
	  "UN_NO__1": 3522
	},
	{
	  "BAKANLIK_KOD": 352300,
	  "UN_NO": 3523,
	  "ORİJİNAL İSİM": "GERMAN, ADSORBE",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "9TF",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 352300,
	  "UN_NO__1": 3523
	},
	{
	  "BAKANLIK_KOD": 352400,
	  "UN_NO": 3524,
	  "ORİJİNAL İSİM": "FOSFOR PENTAFLORÜR, ADSORBE",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "9TC",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 352400,
	  "UN_NO__1": 3524
	},
	{
	  "BAKANLIK_KOD": 352500,
	  "UN_NO": 3525,
	  "ORİJİNAL İSİM": "FOSFİN, ADSORBE",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "9TF",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 352500,
	  "UN_NO__1": 3525
	},
	{
	  "BAKANLIK_KOD": 352600,
	  "UN_NO": 3526,
	  "ORİJİNAL İSİM": "HİDROJEN SELENÜR, ADSORBE",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "9TF",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 352600,
	  "UN_NO__1": 3526
	},
	{
	  "BAKANLIK_KOD": 352701,
	  "UN_NO": 3527,
	  "ORİJİNAL İSİM": "POLİESTER REÇİNE KİTİ, katı taban \n malzemesi",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F4",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 352701,
	  "UN_NO__1": 3527
	},
	{
	  "BAKANLIK_KOD": 352702,
	  "UN_NO": 3527,
	  "ORİJİNAL İSİM": "POLİESTER REÇİNE KİTİ, katı taban malzemesi",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F4",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 352702,
	  "UN_NO__1": 3527
	},
	{
	  "BAKANLIK_KOD": 352800,
	  "UN_NO": 3528,
	  "ORİJİNAL İSİM": "MOTOR İÇTEN YANMALI, ALEVLENEBİLİR SIVIYLA ÇALIŞAN veya MOTOR, YAKIT PİLİ, ALEVLENEBİLİR SIVIYLA ÇALIŞAN veya MAKİNE, İÇTEN YANMALI, ALEVLENEBİLİR SIVIYLA ÇALIŞAN veya MAKİNE, YAKIT PİLİ, ALEVLENEBİLİR SIVIYLA ÇALIŞAN",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F3",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 352800,
	  "UN_NO__1": 3528
	},
	{
	  "BAKANLIK_KOD": 352900,
	  "UN_NO": 3529,
	  "ORİJİNAL İSİM": "MOTOR İÇTEN YANMALI, ALEVLENEBİLİR GAZLA ÇALIŞAN veya MOTOR, YAKIT PİLİ, ALEVLENEBİLİR GAZLA ÇALIŞAN veya MAKİNE, İÇTEN YANMALI, ALEVLENEBİLİR GAZLA ÇALIŞAN veya MAKİNE, YAKIT PİLİ, ALEVLENEBİLİR GAZLA ÇALIŞAN",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "6F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 352900,
	  "UN_NO__1": 3529
	},
	{
	  "BAKANLIK_KOD": 353000,
	  "UN_NO": 3530,
	  "ORİJİNAL İSİM": "MOTOR, İÇTEN YANMALI veya MAKİNE, İÇTEN YANMALI",
	  "SINIF": 9,
	  "SINIFLANDIRMA_KODU": "M11",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 353000,
	  "UN_NO__1": 3530
	},
	{
	  "BAKANLIK_KOD": 353100,
	  "UN_NO": 3531,
	  "ORİJİNAL İSİM": "POLİMERLEŞTİRİCİ MADDE, KATI, STABİLİZE, B.B.B.",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "PM1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 353100,
	  "UN_NO__1": 3531
	},
	{
	  "BAKANLIK_KOD": 353200,
	  "UN_NO": 3532,
	  "ORİJİNAL İSİM": "POLİMERLEŞTİRİCİ MADDE, SIVI, STABİLİZE, B.B.B.",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "PM1",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 353200,
	  "UN_NO__1": 3532
	},
	{
	  "BAKANLIK_KOD": 353300,
	  "UN_NO": 3533,
	  "ORİJİNAL İSİM": "POLİMERLEŞTİRİCİ MADDE, KATI, SICAKLIK KONTROLLÜ, STABİLİZE, B.B.B.",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "PM2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 353300,
	  "UN_NO__1": 3533
	},
	{
	  "BAKANLIK_KOD": 353400,
	  "UN_NO": 3534,
	  "ORİJİNAL İSİM": "POLİMERLEŞTİRİCİ MADDE, SIVI, SICAKLIK KONTROLLÜ, STABİLİZE, B.B.B.",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "PM2",
	  "PAKETLEME_GRUBU": "III",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 353400,
	  "UN_NO__1": 3534
	},
	{
	  "BAKANLIK_KOD": 353501,
	  "UN_NO": 3535,
	  "ORİJİNAL İSİM": "ZEHİRLİ KATI, ALEVLENEBİLİR, İNORGANİK, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF3",
	  "PAKETLEME_GRUBU": "I",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 353501,
	  "UN_NO__1": 3535
	},
	{
	  "BAKANLIK_KOD": 353502,
	  "UN_NO": 3535,
	  "ORİJİNAL İSİM": "ZEHİRLİ KATI, ALEVLENEBİLİR, İNORGANİK, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "TF3",
	  "PAKETLEME_GRUBU": "II",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 353502,
	  "UN_NO__1": 3535
	},
	{
	  "BAKANLIK_KOD": 353600,
	  "UN_NO": 3536,
	  "ORİJİNAL İSİM": "LİTYUM BATARYALAR, KARGO TAŞIMA ÜNİTESİNE MONTE EDİLEN, lityum iyon bataryalar veya lityum metal bataryalar",
	  "SINIF": 9,
	  "SINIFLANDIRMA_KODU": "M4",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 353600,
	  "UN_NO__1": 3536
	},
	{
	  "BAKANLIK_KOD": 353700,
	  "UN_NO": 3537,
	  "ORİJİNAL İSİM": "NESNELER, ALEVLENEBİLİR GAZ İÇEREN, B.B.B.",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "6F",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 353700,
	  "UN_NO__1": 3537
	},
	{
	  "BAKANLIK_KOD": 353800,
	  "UN_NO": 3538,
	  "ORİJİNAL İSİM": "NESNELER, ALEVLENEBİLİR OLMAYAN, ZEHİRLİ OLMAYAN GAZ İÇEREN, B.B.B.",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "6A",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 353800,
	  "UN_NO__1": 3538
	},
	{
	  "BAKANLIK_KOD": 353900,
	  "UN_NO": 3539,
	  "ORİJİNAL İSİM": "NESNELER, ZEHİRLİ GAZ İÇEREN, B.B.B.",
	  "SINIF": 2,
	  "SINIFLANDIRMA_KODU": "6T",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 353900,
	  "UN_NO__1": 3539
	},
	{
	  "BAKANLIK_KOD": 354000,
	  "UN_NO": 3540,
	  "ORİJİNAL İSİM": "NESNELER, ALEVLENEBİLİR SIVI İÇEREN, B.B.B.",
	  "SINIF": 3,
	  "SINIFLANDIRMA_KODU": "F3",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 354000,
	  "UN_NO__1": 3540
	},
	{
	  "BAKANLIK_KOD": 354100,
	  "UN_NO": 3541,
	  "ORİJİNAL İSİM": "NESNELER, ALEVLENEBİLİR KATI İÇEREN, B.B.B.",
	  "SINIF": 4.1,
	  "SINIFLANDIRMA_KODU": "F4",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 354100,
	  "UN_NO__1": 3541
	},
	{
	  "BAKANLIK_KOD": 354200,
	  "UN_NO": 3542,
	  "ORİJİNAL İSİM": "NESNELER, KENDİLİĞİNDEN YANMAYA YATKIN MADDE İÇEREN, B.B.B.",
	  "SINIF": 4.2,
	  "SINIFLANDIRMA_KODU": "S6",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 354200,
	  "UN_NO__1": 3542
	},
	{
	  "BAKANLIK_KOD": 354300,
	  "UN_NO": 3543,
	  "ORİJİNAL İSİM": "NESNELER, SU İLE TEMAS ETTİĞİNDE ALEVLENEBİLİR GAZLAR AÇIĞA ÇIKARAN MADDE İÇEREN, B.B.B.",
	  "SINIF": 4.3,
	  "SINIFLANDIRMA_KODU": "W3",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 354300,
	  "UN_NO__1": 3543
	},
	{
	  "BAKANLIK_KOD": 354400,
	  "UN_NO": 3544,
	  "ORİJİNAL İSİM": "NESNELER, YÜKSELTGEN MADDE İÇEREN, B.B.B.",
	  "SINIF": 5.1,
	  "SINIFLANDIRMA_KODU": "O3",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 354400,
	  "UN_NO__1": 3544
	},
	{
	  "BAKANLIK_KOD": 354500,
	  "UN_NO": 3545,
	  "ORİJİNAL İSİM": "NESNELER, ORGANİK PEROKSİT İÇEREN, B.B.B.",
	  "SINIF": 5.2,
	  "SINIFLANDIRMA_KODU": "P1 veya P2",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 354500,
	  "UN_NO__1": 3545
	},
	{
	  "BAKANLIK_KOD": 354600,
	  "UN_NO": 3546,
	  "ORİJİNAL İSİM": "NESNELER, ZEHİRLİ MADDE İÇEREN, B.B.B.",
	  "SINIF": 6.1,
	  "SINIFLANDIRMA_KODU": "T10",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 354600,
	  "UN_NO__1": 3546
	},
	{
	  "BAKANLIK_KOD": 354700,
	  "UN_NO": 3547,
	  "ORİJİNAL İSİM": "NESNELER, AŞINDIRICI MADDE İÇEREN, B.B.B.",
	  "SINIF": 8,
	  "SINIFLANDIRMA_KODU": "C11",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 354700,
	  "UN_NO__1": 3547
	},
	{
	  "BAKANLIK_KOD": 354800,
	  "UN_NO": 3548,
	  "ORİJİNAL İSİM": "NESNELER, MUHTELİF TEHLİKELİ MALLAR İÇEREN, B.B.B.",
	  "SINIF": 9,
	  "SINIFLANDIRMA_KODU": "M11",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 354800,
	  "UN_NO__1": 3548
	},
	{
	  "BAKANLIK_KOD": 354900,
	  "UN_NO": 3549,
	  "ORİJİNAL İSİM": "TIBBİ ATIK, KATEGORİ A, İNSANLARI ETKİLEYEN,katı \"veya \"TIBBİ ATIK, KATEGORİ A, yalnızca HAYVANLARI ETKİLEYEN, katı",
	  "SINIF": 6.2,
	  "SINIFLANDIRMA_KODU": "I3",
	  "PAKETLEME_GRUBU": "",
	  "": "",
	  "__1": "",
	  "BAKANLIK_KOD__1": 354900,
	  "UN_NO__1": 3549
	}
  ]

  export {unCodes}